const lang = {
    "WanJu": "Toys",
    "RiYongPing": "Consumer products",
    "NinHao": "Hello!",
    "ZhuCe": "Register to get offers",
    "DengLu": "Sign in",
    "TuiChu": "sign out",
    "XinYongHuZhiYin": "New user guidelines",
    "BangZhuZhongXin": "Help Center",
    "ShangPinFenLei": "Categories",
    "QuanBu": "All",
    "SouSuo": "Search",
    "GouWuChe": "Cart",
    "NinDe": "My",
    "ZhangHuZhongXin": "Account",
    "DaiChuLiDingDan": "Pending order",
    "XuYaoQueRenCaiGou": "Need to confirm purchase",
    "XuYaoZhiFuDingJin": "Need to pay deposit",
    "XuYaoZhiFuHuoKuan": "Need to make payment",
    "XuYaoChuLiYiChang": "Need to fix some parts",
    "BuHuoWeiWanCheng": "Replenishment is not finished",
    "NinDangQianMeiYouDaiChuLiDeDanJu": "No orders awaiting processing",
    "ShouYe": "Home",
    "YouHui": "Promotions",
    "JiDan": "New pre-sale products",
    "PinPaiQu": "Brands",
    "ZuiXinShangPin": "Recommendations",
    "GengDuo": "More",
    "NTianChuHuo": "{0} days to shipping",
    "ShengYu": "Remaining",
    "TianS": "days",
    "XiaoShi": "hrs",
    "Xiang": "Carton",
    "Kuan": "items",
    "QingTianXieN": "Please write {0}",
    "QingXuanZeN": "Please choose {0}",
    "BuYunXuChaoGuoNGeZiFu": "Can't be more than {0}",
    "NGeShiBuZhengQue": "{0} formats are wrong",
    "DaXiaoBuNengChaoGuoN": "Size can't be more than {0}",
    "GeShiBuZhengQue": "Wrong format ",
    "XiaDanLiuCheng": "Placing order process",
    "ZhaoShangPin": "Product",
    "XianShangHeJia": "Cart",
    "XianShangXiaDan": "Online placing order",
    "ZaiXianDingDanGenZongChuLi": "Online tracking order",
    "FaHuoFuKuan": "Warehousing and logistics",
    "SouSuoShangPin": "Product search",
    "XuanZeYiXiangShangPin": "First choose product",
    "ChaZhaoXiangSiKuan": "Find similar",
    "JinXingDuiBi": "Compare",
    "JiaRuGouWuCheZhong": "Add to cart",
    "GouWuCheXuanZeShangPinTiJiaoHeJia": "Automatic calculation",
    "ZaiShangPinChiChaKanHeJiaHouDeJieGuo": "Product management",
    "ChuLiShangPinXinXiFanKui": "Feedback processing",
    "ZaiShangPinChiZuHePODan": "Create PO in the shopping cart",
    "SheZhiChuHuoShiJian": "Place the shipping time",
    "SheZhiTieZhiHeMaiTou": "Place stickers and shipping marks",
    "QueDingDingDanXinXiJiYaoQiu": "Order information to determine requirements",
    "TiJiaoPODan": "Submit the PO",
    "ZhiFuPODanDingJin": "Pay deposit for PO",
    "ChaKanPODanShengChanJinDu": "Check PO production schedule",
    "ChanShengShangPinYiChangShi": "If there are any questions during the production, please use on-line processing to solve it",
    "TiJiaoHeDuiChuanWuXinXi": "Submit / Check shipping information",
    "ChaKanZhiJianTuPian": "Check QC pictures",
    "ChaKanYuChuHuoQingDan": "See the packing list draft",
    "JieShouChuHuoTongZhi": "Get the shipping notice",
    "XiaZaiGeNeiDanZheng": "Download documents (packing list, invoice, bill)",
    "DengDaiShouHuo": "wait for shipment",
    "ZhiFuPODanHuoKuan": "Make payment ",
    "ShouHuoBingJianYanShangPin": "Receiving goods and QC",
    "RuHeZhuCe": "Exclusive products, effective prices",
    "YongYouYiGeEssaCnZhangHao": "Create essa.cn account",
    "RuHeZhaoShangPin": "How to search products?",
    "ShaiXuanXuYaoCaiGouDeShangPin": "Product filter",
    "RuHeTiJiaoDingDan": "How to send the order?",
    "ZaiXianTiJiaoCaiGouDingDan": "Send order online ",
    "RuHeZhiFu": "What is a procurement plan？",
    "DingDanHuoKuanZhiFuJiJieSuan": "Order payments and calculations",
    "ZuiXinLaiFangYongHu": "For new customers",
    "AnFenLeiChaZhaoShangPin": "Search goods by categories",
    "SouSuoLiShi": "Search history",
    "QueDing": "OK",
    "QuXiao": "Cancel",
    "ShangJiaShiJian": "Added time",
    "NTianNei": "during {0} days",
    "YiYueNei": "within a month",
    "BanNianNei": "within half year ",
    "NinZhengZaiLiuLan": "You are now on ",
    "ZhanKai": "Unfold",
    "ShouQi": "Fold",
    "QingChu": "Clear",
    "QingChuQuanBu": "Clear all",
    "DaTu": "Large picture",
    "LieBiao": "List",
    "MoRen": "By default",
    "HuoQi": "Delivery",
    "QiDingLiang": "MOQ",
    "JiaGe": "Price",
    "KuanKeXuan": "You can choose {0} items",
    "XiangShiDe": "Similar",
    "XiangShiShangPin": "Similar",
    "JiaRuShouCang": "Favourites",
    "YiShouCang": "Favorited",
    "ShouCangChengGong": "Favorited Successfully",
    "KeNengYouBanQuanJiuFen": "No copyrights",
    "WeiZhaoDaoFuHeTiaoJianDeJiLu": "Specified records are not found",
    "SouSuoZhong": "Searching ",
    "JiaGeJiBuFenXinPinXuYaoDengLuHouChaKan": "Please sign in to check the price and new items",
    "DengLuHouChaKanJiaGe": "Please sign in to check the price",
    "JiaGeJiBuFenXinPinXuYaoTiShengDengJiHouChaKan": "To see prices and new items you need convert into Deluxe level ",
    "XuYaoTiShengDengJiHouCaiNengChaKanJiaGe": "You need Deluxe level to see prices",
    "SSShangPinJiaGeZhiYouVIPYongHuCaiNengChaKan": "Price for brands S+S, Decora are available for VIP only",
    "ShenMeShiVIPYongHu": "What is a transaction user",
    "DengJiShuoMing": "Customer's status",
    "HuoDongJieShuJinShengNTian": "Promo will be finished in {0} days",
    "ZhiChi": "support",
    "ShuLiang": "Quantity",
    "DanJia": "Price",
    "ShangPinBianHao": "Article No.",
    "XuanZe": "Select",
    "YiXuanZe": "Selected",
    "GongNKuan": "In total {0} art.",
    "YiXuanZeNKuan": "Chosen {0} art.",
    "ZongJi": "Total",
    "TiJi": "Volume ",
    "MaoJingZhong": "G/N",
    "JiaRuGouWuChe": "Add for Inquiry",
    "NKuanShangPinYiJiaRuGouWuChe": "{0} items already in the cart",
    "YiJiaRuGouWuChe": "View the cart",
    "TianJiaChengGong": "Added successfully",
    "ShangPinMiaoShu": "Product Description",
    "GongYingShangXinXi": "Supplier information ",
    "ZhengShu": "Q/certificate",
    "ChangJianWenTi": "F.A.Q.",
    "JiaoYiShuoMing": "Trade description",
    "JiBenXinXi": "Basic Information",
    "ZhuYingChanPin": "Main products",
    "QiYeZhengShu": "Certificates",
    "HeZuoNianXian": "Cooperation time history",
    "ShuJuPingGu": "Statistics",
    "JiYuQianNNianShuJu": "Datas during {0} years",
    "FaHuoZhunShiLv": "Delivery time",
    "ZhiLiangTouSuLv": "Quality claims",
    "XinYongZhiShu": "Degree of confidence",
    "XinPinYanFaNengLi": "New items development",
    "MOQPingJunZhi": "Average MOQ",
    "BaoJiaPingJunYongShi": "Average time pricing ",
    "WenTiFanKuiPingJunYongShi": "Average feedback time",
    "JieDanPingJunYongShi": "Average time to receive order",
    "ShuJuPingGuJiSuanGuiZe": "Data calculation rules",
    "FaHuoZhunShiLvN": "Delivery on time rate: 1- The number of detained shipments/ Total shipments qty",
    "ZhiLiangTouSuLvN": "Сlaims of quality statistics: 1- Claims qty / Total shipments qty",
    "XinYongZhiShuN": "Credit index: 1- Number of rejected queries / Total queries numbers",
    "XinPinYanFaNengLiN": "New items development range: Last year range",
    "MOQPingJunZhiN": "Avarage MOQ: Total MOQ / Items number",
    "BaoJiaPingJunYongShiN": "Pricing time: Total time / Qty",
    "WenTiFanKuiPingJunYongShiN": "Avarage time for factories reply: Total time / Replies number",
    "JieDanPingJunYongShiN": "The order processing time: Total time/ Order qty",
    "JinNNianChuHuoLiang": "Ordered goods during last {0} years",
    "ZhangHao": "Account",
    "YongHuMingYouXiang2": "User Name / E-mail",
    "ZhangHaoBuCunZai": "Account  is incorrect",
    "WangJiMiMa2": "Forgot your password?",
    "MiMa": "Password",
    "ZhangHaoHuoMiMaCuoWu": "Accound number or password is incorrect",
    "YongYouYiGeESSAZhangHao": "Own essa.cn account",
    "KaiShi": "Start",
    "HuanYing": "Welcome!",
    "MeiYouMaoYiGongSi": "No trading company, factories only. Clear prices, free customer service help. Online commerce - easy, high effective, safe.",
    "ZheLiShiDiYiBu": "Step 1",
    "ZhangHaoYuMiMa": "Account number and password",
    "DianZiYouXiangBiXuZhenShiYouXiao": " E-mail has to be real. Right after registration you will receive activation letter on this e-mail",
    "YouXiang": "E-mail",
    "SheZhiMiMa": "Create Password",
    "ZaiCiShuRuMiMa": "Put the password again",
    "LianXiXinXi": "Contact information",
    "JiaoYiBiZhong": "Currency",
    "JianYiXuanZeRenMinBiZuoWeiJiaoYiJieSuanHuoBi": "We recommend that you select CNY, which will not be influenced by the exchange rate fluctuations.",
    "GongSiMingCheng": "Company Name",
    "GuoJiaDiQu": "Country/Region",
    "DaZhou": "Continent",
    "GuoJia": "Country",
    "LianXiRen": "Name",
    "GuoJiaDaiMa": "Zip code",
    "GuDingDianHua": "Landline phone",
    "YiXiangCaiGouShangPin": "Favorite products",
    "QingXuanZe": "Plese choose",
    "XuanTian": "Optional to fill",
    "YiXiaXinXiWeiXuanTianXinXi": "Fill this information is optional, but your response will help us to improve our service we provide for you",
    "HeZuomoshi": "Ways of cooperation",
    "XiaoShoufangshi": "Marketing channels",
    "NianDuCaiGouLiang": "Purchase volume of toy",
    "DanKuanCaiGouLiang": "Purchase volume of one toy",
    "MuBiaoShiChang": "Main market",
    "LiJiZhuCe": "Register now",
    "DianZiYouXiangBuNengWeiKong": "E-mail field can't be empty",
    "QingTianXieZhengQueDeDianZiYouXiang": "Please type correct e-mail ",
    "ZhangHaoYiCunZai": "This account number already exists",
    "ZhiShao6GeZiFu": "The password must be at least 6 characters, comprised of letters and numbers, contain a combination of uppercase and lowercase letters",
    "QingZaiCiShuRuMiMa": "Please entre password again",
    "LiangCiMiMaBuYiZhi": "Two times put wrong password",
    "QingTianXieGongSiMingCheng": "Put you company name",
    "GongSiYiCunZai": "This company already exists",
    "QingXuanZeGuoJiaDiQu": "Choose your country",
    "QingTianXieGongSiGuHua": "Put your phone number",
    "GuHuaBiXuWeiShuZi": "Phone must consist of numbers",
    "GuHuaYiCunZai": "This number exists already, please put another one",
    "QingTianXieLianXiRen": "Please write contact person",
    "QingXuanZeZhuYaoCaiGouDeShangPinLeiXing": "Please choose main group products",
    "ZhiDuoXuanZeNXiang": "Choose more than {0} pages",
    "NinYiChengGongZhuCe": "You are registered now!",
    "NinDeZhangHao": "Your account number",
    "JiXu": "Continue",
    "XiangChaKanReXiaoHeCuXiaoShangPinDeJiaGe": "Want to see hot items and promo? The letter has been sent to your email, please check",
    "ChongXinFaSong": "Resend the message",
    "NMiaoHouChongXinFaSong": "Resend message after {0} seconds ",
    "XuanZeYiWeiZhuanShuKeHuJingLiWeiNinFuWu": "Please choose your customer assistant",
    "NinZaiTiaoXuanShangPinDingDanChuLiYuDaoWenTiShi": "If you have any questions, please ask your customer assistant, he will help you to solve each problem. This serves is for free",
    "ChaKanQuanBuKeHuJingLi": "See all sales assistants",
    "JingYan": "Experience",
    "KeYongNJiaoLiu": "Can use {0} ways of communication",
    "ShuXiNHangYe": "Similar groups {0} ",
    "QueDingXuanZeGaiKeHuJingLi": "Confirm to choose this sales consultant?",
    "QingXianQianWangNinDeDianZiYouXiangChaShouYouJian": "The letter has been sent to your email. Please ckeck it and follow the instructions, written in the letter. After that our customer assistant will contact you",
    "WoMenDeGongZuoRenYuanJiangZai1GeGongZuoRi": "Our customer assistants willcontact you during 2 working days. After that you can see the prices and place orders",
    "YouXiangYanZheng": "Verification of email address",
    "YiTongGuoYanZheng": "Verified",
    "QuanBuKeHuJingLi": "All customer service assistants",
    "XingMing": "Name",
    "WeiZhaoDaoFuHeTiaoJianDeKeHuJingLi": "No matches for corresponding to the specified parameters customer assistance",
    "ZhaoHuiMiMa": "Restore password",
    "YanZhengMa": "Verification code",
    "HuanYiZhang": "Next pic",
    "TiJiao": "Submit",
    "YiFengZhongSheMiMaDeYouJianHuiFaWangNin": "A letter about the password change has been sent to your email. To set up a new password click on the link provided in the email",
    "ChongSheMiMa": "Reset password",
    "XinMiMa": "New password",
    "TiJiaoChengGong": "Submitt cofirmed",
    "MiMaChongSheChengGong": "Password successfully reset",
    "XiTongWeiHuZhong": "The site is under maintenance work, please retry the request later",
    "WeiHuShiJian": "Maintenance work time:",
    "XiTongWeiHuQiJian": "Contact details while website is under construction: {0}",
    "ZhiKanQiTaGongYingShang": "See other suppliers only ",
    "DuiBi": "Compare",
    "ShangPinDuiBi": "Products Comparison",
    "GaoLiangXianShiBuTongXiang": "Show different characteristics",
    "YinCangXiangTongXiang": "Hide same characteristics",
    "ShangPinMingChen": "Product Name",
    "ReMenPinPai": "Hot brands",
    "PinPaiLieBiao": "Brand list",
    "GengDuoPinPai": "More brands",
    "QuanBuPinPai": "All brands",
    "DaoChu": "Export order to excel",
    "HaiChaNXiang": "still need {0} carton(s)",
    "YiManZuCaiGouTiaoJian": "Meets the requirements",
    "LiJiCaiGou": "Order now",
    "JiJiangZhunBeiShengChan": "The order will soon be sent for production, after conformation is impossible to make any changes",
    "YuJiDaoHuoRiQi": "Preliminary production day",
    "CaiGou": "Buy",
    "ShangPinChi": "Your purchase plan",
    "NingDePODan": "Your PO",
    "NinHaiMeiYouTiJiaoRenHePODan": "You haven't sent PO yet",
    "PinGui": "My container",
    "HaiMeiYouKeYiYongYuPinGuiDeShangPin": "No item(s) for consolidation now",
    "ZiChan": "Finance",
    "ZiJinGuanLi": "Payment management",
    "HuiKuanMingXi": "Payment information",
    "HaiWeiShouDaoNinDeHuiKuan": "Your payment hadn't received yet ",
    "QianKuanMingXi": "Debt information",
    "NinMeiYouWeiZhiFuDeQianKuan": "You have no any payment  arrears ",
    "ShouXinGuanLi": "Credit management",
    "NingDeDuiZhangDan": "Your acts of reconciliation",
    "HaiMeiYouDuiZhangShuJu": "No any data reconcilation yet",
    "GuanLi": "Management",
    "JiaoYiSheZhi": "Trading settings",
    "MaiTouHeTieZhi": "Labels and stickers",
    "HaiMeiYouTiJiaoMaiTouYangBan": "Shipping marks are not sent yet",
    "HaiMeiYouTiJiaoTieZhiYangBan": "Stickers are not sent yet",
    "DingDanYaoQiu": "Order requirements",
    "ShangPinFuWu": "Goods services",
    "ZhunShuShangPin": "Exclusive products",
    "DaiLiShangPin": "Agent's products",
    "ShouCangJia": "Favorites",
    "ShouCangDeShangPin": "Favorite goods",
    "ShouCangDePinPai": "Favorite brands",
    "QiTa": "Others",
    "TuiJianShangPin": "Recommended products",
    "HaiMeiYouTuiJianDeShangPin": "Recommended products ",
    "LiuLanLiShi": "Browsing History",
    "NinZuiJinWeiChaKanGuoRenHeShangPin": "You didn't check any items recently ",
    "LiuLan": "Browse",
    "NinGouWuCheZhongDiShangPin": "Your cart",
    "NinGouWuCheZhongHaiMeiYouShangPin": "The cart is empty",
    "DaoRu": "Import",
    "XianXiaZaiMuBan": "First, download the template, log into the products then upload",
    "XlsXlsxGeShi": "Xls, xlsx files can't be more than 10 MB",
    "ShangChuan": "Add",
    "ShangChuanZhong": "uploading",
    "XiaZaiMuBan": "Download template",
    "ChengGongDaoRuNKuanShangPin": "Imported {0} items",
    "XiTongCuoWu": "System error please try again",
    "ChengGongTiJiaoNKuanShangPin": "{0} items are successfully exported",
    "NinHaiWeiTongGuoRenZheng": "Your account is not activated yet, you can't see the price",
    "TianJiaShiJian": "Time added",
    "XiaYiBuShiShenMe": "What is next?",
    "GongYingShang": "Supplier",
    "QuYu": "Region",
    "QuanBuQuYu": "All regions",
    "QuanBuFenLei": "All categories",
    "QuanBuBaoZhuang": "All kinds of packing",
    "QuanBuZhuangTai": "Status",
    "QuanBuShiJian": "All time",
    "ShangPinBianHaoHuoMingCheng": "Product name or item",
    "FanHui": "Back",
    "QiSongLiang": "Minimum delivery quantity(BOX)：",
    "GongYingShangYaoQiuDaDaoCiDingGouLiang": "Only if reach Min.Order this supplier will send the goods",
    "QuanBuXuan": "Don't choose all",
    "QuanXuan": "Choose all",
    "ShanChu": "Delete",
    "QueDingShanChuGaiShangPin": "Delete this product?",
    "ShanChuChengGong": "Deleted successfully ",
    "NKuanShangPinYiShanChu": "Deleted {0} items",
    "TiWen": "Ask a question ",
    "DengNGeWenTi": "{0} questions are pending",
    "ChengGongTiJiaoLeNGeWenTi": "Sent successfully {0} questions",
    "DangQianShuLiangXiaoYuMOQ": "At this very moment qty is less than MOQ, we will try to confirm this question, but can't guarantee it will work",
    "YiRuShouCang": "Favourites",
    "QueDingJiangGaiShangPinYiRuShouCangJia": "Confirm moving to favorites?",
    "DingGouLiang": "Order Quantity (Carton)",
    "GaiJiaGeWeiBaoKuoDanJiaXianShiWei": "Items with \"no price\" are not included",
    "TiJiaoHouWoMenJiangDuiZheXieShangPin": "After submitting we need around 2 days to confirm price with suppliers (more items, more time). The process progress you can check at Storage for confirmed items",
    "ZanWuShangPin": "It's empty",
    "HaiMeiYouDingDan": "No order yet",
    "JiaGeBaoHuQiShengYuNTian": "The price will be invalid in {0} days",
    "QiTaWenTi": "Another question",
    "JiangZheXieWenTiYingYong": "Apply these questions to all selected items",
    "XuanZeMuBan": "Choose tamplate first",
    "ZanWeiHuiFu": "No reply",
    "NinShangPinChiZhongDiShangPin": "My Goods according to the plan",
    "HaiMeiYouShangPinNinKeYiCong": "No any goods yet. You can add items from the cart",
    "ZhiKanGeXingHuaBianGengDeShangPin": "See only items, which can be changed individually for the client",
    "GeXingHuaBianGengDeShangPin": "Customers' individual items",
    "ChuLiHeJiaHouYouBianHuaDeShangPin": "Goods with changed proce after treating",
    "QuPinGui": "To consolidate",
    "HeJiaZhong": "Price calculation",
    "HeJiaWanCheng": "Price calculation is over",
    "HeJiaHouQueRenWuWuDeShangPin": "PO can be submitted after price confirmation. Attention: the items cannot be consolidated if it is under price confirmation or the its price has changed.",
    "YiChangLeiXing": "Unique categories",
    "XuYaoChuLiWanXiaLieShangPinHouCaiNengJiXu": "Need to fix questions with these items, than can continue",
    "NinCanYuJiDanDeXiaLieShangPin": "The items of New pre-sale product have been satisfied the purchase conditions, please make confirmation and we start production",
    "QingZhuYiQueRenCaiGouZhiHou": "Attention! After confirmation the order is sent to the production and any changes are impossible",
    "QueRenCaiGou": "Confirm order",
    "QuXiaoCaiGou": "Cancel purchase",
    "BuNengShaoYuNXiang": "Can't be less than {0} carton",
    "YiJingKeYiAnPaiShengChan": "Order can be placed for production already. Confirm to cancel?",
    "HuoDongYiGuoQi": "Promotion is over",
    "JieShou": "Accept",
    "XiaCiCaiGou": "Wait until next time",
    "YuanJiaGe": "Old price",
    "XinJiaGe": "New price",
    "YuanHuoQi": "Primary production day",
    "XinHuoQi": "New production day",
    "YuanYuZhuangGuiRiQi": "Estimated loading date",
    "XinYuZhuangGuiRiQi": "New loading date",
    "YuanMOQ": "Previous MOQ",
    "XinMOQ": "New MOQ",
    "WeiNinTuiJianYiXiaXiangSiDeShangPin": "Similar",
    "KeXiaDanDeShangPin": "Can be ordered goods",
    "ZhiKanWeiHuoShangPin": "Leftover stock",
    "ZhiKanJiDanShangPin": "See new pre-sale products only",
    "KeXiaDanDeJiDanShangPin": "Pre-sale products available",
    "KeXiaDanDeWeiHuoShangPin": "Rest of goods for order",
    "WeiHuo": "Leftover stock",
    "NinDeZhangHaoYouQiTaRenZhengZaiCaoZuo": "Your account number is being used from another computer",
    "ShuaXin": "Refresh",
    "YuFuWuQiLianJieShiBai": "Server is not replying ",
    "QingNTianNeiChuHuo": "Please ship the goods during  {0} days ",
    "WeiShenMeYaoXianQiQueRenLinShiPO": "Why should you send PO in limited time?",
    "ZheShiYinWei": "Because of ",
    "NinKeXiaDanDeShangPinZhongRuGuoCunZai": "During placing order you might have next questions: ",
    "RuKuManNTianDeWeiHuo": "Leftover stock over {0} days ",
    "JiDanChengGongManNTianDeShangPin": "The items of \"New products pre-sale\" have been available since {0} days ago.",
    "ZheXieShangPinDeJiYa": "These goods cause to inventory pressure and storage costs, therefore, please send PO within {0} days.",
    "XianChuHuoGui": "Containers that need to be formed first",
    "QiTaHuoGui": "Other containers",
    "ShenMeShiXianChuHuoGui": "What are containers that need to be formed first？",
    "WeiZaiYueDingShiJianNeiTiJiaoPODeWeiHuo": "If the orders of the remaining cargo,New products pre-sale are not submited, these products will be placed in the same container. Next time when you submit PO, you must deal with these products first, so reduce ESSA's storage cost",
    "BiXuXianAnPaiCiHuoGuiQueRenLinShiPO": "First you have to send PO for this container, only after that you can confirm other PO.",
    "WeiShenMe": "Why? ",
    "DangNinDeHuoYuanShangPinZhongCunZaiYiXiaLeiBieShangPinShi": "You resource items has following conditions:",
    "WeiJianQingESSADeKuCunYaLi": "To prevent oversaturation of warehouses, the system will automatically generate containers. The goods can be deleted automatically only after your request and confirmation.",
    "QingFangXin": "You can be assured this container is not different from others, but restricted to remove the items above.",
    "HuoGuiBuManShi": "Container is not full yet. You can continue to add items",
    "ShenQingYanQi": "The application for postpone",
    "WoMenShenHeTongGuoZhiHou": "After review the goods were removed from the container",
    "JiHuaChuHuoRiQi": "Delivery plan",
    "YanQiYuanYin": "Postpone reasons",
    "ChengGongTiJiaoYanQiShenQing": "The application for postponement has been sent",
    "YanQiShenQingChuLiZhong": "The application for postponement is in the review process",
    "TianJia": "Add",
    "YiChu": "Remove  ",
    "TianJiaHouShengYuShuLiangShaoYuMOQ": "After adding this item qty, the rest is less then the Min.Order ({0} carton), maybe next time is not possible to order this item. Confirm to add this amount?",
    "TianJiaHouGaiGongYingShangShengYuShuLiang": "After adding this item quantity, the rest is less then the Min.Order ({0} carton), maybe next time is not possible to order this item. Confirm to add this amount?",
    "HuoGuiNZhongDiShangPin": "No.{0}  Container",
    "ChaoChuHuoGuiKeZhuangTiJi": "Overstep container capacity ",
    "SuoXuanZeDeHuoGuiTiJiTaiXiao": "Capacity of all chosen containers is too small ",
    "YuJiZhuangGuiRiQi": "Preliminary loading date ",
    "YiXiangZhuangGuiRiQi": "Requested ship date",
    "YuJiShouHuoRiQi": "Planning date to receive order",
    "ShouHuoRiQi": "Receiving trade date",
    "ZhuangGuiRiQi": "Shipping date",
    "ZhuangGuiWanChengRiQi": "Date of loading complete",
    "YuJiDaoGangRiQi": "Pre date of arrival at the port",
    "DaoGangRiQi": "Date of arrival at the port",
    "DuanTuYunFei": "Short-haul freight",
    "YinShangPinChanDiYuChuHuoQuYuBuYiZhi": "As place of production and shipping place are different, the transportation fee will be added",
    "NinZaiGaiGongYingShangDeDingGouLiang": "Items quantity are less then the Min.Order, can't order",
    "BuFenGongYingShangDeDingGouLiangWei": "Some items  quantity are less then the Min.Order, can't order",
    "ManJianDiKou": "Ammount to cut",
    "SheZhiMaiTouHeTieZhi": "Set up stickers and marks",
    "BaoCunQuanBuHuoGui": "Save all containers ",
    "GaiRiQiZaoYuZhengChangJiaoHuoRiQi": "The date is earlier than fixed delivery date, probably wouldn't be delivered earlier.",
    "YinBuFenShangPinChuHuoQuYuTiaoZheng": "Some of the items in the order are made in other areas, respectively, the transportation costs will be included in the price",
    "ESSAShangPinTiaoMa": "ESSA product barcode",
    "TieZhiYangBan": "Sticker template",
    "MaiTouYangBan": "Marks template",
    "TieZhi": "Stickers",
    "MaiTou": "Mark",
    "ShiYongShuoMing": "Guidelines",
    "TiJiaoDingDanZhiQian": "Before submitting the order, please provide us shipping marks and stickers ",
    "MeiKuanShangPinKeYiShiYongYiZhongMaiTou": "1. One item may correspond to one kind of shipping mark and several types of stickers; press \"+\" to add  stickers and shipping marks",
    "KeYiZaiXianBianJi": "Can be edit in the system. Enter the information on shipping marks and stickers in the appropriate cells",
    "ShangPinBuXuYaoShiYongDeTieZhiHuoMaiTou": "Put symbol “-” in cells without shipping marks and stickers. If all the items without it, put “-” in each cell",
    "RuoZaiXianBianJiBuFangBianShi": "If you feel uncomfortable, just download tamplate, fill the information and download it again",
    "GaiMaiTouYiCunZai": "Have shipping mark already",
    "GaiTieZhiYiCunZai": "Have stickers already",
    "BuFenShangPinYiSheZhiNeiRong": "Part of the goods already set, it is impossible to remove",
    "TieZhiPaiBanTu": "The layout for the stickers",
    "YiBaoCun": "Saved",
    "FuZhi": "Copy",
    "ZhanTie": "Stickers",
    "QingShuRu": "Please, enter",
    "ShangChuanShiBai": "Uploading failed, please try again",
    "XiaZai": "Download",
    "BaoCunBingFanHui": "Save and return",
    "QingZaiCiQueRen": "Please confirm again",
    "BuHuoShangPinDeMaiTouHeTieZhiXinXiWuWu": "Shippimh marks and stickers for the replenishment items correct? After confirmation we start the production",
    "NKuanShangPinYiBuHuoChengGong": "Replenishment of  {0} items completed",
    "NinBenCiBianJiDeMaiTouHeTieZhiXinXi": "Changes in stickers and shipping marks ",
    "QueDingQuXiao": "Confirm to cancel?",
    "JiJiangShengChengPODan": "Create PO",
    "XiaDanRen": "Customer",
    "HuoGuiLeiXing": "Container type ",
    "XiaShuiGang": "Port of loading",
    "ChuHuoCang": "Shipping warehouse",
    "KuanShu": "Items Quantity",
    "TeShuYaoQiu": "Special conditions",
    "JieSuanFangShi": "Payment methods",
    "YingFuDingJin": "Deposit to pay",
    "TiJiaoPO": "Send PO",
    "YiXiaXinXiZhongYao": "Please note",
    "QingHeDuiMaiTouHeTieZhiXinXiHouZaiTiJiaoPO": "Please check shipping marks and stickers before sending PO",
    "ZhuYiTianXieNBiaoShi": "Attention: Symbol \"-\" means this item doesn't need any shipping mark and stickers",
    "XiuGai": "Modify",
    "BuNengWeiKong": "Can't be empty",
    "RuDuiDingDanYouEWaiYaoQiu": "If there are any additional requirements for the container, please specify ",
    "HuoGuiBuMan": "The container is not filled to the end, continue forming",
    "ShenQingTiJiao": "Ask to place order",
    "ShenQingLiYou": "Reasons for request",
    "ShenQingYiTiJiao": "Request has been sent",
    "GaiHuoGuiTiJiaoPODeShenQingZhengZaiChuLiZhong": "PO is sending, can't make any changes at this very moment",
    "ZhuYiShangPinDeMaiTouHeTieZhi": "Please check shipping marks and stickers!",
    "QueDingTiJiaoPO": "Confirm to send PO?",
    "ChengGongTiJiaoPO": "PO successfully submitted",
    "QiTaShuoMing": "Do you arthorize ESSA to help transfer cargoes",
    "ShouQuanESSADiaoHuo": "I agree",
    "DangHuoWuShengChanGuoChengZhong": "After PO, delay may accur in the process of production. To avoid the delay of delivery due to a small amount of caogoes, do you agree ESSA transfers cargoes reasonably according to the production progress for me and inform me. Statement: If  the delivery date of part of cargoes delays and has an affect on the delivery of the whole container, ESSA will help to exchange the delayed cargoes for other cargoes in another container, to ensure the punctuality of the container's shipment.",
    "XianJin": "Cash",
    "HuoKuan": "Value of goods",
    "FuWuFei": "Service fee",
    "TieZhiFei": "Sticker fees",
    "XiuGaiMingCheng": "Change the name",
    "XiuGaiChengGong": "Changes complete",
    "MingCheng": "Name",
    "GuiGe": "Standarts",
    "QueRenShiYong": "Confirm to use",
    "TuiHuiXiuGai": "Cancel changes",
    "TianXieXiuGaiYiJian": "Write the changes",
    "YiTuiHui": "Canceled",
    "QueDingShanChuGaiTieZhi": "Confirm to delete stickers?",
    "QueDingShanChuGaiMaiTou": "Confirm to delete shipping marks?",
    "ChiCun": "Size",
    "YanSe": "Color",
    "WenDangTuPianTuZhi": "Files / Pictures / ",
    "YiTiJiaoZhiZuoShenQing": "Application has been sent",
    "TiJiaoHouWoMenHuiJinXingZhiZuo": "We will processing the information and after you can check the list. This information will be used in order",
    "DingDanZhuangTai": "Order status",
    "ZhiFuDingJinHouWoMenHuiKaiShiAnPaiShengChan": "Production starts right after ESSA receives deposit. Please note that delivery day directly depends on ESSA receiving deposit",
    "ZhunBeiShengChanXiangGuanDeAnPaiShiYi": "Questions about production",
    "JinXingShengChan": "Goods are on the production now. If production date is changed on any reasons, we will inform you ",
    "DuiShengChanWanChengDeShangPinJinXingZhiJian": "QC produced goods",
    "JiangShengChanWanChengDeShangPinShouRu": "Produced goods are at the ESSA company warehouse",
    "JiangShangPinJinXingZhuangGui": "Goods are going to container",
    "WanChengZhuangGui": "Loading is complete. You can download packing list and invoice",
    "WanChengBaoGuanShiYi": "Custom check is complete",
    "HuoGuiYiKaiShiYunShu": "Container is on the way. Please make payment in time",
    "BenCiJiaoYiWanCheng": "This transaction completed",
    "ZhiKanZuiJinYiZhou": "Current week PO ",
    "ZhiKanZuiJinYiYue": "Current month",
    "ZhiKanYiYueYiQian": "Last month",
    "NinZuiJinYiZhouDePODan": "Current week PO ",
    "NinZuiJinYiYueDePODan": "Current month PO",
    "NinYiYueQianDePODan": "Last month PO",
    "ChaKanXiangXi": "View Details",
    "DingDanGenZong": "Order tracking",
    "ShangPinShengChanZhongChuXianYiChang": "During the production  some items had problems, please handle now",
    "NinYiTiJiaoBuHuo": "Your replenishment has been submited. Please {0} provide shipping marks and stickers  {0}",
    "BuHuoShangPinYiHeJiaWanCheng": "In order to submit to the factory for production as soon as possible, please confirm the information of the restocked product stickers and shipping marks in time.   {0} To Confirm  {1}",
    "DingDanShuLiang": "Order quantity",
    "QingZaiNTianNeiZhiFuDingJin": "Please pay the deposit ASAP. The estimated loading date depends on ESSA receiving deposit, which might be delayed.",
    "QingJinKuaiZhiFuDingJin": "Please pay the deposit ASAP. Delivery day depends on ESSA receiving deposit",
    "BianGengJieSuanFangShi": "Change payment method",
    "DangQianJieSuanFangShiWei": "Current payment method",
    "BianGengJieSuanFangShiWei": "Change payment method to ",
    "NinPODanZhongDiShangPin": "My PO",
    "ZhiJianTuPian": "QC Pictures",
    "ZhuangXiangDan": "Shipping list",
    "ZhuangXiangTuPian": "Packing pictures",
    "YiZhuangXiangDeShangPinQingDan": "Pre-packing list",
    "XiaZaiDanZheng": "Download documents",
    "XiaZaiShangPinTuPian": "Download pictures",
    "XiangShu": "Boxes Quantity",
    "NeiHeShu": "Inner box",
    "WaiXiangZhuangLiang": "Pieces/Box",
    "ZhuangLiang": "Quantity",
    "ZongGeShu": "Total Quantity ( Pieces）",
    "ZongMaoZhong": "total gross weight",
    "ZongJingZhong": "total net weight",
    "ZongTiJi": "Total volume",
    "WaiXiangChiCun": "Box size (length*width*height)",
    "FaPiao": "Invoice",
    "HuoHao": "item",
    "TiaoXingMa": "barcode",
    "ChengJiaoJia": "Transaction price",
    "XiaoJi": "Total",
    "HeJi": "Total",
    "FaPiaoJinE": "Invoice ammount",
    "YongLiang": "Amount",
    "FuWuFeiLv": "Service rate",
    "JieSuanDan": "Settlements",
    "BenDanFeiYongMingXi": "Charges details",
    "FeiYongXiang": "Cost items",
    "HaiYunFei": "Sea freight",
    "DaiFuFOBFei": "FOB payment",
    "BiZhong": "Currency",
    "YingFuJinE": "Total",
    "YiZhiFu": "Already payed",
    "HaiXuZhiFu": "Need to pay",
    "LiShiFeiYongMingXi": "Expenses history",
    "JinE": "Sum ",
    "JieZhiN": "Due {0}",
    "JieZhiXNinHaiXuZhiFu": "Due {0}",
    "FeiYongHeJi": "Total fee",
    "QiTaDanZheng": "Other documents",
    "ShangPinChuXianYiChang": "There are some questions for several items, please check them",
    "YiXiaShangPinYingXiangShengChanHuoChuHuo": "These items influence shipment date, please solve the questions in time",
    "ZhiJianBuHeGe": "QC does not meet the requirements",
    "ShangPinGuiGeBianHua": "Product size changes",
    "AnMOQCaiGou": "Buy according to MOQ",
    "CheXiao": "Cancel",
    "YiJieShou": "Confirmed",
    "YiShanChu": "Deleted",
    "AnYuanYuZhuangGuiRiQi": "Only {1} carton can be shipped according to the original loading date {0} .",
    "AnYuanDingGouLiangNXiang": "According to the original order quantity {0} carton, the estimated loading date will be postponed to {1}",
    "YiRuQiTaPODan": "Go to another PO",
    "XuanZePODan": "Choose PO",
    "YouESSAGenJuShiJiShengChanQingKuangDiaoPei": "Let ESSA company solve the question in production",
    "BaoCun": "Save",
    "BuManGui": "Container is not full. You can make replenishment",
    "DiaoRuShangPin": "select items from",
    "XuanZeXuYaoDiaoRuShangPinDePODan": "Select transferred goods PO, ESSA will be allocated based on the actual production schedule these orders in commodities, and notify you",
    "TiaoRu": "Move into",
    "CongNGePOZhongXuanZeShangPinDiaoRu": "Choose items for replenishment from PO {0}",
    "YunXuDiaoRuBiYuZhuangGuiRiQiWan": "The products,whose loading date are {0} days later than the estimated loading date, are allowed to add.",
    "NinYiShenQingCongQiTaPODanDiaoRuShangPin": "You have apply to shift the items from other PO, ESSA is being processed",
    "BuHuo": "Replenishment",
    "QuanBuLaiYuan": "The sources to be added from",
    "YiXuanZeNKuanShangPin": "{0} items had been chosen",
    "NKuanShangPinTiJiaoZhiHou": "We will confirm the prices with suppliers for your chosen items very soon",
    "FuHeYuZhuangGuiRiQiDe": "In conformity with the estimated loading date.",
    "XiuGaiMiMa": "Change password",
    "FaSongYanZhengYouJian": "Send a message of verification",
    "NinZaiXiuGaiMiMaQianXuYaoYanZhengZhangHao": "To change the password press button \"Send letter\". Check your e-mail and follow the instructions ",
    "YouJianYiFaSong": "Letter has been sent",
    "YuanMiMa": "Old password",
    "MiMaXiuGaiChengGong": "Password has beed changed",
    "XiuGaiYouXiang": "Change e-mail",
    "NinZaiXiuGaiYouXiangQianXuYaoYanZheng": "You need to verify the account before modifying mailbox. Click on \"Send Verification\" link, a message will be sent to your mailbox, please proceed according to the e-mail guidelines.",
    "YuanYouXiang": "Old e-mail",
    "XinDeYouXiang": "New e-mail",
    "XinDeYouXiangXuYaoTongGuoJiHuo": "The letter has been sent to your e-mail. Please follow instructions written in the letter to activate your new e-mail address",
    "YouXiangXiuGaiChengGong": "Email changed",
    "GongSiXinXi": "Company information",
    "BuFenShuYuGuanJianXinXi": "Main information",
    "WeiBaoZhangNinDeXinXiZhengQueXing": "To protect your information correctness, when you change your key information we need to review it again to take effect.",
    "GuanJianXinXiXiangZaiNinTiJiaoBianGengShi": "We can confirm you if there are any changes in basic info",
    "NinBianGengLeGuanJianXinXi": "Your main information has been changed",
    "GuanJianXinXi": "Main information",
    "GuanJianXinXiBianGengShi": "Changes will be activated after our confirmation only",
    "GongSiWangZhi": "Company website",
    "GongSiLOGO": "Company Logo",
    "JingYingXinXi": "Business activity information",
    "ZhuYingChanPinFenLei": "Main products",
    "JieSuanYaoQiu": "Сalculation requirements",
    "JiaoYiHuoBi": "Currency ",
    "NinXuYaoShiYongXinHuoBiLaiJieSuan": "If you need to change currency, please contact your customer assistant",
    "NinYiTiJiaoShenQing": "Your request has been sent, our assistants will look it through very soon",
    "BaoCunChengGong": "Saved successfully",
    "ZhengShuYaoQiu": "Certificate requirements",
    "QiYeZhengShuYaoQiu": "Certificate requirements for business activity",
    "ChanPinZhengShuYaoQiu": "Product certificates requirements",
    "QiTaYaoQiu": "Other requirements",
    "ShiYiTu": "Sketch map",
    "ZhangHaoXinXi": "Account information",
    "YongHuMing": "User ID",
    "ZhiWu": "Position",
    "JiShiTongXunGongJu": "Emergency number",
    "GeXingHuaSheZhi": "Personalized settings",
    "YeMianLiuLanSheZhi": "Page view settings",
    "MoRenBaoJiaFangShi": "Default terms of quotation",
    "MeiYeShangPinShuLiang": "Items per page",
    "JieGuoChaKanMoShi": "Results",
    "YeMianChaKanYuYan": "Language",
    "YuanGongZhangHao": "Assistant number",
    "SheWeiBOSSZhangHao": "Set as BOSS Account",
    "TiShengGaiZhangHaoGuanLiGongSiZiLiao": "Do you require to elevate to privilege account so that manage company information and employee account? After the upgrade, you will be downgraded and not able to manage information. This does not affect your next order.",
    "NinDeZiJin": "Your funds",
    "ZiJinZongJi": "Total asset",
    "KeYongZiJin": "Asset available",
    "BaoZhengJin": "Deposit",
    "NingDeYingFuKuan": "Your credit debt",
    "LeiJiYingFu": "To be paid",
    "NingJinQiJiaoYiE": "Your money circulation during recent time",
    "NNianDingHuoJinE": "{0} orders amount",
    "NNianChuHuoJinE": "{0} shipments amount",
    "ZiJinFenPeiMingXi": "Detail of the fin. Costs",
    "QuanBuYongTu": "All use for",
    "ZhiFuHuoKuan": "Payment",
    "ZhiFuDingJin": "Pay deposit",
    "QiTaFeiYong": "Other expenses",
    "FenPeiRiQi": "Allocation date",
    "JinNGeYue": "Recent {0} months",
    "JinNNian": "Recent {0} tears",
    "JinSanGeYue": "Past 3 months",
    "JinBanNian": "Past 6 months",
    "JinYiNian": "Past year",
    "JinNian": "This year",
    "YongTu": "use for",
    "BenCiFenPeiJinE": "Distribution of funds",
    "HuiLv": "Exchange rate",
    "RuZhangRiQi": "Period",
    "ShouKuanJinE": "Received amount",
    "ShouKuanBiZhong": "Received currency",
    "RuZhangBiZhong": "Credited currency",
    "RuZhangJinE": "Credited amount",
    "RiQi": "Date",
    "ShuoMing": "Details",
    "BenYueZhangDan": "Current month bills",
    "LiShiZhangDan": "Bills history",
    "DaiFang": "Creditor",
    "JieFang": "Borrower",
    "ShangQiJieYu": "Old balance",
    "BenQiJieYu": "Current balance",
    "YuE": "Balance",
    "HuiKuan": "Money transfer",
    "YiTongGuoRenZheng": "Confirmed",
    "DaiRenZheng": "Confirmation pending",
    "ShangCiDengLuShiJian": "Login Last Time",
    "WoShiN": " I am {0}, will be very glad to help you",
    "NinHaoWoShiN": "Hello! I am your consultant {0}",
    "WoCongShiWaiMaoHangYeYiJingYouNNian": "My activity in foreign trade business is {0} years and I'm very experienced in market of  {1} ",
    "CaiGouGuoChengZhongYouRenHeWenTi": "If you have any questions please feel free to contact me ({0})",
    "ChangYongGongNeng": "Common functions",
    "NinXuYaoChuLiDeShiXiang": "Questions to be solved",
    "XiaDanQian": "Before placing order",
    "XiaDanHou": "After placing order",
    "NKuanShangPinXuYaoQueRenCaiGou": "Need to confirm {0} items",
    "NZhangDingDanXuYaoZhiFuDingJin": "Deposit should be paid for {0} order(s)",
    "NZhangDingDanXuYaoZhiFuHuoKuan": "Need to make payment for order {0}",
    "NZhangDingDanXuYaoChuLiYiChang": "Need to solve some questions for order {0}",
    "NZhangDingDanBuHuoWeiWanCheng": "Replenishment for {0} order is not complet yet",
    "ZhongYaoTiXing": "Important notice",
    "WeiNinTuiJianDeShangPin": "Recommended product for you",
    "NinDaiLiDeShangPin": "Your proxy item",
    "NinHaiMeiYouDaiLiRenHeShangPin": "You did not proxy any item yet",
    "NinDeZhuanShuShangPin": "Your unique products",
    "HaiWeiKaiFaNinZhuanShuDeShangPin": "Your exclusive products are not developed yet",
    "NinShouCangDeShangPin": "Your favorite items",
    "NinHaiMeiYouShouCangRenHeShangPin": "You have no yet favorite items",
    "NinShouCangDePinPai": "Your chosen brands",
    "NinHaiMeiYouShouCangRenHePinPai": "You have no chosen brands",
    "JinRuZhuanQu": "View",
    "XiaoXiTiXing": "Notifications",
    "JiaoYiTiXing": "Transaction notifications",
    "HuoDongTiXing": "Promo notifications",
    "XiTongXiaoXi": "System notification",
    "DaoChuMuBan": "Produce thepress form",
    "BaoJiaDan": "Price list",
    "PODan": "Your PO",
    "FaPiaoDan": "Invoice",
    "DuiZhangDan": "Statement",
    "QiYongRiQi": "Opening date",
    "MuBanMingCheng": "Template name",
    "KeFuReXian": "Service Hotline",
    "BeiJingShiJian": "Bejing time, monday-Friday",
    "LianXiFangShi": "Contact details",
    "DianHua": "Phone",
    "ShiJian": "Time",
    "BaoZhuangYuYan": "Package language",
    "CaiZhi": "Main material",
    "TuPian": "Picture",
    "ZhengZaiChuLiQingShaoHou": "Loading…",
    "YanZhengMaBuZhengQue": "Code error",
    "BaoQianMeiYouSouSuoDaoShangPin": "Sorry, no match results",
    "QueDingYaoShanChuMa": "Confirm to delete?",
    "GongChangHuoHao": "Factory Item No.",
    "WoYiYueDuBingTongYiESSAYongHuZhuCeXieYi": "I have read and agree to {0}\"ESSA User Registration Agreement\"{1}",
    "DingDanPeiKuan": "Compensation",
    "TuiKuan": "Refund",
    "ZengPin": "Free sample",
    "FengXiangJiaoDai": "Use the tape on the box",
    "ChongDianQiChaTou": "Charger plug",
    "ChongDianQiDianYa": "Charger voltage",
    "YaoKongPinLv": "Remote control frequency",
    "WaiXiangMaTouYaoQiu": "Shipping mark requirements (box)",
    "NeiXiangMaTouYaoQiu": "Shipping mark requirements (inner box)",
    "TieZhiYaoQiu": "Sticker requirements",
    "ZhiXiangYaoQiu": "Carton requirements",
    "TongYongMoBan": "General mold",
    "ShouJi": "Phones",
    "XingBie": "Gender",
    "JinZhiChiGeShi": "Support only JPG, GIF, PNG, JPEG, BMP formats",
    "HeJia": "Send request",
    "WeiHeJia": "Not final price",
    "YouKe": "Guest",
    "ZhuCeCaiGouShang": "Buyer",
    "RenZhengCaiGouShang": "Certified Buyer",
    "VipCaiGouShang": "Trading buyer",
    "Zhang": "pcs",
    "WenJian": "File",
    "mingzi": "name",
    "XiuGaiMingZi": "Modify name",
    "Yuan": "Yuan",
    "XiuGaiMingZiChengGong": "Name has beed changed",
    "ShangChuanChengGong": "Upload Successfully",
    "QingXuanZeGuiGe": "Chose a spec",
    "WeiShangChuanWenJian": "File didn't upload",
    "WangLuoGuZhangHuoZheXiTon": "Sorry, the system is experiencing an issue and is currently unable to provide services. Please contact the platform's customer service or your sales consultant for assistance.",
    "CuoWuDaiMa": "Error code",
    "RuGuoXuYaoBianGengJiaoYiB": "If you need to change the trading currency, please contact customer service",
    "DangQianJiaoYiBiZhong": "Current currency",
    "YouXiangYanZhengLianJieYi": "Link already expired",
    "YuanMiMaBuZhengQue": "Password is not confirmed",
    "LeiJiQianKuan": "The total number of arrears",
    "WeiTongGuoYanZheng": "Validation Failed",
    "BianGengJiaoYiBiZhongWei": "Currency change to",
    "QingTongYiXieYi": "Please agree",
    "QingTianXieQuHao": "Please fill out the area code",
    "Nian": "Year",
    "DianZiYouXiangBiXuYouXiao": "The email must be valid , create account according the requirements, after verification you use this account to log on the website for purchase",
    "ZaiShuWanGongYingShangFaB": "In the tens of thousands of suppliers published more than a hundred million items , free pick , information-rich and transparent , and by means of advanced information science and technology complete to pick from , the shop price to the order , tracking the trading process , simple and efficient",
    "QingDengLu": "Please sign in",
    "XianZaiXuanZeYiWeiZhuanSh": "Now, Choose Sales consultant",
    "DangNinChengWeiWoMenDeRen": "When you become a certified user you will get a dedicated customer service for you.",
    "XiaoShiNeiWoMenGongZuoRen": "Within 24 hours our staff will contact you",
    "ZhiNengXuanZeYiGe": "Please choose one only",
    "KanKanZhengZaiJinXingDeYo": "Look at the ongoing promotions",
    "YanZhengMaWuXiao": "Authenticode invalid",
    "ZhuYaoCaiGouLeiXingBuNeng": "The main types of procurement is not more than 5 items",
    "QiTaXinXi": "Please fill this information",
    "ZhuYaoCaiGouLeiXing": "<b>Main Sales Regions and Purchase Categories</b>(New Products & Hot Products Proposed At The Earliest Time)",
    "XuanZeCaiGouLeiXingYouZhu": "Select the purchase type, helps us to provide you with a more refined service",
    "XuanTianZheiXieXinXiYouZh.": "Filling this information you help us to provide you a good service",
    "QuanQiuWanJuYuLiPinDeMaoY": "ESSA - Direct Toys Purchase from China",
    "DengLu1": "SIGN IN",
    "ZhuCe1": "Register to get offers",
    "ZhaoHuiMiMa1": "recover the password",
    "SouSuoLieBiao": "search list",
    "KaiXinFangXin": "HAPPINESS and SAFETY",
    "TeJiaWanJu": "Special price toys",
    "JiDanTuanGou": "New product pre-sale/Group purchase",
    "WanJuPinPaiDaQuan": "TOP brands",
    "JingXuanWanJuChanPin": "Big variety of toys",
    "BangZhuZhongXin1": "Help Center",
    "XiTongWeiHu": "System maintenance",
    "WoDeZhangHu": "My account",
    "WoDeXiaoXi": "My updates",
    "WoDeGouWuChe": "Your Cart",
    "WoDeCaiGouJiHua": "Your purchase plan",
    "WoDeHuoGui": "My containers",
    "SheZhiTieZhiMaTou": "Set stickers and shipping marks",
    "TiJiaoDingDan": "Send Order",
    "WoDeDingDan": "My orders",
    "WoDeZiChan": "Payment Management",
    "ZhangHuSheZhi": "Account Settings",
    "JiaoYiSheZhi1": "Transactions",
    "JieSuanYaoQiu1": "Settlement requirements",
    "CaiGouYaoQiu": "Procurement requirements",
    "HuoDaiLianXiRen": "Freight forwarding contact",
    "TieZhiYuMaTou": "Stickers and shipping marks",
    "MoBanGuanLi": "Template management",
    "ShangPinFuWu1": "Goods and services",
    "WoDeZhuanShuShangPin": "My exclusive products",
    "WoDeDaiLiShangPin": "My agents products",
    "GongSiXinXi1": "Company information",
    "WoDeYuanGong": "My employees",
    "ZhangHaoXinXi1": "Account information",
    "JiBenZiLiao": "Basic information",
    "XiuGaiYouXiang1": "Change e-mail",
    "XiuGaiMiMa1": "Change password",
    "ShouZangJia": "Favorites",
    "ShouZangDeShangPin": "Favorite goods",
    "ShouZangDePinPai": "Favorite brands",
    "QiTa1": "others",
    "LiuLanLiShi1": "Browsing History",
    "YeMianSheZhi": "Page settings",
    "DangQianHuoJuShengYuKongJ": "The volume is not allowed to exceed the maximum size of the container:{0}m³",
    "ZuiDaXiangShuWeiXiang": "The maximum number of carton is: {0}",
    "QingShuRuShuZi": "Please input a number",
    "GaiGongYingShangKeTianJiaDeShangPin": "The supplier can add the goods",
    "GaiGongYingShangYiWuKeTianJiaShangPin": "The supplier didn't add goods",
    "BaoCunQuanBuHuoGuiChengGong": "All the containers successfully saved",
    "ZhiDingShanChuHuoGuiYiBeiShanChu": "This container does not exist in the list or already deleted.",
    "ZhiDingShanChuHuoGuiBiXuWeiKong": "Specified to delete the container {0} must be empty!",
    "QingXuanZeYaoShanChuDeShangPin": "Please choose items to delete!",
    "QueDingYaoShanChuXuanZhongDeShangPinMa": "Sure you want to delete the selected goods?",
    "QueDingYaoShanChuCiShangPinMa": "Sure you want to delete this item?",
    "ShenQingWeiManGuiTiJiaoPODoing": "Your application to submit PO,  it's being under process",
    "QingXuanZeYaoTianJiaDeShangPin": "Please choose  product to add!",
    "QingXuanZeYaoYiChuDeShangPin": "Please select the goods you want to move out!",
    "DangQianZhangHuYouQiTaRenZaiXiaDanLater": "Your order is being processed, please contact your sales consultant if you need .",
    "NinDeCaiGouJiHua": "Your confirmed products",
    "DaoChuShangPin": "Download pics",
    "DangQianZhangHuYouQiTaRenZaiXiaDan": "Current account is being under order placing by other person",
    "YiXuanZhongNKuan": "Have selected {0} items",
    "WaiXiangMaoZhong": "Box gross weight",
    "JingZhong": "net weight",
    "WaiXiangTiJi": "Box volume",
    "DingGouLiangXiang": "Order amount: {0} carton",
    "ZhuYiYouBuFenShangPinWeiM": "Note: there is a part of the goods do not meet the order condition",
    "LiJiChuLi": "See all",
    "RiQiShenQingTiQianForPI": "Some of the items were not available on your request loading date, submit your date and pay attention on our feedback.",
    "CaiGouLiang": "purchases volume",
    "XiaoYuQiSongLiangBuNengXiaDan": "Manufacturers won’t deliver the order and you can’t place order if your (order) quantity is less than the Min.Order.",
    "SheZhiTieZhiMaiTou": "Set stickers and shipping marks",
    "HuoGuiNWeiManZuXiaDanTiaoJian": "The goods of the following container  {0} do not meet the order condition",
    "QingCanKaoCuoWuTiShiHouTiJiaoPI": "Please refer to the“delivery amount”and“Min.Order”prompt, the processing again after the Submitting",
    "MeiYouZhaoDaoXiangGuanDeS": "It did not match any products.",
    "QingHeDuiMaTouTieZhiXinXi": "Please confirm the  shipping mark  and sticker",
    "TianBiaoShiBuShiYongGaiTi": "Symbol \"-\" means there are no any stikers and shipping marks",
    "ShangPinBianMa": "Item code",
    "XuanZeTieZhiYangBan": "Select sticker model",
    "XuanZeMaTouYangBan": "Select the model marks",
    "XiaZaiXinXi": "Download",
    "WaiXiang": "Box",
    "ZhengMa": "Front Mark",
    "CeMa": "Side Mark",
    "NeiXiang": "inner box",
    "BuHuoShangPinDeTieZhiMaTo": "Replenishment goods sticker mark information is correct?",
    "QueRenHouWoMeJiangAnCiAnP": "After the confirmation, we will arrange the production according to the arrangement.",
    "NinBenCiBianJiDeMaTouTieZ": "Not save the marks and sticker this time",
    "QueDingQuXiaoMa": "Cancel?",
    "CaiGouJiHua": "Your Purchase plan",
    "HuiYuanZhongXinShouYe": "Member Center",
    "DaiQueRenFuKuan": "No confirmed deposit",
    "DaiQueRenDingJin": "Unconfirmed deposit",
    "DaiChuLiYiChang": "Pending abnoramlity",
    "WeiWanChengDeDiaoBuHuo": "Replenishment is not complete",
    "NinMeiYouDaiChuLiDeDanJu": "No pending documents",
    "BangZhu": "Help",
    "XinShouZhiNan": "Guides to the website",
    "XinShouShiPinJiaoCheng": "Help Center",
    "FenZhongLeJie": "One minute to know ESSA",
    "MianFeiZhuCe": "Free Sign Up",
    "DengLuShuoMing": "Sign in instructions",
    "YongHuDengJiQuanXian": "Types of users",
    "CaiGouShuoMing": "Work with orders",
    "CaiGouShiPinJiaoCheng": "Purchase video manuals",
    "JiaoYiLiuCheng": "Transaction process",
    "CaiGouJiHua1": "Purchase plan (PP)",
    "ShangPinPinJu": "Consolidation",
    "PODan1": "Purchase order (PO)",
    "ZhiFuHeYunShu": "Payment and shipping",
    "BaoJiaFangShi": "Terms of quotation",
    "ZhiFuFangShi": "How to pay",
    "DingHuoYaoQiu": "Ordering requirements",
    "HuoYunShuoMing": "Shipping notions",
    "XiaShuiChengShi": "Shipping ports",
    "GuanYuWoMen": "About us",
    "GuanYu": "About ESSA",
    "FuWuYuJiaZhi": "Service and Value",
    "SJieShao": "S+S TOYS Introduction",
    "DJieShao": "DECORA Introduction",
    "GongSiTuPian": "Company pictures",
    "KeJian": "VIP visible price",
    "SuoYouLeiMu": "CATEGORIES",
    "1059ER10018": "The container can be installed over the volume, not allowed to confirm the replenishment",
    "TiaoJianDaCheng": "Meet Condition",
    "ShengYuXiangShu": "Sent",
    "KuaiSuChuHuo": "Fast deliver",
    "TuanGou": "Group purchase",
    "JianYiSouSuo": "Easy to source",
    "RuHeXunJia": "How to send the order?",
    "ShiShiXunJiaHeChaXunShang": "Check product price and features in real-time",
    "KeKaoDeFuKuanFangShi": "Free to arrange your purchase plan",
    "FuWuYuBaoZhang": "How to make payment?",
    "ShouHouMaoYiBaoZhang": "Reliable method of payment",
    "ShangPinWeiYiGaoXiaoBiJia": "Ordering in real-time, autonomous controlling",
    "ChaoDaZhanTingXianXiaHuDo": "Extra large showroom, offline interactions",
    "MaoYiBaoZhangJiangDiFengX": "Trade guarantee, minimum risks",
    "JiaGeDi": "Exclusive products, effective prices",
    "DaFuLiPaiSongYuanChangJia": "Large welfare delivery, factory price standardization",
    "ShangPinDuo": "Ordering in real-time, autonomous controlling",
    "HaiLiangChanPinXinXiQingS": "Massive product information, easy screening",
    "ZaiXianJiaoYi": "Extra large showroom, offline interactions",
    "ZiZhuCaoZuoYiTiHuaShiShiD": "Integration of Autonomous operation and real-time order tracking",
    "ShiNianPinPai": "Trade guarantee, minimum risks",
    "KeKaoDeHeZuoHuoBanGongJia": "Reliable partner! 10 years of brand build integrity trading",
    "WuTiaoJianTuiHuan": "Unconditional return",
    "YiWaiQingKuangYouBaoZhang": "Other cases of guarantees",
    "BaoXianMianFeiSong": "Free insurance",
    "ShuiZiXianPingAnXian": "WPA (with particular average)  FPA (free of particular average)",
    "ZhiLiangYouPeiChang": "Quality compensation",
    "DaoGangKanZhiLiangShouHou": "Our service doesn't finish at the port",
    "XinShouZhiYin": "Novice guide",
    "ChaKanGengDuo": "View More",
    "ZhuYi": "Attention",
    "ShangPinHeJiaJieGuoYouYiC": "Pricing abnormal",
    "TiShi": "Tip",
    "GaiShangPinYiGuoJiaGeBaoH": "The price protection has expired",
    "ZaiCiHeJia": "Enquiry again",
    "YanZhengMaCuoWu": "Verification code error",
    "WangLuoGuZhangHuoZheXiTonCode": "Sorry, the system is experiencing an issue and is currently unable to provide services. Please contact the platform's customer service or your sales consultant for assistance. Error code: {0}.",
    "YongHuXinXiYiGuoQiQingZho": "User information has expired, please login. After {0} seconds will auto jump",
    "CunRu": "deposit",
    "ZhiChu": "pay",
    "XieYi": "Agreement",
    "WoYiJingYueDuBingTongYi": "I have read and agreed",
    "XiangQing": "Details",
    "ChanPinZhengShu": "Product certification",
    "ZhuCaiZhi": "Material",
    "ZhangHaoYiJinYong": "Account has disabled",
    "QingXianQianWangNinDeDian": "Please confirm your email (during 24 hours)",
    "CuoWu": "Error",
    "KeFuTuanDui": "Essa customer service team",
    "NinQueDingXuanZeGaiKeFu": "You determine the selection of the consultant",
    "JiYuQianSanNianShuJu": "Based on the data of the previous three years",
    "BaoZhuangFenLi": "Packaging separation",
    "BaoZhuangNianLingBiaoQian": "Age label",
    "JinNianChuHuoLiang": "Shipments in recent 3 years",
    "JiDanTuanGouShangPinJiaGe": "New products pre-sale/group purchase is available for VIP only",
    "ShanChuBuChengGong": "Deleted unsuccessfully",
    "CaiGouShangZhangHaoXiaJin": "Only one container under the account, not allowed to delete",
    "KongHuoJuCaiNengBeiShanCh": "Can be deleted when container is empty",
    "GaiShangPinYiJingQueRenGo": "Purchase has been confirmed, quantity can add only, can't make it less",
    "GengXinShiBai": "Update failed",
    "QuXiaoCaiGouShiBai": "Cancellation of the procurement failed",
    "XunJiaZhongDeShangPinBuNe": "Can't change quantity for quotation requested goods",
    "FeiHuoDongShangPinDingGou": "You cannot choose the value between 【quantity available】and 【purchase Min.Order】 for the quantity of non-promotion product",
    "FeiHuoDongShangPinDingGou1": "Not in stock products qty can not be less than 【Min.Order】",
    "HuoDongShangPinZaiDiaoZhe": "Quantity for these goods can't be less then 【Min.Order】",
    "JiDanTuanGouHuoDongBuCunZ": "New products pre-sale/group purchase does not exist",
    "HuoDongZhuangTaiJiDanZhon": "Promotion state=when New products pre-sale/Group purchase  is continuing, you cannot change the 【Quantity】lower than 【Min.Order】",
    "QueRenCaiGouQianDiaoZheng": "Before confirming the order pls make sure 【Quantity】can't be less that 【Min.Order】",
    "QueRenCaiGouHouBuYunXuDia": "After confirmation can't change 【 】",
    "JiDanChengGongHouBuYunXuD": "After \"New product pre-sale\" is confirmed, you cannot change the quantity 【订购量】,or delete.",
    "JiDanShiBaiHouZhiYunXuSha": "The failed pre-sale products can only be deleted",
    "ErCiHeJiaShiBai": "enquiry again failed",
    "ShangPinBuFuHeYaoQiuWuFaT": "Goods do not meet the requirements, can not be added to the PP",
    "JiDanTuanGouZhiJieJiaRuSh": "Failed to add the products from the promotions of New products pre-sale/Group purchase to the purchase plan",
    "JiDanTuanGouHuoDongBuZaiY": "Group purchase is not valid yet",
    "XunJiaZhongDeShangPinBuYu": "Request for quotation of goods is not allowed to delete",
    "YiQueRenDeShangPinBuYunXu": "Can't delete confirmed items",
    "HuoJuYiJingYouGeBuNengZai": "There 30 containers at this moment, can't add more",
    "YiXiangYuZhuangJuRiQiShou": "The preferred loading date can be changed to 10 days at most earlier than the default time.",
    "ShangPinShengYuShuLiangBu": "Order quantity ={0}, can't be less than the Min.Order ={1}",
    "ShangPinBianHaoDeTieZhiMa": "Stickers and shipping marks for item number {0} set up not correct",
    "ShangPinBianHaoDingGouLia": "Item number {0} is less then the Min.Order",
    "GongYingShangBianHaoWeiDe": "Item number {0}is less then the Min.Order",
    "CaiGouShangMeiYouSheZhiJi": "You didn't set the transaction currency",
    "CaiGouShangZhangHaoXiaBuC": "Buyer's account does not exist, you can delete the container",
    "WeiHuoBuNengGaiBianXiangS": "The carton quantity of the remaining cargo cannot be changed, only can be removed",
    "ShouDongDiaoZhengDeRiQiYu": "You can change the date. At most, 10 days earlier or 15 days later than【the estimated loading date】.",
    "HaiCha": "still need",
    "ShuRuShangPinBianHaoGongC": "Enter an item number, keyword or search by image",
    "CaiGouJiHuaZhongShiKongDe": "Purchase plan is empty",
    "ChaKanCaiGouJiHua": "View the plan",
    "HeJiaShiBai": "enquiry failed",
    "ShangChuanXinXi": "Upload",
    "CiDanYiJingShenQingLeDiao": "The items had been added already to this PO",
    "CiDanBuNengZaiGengGaiJieS": "This PO can't  change the settlement",
    "TianJiaGouWuCheChengGong": "Added successfully",
    "GouWuCheShiKongDe": "No chosen goods",
    "HPBangZhuZhongXin": "Help Center",
    "BuCunZaiHeShiDeBaoBiaoMoB": "There are no any suitable templates, pls contact your assistant",
    "QingXuanZeYaoDaoChuDeShuJ": "Please choose items to export",
    "QingXuanZeMoBan": "Please, choose the template",
    "ShangPinTuPian": "Product picture",
    "QingShuRuQuHao": "Please enter the area code",
    "BuNengZhongFuXuanZe": "Can't choose again",
    "Shi": "Yes",
    "Fou": "No",
    "QingTianJiaShangPin": "Please, choose items",
    "LeiMu": "Categories",
    "QueShaoBaoBiaoZiYuanBianMaCanShu": "The lack of reporting resources to the encoding parameters, please contact your consultant",
    "QingXianXiaZaiMoBanTianXi": "Please download the template, fill in and upload then",
    "queren": "OK",
    "ShengChanYaoQiu": "Production requirements",
    "BeiZhu": "Notes",
    "BaoZhuangYaoQiu": "Packaging requirements",
    "BuManJuLiYouWeiKong": "Blank! The reasons for non-full container",
    "NinZaiZhiFuDingJinHouEssaWeiNinTouChan": "We will start the production right after your deposit payment",
    "ZhengZaiZhunBeiShengChanXiangGuanDeAnPai": "Production is under preparing",
    "NinDeDingDanYiJingZaiShengChanZhong": "Your order is under production already, if there are any questions we will contact you immediately",
    "ShengChanYiWanBiZhengZaiJinXinZhiJian": "Production is finished, goods are under quality checking",
    "ShangPinYiZhiJianWanChengZhengZaiShouRuEssaCangKu": "Quality checking is finished. Goods are going to our warehouse",
    "DingDanYiJingZhuangGuiWanCheng": "Orders have already started loading",
    "HuoWuYiJingZhuangGuiWanCheng": "Container loading is finished",
    "YiJingBaoGuanTongGuo": "Has been the declared",
    "NinDeHuoGuiYiZaiYunShuGuoChengZhongQingJiShiZhiFu": "Your container is on the way, please make the payment in time",
    "TiDanYiJiaoFu": "The bill of lading has been delivered",
    "PoDanLieBiaoShiKongDe": "PO list is empty",
    "LieBiaoShiKongDe": "The list is empty",
    "XunJiaYiChangXuYaoChuLi": "Price has some incorrects, need to process",
    "YiChangChuLi": "Handling inconsistencies",
    "ChaKanShangPin": "View product",
    "QiTaDanJu": "Other documents",
    "FuWuFeiYouHuoGuiShangPinKuanShuJueDing": "Service charge depends on items quantity at the container",
    "GaiFeiYongBaoKuoHuoKuanTieZhiFeiFuWuFeiDaiFuFob": "The cost includes the purchase price, sticker fees, service charges, payment FOB",
    "YiXuanZhong": "Chosen",
    "Jian": "pieces",
    "YiXiaShangPinYiGuoJiaGeBaoHuQi": "Price is not valuable already",
    "YiXiaJia": "No more in stock",
    "YiJieSouCiMoq": "Reached MOQ",
    "ShangPinXinXiYiChang": "Product information is incorrect",
    "ZhiJianYiChang": "Quality has some problems",
    "YiDongDaoN": "Move to {0}",
    "ZanShiMeiPoDan": "There are no any PO at this very moment",
    "QingChaKan": "Check",
    "GouWuCheZhongShiKongDe": "The cart is empty",
    "JiBenGouWuLiuChen": "Shopping process",
    "ChaZhaoShangPinJiaRuGouWuChe": "Search product",
    "TiJiaoBingQueRenPI": "Submit  purchase plan",
    "PIPinGuiBingTiJiaoPO": "Create container",
    "QueRenPO": "Firm order",
    "ChuHuoJiaoYiWanCheng": "Shipping, payment",
    "QueRenXinMiMa": "Confirm the password",
    "KeHuFuWu": "Customer Service",
    "YiChangYuanYin": "The reasons for the discrepancy",
    "JiaGeYiChang": "Price discrepancy",
    "HuoQiYiChang": "Delivery time discrepancy",
    "MOQYiChang": "MOQ discrepancy",
    "WuLiaoKeYongLiangBuZu": "Insufficient material",
    "TingChanXiaJia": "Out of stock",
    "HeZuoFangShi": "ways of cooperation",
    "XiaoShouQuDao": "distribution channel",
    "BaoZhuangChiCun": "Package size",
    "SuoYouXunJiaWanChengHouHe": "The items can be found in \"Consolidation\" if price inquiries are completed without abnormality. You can select some items to consolidate in your containers and place an order, or deal with the items with abnormal price inquiry.",
    "QingHuaDongYanZhengMa": "Please put the verification code",
    "TuoDongHuaKuaiDaoZuiYou": "Drag the slider to the right",
    "ZhongXinTianXie": "Reset E-mail",
    "TianXieShangMianDeYouXian": "After you put your e-mail, you will receive the letter to your email box. Please check it and complete the registration according with the instructions",
    "JiXuJiJiangWanChengZhuCe": "Continue to complete your registration",
    "SheZhiMiMa1": "Set the password",
    "QianWangNinDeYouXiangChaS": "Check your email, Continue the registration",
    "YanZhengYouXiang": "Verify E-mail",
    "QianWangNinDeDianZiYouXia": "Please confirm your email (during 24 hours)",
    "XinPinTuiJian": "New products",
    "HaiYouYiChangWeiChuLi": "There are some abnormal orders not processed.",
    "CaiGouShuLiang": "Carton",
    "JiDanZhong": "Joint ordering is under pre-sale",
    "TuanGouZhong": "Group purchasing",
    "QingQueRen": "Please confirm",
    "ZhuJiMa": "Factory article",
    "HongShengJiuBianHao": "Old Item NO.",
    "XuanZeZhou": "Continent",
    "XuanZeSheng": "Province",
    "XuanZeGuoJia": "Please select a country/ region",
    "XiaYiBu": "Next step",
    "YnV5ZXJfY29uZmlybV9lbWFpbF9jb2Rl": "Conditions of pre-sale new arrival have been reached",
    "cHJvX2xvYWRfZGF0ZV9jaGFuZ2VkX2VtYWls": "Loading date had been changed",
    "cG9fYWJub3JtYWxfZW1haWw=": "PO has one question",
    "cmVwbGVuaXNoX2lucXVpcnlfZW1haWxfY29kZQ==": "Price request for the replenishment goods completed",
    "YnV5ZXJfc3RpbWFya19lbWFpbF9jb2Rl": "Sticker and shipping marks had been produced",
    "cG9fYmlsbF9vZl9sYW5kaW5nX2VtYWls": "The bill of lading had been released",
    "c3VibWl0X3BvX2J5X3NhbGVzX2VtYWls": "Submit PO",
    "QnV5ZXJfU3RhdGVtZW50cw==": "Monthly bill check",
    "UmVtYWluX0JhbGFuY2VfUGF5bWVudF9lbWFpbA==": "Trade arrived to the port",
    "YnV5ZXJfZ29vZHNfcmVjb21tZW5kX2VtYWlsX2NvZGU=": "Recommended products",
    "bG9hZF9jb250YWluZXJfZG9uZV9lbWFpbA==": "Packaging has been complete",
    "cGF5bWVudGRfZXBvc2l0X2VtYWls": "Deposit payment",
    "BulkMaterialConfirmBuyTemplate": "Shipping information confirmation alert",
    "YouJianTuiDing": "Cancel a subscription",
    "YouJianDingYue": "E-mail service",
    "MeiYouGouXuanDeXiangMuWoM": "This is e-mail alert function: if you didn't choose any category we won't send you the newsletters. You can change email notifications according to your requirements",
    "NinXiangYaoTuiDingDeFuWu": "You want to refuse this service",
    "QingBuYaoFaJiWoDeYouJianT": "Please do not send me \"{0}\"  e-mail notifications, thanks!",
    "XiangXiDeYouJianFuWuSheZh": "Details of the mail service settings in User's Center account settings",
    "YouJianFuWu": "E-mail service",
    "QuXiaoDingYue": "Cancel a subscription",
    "DianJiZheiLi": "click here",
    "TuiDingChengGong": "Unsubscribed",
    "DanJuDingJinBiLi": "Single container deposit ratio",
    "DanJuGuDingDingJin": "Fixed deposit for one container",
    "BaoZhengJinEDu": "Guarantee deposit system",
    "YnV5ZXJfY29uZmlybV9lbWFpbF9jb2Rl_remark": "As soon as conditions for group purachase are reached, you will receive an email notification",
    "c3VibWl0X3BvX2J5X3NhbGVzX2VtYWls_remark": "As soon as your consultant will submit PO,  you will receive email notification",
    "cHJvX2xvYWRfZGF0ZV9jaGFuZ2VkX2VtYWls_remark": "If there are any changes at shipment day, you will receive email notification",
    "cG9fYWJub3JtYWxfZW1haWw=_remark": "If there are any questions at PO, you will receive email notification",
    "cmVwbGVuaXNoX2lucXVpcnlfZW1haWxfY29kZQ==_remark": "As soon as rice request for the replenishment goods complete,  you will receive email notification",
    "bG9hZF9jb250YWluZXJfZG9uZV9lbWFpbA==_remark": "As soon as container loading is finished,  you will receive email notification",
    "cG9fYmlsbF9vZl9sYW5kaW5nX2VtYWls_remark": "As soon as bill of lading will be issued, you will receive email notification",
    "UmVtYWluX0JhbGFuY2VfUGF5bWVudF9lbWFpbA==_remark": "As soon as container arrives to port,  you will receive email notification",
    "YnV5ZXJfc3RpbWFya19lbWFpbF9jb2Rl_remark": "As soon as stickers and shipping marks production is finished, you will receive email notification",
    "YnV5ZXJfZ29vZHNfcmVjb21tZW5kX2VtYWlsX2NvZGU=_remark": "You will receive e-mail notification with new items",
    "QnV5ZXJfU3RhdGVtZW50cw==_remark": "You will receive e-mail notification with every month check bills",
    "GengXinZhong1": "Updating",
    "DaiQueRen1": "Pending confirmation",
    "ZhongTu": "Medium size picture",
    "XiaoTu": "Small size picture",
    "FenBianLv": "Resolution",
    "QingXuanZeTuPianGeShi": "Please, choose picture size",
    "QingXuanZeShangPin": "Please, choose items",
    "WaiBuDingDanHao": "Order numbers",
    "JinNengXuanZeNGe": "Only can choose {0} items",
    "JieXiChuCuoQingChangShiZh": "Format does not meet the requirements, please re-download the template and upload again",
    "1007S0019": "There are no stikers and shipping marks {0}",
    "ShangChuanChengGongNKuan": "Successfully imported {0} items",
    "ShangChuanShiBaiCunZaiBuYiZhiDeNeiRong": "Uploading failed, please try again",
    "MeiKuanShangPinZuiDuoZhiY": "For one item can be only one shipping mark model",
    "TieMa": "Stickers and shipping marks",
    "ZiDuanZhiBuWanZheng": "Field value is not complete",
    "ShangPin": "Products",
    "De": "Stickers and shipping marks information",
    "CunZaiBuYiZhiDeNeiRong": "Information is  inconsist",
    "DingGouLiangWuXiao": "The total amount for item {0} is invalid",
    "GaiShangPinYuJiZhuangGuiR": "Change the loading time",
    "RuGuoMOQBuManZuQingJiangQ": "If MOQ is not met, please increase it or add other items from the left column",
    "RuGuoQiSongLiangBuManZuQ": "If qty for sending goods is not enough please add it or add other items from this supplier",
    "RuGuoYuJiZhuangGuiRiQiBuM": "If you can't set needed date of container loading, please change it",
    "MaiTouShuLiangBuNengChaoGuoShangPinShuL": "Shipping marks quantity can't be more than product quantity",
    "YangBanLieBiaoWeiK": "The template list is empty",
    "QingQingKongLieBiaoHouZaiShanC": "Please empty the list and then delete",
    "BaoCunTieZhiHeMaiTouYiC": "Save changes for stickers and shipping marks",
    "QingJiangTieZhiMaiTouXinXiTianXieWanZ": "Please send stickers/ shipping marks information for complete",
    "BaoCunTieZhiHeMaiTouChengG": "Saved succesfully",
    "TieZhiYiJingYingShuaWanBiXuZhiFuFanGongFeiY": "Stickers already produced. To change information for {0} need to pay extra fee",
    "ShenQingXiuGai": "Apply to modify information",
    "LeiBie": "Categories",
    "ShouFeiFangShi": "Payment methods",
    "ShouFeiBiaoZhun": "Types of payment",
    "AnZhang": "According to stickers qty",
    "AnXiang": "According to carton quantity",
    "ShenQingXiuGaiTieZhiChengG": "Application to modify  stickers sent successfully",
    "BuHuoShangPinShangWeiJinRuPODan": "Replenishment goods were not added to PO!",
    "CaoZuoChengGong": "Operation is successful",
    "CaoZuoShiBai": "Operation failed",
    "PaiBanTu": "Layout",
    "XiaZaiShiBai": "Downloading failed",
    "JiaoHuoQi": "Delivery day",
    "KeHuDingDanHao": "Order number",
    "KuaiJieJian": "Shortcuts",
    "QiYong": "Enabled",
    "YiQiYong": "Enabled",
    "XiangTongZiDuanZhiBiXuYiZhiQingHeDui": "The same field value must be the same, please check the following stickers/marks information",
    "GuDingTieZhi": "Fixed stickers",
    "GuDingMaTou": "Fixed shipping marks",
    "ShiYong": "Use",
    "BuShiYong": "Not to use",
    "YiShiYong": "Already in use",
    "TiJiaoHeJia": "Send request",
    "ZanWuWenJianXuXiaZai": "No files can be downloaded",
    "ChengGongTiJiaoBuManGuiXiaDanShenQing": "Submitt cofirmed",
    "YaSuoBao": "Archive",
    "ZuiZaoJiaoHuoRiQiWeiQingD": "The earliest delivery date is {0}, please adjust the intention of loading date",
    "CiMaiTouZanWuTuPianXinXi": "This mark has no picture",
    "CiTieZhiZanWuTuPianXinXi": "This sticker without picture",
    "Huo": "or",
    "CiMaTouWuXuTianXieNeiRongQingXuanZe": "This mark is not required to fill in the contents, please select",
    "JiWuLiaoDeHuoDongShangPinG": "The quantity or the remaining quantity of the promotion item  {0}  should be not less than promotion Min.Order  {1}, please adjust",
    "JiWuLiaoDeHuoDongShangPinC": "Quantity of the promotion items {0} must match Min.Order {1}",
    "HuoJuZhuangTaiChuYuBuManJ": "The application for sending the non-full container container is in process. Can't be submitted",
    "SanHuoYiXiangZhuangJuRiQi": "Delivery date for the replenishment order is later than loading time. If you want to send these items, you need to change shipment date + {0} days more. Please correct the date of shipment",
    "FeiSanHuoYiXiangZhuangJuR": "Delivery date for the replenishment order is later than loading time. If you want to send these items, you need to change shipment date + {0} days more. Please correct the date of shipment",
    "HuoJuCunZaiHuoQiYiChangSh": "Abnormal shipment of  items in the container, please solve them in time",
    "ShangPinDeTieZhiMaTouMeiY": "Stickers and marks for {0} are not set propperly",
    "HuoDongShangPinXuYaoManZu": "The quantity of the promotion product must meet match MOQ",
    "GongYingShangDingGouLiang": "The quantity does not match to the minimum for supplier {0} to make the delivery",
    "TieZhiYiJingYingShuaWanBiCode": "Stickers have been produced already",
    "TieZhiShengChanZhongCode": "Stickers production is in the process",
    "TieZhiMaTouMingChengZhong": "Write the new name for stickers and marks",
    "YiKuanShangPinZhiNengLuRuYiFenMaiTouQingHeDui": "One article can have only one mark, please change the numbers",
    "ShangPinBianHaoWuXiao": "Item number doesn't exist",
    "YiChangChuLiBaoCunChengGong": "Changes saved",
    "MeiYouBianGeng": "No changes",
    "BaoZhuang": "{0} packaging",
    "XuanZeQiTaBaoZhuangYuYan": "Other packaging language",
    "YuGaiShangPinXiangSiDe": "Similar to this product",
    "QingXuanZeShangPinShuLiang": "Please choose quantity",
    "ZhongZhi": "Reset",
    "MeiZhaoDaoFuHeTiaoJianJiL": "Didn't find the qualifying records, please change the filter criteria",
    "GeShuHuiAnZhaoZhuangLiang": "Pieces will conversion to Carton",
    "ZuiXinShangPin1": "New Products",
    "1059B10002": "The price for the replenishment goods is not confirmed yet",
    "BianJiGouWuChe": "Edit cart",
    "Ge": "pcs",
    "GeShu": "Quantity",
    "KeHuZiDingYiWenTi": "Customer's questions",
    "DanWei": "Unit:",
    "BaoCunGouWuCheShuJuYiC": "When saving arose inconsistencies",
    "ShuJuChuLiYiChangQingShuaX": "Data processing is abnormal, please refresh the page",
    "TianJiaYiHang": "Add a line",
    "ShangPinBianMaLuRuYouWuQingHeDui": "The item number is incorrect, unable to get the loaded amount, please check",
    "QingJiangShangPinXinXiTianXieWanZ": "Please complete the product information",
    "ZhuangLiangBuYunXuBianJi": "Can't edit the amount of goods",
    "BianHaoHuoMingCheng": "Please enter the order number",
    "ChengGongQuXiaoCaiGou": "Successful cancellation of the procurement",
    "PiLiangTianJiaShangPin": "Import items from excel",
    "TianXieShangPinXinXi": "Fill up product info",
    "BianHaoHuoZheMingChen": "Number or name",
    "DanYuanGeBiXuShiWenBenGeS": "Table cells must be in the text format",
    "XiangQingYeWuQuanXianTiShi": "This item is new. To view it you must log into your account. Account activation will take 1 to 3 working days. Please ensure that your contact details are correct. We will contact you soon!",
    "XuanZeShangPin": "Please, choose items",
    "Wu": "No",
    "JiXuPinGui": "Continue to consolidate",
    "HeDuiXinXi": "Check the information",
    "ShangPinSuoZaiLeiMu": "Product belongs to category",
    "DengLuXinLai": "New To ESSA?",
    "ZaiTuWeiHuoDeShouHuoRiQiC": "The arrival date for the remaining products{0} is later the estimated loading date.",
    "TuanGouShangPinDeShouHuoR": "The delivery date of group purchase product exceeds the estimated loading date",
    "DuoXuan": "Choose more",
    "ZhaoBuDaoGaiYeMian": "Sorry,this page could not be found.",
    "NiKeNengXuYaoHuiDao": "You may want to go back to the",
    "HuoZheQu": "or go to",
    "YiChangShangPinYiBeiChuLi": "Inconsistencies resolved. Please refresh page to view",
    "NinHaiYouShuXingMeiYouXuanZe": "Some properties haven't been set",
    "NKuanShangPing": "{0} items",
    "DingGouLiangDanWeiXiang": "Quantity (Box)",
    "GeShuDanWeiGe": "Qty (pcs)",
    "ChengGongTiJiao{0}KuanDaoChu{1}BuNengDaoChu": "Successfully exported {0} of art. You cannot export {1}",
    "ChengGongTiJiao{0}KuanTiWen{1}BuNengTiWen": "Successful submission of the  {0} product, wherein the product {1} is not a question of",
    "ChengGongTiJiao{0}KuanShanChu{1}BuNengShanChu": "Successfully deleted{0}items, wherein the product{1}cannot be deleted",
    "ShouCangShangPin": "Favourites",
    "TianJiaGouWuCheChengGongHuoDongYiDaCheng": "Successfully added to the cart. Promotion has been reached, please proceed to the shopping cart to confirm the purchase",
    "GouWuCheYiYou{0}{1}": "Now in the cart there is qty {0} of item {1}. Do you need to change the qty for the original number?",
    "CiKuanHuoDongShangPinHuoDongYiDaCheng": "The conditions of the promotion products are reached, please add to the cart and confirm purchase",
    "CiKuanHuoDongShangPinNinYiQueRenGouMai": "You confirmed to buy the promotion product, please check or adjust the carton quantity in the cart",
    "YiChuHuoDongWeiDaChengSha": "Attention: the item {0}  is not available, or its promotion conditions are not satisfied, so it cannot be consolidated and has been moved back to your cart.",
    "HuoDongXiaoShouMOQBuNengXiaoYu": "The purchase quantity can not be less than the Min.Order",
    "ZiDingYiWenTiZiShuBuNengC": "Custom problem word count cannot exceed{0},{1}",
    "QingWenNinSanChuDeYuanYinShi": "Please tell us the reason of delete",
    "DaiHuiFu": "Reply",
    "YouHuiFu": "There is a reply",
    "QingRenZhenTianXieYiXiaZiLiaoBaoZhengNeiRongZhenShi": "Please fill in the following information to ensure the content is true. The electronic mailbox must be valid, create the post through the email verification to complete registration",
    "WoMenJiangHuiTongGuoNinDeXinXiHuoZheDianHua": "We will pass your information or telephone contact you for follow-up audit, non-toy or daily necessities buyers will cancel the membership",
    "HuanYingLaiDaoEssa": "Welcome to www.essa.cn!",
    "NinKeYiChaKanChanPinDeJiaGe": "1. You can see <b>the price for any item</b>",
    "NinKeYiHuoQuDaoZuiXinDeChanPinXinXi": "2. You can get <b>the latest product information</b>",
    "WoMenJiangBuDingQiGeiNinTuiSongZuiXinDeYouHuiHuoDong": "3. We will send you <b>the latest promotions</b>",
    "ZhuCeChengWeiEssaHuiYuanNinJiangKeHuoDe": "Becoming ESSA user, you will be able:",
    "GongXiNinYiTiJiaoChengGong": "Congratulations, you have submitted successfully!",
    "JiDanShangPinMeiYouZaiJiD": "The items {0} are not in the \"New pre-sale products\" promotion",
    "HuoDongShangPinXuYaoManZuH": "Promotion products should meet MOQ {0}",
    "MiaoHou": "In {0} sec.",
    "NinDeZhangHou": "Your Account",
    "1059PR10019": "This e-mail had been already registered",
    "WeiDengLuHuoWeiRenZhengQingRenZhengHouChaKan": "Not logged in or not authentication users, please login first or wait after authentication is required for the product core price",
    "WoDe": "My",
    "DingDan": "Order",
    "RenZhengHuoYongHuCaiKeCan": "Only verified or VIP users can participate in promotion products, please timely contact your clerk for verification.",
    "YiTiWen": "Already put questions to",
    "YiQueRenCaiGouDeHuoDongSh": "Confirmed promition products can not be re-added to the cart",
    "GaiBanWenTi": "Revised edition questions",
    "BuZhiChi": "Unsupport",
    "WoMenDeHeZuoHuoBan": "Our Partners",
    "100AnQuan": "100% safe",
    "GongChangJia": "Factory price",
    "GaoXiaoBianJie": "Efficient and convenient",
    "ShiPinJieShao": "Video presentation",
    "QingXuanZeNinSuoZaiDeGuoJ": "Please select your country",
    "DingWeiGuoJia": "Location country",
    "DingWeiShiBaiQingShouDong": "Positioning failed, please manually select your country or refresh",
    "ZhengZaiDingWeiZhong": "Localization",
    "QingXuanZeGuoJia": "Please select a country/ region",
    "NinHaoNinShiGuoJiaCaiGouS": "Hello, you are {0} countrie buyer, has helped you navigate to {1}",
    "HuanYiPi": "Show another pictures",
    "ZuiJinFangWenGuoJia": "Countries that recently reviewed the website",
    "HuiYuanQuanYi": "Membership benefits",
    "MianFeiChaKanJiHeDuiShangPinJiaGe": "Free preview and price comparison of the goods",
    "ChaKanZuiXinChanPin": "View new products",
    "DingQiHuoQuYouZhiShangPinTuiJian": "Regularly receive recommendations for products of excellent quality",
    "ChaZhaoShangPin": "Product search",
    "ShangPinGuanLi": "Product management",
    "ZuZhiChuHuoJiHua": "Organize shipping plan",
    "ChaKanDingDanShengChanGuoCheng": "Tracking order",
    "FuKuanShouHuo": "Payment and Receipt",
    "YiZhanTiaoXuanShangPin": "The selection",
    "FenLeiChaZhao": "Search on category basis",
    "XiangSiKuanDuiBi": "Comparison of similar models",
    "RuHeChaZhaoShangPin": "How to find the goods?",
    "ShangPinZiZhuGuanLi": "Self-service product management",
    "ZiDongHeJia": "Automatic calculation",
    "GuanLiShangPin": "Product management",
    "GouWuCheGuanLi": "\"Cart\" management",
    "ShouGeZaiXianPinGuiDeJiaoYiPingTai": "The first online trading platform that supports container consolidation.",
    "GenJuJiHuaZiWoZuZhuang": "Organize self-assembly as planned",
    "SheZhiYiXiangZhuangGuiShiJian": "Set up your own loading time",
    "SheZhiTieZhiMaiTouXinXi": "Set up the stickers and the marks information",
    "RuHeJinXingPinGui": "Items for consolidation",
    "QueRenDingDanXinXi": "Place order",
    "ZhiDingShengChanYaoQiu": "filing your customize requests",
    "LiaoJieDingHuoYaoQiu": "Ordering Requirements",
    "ChaKanShengChanJinDu": "Viewing the progress of production",
    "WeiNinLiuXiaFanKuiXinXi": "We leave feedback information for you",
    "24XiaoShiSuiYiChaKanZuiXinDongTai": "Feel free to view the latest dynamic during twenty-four-hours",
    "ChaKanZhiJianTuPianJiXinXi": "View the inspection images and the information",
    "NinDeDingDanYiJingShengChanWanCheng": "The production of your order is completed",
    "HuoYunYiJingDaoGang": "The cargo arrived at the port",
    "TiDanDianFangZaiXianChaKan": "Telex release",
    "DingDanLiuCheng": "The order process",
    "PoDanLieBiao": "The list of orders",
    "GongSiShiLi": "The strength of the company",
    "ZhengShuBaoZhang": "Certificate guarantee",
    "BaoZhangTiXi": "Security system",
    "KuaiSu": "Reliability",
    "GaoXiao": "Highly effective",
    "ZhuZhan": "Toys sourcing & wholesale | ESSA.CN Your Best Toys Soucing Expert",
    "ZhuZhanFuWuXiangQing": "The Main station services details",
    "AnBianHaoJingZhunSouSuo": "Accurate search",
    "CaiGouWanJu": "Purchasing toys",
    "CaiGouRiYongPin": "Purchasing consumer products",
    "ReMenTuiJian": "Top recommendations",
    "TuiJianMa": "Coupon Code",
    "TuiJianMaWuXiao": "Coupon code is invalid",
    "YiZhuCeChengGong": "Registration has been successfully completed",
    "QingShuRuTuiJianMa": "Please enter the coupon code",
    "BuYingYongTieZhi": "No need to apply the sticker",
    "BuYingYongMaTou": "No need to apply the marks",
    "ZhongXinJiHuoQingLianXiNi": "For reactivation, please contact your network operator. How you can contact your center operators, see here:",
    "DengLuXiTong": "Login system",
    "ShuBiaoYiRuNinDeZhangHao": "Move the mouse over \"Your account\"",
    "JinRuHuiYuanZhongXinShouY": "Log in to the Member Center",
    "ZhiJieQuHuiYuanZhongXinSh": "Go to the member center",
    "NinYiJiHuoChengGongQingBa": "You have successfully activated, please go to your mail box or mobile phone and keep refreshing until you see an email from the essa certification, thank you.",
    "RuoMeiNengJiShiWeiNinRenZ": "If you have not received a confirmation from essa, maybe you will not be able to see the prices for a short time, wait patiently, we apologize for any inconvenience.",
    "LiuLanShangPin": "Browse products",
    "NinShiYongZhuCeYiChengGon": "Your registration experience is matched with 7-day experience time, and please valid your account forever during this period.",
    "ZhuYiXiaoShiHouRuoBuJiHuo": "Please note that if you not valid your account within 7 days,which should be downgraded,leading your not able to check special ESSA commodity or any price.",
    "JiHuoChengGong": "Successfully activated",
    "JiHuoShiBai": "Activation error",
    "QingXianXuanZeTieZhi": "Please select the stickers",
    "QingXianXuanZeMaTou": "Please select the shipping marks",
    "QingXianSheZhiTieZhi": "Please set up the stickers",
    "QingXianSheZhiMaTou": "Please set up the shipping marks",
    "SheZhiMaTouXinXi": "Set up marks information",
    "SheZhiTieZhiXinXi": "Set up stickers information",
    "YuLanDingDan": "Order preview",
    "ShangYiBu": "The previous step",
    "ZanShiBaoCun": "Temporarily save",
    "ZanShiBaoCunChengGong": "Temporarily saved successfully",
    "ZhengZaiBaoCun": "Saving...",
    "BuZhouYiQueRenNinYaoShiYo": "Step one: Make sure about your shipping marks (if you cant find the right shipping marks, please contact our consultant).",
    "TianJiaMaTouMoBan": "Add shipping marks template",
    "XuanZeMaTouYangShi": "Select the mark type",
    "NinDeMaTouYangBan": "Your shipping marks model",
    "WuMaTouYangShi": "No marks template!",
    "BuZhouErGouXuanNinYaoShiY": "Step two: Put a tick against corresponding marks of the goods which would you use",
    "TieZhiBuZhouYiQueRenNinYaoShiYo": "Step one: Make sure about your shipping marks (if you cant find the right shipping marks, please contact our consultant).",
    "TianJiaTieZhiMoBan": "Add stickers template",
    "NinDeTieZhiYangBan": "Your stickers type",
    "WuTieZhiYangBan": "No sticker template!",
    "TieZhiBuZhouErGouXuanNinYaoShiY": "Step two: Put a tick against corresponding stickers of the goods which would you use",
    "TiShiTongYiKuanShangPinZh": "Note: On the same item set one mark",
    "TieZhiYangBanYuLanRuXia": "Stickers template preview are as follows:",
    "MaTouYangBanYuLanRuXia": "Marks template preview are as follows:",
    "NinHaoZiZhuSheZhiTieZhiMa": "Hello, the function for automatically set the marks and stickers is not available yet, please contact your consultant to help you add, thank you.",
    "BaoCunTieZhiYiChang": "Failed to save the stickers",
    "BaoCunMaTouYiChang": "Failed to save the shipping marks",
    "DingDanZongJiaWei": "Total",
    "MaiTouXinXi": "Marks information",
    "TieZhiXinXi": "Stickers information",
    "NinBenCiBianJiDeTieZhiMaT": "You edited the sticker and mark information will not save! Are you sure you want to return?",
    "HaiMeiYouMaTouTieZhiYangB": "Still no have stickers and marks model, please contact our consultant and send him all the materials and requirements",
    "QingShuRuMingCheng": "Please enter the name",
    "YiChangLieBiao": "Abnormal items",
    "ZhengZaiShenHeZhongBuKeXiuGai": "Verification process",
    "WuMaTouYangBan": "No marks model",
    "TiShiTongYiKuanShangPinKe": "Reminder: For the same goods you can set different patterns of stickers",
    "WoShiMaiJia": "我是工厂",
    "ZhongYangBanYuYeMianBuYiZ": "The template in the excel table and on the web page do not match, please re-download the template",
    "WeiChanShengFeiYongJiJiangFanHuiPO": "Payment is not required, go to ordering for more information",
    "QingXuanZeTieZhiYangShi": "Please select the sticker type",
    "QingXuanZeMaTouYangShi": "Please select the mark type",
    "MoBanYouWuQingZhongXinXia": "Template error, please download again and upload the correct version",
    "QingJiangTieZhiXinXiTianX": "Please enter the stickers information",
    "QingJiangMaTouXinXiTianXi": "Please enter the marks information",
    "QuShouYe": "Home Page",
    "WeiRenZhengWuFaXiaPinGuiXiaDan24XiaoShiNeiHuiLianXiNin": "Sorry, your account has not been verified, so you cannot consolidate and place orders. ESSA will contact you within 24 hours, please keep your phone and E-mail available.",
    "QingLianXiNinDeZhuanShuYeWuKeFuJinXingZiXun": "Please feel free to contact VIP customer service personnel at any time if there is any problem!",
    "ShiYongCaiGouShang": "Trial account",
    "YuZhuangJuRiQiYiChang": "Estimated loading date error",
    "GongChangDingGouLiangBuZu": "Insufficient volume for factory Min.Order",
    "GongChangQuXiaoShengChan": "The factory canceled the order",
    "YinWuLiaoCaiGouYiChangQuX": "Order has been cancled - Insufficient production materials",
    "ZhengZaiYiChu": "Removing",
    "ZhengZaiTianJia": "Adding",
    "LiShiYiChangQuXiaoJiLu": "History record of cancelled items",
    "YiChangQuXiaoJiLu": "Record of cancelled items",
    "QuXiaoYuanYin": "Cancel reason",
    "QuXiaoShiJian": "Cancel time",
    "ZongGeShuDanWeiGe": "Total canceled quantity",
    "WoShiNinDeZhuanShuKeFuKeYiYuWoLianXi": "I am your sales consultant, please feel free to contact me if there is any problem",
    "CongYeJingYan": "Experience",
    "ShuXiYuYan": "Language",
    "ZhuGongShiChangQuYu": "Target market",
    "CongYeHangYe": "Industries",
    "GeRenYouShiJiFuWuBeiZhu": "Personal skills",
    "ZiWoMiaoShu": "Profile",
    "NNianGongZuoJingYan": "{0}years",
    "DianJiChaKanGengDuoZiLiao": "Click to see more information",
    "XiaoShouGuWen": "Sales consultant",
    "ZhengZaiXiaZai": "Downloading",
    "ShuangJiKongBaiBiaoGeJinR": "1. Please get into edit mode by a click on the blank sheet (Note: You cannot edit, copy or paste non-blank cell).",
    "BiaoGeZhiChiJianPanFuZhiH": "2. Hotkeys Ctrl+C (copy) and Ctrl+V (paste) are available",
    "BiaoGeZhiChiDuoXuanDanYua": "3. Multiple selected for \"copy and paste\" is available",
    "ZhiChiCongZhongDuoGeDanYu": "4. Using \"Ctrl+C\" to copy multiple cells and using \"Ctrl+V\" to paste content to the table",
    "YinWuLiaoCaiGouYiChangBuNengXiaDan": "Sorry, the order can not be processing due to the insufficient manufacturing supplies",
    "GongChangYiQuXiaoShengChanBuNengXiaDan": "You cant place the order due to the cancelation issused by manufacturer",
    "ZuoTian": "Yesterday",
    "YongHuFangWenLiang": "Users that recently reviewed the website",
    "GuoJiaFangWenLiang": "Countries that recently reviewed the website",
    "WoZhiDaoLe": "I get it",
    "XiaoShouGuWenXiangQing": "Details",
    "MoSiKeFuWuBu": "Office in Moscow",
    "QuXiaoXiangShu": "Cancel  boxes",
    "ShengChanQuXiao": "Cancel production",
    "DingDanBianHao": "Order number",
    "CaoZuo": "Operation",
    "XiaDanShiJian": "Order time",
    "ShangPinLaiYuan": "Merchandise source",
    "ShangPinLeiXing": "Type of goods",
    "KuaiSuBiJia": "Price comparison",
    "DeGongChangKuChanPinKuYiJ": "Essa cooperated with more than 20 000 Chinese manufacturers,",
    "QingShuRuGongYingShangMin": "Please enter the supplier's  name, brand name,factory's item No.,or product keyword",
    "RuHeBiJia": "How to make a price comparison?",
    "DiYiBuJingZhunSouXuanShan": "Conform your products",
    "DiErBuQuXunJia": "Go request inquiries",
    "DiSanBuGouWuCheHuoQuGongY": "Add the items to your cart to receive the updated prices from manufacturers",
    "DiSiBuDaoChuBaoJiaDanBiJi": "Export quotation sheet for comparison",
    "DeWanJuKuanShiDouZaiZheiL": "We guarantee 80% of toy designs can be found at ESSA.CN!",
    "DiYiBu": "Step 1:",
    "DiErBu": "Step 2:",
    "DiSanBu": "Step 3:",
    "DiSiBu": "Step 4:",
    "GuoQuYiTianWanGongChangZh": "{0} factories updated their {1} new products yesterday (Partner manufacturers: 20,000)",
    "GuoQuYiZhouWanGongChangZh": "There were {0} factories updated {1} new products last week(Partner manufacturers: 20,000)",
    "GuoQuYiGeYueWanGongChangZ": "{0} factories updated {1} new products last month(Partner manufacturers: 20,000)",
    "ZhongTiJi": "Total canceled volume",
    "TiShiShangPinYouDuoKuanSh": "Reminder: You can add more samples of the marks, if the goods have several models",
    "TiShiKeXuanZeDuoGeTieZhiY": "Reminder: you can choose several models of stickers",
    "ZhuYiZongGeShuHeDingGouLi": "Note: total number and subscription amount can only choose one to fill in from Excel at the same time Ctrl+V to paste the two columns comes in, will be total number of subject to calculate the order amount total number=(pack x capacity)",
    "GongYingShangMingCheng": "Supplier",
    "DengYu": "equal to",
    "DaYu": "more than",
    "KuanXiangSi": "{0}similar",
    "ChaKanQuanBuXinPin": "View all new products",
    "XinPinBaoHu": "New product",
    "CiShangPinShuYuXinKuanBao": "Your account is in the approving now, please be patient for waiting !",
    "GongZuoShiJianNeiFenZhong": "To get fast approved in 5mins within working days",
    "FeiGongZuoShiJianYuJiXuYa": "Now it is non-working hours, it takes around 2 working days to complete your certification.",
    "QingLianXiNinDeXiaoShouGu": "You can also contact your sales consultant {0} to complete your certification.",
    "GengDuoShaiXuanXiang": "More options for the goods selection",
    "RenZhengYongHuKeJian": "Visible for certified user",
    "ChaKanJiaGeQingXianDengLu": "To view prices, please register",
    "RenZhengHouKeJianJiaGe": "Prices will be visible after confirmation",
    "ZuiJinYiGeYue": "The latest month",
    "JiaGongChangShangXinLeKua": "{0} manufacturers updated {1} products",
    "ZuiJinYiGeYuePinPaiShangX": "New Brands Latest Month",
    "ChuHuoQuYu": "Delivery  area",
    "XinZeng": "updated",
    "BaoZhuangFangShi": "Packaging",
    "XiaoYuDengYu": "Less than or equal to",
    "XinPinQingBao": "New arrival",
    "GongYouJiaGongChangKuanXi": "Total {0} manufacturers have updated {1} new products",
    "CunZaiBuFuHeTiaoJianDaoRu": "Below products have some problems that can not import to the cart.",
    "NinZhangHaoDengJiBuNengCh": "Can't find eligible items",
    "KuanXinPin": "{0}new products",
    "PinPaiLeiXing": "Brands screening",
    "WoGuanZhuDePinPai": "Brands follow with interest",
    "TuiJianPinPai": "Brands recommendation",
    "XinPin": "NEW",
    "XiangSiKuanShuLiang": "Quantity of similar",
    "ChanDiQuYu": "Place of origin",
    "QuanBuShangPin": "All items",
    "KePinJu": "Consolidation allowed",
    "HuoDongShangPin": "Promotion items",
    "QingYouXianChuLiYiXiaShan": "Please prioritize the following items",
    "NinCanJiaDeJiDanHeTuanGou": "Due to the promotion \"New products pre-sale\" and \"Group purchase\" you participated in, if the item quantity meets the conditions, we will place the order for production. Please confirm.",
    "SanTianNeiBuQueRenCaiGouX": "Within three days, the system will automatically cancel the procurement if it has not been confirmed.",
    "ZhuTi": "Theme",
    "ShiXiao": "Invalid",
    "GuoQi": "Expired",
    "TianJiaJinGouWuCheShiJian": "Time when added to the cart",
    "GuoQiShangPinQingJinKuaiP": "Please inquire again for the Invalid items, and consolidate ASAP",
    "YiQueRenDeHuoDongBuNengSh": "The confirmed promotion cannot be deleted, please remove the check mark",
    "YiJiang": "Decreased",
    "YiSheng": "Raised",
    "GaiKuanShangPinZhengZaiDe": "This product needs reply from the factory, and 1-2 workdays are needed predictably",
    "XinPinYuShou": "Pre-sale",
    "YiQueRen": "Factory Confirmed",
    "TianHouZiDongShanChu": "Automatically deleted after {0} days",
    "ShangPinXinXi": "Product information",
    "ZhongXinChuJia": "Negotiation",
    "NinDeGouWuCheMeiYouShangP": "Your cart is empty",
    "HuoDongZhuangTai": "Promotion Status",
    "XunJiaZhuangTai": "RFQ status",
    "YiXiaShangPinWeiGouWuCheL": "Below are all items in the cart",
    "YiXiaShangPinWeiHuoDongSh": "Here are the promotion items",
    "YiXiaShangPinYiManZuPinJu": "The following items can be consolidated",
    "YiXiaShangPinYiXunJiaWanC": "The following items have been successfully inquired or met the promotion conditions. You can consolidate and place an order.",
    "XunJiaHouYiXiaShangPinYou": "The following items have changed after quotation",
    "YiXiaShangPinKeNengShiJia": "Please prioritize the following items due to the changes of price after you quoted. Please confirm the latest information before placing an order.",
    "GongKuanDaiQueRenCaiGouDe": "{0} items need to confirm totally",
    "PiLiangShanChu": "Bulk delete",
    "PiLiangTiWen": "Ask questions in bulk",
    "PiLiangDaoChu": "Bulk export",
    "PiLiangDaoRu": "Bulk import",
    "QingChuShiXiaoShangPin": "Remove invalid items",
    "ChaKanKePinJuShangPin": "See the items for consolidation",
    "PiLiangJieShou": "Bulk accept",
    "KaiShiPinJu": "Start consolidation",
    "DaoChuBaoJiaDan": "Export quotation",
    "QueDingCongGouWuCheZhongS": "Remove all the selected items from the cart?",
    "QueDingCongGouWuCheZhongQ": "Remove from the cart all the invalid model?",
    "NinKeYiDiaoZhengJiaGeHuoD": "You can adjust the price or order quantity, then negotiate with the supplier",
    "TuanGouQiaTanZhong": "Group purchase is in negotiation",
    "TuanGouShiBai": "Group purchase failed",
    "TuanGouChengGong": "Group purchase succeeded",
    "XinPinYuShouZhong": "New products pre-sale",
    "XinPinYuShouQiaTanZhong": "New products pre-sale is in negotiation",
    "XinPinYuShouShiBai": "New products pre-sale failed",
    "XinPinYuShouChengGong": "New products pre-sale succeeded",
    "CanKaoJia": "Proposed price",
    "MeiYouSheZhiZhuTiDeShangP": "Products without subject",
    "SheZhiZhuTi": "Set the subject",
    "QuanBuShuXing": "All properties",
    "QueDingJieShouSuoYouXuanZ": "Accept all selected products? Please, confirm",
    "GongTiWenLeGeWenTi": "Ask {0} question(s)",
    "QiTaCaiGouShangDaiLiShang": "Other agent products from buyers",
    "QiTaCaiGouShangZhuanShuSh": "Other buyers exclusive items",
    "XiaJiaShangPin": "Item unavailable",
    "XinPinYuShouShiBaiShangPi": "Failed pre-sale products",
    "YiQueRenGouMaiDingGouLian": "Confirmed already, please adjust PO amount in the cart",
    "WuShangPinChaKanQuanXianQ": "You have no access to the product information, please contact your account manager for advice",
    "ZhuYiHeBingDaoXinZhuTiDeS": "Notice: the product added to new subject will be moved from the original subject",
    "ChuangJianXinZhuTi": "Create a new subject",
    "JiaRuYiYouZhuTi": "Add an existing subject",
    "QingShuRuZhuTi": "Please enter a subject",
    "ZhengZhuang": "Assembled",
    "FenZhuang": "Package in smaller quantities",
    "WuZhuTi": "Without subject",
    "ShengYuQueRenShiJian": "The remaining confirmation time{0}h",
    "KaiShiShiJian": "Start time",
    "JieShuShiJian": "End time",
    "BaoZhuangLeiXing": "Package",
    "YinHuoDongYiDaChengWeiJiS": "Promotion is achieved, but you failed to confirm PO promptly",
    "ShangPinYiZhongXinFaQiYiJ": "Price of the item has been renegotiated.",
    "ShangPinYiXiaJia": "Item unavailable",
    "YinShangPinYiJingCanYuHuo": "Promotional items cannot be consolidated",
    "GongKuanShangPinKeYiPinJu": "Total {0} item(s) for consolidation",
    "QingJinKuaiZaiShangPinXia": "Please confirm procurement  within the limited time, otherwise it will be canceled after countdown by the system automatically",
    "HuiLvBianHua": "Currency movements",
    "JiaJiaLvBianHua": "Markup percentage movements",
    "ShangPinTiJiBianHua": "Volume of products movements",
    "ShangPinZhuangLiangBianHu": "Volume capacity movements",
    "ShangPinZhongLiangBianHua": "Product weight change",
    "ChangGuiBaoJiaDan": "General price list",
    "ShangPinChuHuoCangMoRenWe": "The place of loading warehouse refers to the place of origin by default",
    "ZhiDingShangPinBaoJiaFang": "Price list is exported with the chosen items' quotation",
    "ShangPinChuHuoJiangAnSuoX": "The offer is based on the cargo's loading warehouse, loading port,container type, which may affect the FOB shared charge and cause short-distance freight.",
    "GaiShangPinYiGuoJiaGeBaoHuNC": "The price is invalid and the item will expire in {0} days",
    "YuanWaiXiangZhuangLiang": "The original quantity of box",
    "ShangPinYiPinRuZaiHaoHuoJ": "This item has been already added to the container No.{0}, please remove first",
    "ShangPinYiZaiDingDanZhong": "The item is under replenishment, please remove from the replenishment pool",
    "CunZaiShangPinBuNengShanC": "The existing items can not be deleted, please check again",
    "FOBJunTan": "FOB shared charge",
    "ShangPinBaoJia": "Item offer",
    "ZanShiMeiYouShiXiaoBaoBei": "No invalid item",
    "JiaGeBiYuanJiaGeGaoShiFouYiJia": "The current price is higher than the original price, will you continue to negotiate?",
    "WanJuCaiGouPiFaYiGeChiXuG": "Toys sourcing & wholesale | A toy platform offering new toys",
    "HuoDongShangPinBuXiaoYuN": "The order quantity of promotional goods can not be lower than promotion min.order：{0}",
    "QingXuanZePinGuiDeZiYuan": "Please choose items for consolidation",
    "ChanDi": "Place of origin",
    "KePinLiang": "Volumn available of consolidation",
    "GouWuCheShangPin": "Items in the cart",
    "YiRu": "Add",
    "YiPinLiang": "Volumn used of consolidation",
    "WeiManZuCaiGouTiaoJianShangPin": "The purchase requirement is not reached",
    "BaoJiaGuiZe": "Quotation rule",
    "BaoJiaGuiZe1": "Standard quotation rule of EXW",
    "BaoJiaGuiZe2": "Item quotation: produced and loaded at the same place",
    "BaoJiaGuiZe3": "Standard quotation rule of FOB",
    "BaoJiaGuiZe4": "When the place of origin is Shantou",
    "ShanTouZuHeBaoJia": "Shantou(loading warehouse)-Shantou(shipping port)-40HQ(container) combined price",
    "BaoJiaGuiZe5": "When the place of origin is Guangzhou",
    "BaoJiaGuiZe6": "When the place of origin is Yiwu",
    "GuangZhouZuHeBaoJia": "Guangzhou(loading warehouse)-Guangzhou(shipping port)-40HQ(container) combined price",
    "YiWuZuHeBaoJia": "Yiwu(loading warehouse)-Yiwu(shipping port)-40HQ(container) combined price",
    "BaoJiaGuiZeZhuYi": "Note:if the loading warehouse,shipping port,or container type changes, the FOB shared charge will be affected and might cuase short-distance freight( when the place of loading warehouse is different from the place of origin)",
    "BuFenShangPinBuFuHePinGui": "Some items do not satisfy the consolidation conditions, and have been moved out of your containers.",
    "BuYunXuPinGuiYuanYin": "Reason for refusing consolidation",
    "YiChuShiJian": "Time when removed",
    "BuFuHePinGuiKuan": "{0} items below do not reach theconsolidation conditions, and have been moved out of your containers.",
    "YiXiangBangZhu1": "1.Preferred loading time: start counting the time of consolidation from now",
    "YiXiangBangZhu2": "2.Due to shipping mark,booking cargo and tranport need,at least 15 days are needed for shipment. If the maximum time of shipment + preparing time are more than 15 day, the preferred loading time can be adjusted.",
    "YiXiangBangZhu3": "3.If preferred loading time is earlier than the general delivery time, the preferred loading time might not be satisfied.",
    "YuanJia": "Original price",
    "HuoGui": "Container",
    "CartMeiYouPinGuiShangPin": "No items for consolidation in the cart",
    "XiaYiBuSheZhiTieZhiMaiTou": "Next, set a sticker",
    "HuoDongShangPinBuZhiChiYiJia": "Negotiable price unavailable for the promotional items",
    "TiaoZhengJiaGeHuoDingGouLiang": "Negotiable price available if price or quantity is adjusted",
    "WeiTongGuoRenZhen": "Your account has not been verified. Thus after verification,we will inquire the supplier of the price according to your preferred purchase price and quantity. Please wait patiently.",
    "WoDeZhuangGuiRiQi": "My preferrd loading date",
    "ShangPinZhuangGuiRiQi": "Estimated loading date of this item",
    "ZuiDaKePinLiang": "Maximum volunm of consolidation",
    "ShangPinGuoQiQingJinKuaiPinGui": "This item has expired, please consolidate ASAP, or this item will be deleted in {0} days.",
    "QiDingLiangBuZuQingTiaoZheng": "The minimum quantity for delivery is not met, so you cannot place the order. Please increase the quantity first.",
    "KePinRuLiangYiDaZuiDaJiXu": "Consolidation volumn has reached the maximum,please increase the item quantity before consolidating.",
    "QuGouWuChe": "Go to cart",
    "YiXiaShangPinBuYunXuDaoRu": "{0} items below can not be imported",
    "QingShuRuZhengZhengShu": "Please put positive interger number",
    "ShangPinBianHaoNYiCunZai": "The item No.{0} has already existed",
    "QingShuRuXiaoShuWeiNZhengShu": "Please put a positive number with at most {0} decimal(s)",
    "JiaZaiZhuTiShiBai": "Failed to load the subject",
    "XuanZeYiYouZhuTi": "Choose the existing subject",
    "XinZhuTi": "New subject",
    "QingShuRuBenCiTianJiaShangPinZhuTi": "Please put the new product subject",
    "BuYunXuDaoRuYuanYin": "Reason the failure in importing",
    "JiaGeBaoJiaFangShi": "Price (pirce term:{0})",
    "YiChangShangPinBuNengTiWen": "Abnormal goods can not ask questions, can not ask for quotes, please deal with the exception after the operation.",
    "GouWuCheNeiHaiMeiYouShang": "You have no items in your cart, you can search for items then add to the cart or import items in bulk",
    "PiLiangDaoRuShangPin": "Import items in bulk",
    "QiSongLiangBuZu": "Insufficient MOQ for delivery",
    "DangQianYiXiangZhuangJuRi": "The current expected loading date is too early, please adjust.",
    "WeiHuoGuoQiQingChuLi": "The delivery date is too long to suit your preferred loading date, please handle it.",
    "ZuiJinYiZhou": "The lastest week",
    "ZuiJinSanGeYue": "The latest 3 months",
    "QingShuRuTuiJianZhuTi": "Enter the recommendation subject",
    "TuiJianMiaoShu": "Description of the recommendation",
    "TuiJianShiJian": "Time of the recommendation",
    "ChaKanQuanBuShangPin": "View all items",
    "ShiXiaoShangPinBuNengCanJiaCaiGou": "Please handle the items that do not satisty the order requirements.",
    "CunZaiBuManZuXiaDanTiaoJi": "There are items you cannot purchase in the container, you can check it according to the suppiler classification. Please follow the guidance and handle it.",
    "JiaBaoNeiBuYiJiaJiangBuFa": "Inquiry will not be sent under price protection",
    "GongYingShangZaiShou": "On-sale items of the supplier",
    "WuYiChangTianJia": "In cart, the items can only be added after inquiry and without abnormality.",
    "GongYingShangWuKePin": "Now, there are no other items for consolidation, please increase the quantity of the added items or choose other items of this supplier. Please send inquiry first and add the item to the cart.",
    "JingPinTuiJian": "Selected recommendation",
    "HuoDongTuiJian": "Recommended promotion",
    "JingZhunTuiJian": "Accurate recommendation",
    "ReXiaoTuiJian": "Hot recommendation",
    "DaoChuShangPin1": "Export products",
    "YiXiaJiaBuNengTianJiaGouW": "{0} is out of stock and cannot be added to the cart",
    "CaoZuoShiJian": "Operating time",
    "QingShuaXinYeMian": "Please refresh the page",
    "QingXuanZeYuanYin": "Please choose reason",
    "QingXianXuanZePinJuShangP": "Please choose items for consolidation",
    "QingXianXuanZeHuoJuZhongS": "Please choose items in container first",
    "WuKePinJuShangPin": "No items for consolidation",
    "WuJiaGeYiChangShangPin": "No items with abnormal price",
    "WuHuoDongShangPin": "No promotion item",
    "HuoDongShangPinShengYuDeD": "The quantity or the replenishment quantity of the promotion item {0} does not meet the promotion Min.Order, please adjust",
    "GaiHuoDongShangPinShengYu": "The quantity or the replenishment quantity of this promotion item does not meet the promotion Min.Order, please adjust",
    "ZhuYiHuoJuBaoJiaFangShiCh": "Notice： FOB shared charge might be affected and short-distance freight might be caused if price term,warehouse,loading port,or container type changes..( short-distance freight might be caused if the place of warehouse is not the place of origin)",
    "GouWuCheNeiZanShiMeiYouSh": "No items in your cart now, you can import items in bulk or add items",
    "KeSheZhiNinDeYiXiangZhuan": "You can set your preferred loading date, we will negotiate with the factory, but it might not be achieved.",
    "DingGouLiangYiQueRenQieBu": "The purchase quantity has been confirmed and cannot be reduced. You can contact online customer service if you have any question.",
    "DingGouLiangZengJiaHouBuN": "You can only increase the quantity but not reduce, are you sure you continue?",
    "LiShiXiaDanHaiWeiZhuangJu": "Please deal with the product that has not been loaded in the previous orders",
    "WangJiMiMa": "Forgot password",
    "RiYongPinLeiMu": "Home supplies",
    "WanJuLeiMu": "Toy categories",
    "FenLei": "Categories",
    "BianJiTieZhi": "Edit sticker",
    "BianJiMaiTou": "Edit shipping mark",
    "ChaKanTieZhiMaTou": "See stickers of shipping mark",
    "WaiXiangChiCun2": "Box size",
    "ShouCangPinPai": "Favorite brand",
    "ShangPinXiangQing": "Product description",
    "ChanPinRenZhen": "Product verificationi",
    "CheJian": "Garage",
    "ZiYouZhanTing": "Self-owned showroom",
    "BanGongQuYu": "office area",
    "ShouQiGengDuoWenTi": "Fold the questions",
    "ZhanKaiGengDuoWenTi": "Unfold to see more question",
    "HuoDongMuBiaoXiangShu": "Carton quantity of activity target",
    "YiDaChengHuoDongMuBiaoXiangShu": "The target quantity of the promotion has been reached",
    "HaiChaXiangShu": "still need (carton)",
    "TuanGouTip2": "The product of group purchase reached the promotion requirement. ESSA is negotiating with the supplier, please add to the cart and confirm the carton quantity.",
    "TuanGouTip1": "This item is in group purchase promotion, the earlier you add, the cheaper you get.",
    "YuShouTip2": "The product of pre-sale new arrivial reached the promotion requirement. ESSA is negotiating with the supplier, please add to the cart and confirm the carton quantity.",
    "YuShouTip1": "This item is now on pre-sale new arrival promotion, the earlier you add, the cheaper you get",
    "YiShouZangShangPin": "Favored item",
    "YiShouZangPinPai": "Favored brand",
    "PinPai": "Brand",
    "HuoDongGuiZe": "Promotion rules",
    "NinYiChengGongDengLuQingX": "Sign in successfully, please choose your sale consultant",
    "NinZhiQianYiXuanZeLeXiaoS": "You have chosen your sales consultant, you will go to home page after page refreshes.",
    "KeCanGuan": "Visitable",
    "BaoZhuangXingShi": "Packaging method",
    "NeiRongWeiKong": "Null content. Please contact our staff for template",
    "DangQianWuKeYongDeMaTouYa": "No sticker pattern available now. If you need stickers, please send your sticker pattern to your sales assistant by email or other ways.",
    "DangQianWuKeYongDeTieZhiY": "No sticker pattern available now. If you need stickers, please send your sticker pattern to your sales assistant by email or other ways.",
    "ZhuCeTiaoJian1": "I agree and obey",
    "ZhuCeTiaoJian2": "<Buyer registration on ESSA and terms of service>",
    "ZhuCeTiaoJian3": "Please read and choose whether to agree to the above registration terms",
    "WeiZhaoDaoFuHeTiaoJianDeDingDan": "No eligible order is found. Please enter the order number again.",
    "PingTaiZhuCeJiFuWuTiaoKuan": "Buyer registration on ESSA and terms of service",
    "YuanGongZhangHaoWeiKong": "You can create an account for employees. This account can be used for log-in, selecting product, quotation, exporting price list, consolidation & orders, etc.",
    "DianWoTianJia": "Click here to add",
    "WanShanZiliaoKeZengJiaXinYuDu": "Completing information for better credibility",
    "QingXuanZeYiXiangCaiGouShangPin": "Please select your favorite purchase categories",
    "QingXuanZeZhiWu": "Please select a position",
    "DanPinShengChanYaoQiu": "Special requirements",
    "GongChangFanKuiJiLu": "The record of the reply from factory",
    "ChaKanFanKuiJiLu": "Record of feedback",
    "QingShuRuShengChanYaoQiu": "Please enter\\special requirements for products",
    "TeShuShangPinShengChanYaoQiu": "Special production requirements for products",
    "WeiHuoShangPinBuNengChongSheShengChanYaoQiu": "Notice: Production requiremenrs cannot be made for the remaining products. Please contact us if you have any non-production requirements.",
    "GouWuCheZhongDeZiDingYiWenTi": "Questions about the items in the cart",
    "WenTi": "Questions",
    "HuiFu": "Reply",
    "ZuiDuoShuRu1000GeZiAo": "No more than 1,000 words for special production requirement",
    "KeHuHuoHao": "Client's item No.",
    "QingShuRuShangPinBianHao": "Please enter the item No.",
    "QingShuRuGongChangHuoHao": "Please enter factory's item No.",
    "QingShuRuKeHuHuoHao": "Please enter client's item No.",
    "ZanWuFanKuiJiLu": "No record",
    "GongChangFanKui": "Reply from factoroy",
    "ShouQuan": "I agree",
    "BuShouQuan": "I don't agree, you should inform me.",
    "NinKeYiZhenDuiBenCiDingDa": "For example, battery specification, packaging and ect.",
    "ChangGuiShengChanYaoQiu": "Production requirement for factory",
    "QingXianSheZhiDingDanXian": "Please set the order requirements first",
    "TieZhiMaTouXinXiHeDui": "Confirm the sticker information",
    "QingXuanZeShouQuanFangShi": "Choose the  authorization way",
    "ShengYuKePinXiangShu": "The remaining container(s) for consolidation",
    "YiPinXiangShu": "{0} container(s) have been consolidated",
    "ZuiDuoShuRuZi": "Maximum {0} words",
    "RuGuoNinBenCiDingDanZhong": "You can special production requirements for the some items in the order. ESSA will follow up the production progress strictly in accordance with your requirements.",
    "NinYiJingShenQingBuHuoSha": "You have applied for replenishment , ESSA is handling",
    "FeiShengChanYaoQiu": "Notice of ESSA",
    "YiXiaKuanShangPinGongChan": "Replies from factories For the {0} item(s) below",
    "YouTiWenDeShangPin": "Products with question",
    "YouShengChanYaoQiuShangPi": "Item(s) with special requirements",
    "ShangPinDeTiWen": "Questions about products",
    "BuHuoJuTiJinEJiangYiZuiZh": "The amount of money will be recalculated and is subject to the replenish product in the final order.",
    "BuHuoShangPinZongJia": "Total amount of the replenishment",
    "DingDanYiChangYiBeiQiTaRe": "Abnormal orders have been solved by others",
    "QueRenBuHuo": "Replenishment confirmation",
    "QueRenBuHuoDingDan": "Confirm the replenishment information?",
    "BuHuoTiJi": "The volume of replenishment",
    "ZongKuanShu": "Total items",
    "BuHuoKuanShu": "The quantity of replenishment",
    "TianJiaNKuanBuHuoShangPin": "Total {0} product(s) for replenishment",
    "ChaoChuYuZhuangGuiRiQiShiFouBuHuo": "The production period exceeds the estimated loading date, so the cargo might not be loaded on the estimated loading date. Confirm to add the replenishment products?",
    "TianJiqQiTaBuHuoShangPinZhaoShangPin": "If your replenish other products out of the cartl, please first add to the cart and finish inquiry.",
    "LieBiaoKongXuanZeQiTaShangPinHuoXunJia": "The list is empty, please drop-down to choose other products as replenishment. If no product is chosen, please choose other products and add to the cart for inquiry, then finish replenishment.",
    "TiJiaoHouWoMenJiangXunJia": "After submitting, we will inquire to the factory",
    "QingXuanZeXingBie": "Please select gender",
    "ZhouJin": "Go into",
    "NinMeiYouFeiShengChanYaoQiu": "You didn't make any QC requirements or non-production requirements, such as consolidation,cargo placement and ect.",
    "FanKuiShiJian": "Time of feedback",
    "BuHuoChengGongJiangJinKua": "Successfully replenished. Please arrange production ASAP",
    "YiChangYiChuLiWanChengShe": "Abnormality has been solved, please set shipping mark and sticker before production",
    "ShaoHou": "Later",
    "QuSheZhi": "To set",
    "BingWuShangPinBuHuoChengG": "Abnormality has been solved",
    "KeKaoDeHeZuoHuoBanChengXinJiaoYi": "A reliable partner! Build a faith transaction",
    "LianXiWoMen": "Contact",
    "MouXieShangPinXuYaoZh": "1. Some of the cargos should be placed at the last row;",
    "ZhiJianTuPianXuYaoZhengMi": "2. QC pictures from the front, the side, and the back are needed.",
    "GuanYuShangPinZaiShengCha": "The factory will follow your requirements for production.",
    "LiRu": "For example",
    "NinDeShangPinQuanBuWeiWei": "You cannot make special requirements for the remaining cargo. Please make a note at “Notice of ESSA”if you have other requirements",
    "ShangPinYiZhongXinFaQiYiJPI": "Price of the item {0} has been renegotiated.",
    "YuZhuangJuRiQiTuiChiTongZ": "Notice: the postponement of the estimated loading date",
    "ZhuYiLiShiBianGengQingZai": "Attention: the previous estimated loading date has changed, please check out at the order tracking",
    "JiXuTuiChiYuZhuangJuRiQi": "Continue to postpone the estimated loading date",
    "DanDaoRuYiXiaShangPinDaoZ": "Due to the products transferred in the PO, the estimated loading date is postponed",
    "YiXiaShangPinDaoZhiYuZhua": "The products below cause postponement of the estimated loading date",
    "DiaoZhengShiJian": "Adjusts time: {0}",
    "TuiChiZhi": "Postponed to",
    "ZhuYiZuiWanZhiYunXuTuiChi": "Attention: the latest date should not be later than {0}",
    "TuiChiYuZhuangJuRiQi": "Postpone the estimated loading date",
    "QueRenYuZhuangJuRiQiTuiCh": "Sure to postpone the estimated time to {0} ?",
    "QingXuanZeRiQi": "Choose a date",
    "XinYuJiZhuangJuRiQi": "New estimated loading date",
    "CiRiQiZaoYuZhengChangJiao": "This date is earlier than the delivery,which the factory might not satisfy. Please wait for the reply from the factory.",
    "YouYuWeiShouDaoQueRenDing": "We haven't received your deposit, and we cannot place an order for you, so the estimated loading date has been postponed to {0}. Please pay the deposit ASAP (subject to the time when deposit is received)",
    "YouYuBangNinCongZhongDiao": "{0} transferred {2} products from {1}, thus the estimated loading date of this order has been postponed to {3}.",
    "YouYuShangPinShengChanGuo": "The production progress doesn't go as we planned, thus the estimated loading date has been postponed to {0}. We apologize for the inconvenience it caused.",
    "YouYuWuFaDingDaoCangGuDin": "Due to {0}, the estimated loading date of the order has been postponed to {0}. We apologize for the inconvenience it caused.",
    "PiLiangJieShouBingDiaoChu": "Accept and transfer in bulk",
    "DiaoChu": "Transfer",
    "DiaoJinN": "Transfer to {0}",
    "QingXuanZeYaoDiaoJiDe": "Choose the order you transfer products to",
    "YiXuanZeShangPinDeTiJi": "Total volume of the choosen products",
    "ZuiZhangYuZhuangJuRiQi": "the latest estimated loading date",
    "ShengYuTiJi": "Remaining volume",
    "DiaoJin": "Transfer to",
    "NinShenQingDiaoJinDeShang": "The volume of the products you transferred is beyond the max volume of the order. It is not suggested to continue. If you want to continue, ESSA may adjust the volume and product transfer according to the actual situation. Do you continue?",
    "GaiYuanZhuangJuRiQiDiaoRu": "The original estimated loading date is:{0}；But after products are transferred, it will be postponed to {1}；Sure to transfer?",
    "GaiYuanZhuangJuRiQiTongShi": "The original estimated loading date is {0}. After products transfer, it will be postponed to {1}, and the total volume will be beyond  the maximum, so it is not suggested transfer. If you continue, ESSA will adjust the volume and transfer according to the actual situation. Sure to continue?",
    "QueRenDiaoJin": "Transfer?",
    "NinDangQianWuKeDiaoJinDeD": "No orders for products to transfer to",
    "QingXianGouXuanShangPin": "Please choose and tick",
    "YuanShiYuJiZhuangGuiRiQi": "Original estimated loading date",
    "QueDingShanChuXunJiaShangPin": "Inquire all the chosen items again?",
    "PiLiangXunJia": "Inquire in bulk",
    "SouDingDan": "Search for orders",
    "SouShangPin": "Search for products",
    "PoMoRenTiShi": "You can search by item No., factory No., or Client's item No.. Also you can search for several items at the same time, 10 items at most. Please seperate the No. with blank.",
    "QingXianRenZhengNinDeCaiG": "Please verify your buyer identity",
    "FeiGongZuoShiJianYuJiXuYa1": "2 workdays are needed for verification on weekday",
    "GuiSiXiaMianWuYuanGongZha": "No employee accounts",
    "NinDangQianDeCaiGouShangD": "Your current account has no access to the employee account. Please contact our sales assistant for verification.",
    "LianXiXiaoShouGuWen": "Contact platform customer service",
    "TiShengGuDingBaoZhengJinE": "Raise the fixed guarantee deposit level",
    "DanBaoDingDan": "Guarantee order",
    "QueRenDingDan": "Confirm order",
    "YongZhenShiDeXinXiWanShan": "Filling in real information enables you have the access to accurate marketing information, increasing 40% of purchase efficiency.",
    "GuiSiGuDingBaoZhengJinHai": "According to your fixed guarantee deposit {0}, your credit amount is not enough for the amount of the order",
    "GuiSiGuDingBaoZhengJinHaiBu": "You still have the credit amount of {0} according to the fixed guarantee deposit, which can afford this order",
    "QingZaiChuHuoQianZhiFuDin": "Notice：please pay the deposit before shipment",
    "GaiDingDanDingJinYiDaoZha": "The deposit of the order is received, please confirm PO ASAP to avoid delay.",
    "QingJinKuaiZhiFuDingJinZh": "Please pay the deposit {0} ASAP. After ESSA receive the deposit, please confirm the order ASAP",
    "GuiSiDingDanDingJinJiDing": "Do you confirm the product infromation and deposit of the order {0}?",
    "DanBaoCiDingDaoHouShengYu": "After the PO is guaranteed, the balance of the credit amount is  {0}",
    "QueRenDanBaoDingDan": "Guarantee the order  {0}?",
    "BuHaoYiSiGuiSiDangQianYou": "Sorry, you have order(s) under guarantee, so it is now allowed to change the deposit mode. Please pay the order first.",
    "DingDanYiQueRenJiangJinKu": "The order has been confirmed, ESSA will arrange production ASAP",
    "QueRenDanBaoChengGongJian": "Guaranteed. ESSA will arrange production ASAP",
    "BuHaoYiSiDingDanYiJingBeiQueRen": "Sorry, the order has been confirmed by {0}",
    "BuHaoYiSiDingDanYiJingBeiDanBao": "Sorry, the order has been guaranteed by {0}",
    "GuDingBaoZhengJin": "Fixed guarantee deposit",
    "ShenQingGengHuanDingJinMo": "Apply for changing the deposit mode",
    "GuDingBaoZhengJinJinE": "Fixed guarantee deposit level",
    "DanBaoHuoKuanJinE": "Credit amount",
    "HaiKeDanBaoHuoKuanJinE": "The balance of credit amount",
    "ShouXinEDu": "Line of credit",
    "SheZhiBaoZhengJinJinE": "Set your guarantee deposit level",
    "WoXiangLeJieDingJinMoShi": "I want to know about the deposit mode of ESSA",
    "BaoZhengJinJinE": "Levels of guarantee deposit",
    "TiXian": "Withdraw",
    "WeiShiYong": "Unused",
    "ShiYongZhong": "In use",
    "BuHaoYiSiGuiSiHaiYouHuoKu": "Sorry, the payment of {0} is unpaid, so you cannot downgrade the fixed guarantee deposit to  {1}. (Accordingly the credit amount is  {2})",
    "QueRenJiangE": "Downgrade?",
    "JiangEHouDuoYuDeBaoZhengJ": "After the amount downgrade, the extra guatantee deposit will be transferred to the available asset",
    "BuHaoYiSiDangQianNinYouDu": "Sorry, POs have been guaranteed, and the deposit cannot be withdrawn. You can withdraw the deposit after paying for the POs.",
    "QueDingTiQuGuDingBaoZheng": "Withdraw guarantee deposit to available asset?",
    "QueRenBaoZhengEDuCongTiSh": "Do you confirm that the guarantee deposit amount will be raised from {0} to {1}. The credit amount will be raised from {2} to {3}",
    "GuDingBaoZhengJinTiShengC": "The fixed guarantee deposit is successfully raised",
    "GuiSiYouZhangDaiQueRenDan": "You have {0} PO(s) to guarantee, now your credit amount can afford all the PO(s). ESSA will arrange production ASAP.",
    "NinYouZhangDaiDanBaoDeDin1": "You have {0} PO(s) to guarantee, but now the guarantee deposit amount can only guarantee some of them. Do you want to confirm some of them, or raise the credit amount to {1} to guarantee all of them?",
    "QuQueRenPO": "To confirm PO",
    "JiXuTiShengEDu": "Continue to raise the amount?",
    "NinYouZhangDaiDanBaoDeDin": "You have {0} order(s) to guarantee, now the credit amount cannot afford your orders, it should be raised to {1} to afford all your orders",
    "BuHaoYiSiGuiSiXiaKeYongZi": "Sorry, your available asset is not enough, so you cannot raise the guarantee deposit amount.  {0} is needed to raise your guarantee deposit level. Please contact your sales assistant for help.",
    "DanJuBiLiDingJin": "Proportional deposit for one container",
    "Qian": "owe",
    "GongSiZhuZhangHaoCaiNengB": "Only the main account can change the guarantee deposit levels",
    "ZhiSuoYouDingDanDaiZhiFuQ": "The total amount of all the unpaid orders",
    "GuDingDingJin": "Fixed deposit",
    "DingJinZhiFuShiJian": "Time of deposit payment",
    "TiJiaoDingDanHouMeiZhangD": "After you submit order, each order requires different fixed deposit according to the container type.  Only after you pay the deposit, you can confirm PO then the factory starts production.",
    "DingJinGuanLi": "Deposit management",
    "MianDingJin": "Deposit free",
    "WaiHui": "Foreign currency",
    "DaiQueRenDingJinDingDan": "Orders of unconfirmed deposit",
    "YiChangDaiChuLiDingDan": "The pending abnormal order",
    "DaiZhiFuHuoKuanDingDan": "Unpaid order",
    "KeDiaoRuHuoBuHuoDingDan": "Order(s) of goods transfer or replenishment",
    "BuHuoZhongDingDan": "Orders of replenishing",
    "DiaoHuoZhongDingDan": "Order(s) of product transfer",
    "YiXiaXuYaoJinJiChuLi": "Please handle the emergency ASAP",
    "GongSiDingJinMoShi": "Company's deposit mode",
    "DanBaoHuoKuanEDu": "Credit amount for PO",
    "HaiKeDanBaoHuoKuanEDu": "The balance of the credit amount",
    "GouWuCheZhongKuanShangPin": "For  {0}  item(s) in your cart, we are going to negotiate with suppliers, please make sure if you will buy or not?",
    "NinYouZhangDingDanBaoZhen": "You have {0} order(s) to guarantee. To ensure production, please raise the guarantee deposit amount ASAP.",
    "TiShengBaoZhengJinEDu": "Raise the guarantee deposit level",
    "ChaKanQuanBu": "See all",
    "BianGengDingJinMoShi": "Change the deposit mode",
    "QueDingGengHuanGuiSiDingJinMoShi": "Sure to change the deposit mode into {0}?",
    "GuiSiDingJinMoShiGengHuanChengGong": "Deposit mode is successfully changed.",
    "GengHuanHouXinXiaDeDanJia": "After you change the deposit mode, the new POs will follow the the deposit mode, but the previous orders follow the original depost mode instead of the new one untill the previous POs are completed.",
    "QingXuanZeXinDeDingJinMoS": "Please choose your new deposit mode",
    "NinDangQianShiYongDeDingJ": "Your current deposit mode",
    "ShiYongBaoZhengJinKeYiRan": "With guarantee deposit, you can place orders to factory for production quickly without spending time in paying deposit, which shortens the delivery time.",
    "JiangTiGongBuTongCengJiDe": "ESSA has different levels of guarantee deposit for your business scale, which make your business more convenient",
    "GaiDingJinMoShiHaoChu": "The benefits of deposit mode",
    "XuanZeBuTongBaoZhengJinJi": "Different guarantee deposit for different credit amount",
    "ZhengDanManJuHuoSanHuoXia": "Order of FCL or LCL",
    "AnHuoKuanJinEShouQuBiLi": "Charged proportionally to the payment",
    "ZhengDanBuManJuXiaDan": "Order of non-full container",
    "JuTiJuXingDeDingDanJiangA": "Deposit of orders of different containers should be paid according to the standard below",
    "ZhengDanXiaDan": "Place orders by FCL",
    "SanHuoXiaDan": "LCL order",
    "GengHuan": "Change",
    "QingSheZhiGuiSiBaoZhengJi": "Please set your guarantee deposit level",
    "DanBaoZhongHuoKuanJinE": "The used credit amount",
    "FenPeiBaoZhengJinQianKuan": "Allocate the balance of guarantee deposit",
    "ZhuangTai": "State",
    "BaoZhengJinFenPeiChengGon": "Guarantee deposit is allocated successfully!",
    "QueDingFenPeiKeYongZiJinB": "Use the available asset to pay the balance of guarantee deposit?",
    "DingJinTiQuHouZhongXinXia": "After withdrawing the deposit, if you place an order again, the order will not be submited to the factory for production, and you need to allocate the deposit again. Continue?",
    "GuDingBaoZhengJinTiXianCh": "Fixed guarantee deposit is successfully withdrawn.",
    "GuDingBaoZhengJinJiangECh": "You successfully decreased the fixed guarantee deposit.",
    "DuiGuiSiShouXinDeEDuYongY": "The line of credit given by ESSA is for buffering the balance caused by the bank or exchange rate during transfer, and also credit amount can guarantee part of goods payment",
    "DangQianGuDingBaoZhengJin": "Now your fixed guarantee deposit amount is not enough, you can charge it with available asset. Please allocate your asset to avoid affecting guaranteeing the order.",
    "NinYouZhangDingDanDaiZhiF": "Deposit should be paid for {0} order(s). To ensure factory's production, please pay the deposit ASAP. Contact your sales assistant if you have any questions",
    "TongZhi": "Notice",
    "QingWanShanZiLiao": "Please complete the information",
    "WeiZhaoDaoFuHeTiaoJianDeShangPin": "No eligible item is found",
    "ShiJiDaoGangRiQi": "The actual date of arrival at port",
    "GongKuanZongTiJiDeShangPi": "{0} item(s), {1} volume in total. Consolidation available",
    "BuHaoYiSiGuiSiXiaBaoZheng": "Sorry, according to your guarantee deposit, your credit amount is insufficient, which can guarantee {0} at most. For goods replenishment, please raise your guarantee deposit level first.",
    "DingDanBeiChengGongTiJiao": "The order has been submitted by {0}",
    "QingXuanZeWanJuCaiGouGuiM": "Select your toy purchase scale",
    "QingXuanZeWanJuDanKuanCai": "Choose your annual purchase volume of one toy",
    "ZhengJuShouQu": "Charge for one PO",
    "DanJiaJunTanShouQu": "Shared charge for each item",
    "DaiZhiFuDingJinDingDan": "Deposit to pay",
    "DaiQueRenDingDan": "Order to confirm",
    "DaiZhiFuQianKuanDingDan": "Unpaid order",
    "GuiSiDangQianBaoZhengJinQ": "You need to pay {0}， the balance of guarantee deposit to guarantee orders",
    "HaiQingBaoZhengJinQianKua": "To raise the guarantee deposit level",
    "GuiSiXiaYouZhangDingDanBa": "You have {0} order(s) to guarantee. To ensure punctual production, please raise the guarantee deposit to {1}.",
    "BaoJiaZuHe": "Combined offer",
    "YiXiaDanDanBuManGuiDeHuoGui": "Non-full container with PO submitted",
    "WeiTiJiaoDingDanDeHuoGui": "Containers without PO submitted",
    "QingXuanZeNinZhunBeiZuZhuangxxxDeChuHuoLeiXing": "Please select the shipment type of No.{0} container of combined PO",
    "ZhengDan": "FCL（Full container load）",
    "SanHuo": "LCL（Less than container load）",
    "XinHuoGuiDouShiYongGaiBaoJiaZuHe": "The quotation condition will be use for all new consolidation.",
    "LiShiChangYongBaoJiaZuHe": "History of common combined offer",
    "FanHuiXiuGaiBaoJiaZuHe": "Return to change the combined offer",
    "HuoGuiShangPinZongTiZhiBuYunXuChaoChuHuoGuiZuiDaZhi": "The volume of all the goods cannot exceed the maximum of the container volume",
    "QueDingHuoGuiBaoJiaZuHeWuWu": "There are over half of goods in your container, whose places of origin are different from warehouse location. Are you sure to continue?",
    "WeiBuYingXiangDingDanYuZhuangGuiRiQi": "Attention: to avoid postponing the estimated loading date, please pay the deposit promtly. And the  estimated loading date depends on the actual arrival of deposit.",
    "QingZaiChuHuoQianZhiFuDingJin": "Notice: please pay deposit before shipment",
    "QingQueRenYiXiaXinXiShiFouZhengQue": "Please confirm the information below",
    "XiuGaiBaoJiaZuHe": "Change the combined offer",
    "GuiSiHaiWeiSheZhiGuDingBaoZhengJinJinE": "You have not set the fixed guarantee deposit level yet",
    "DingDanTiJiaoChengGong": "PO is successfully submitted, ESSA will arrange production for you promptly.",
    "DingDanTiJiaoChengGongQingJinKuaiZhiFuDingJin": "PO is successfully submitted, please pay deposit to avoid postponement of production",
    "GuiSiHaiWeiSheZhiGuDingBaoZhengJinJinEQingXianSheZhi": "You have not set the fixed guarantee deposit level yet, please set it first.",
    "GuiSiHaiWeiSheZhiGuDingBaoZhengJinJinEQingLianXixxxXianSheZhi": "You have not set the fixed guarantee deposit level, please contact {0} for help.",
    "TiShengGuDingBaoZhengJinJinE": "Raise your fixed guarantee level",
    "NinYiChengGongTiJiaoDingDanQingJinKuaiTiShengBaoZhengJin": "PO is successfully submitted! Please raise your guarantee deposit promptly and confirm the PO, to avoid postponement of production.",
    "NinYiChengGongTiJiaoDingDanQingJinKuaiHuanQingBaoZhengJinQianKuan": "PO is successfully submitted, please raise your guarantee deposit level for PO confirming and production.",
    "WeiNengShunLiQueRenDingDanNinDeBaoZhengJinJinEXuTiShengZhi": "To ensure PO is successfully submitted and confirmed, please raise your guarantee deposit to",
    "RuoNinZhangHaoZiJinBuZuQingLianXiNinDeXiaoShouGuWenXXX": "Notice: If your available fund is insufficient, please contact your sales assistant for help to raise your available fund, If some of your PO are under guarantee, you can pay off the PO to release the guarantee deposit amount.",
    "NinDangQianShiYongDeShiXXXDeDingDanFuWu": "Now you are using order services of {0}",
    "BaoZhengJinQianKuanJinE": "Guarantee deposit needed",
    "ZuiJinNGe": "{0} recently",
    "DangQianKeYongZiJinBuZuQi": "Your available fund is insufficient, please deposit fund in your ESSA account, then allocate reasonably",
    "GuanBi": "Close",
    "BianGengBaoZhengJinEDu": "Change the level of fixed guarantee deposit",
    "FuWuFeiJiangYiDingDanHuoK": "Service fee will be charged in proportion with the PO amount.",
    "GuiSiXiaYouZhangDingDanDa": "You have {0} order(s) to guarantee, please pay off the balance of fixed guarantee deposit",
    "NinDangQianDeCaiGouShangDD": "Your account is approving on our website ,so it can not be traded now ,You can contact the platform customer service to find out   the progress of the approve .",
    "GuDingBaoZhengJinTiQuHouZ": "After fixed guarantee deposit is withdrawn, the new PO you place will not be submitted to the factories for production, and you need to reallocate your deposit.",
    "YiShuRuCuoWuCiShengYuCiJi": "Error input for {0} time(s). {1} time(s) left to try",
    "CuoWuCiShuGuoDuoQingXiaoS": "Excessive times of error ! Please try again after {0} hours, or use \"retrieve password\"",
    "CuoWuCiShuGuoDuoQingFenZh": "Excessive times of error! Please try again after {0} minutes, or use \"retrieve password\"",
    "MiMaCuoWuQingZhongXinShuR": "Wrong password, please try again",
    "MiMaCuoWuLianXuCiShuRuCuo": "Wrong password. Your account will be locked out after password wrongly entered 5 times.",
    "KeBuHuo": "Replenishment allowed",
    "ShenChangAnPaiZhong": "Production under arrangement",
    "YiChangDaiChuLi": "Abnormality to handle",
    "ShenQingTiaoRuZhong": "Applying for transfer",
    "ShangPinSuoZaiXiLie": "Product category",
    "BuChongYiXiangCaiGouShangPin": "Please complete your information, the favorite products",
    "BuHuoZhong": "Replenishing",
    "MoSiKeTuiGuangFuWuBanShiC": "Promotion service office of Moscow",
    "JiaZaiGengDuo": "Load more",
    "PinPaiXiangQing": "Brand information",
    "CheMeiYouKePinGuiDeShangPin": "No products for container consolidation in your cart",
    "ShaiXuan": "Filter",
    "MeiYouGengDuoShuJu": "No more data",
    "YiXuan": "Selected",
    "ShangPinJieShao": "Product description",
    "FaBuZhaoYang": "Product Search Request",
    "FaBu": "Post",
    "FaBuMiaoShu": "For precise search, please discribe in detail. For example, product brand, function, name and so on.",
    "ShangPinSuoShuFenLei": "Product category",
    "ZyWenXinTiShi": "Warm reminder: now essa provides new services, finding suitable samples, by which, you can find the detailed information of the product",
    "ShiBai": "Fail",
    "TuPianShuoMing": "Picture description",
    "TuPianShuoMing1": "Please upload a picture of one product",
    "TuPianShuoMing2": "If sereral picture are uploaded, only one picture will be ramdomly chosen for finding sample.",
    "TuPianShuoMing3": "You can at most upload 4 pictures of jpg/png,each within 5mb",
    "WoDeZhaoYang": "Find sample",
    "FaBuChengGong": "Successfully posted",
    "FaBuShiBai": "Fail to release",
    "ChaKanZhaoYangXiangQing": "Click my samples to see more",
    "XuanZeShangPinSuoShuFenLei": "Choose the product category",
    "TianJiaBuChongXingShuoMing": "Complementary description can be added",
    "BuChongShuoMing": "Additional instruction",
    "ZhanKaiQuanBu": "Unfold",
    "YiDongDuanJinKeBianJiHeChaKan": "Mobile device supports seeing items in cart and simple editing, PC device supports more services: container consolidation and placing order.",
    "ShangPinZanWeiYiJiaQingXianRenZheng": "The product price has not been negotiated yet. Please try inquiring after verification.",
    "YiYiJia": "Negotiated",
    "QingXuanZeWenTi": "Please select the question",
    "ChaKanHuiFu": "See replies",
    "NGeWenTi": "{0} question(s)",
    "QingXianDengLuNMiaoHouJiangTiaoZhuan": "Please log in first. This page will turn to log-in page in 3 seconds.",
    "BianJi": "Edit",
    "JiaGeQuJian": "Price range",
    "DengLuBingRenZhengHouJiaGeKeJian": "You can view the price after log-in",
    "QingXianDengLu": "Please log in first",
    "WeiTongGuoRenZheng": "Your account has not been verified. Your inquiry of preferred price and purchase volume will be sent to suppliers, after your account is verified. Please wait patiently.",
    "TuXiangShiBieZhong": "Identifying",
    "ZhiShaoNGeZiFu": "At least {0} character(s)",
    "ZhuCeYouXiang": "E-mail for registeration",
    "ZhiShaoShuRuNGeZiFu": "At least enter {0} character(s)",
    "ZaiCiShuRu": "Enter again",
    "QueRenXiuGai": "Sure to change?",
    "YiYouZhangHaoQuDengLu": "You have an acount? Just log in",
    "DianJiZhuCeJiTongYiZunShou": "Clicking \"Register\" means you agree and obey  <Buyer registration on ESSA and terms of service>",
    "FanHuiDengLu": "Return and log in",
    "NinDeZhangHaoTiJiaoChengGongQingQ": "Successfully submitted. Please check your E-mail and follow the instruction for verification.",
    "GongXiNinZhuCeChengGongNMiaoHou": "Congratulation! You have successfully registered! You will log in automatically after {0}",
    "DangNinChengWeiWoMenDeRenZhengYonghuJiangYou": "Warm reminder: you will have an exclusive sales assistant to help you, after you become our verified member.",
    "NinXuanZheDeXiaoShouGuWenHuiZaiNXiaoShiNei": "Your sales assistant will contact your within {0} hour(s) for buyer ID verification. After that, you can see all the products' price and have other access. The page will turn to homepage within {1}.",
    "NMiaoHouZiDongDengLu": "After {0}, the page will turn to homepage.",
    "GaiZhangHuShangWeiZhuCe": "This is not a registered account, please register first.",
    "GaiYouXiangYiZhuCeQingGengHuan": "This E-mail has been used for registeration, please change it or log in.",
    "ChongZhiMiMaChengGongFanHui": "Password is successfully reset! After {0}, you will return to the log-in page.",
    "WoDeShouCang": "My favorite",
    "QuanBuLeiMu": "All categories",
    "QiHuo": "Delivery",
    "LieBiaoWeiKong": "Empty list",
    "ChengGongJiaRuGouWuChe": "Added successfully",
    "ChengGongShanChu": "Deleted successfully",
    "YiGeYueYiNei": "Within 1 month",
    "SanGeYueYiNei": "Within 3 months",
    "SanGeYueZhiQian": "3 months ago",
    "SheZhi": "Set",
    "ZhangHuXinXi": "Account information",
    "ZhangHuMing": "Account name",
    "WoDeXiaoShouGuWen": "My sales assistant",
    "GuanYuESSA": "About ESSA",
    "TuiChuDengLu": "SIGN OUT",
    "QingXuanZeNiSuoZaiGuoJia": "Please choose your country",
    "YuYan": "Language",
    "MingChengHeHuoHao": "Name & Number",
    "ZiDingYi": "User-defined",
    "LiShiSouSuo": "Search history",
    "QingKongLiShiJiLu": "Clear history",
    "invalidPO": "This order is invalid.",
    "ShangChuanDeTuPianXiangSuJinLiangQingXi": "Make sure the picture uploaded is clear",
    "TuPianBeiJingJinLiangShiYongChunSeBeiJing": "Pure background is highly recommended",
    "KeShiYongCaiJianGongNengTuChuShangPinZhongDian": "Crop the picture to highlight the important part",
    "TuPianShangZhiBaoHanDanGeShangPin": "Only one product in the picture",
    "TuPianShiBieZhongMaShangJiuHao": "Identifying, just a moment",
    "TuoZhuaiTuPianDaoZheLi": "Drag the picture here",
    "BenDiShangChuanTuPian": "Upload local pictures",
    "XiangSiShangPin": "Simliar products",
    "SouSuoJieGuoBuJingZhun": "Imprecise search result?",
    "DianJiZuoCeKeYiDuiYuanTuJinXingCaiJian": "Click the left side. You can crop the original picture or blurring the background, then search again.",
    "HuoDeSouTuJingZhunJieGuoDeXiaoJiQiao": "How to search precisely?",
    "LiuLanShangPinGengBianJie": "Convenient browsing",
    "CiKuanHuoDongShangPinNinYiQueQingChaKan": "You have confirmed the purchase of the item, please check in your cart",
    "ZanWuTuiJianShuJu": "No date of recommendation",
    "ZhangHaoWeiTongGuoRenZhengNew": "Your account has not been verified, and your inquiry of purchase volume and price will be sent to the suppliers after verification. Please wait patiently.",
    "DengLuHouJiaGou": "Add to card after log-in",
    "ShouJiBan": "Mobile",
    "QueDingYaoTuiChuDengLuMa": "Are you sure to log out?",
    "RenZhengYuanLianXiFangShi": "Contacts for verification",
    "YiShouLuZhongGuoDeWanJuGo": "80% Chinese toy factories online, hundreds of new toys updated everyday",
    "XiLie": "Series",
    "LiangCiShuRuDeMiMaBuYiZhi": "Inconsistent passwords",
    "ShangChuanTuPian": "Upload picture(s)",
    "QingShuRuNGeZiYiNei": "Please enter within {0} character(s)",
    "XiangQingMiaoShu": "Detailed description",
    "TianJiaBuChongShuoMing": "Add additional instruction",
    "ChaKanQuanBuBuChongShuoMing": "See all additional instruction",
    "ESSATiGongJinZhunZhaoYangTips": "Warm reminder: ESSA provides service of finding samples, by which, you can obtain the the detailed product information",
    "YiJieShu": "Ended",
    "YiFanKui": "Feedback is received",
    "DaiFanKui": "No feedback yet",
    "YiQuXiao": "Cancelled",
    "BianHao": "Number",
    "BenCiZhaoYangYiJieShu": "Finding samples ended",
    "ESSAWeiNiZhaoDaoXinAiDeBaoBei": "The items you want are found, click it below to see",
    "ESSAZanShiWeiZhaoDaoMinXinAiDeBaoBei": "ESSA is searching, please wait a minute",
    "BenCiZhaoYangYiQuXiao": "Finding sample is cancelled",
    "JieShuZhaoYang": "End sample",
    "JiXuZhaoYang": "Continue to find samples",
    "MeiYouChaXunDaoZhaoYangShuJu": "No sample data is found",
    "ChaKanXiangQing": "See more details",
    "ShangPinFenLeiS": "Product categories",
    "BianJiZhaoYangXinXi": "Edit information of finding samples",
    "ZhaoYangFuWu": "Service of finding samples",
    "LiShiZhaoYangJieGuo": "History of finding samples",
    "ZhaoYangJieGuo": "Result",
    "QingShangChuanDanKuanTuPianZhaoYang": "Please upload picture(s) of one single product.",
    "DuoKuanJiangSuiJiXuanZeYiKuanZhaoYang": "If several pictures of different products are uploaded, the system will choose one product ramdomly for finding samples",
    "ZuiDuoChuanSiZhangTuPian": "You can at most upload 4 picures of jpg/png, each less than 5mb",
    "QuanBuBuChongShuoMing": "All additional instruction",
    "ChongXinJiaZai": "Reload",
    "HenBaoQianNinYaoFangWenDeYeMianMiShiZaiYuZhouZhongQingDianJiChongXinJiaZai": "Sorry, the page gets lost in the space, please refresh the page",
    "FaBuShiJian": "Time of posting",
    "ShouDaoFanKui": "Feedback received",
    "CKXiangQing": "Details",
    "ZhaoYangMiaoShu": "Discription of the target samples",
    "GongDuoShaoKuang": "{0} item(s) totally",
    "WeiZhaoDaoShangPin": "ESSA is searching, please wait a minute",
    "YiJingZhaoDaoShangPin": "ESSA is looking for your favorite",
    "ZhaoYangYiQuXiao": "Данный поиск образца отменен",
    "ZhaoYangYiJieShu": "Ended",
    "XuanZeShiJian": "Please choose time",
    "DengLuHouZaiFaQiZhaoYang": "Please log in first before finding samples",
    "CMYKBuZhiChi": "CMYK is not supported, please convert to RGB and upload again.",
    "FanHuiShangYiYe": "Вернуться на предыдущую страницу",
    "FanHuiShouYe": "Return to homepage",
    "YeMianNongDiuLe": "Sorry, the page is lost",
    "JiXuFangWen": "Continue to visit by the ways",
    "MeiYouShuJu": "No data",
    "YiShiXiao": "Invalid",
    "TuiJianLeiXing": "Recommendation type",
    "TuXiangShiBieShiBai": "Identifying failed",
    "QingShanChuXiaJiaChanPin": "Пожалуйста, удалите товары, которые уже не в продаже",
    "TuiJianZhuTi": "Тема рекомендации",
    "originQuantityNotEqualQuantity": "The item(s) in cart are added to temporary storage or replenishment pool",
    "TuPianShuoMing4": "The pictures of one product are better to be the complete picture, front picture，back picture, and side picture",
    "KaiFaZhong": "В процессе разработки",
    "ZongWenJianDaXiaoChaoChuXianZhi": "The total file size exceeds the limit {0}",
    "ZuiDuoYunXuYiCiXingShangChuanShu": "At most {0} file(s) can be uploaded",
    "WenJianChongFu": "Повтор документа",
    "XiTongBuZhiChiCMYK": "CMYK is not supported, please convert to RGB then upload",
    "ShiFouQueRenShanChu": "Sure to delete?",
    "BangNingZhaoYang": "Find samples for you",
    "WenXinTiShi": "Warm reminder",
    "GaiBanShangPin": "Revised product",
    "ShiChangShangPin": "Product on the market",
    "dealing": "Loading",
    "GongXiNin_Yi": "Congratulations, you have successfully submitted the PO. Your current fixed deposit is not enough to guarantee this order. Please add your fixed deposit margin as soon as possible to so as not to delay the factory production.",
    "GongXiNin_Er": "Congratulations!PO is successfully submitted. To avoid the delay of factory production，please soonly  upgrade the level of fixed guarantee deposit not affordable for the order.",
    "GongXiNin_San": "PO is successfully submitted. The current available fund can guarantee this PO. Click \"confirm\", the system will allocate your deposit automatically",
    "GongXiNin_Si": "PO is successfully submitted.  Please pay the deposit before shipment.",
    "GongXiNin_Wu": "PO is successfully submitted. The current available fund can afford the deposit. Click \"confirm\", system will process automatically",
    "GongXiNin_Liu": "PO is successfully submitted. Your available fund cannot afford the PO deposit, please charge your available fund.",
    "GongXiNin_Qi": "PO is successfully submitted. As a VIP, you do not need to pay deposit, please confirm your PO",
    "DingDanXinXi": "PO information",
    "PODanHao": "PO number",
    "DingDanZongJinE": "Total amount",
    "TieZhiFeiYong": "Charge of sticker",
    "FuWuFeiYong": "Service fee",
    "YuZhuangGuiShiJian": "Estimated time of loading",
    "DingJinDanBaoFangShi": "Guarantee method",
    "ZiJinXinXi": "Fund information",
    "ZhangHuBaoZhengJinDengJi": "Deposit level",
    "KeDanBaoHuoKuanEDu": "Available credit amount",
    "YiDanBaoHuoKuan": "The amount of guaranteed payment",
    "ShengYuKeDanBaoHuoKuanEDu": "The balance of credit amount",
    "HaiChaBaoZhengJin": "Guarantee deposit needed",
    "GaiBiDingDanSuoXuHuoKuanDanBaoEDu": "Credit amount for the PO",
    "ZhangHuKeYongZiJin": "Available fund in the account",
    "BenDanXuZhiFuDingJin": "Deposit is needed for the PO",
    "ChaKanZiJinMingXi": "See the fund detail",
    "GongXiNin_Er_Er": "PO is successfully submitted.  Please upgrade the level of fixed guarantee deposit with the main account.",
    "LiJiQueRen": "Confirm now",
    "DingDanMianShouDingJin": "No deposit needed, please comfirm, then ESSA will arrange production",
    "ZuGouDanBaoBenDan": "Your credit amount can guarantee this PO, please confirm, then ESSA will arrange production",
    "KeYongZiJinZuGouZhiFu": "Your available fund can afford deposit of the PO{0}. Please confirm PO promtly, to avoid production postponement.",
    "KeYongZiJinBuZuZhiFu": "Your available fund cannot afford the deposit of the PO {0}, please contact ESSA to increase your available fund, and confirm the PO after the arrival of fund.",
    "ShiYongZhiFuGaiBiDingDanDingJin": "Use {0} to pay deposit of the PO",
    "NiDeZhangHuKeYongZiJinBuZuZhiFuBenDanDingJin": "Your available fund {0} cannot afford the deposit of {1} of the PO. However, a temporary credit amount, {2} is given to your account for your good credit.",
    "NinDangQianWeiMianDingJinKeHu": "You are VIP and free of deposit, please confirm the PO",
    "DingDanYiTiJiao": "Your order is submitted",
    "BenDanYiZhiFu_QingLianXiESSA": "Notice: Deposit of {0} has been paid for this PO, please contact essa and pay off the balance payment, {1}",
    "DingDanYiQueRen": "PO has been confirmed",
    "YeMianMiShiJiangChongXinQiHang": "Sorry, the page got lost in the universe, and will be back soon.",
    "DengLuHouQieBaoJiaFangShi": "Terms of quotation can be switched after log-in",
    "GenJuNinDeLiangHaoXinYong": "For your good credit, you are given temporary credit amount {0} to afford the deposit.",
    "QueRenZhiFu": "Sure to pay",
    "QueRenZhiFuJiangHuiCongZiJin": "Available fund will be deducted as the deposit of the PO after you confirm.",
    "WeiKuanZhiFuQianZhiFu": "Notice: this PO needs deposit {0}, you are given a temporary credit amount {1}, which, {1} should be paid before balance of payment.",
    "DanBaoChengGong": "Guaranteed successfully",
    "ZhiFuChengGong": "Paid successfully",
    "ShiYongHuoKuanEDu": "Use {0} credit amount to guarantee this PO",
    "c3VibWl0X3BvX2VtYWls": "Submit PO",
    "c3VibWl0X3BvX2VtYWls_remark": "E-mail will be sent after you submit PO",
    "cG9fY29uZmlybQ==": "Confirm PO",
    "cG9fY29uZmlybQ==_remark": "After submitting PO, please confirm PO in the E-mail we send",
    "BangDingChengGong": "Bound successfully, please continue",
    "BangDingShiBai": "Binding failed, please try again",
    "BaoCunShiBai": "Failed to save, please try again",
    "QingWanChengZhangHuZiLiaoWanChengZhuCe": "Please complete account information for registeration",
    "YanZhengMaYiFaSong": "Verification code is sent",
    "QingShuRuYanZhengMa": "Please enter verification code",
    "WanCheng": "Finish",
    "ShouJiZhuCe": "Phone number register",
    "QieHuanShouJiZhuCe": "Switch to phone register",
    "QieHuanYouXiangZhuCe": "Switch to e-mail register",
    "YanZhengMaYouWuQingChongXinShuRu": "Wrong verification code, please try again",
    "FaSongYanZhengMa": "Send verification code",
    "BangDingShouJi": "Bind my phone",
    "YanZhengShouJi": "Verify your phone",
    "BangDingShouJiChengGong": "Your phone is bound successfully",
    "YanZhengShouJiChengGong": "Phone verified successfully",
    "HaoMaoGeShiYouWu": "Wrong number format",
    "ShouJiHaoMa": "Phone number",
    "YanZheng": "Verify",
    "QuBangDing": "To bind",
    "QinAiDe": "Dear",
    "ShangWeiDengJiYouXiang": "Hello, your account has not bound E-mail. Important notices will be sent to your mailbox, please provide your E-mail address.",
    "YouXiangYanZhengHouKeDeng": "Reminder: After E-mail verification, you can log in with E-mail address",
    "YangZhengMaFaSongYouXiang": "Verification code is sent to your mailbox",
    "QingGouXuanCaiGouLeiXing": "Please choose and tick purchase type",
    "ShouJiDengLu": "Phone log-in",
    "YouXiangDengLu": "E-mail log-in",
    "GengDuoYuZhong": "More languages",
    "WoXiangYongDianZiYouXiangZhuCe": "I want to register with E-mail",
    "WoXiangYongShouJiHaoMaZhuCe": "I want to register with phone number",
    "YouXiangZhuCe": "E-mail register",
    "HuoQuYanZhengMa": "Get verification code",
    "YanZhengMaShuRuYouWuChongXin": "Wrong verification code, please try again",
    "ShouJiHaoMaGeShiYouWuQingChongXin": "Wrong number, please try again",
    "YanZhengMaFaSongShiBai": "Failed to send verification code",
    "ZhuCeChengGongXuanYeWuYuan": "Registered successfully! {0} later, you will go to a page to choose a sales assistant.",
    "GaiZhangHuYiCunZaiQingQueRen": "The account is taken, please confirm your phone number",
    "GaiZhangHuBuCunZaiQingQueRen": "The account does not exist, please confirm phone number",
    "GaiZhangHuYiJinYongQingQueRen": "The account is disabled, please confirm the phone number",
    "WoXiangYongDianZiYouXiangZhaoHuiMiMa": "I want to reset password with E-mail",
    "WoXiangYongShouJiZhaoHuiMiMa": "I want to reset password with phone number",
    "ShangWeiDengJiShouJiHaoMa": "Add a mobile phone number to be used to sign in to ESSA",
    "KuaGuoCaiGouPingTai": "essa.cn, an international purchase platfrom",
    "JingXuanTuiJian": "Recommendation",
    "QingTianXieZhenShiYouXiao": "Please enter the real and valid phone number. You can go to the next step after message verification. After you successfully register, you can log in with your E-mail.",
    "yi_jing_bang_ding_shou_ji": "Phone number is bound",
    "wu_xiao_yan_zheng_ma": "Invalid verification code",
    "yi_jing_bang_ding_email": "E-mail is bound",
    "shou_ji_yi_jing_bei_shi_yong": "Phone number is taken",
    "you_xiang_yi_jing_bei_shi_yong": "The E-mail is taken",
    "LiJiBangDing": "Bind now",
    "ShouJiHaoMaCunZai": "The number is taken",
    "ShuRuKuangBuNengWeiKong": "Blank input box prohibited",
    "ZhiShaoNGeZiFuZiMuYuShuZiZuHeQuFenDaXiaoXie": "At least 6 characters, numbers with letters, case sensitive",
    "DianJiDengLu": "Log in",
    "QianWangBangDing": "Go to bind",
    "NinHaiWeiBangDingShouJiHaoMa": "Your phone number is not bound",
    "DianJiChaKanGengDuoYouZhi": "Click here for more good products-essa.cn, an international purchase platform for toys",
    "ChongZhiMiMa": "Reset password",
    "QuYanZheng": "To verify",
    "DiJiaReXiaoPinCuXiaoTuanG": "The Best-selling Products r with Low Price for Promotion & Group Purchase.",
    "MeiYueGengXinPinPaiReXiao": "Updated Best-selling Brands Toys Monthly,Group Purchase Right Now",
    "TuanGouShuoMing": "Group Purchase Profile",
    "HuoBaoTuanGou": "The Most Popular Group Purchase",
    "TuanGouShuoMing1": "Group Purchase promotion:  Group Purchasing, to buy supreme",
    "TuanGouShuoMing2": "New updating at the 1st of each month, 30 days flashing sales time",
    "TuanGouShuoMing3": "Activity time: Start from 1st ,to end of last day of each month .",
    "TuanGouShuoMing4": "The Rules of Promotion :",
    "TuanGouShuoMing5": "Each promotion item has a activity cartons number. Just achieve this cartons number ,the group purchasing can be success .",
    "TuanGouShuoMing6": "During the promotion time, you can select any activity product or delete it into your shopping cart at any time.",
    "TuanGouShuoMing7": "when the promotion product carton number is enough , we will send purchasing message to your email , you need to confirm it in 7days.",
    "TuanGouShuoMing8": "Once confirm purchase order , it can be cancel . but if over 7days , this order is still not confirmed , we will cancel your this promotion product purchasing .",
    "TuanGouShuoMing9": "you can add some promotion products when you chat with sales during promotion time , but it need you confirm to order right now .",
    "TuanGouShuoMing10": "when this promotion is success , these products you selected can be consolidation and make order . but if it is unsuccess，you still can choose original factory price and original min.order to make order .",
    "GuiZe": "Rules",
    "BangNingZhaoYang2": "Please click \"Find Samples For You\", ESSA searches items for you!",
    "BangNingZhaoYang1": "What to do if I can't find the item I want?",
    "FangWenGuoJia": "Access to users",
    "ReMenFenLei": "Top Categories",
    "ShangPinBaoHu": "Limited Product",
    "ChaKanQuanBuTuiJianPinPai": "View All Recommended Brands",
    "ZanWuPinPai": "No Matches Found",
    "JinYiGeYuePinPaiGuanZhuDu": "Latest month's top brands",
    "JinYiGeYuePinPaiShangXin": "Latest month's new arrivals",
    "XinZengNGeKuanShi": "<b>{0}</b> New items uploaded",
    "TuiJianPaiXu": "Sort By Recommended",
    "GuanZhuDuPaiXu": "sort by popularity",
    "GengXinKuanShuPaiXu": "Sort By New Arrivals",
    "ZhuYingLeiMu": "Main Categories",
    "ZhuYingShiChang": "Main Markets",
    "Jin90TianXunJiaCiShu": "Quotation In 90 Days",
    "Jin90TianDingDanLiang": "Orders in 90 Days",
    "RenZhengXinXi": "Verification Information",
    "GuanLianPinPai": "Relevant Brands",
    "GongChangZhanShi": "Factory Views",
    "ESSAZhanTing": "Product Shoppe",
    "DianJiShu": "Clicks",
    "ShangPinZhengShu": "Product Certificate",
    "JiangXuanZhongShangPinJiaRuGouWuChe": "Are you sure to add the item(s) seleted to the cart?",
    "ZhanTingXuanPin": "Showroom Products",
    "NinHaiMeiYouZhanTingXuanPin": "No showroom products found",
    "NinHaiMeiYouShiChangShangPin": "No market products found",
    "XuanPinShiJian": "Selected Time",
    "XiaoLiang": "Orders",
    "LiShiJiaoYi": "Orders History",
    "PiLiangJiaRu": "Add Selected",
    "ReDu": "Popularity",
    "NCiGuanZhu": "<b>{0}</b> Followed",
    "QiZhongYouKuanXuYaoSheZhiMaiTou": "not any {0} style needs to be set up marks",
    "QiZhongYouKuanXuYaoSheZhiTieZhi": "not any {0} style needs to be set up stickers",
    "DanKuanShangPinBuShiYongMaiTou": "No shipping marks for these products",
    "DanKuanShangPinBuShiYongTieZhi": "No stickers for these products",
    "DengLuChaJia": "Check Price with Sign In",
    "JiZhuMiMa": "Remember me",
    "QingXuanZeQuYuZhanDian": "Please Select The Region of Sales Market",
    "DengLuZhuanXiang": "Login ESSA Membership Benefits",
    "ChaKanChuChangJiaGe": "Check <b>Real</b> EXW Price",
    "SuiShiZhiJieYiJia": "<b>Price Negotiation</b> with Factories Anytime",
    "KeJiShiChaKanXinPin": "Check <b>Over 2,000 New Toys</b> Update Online Daily",
    "ShiFouSuoYouShangPinBuShiMaiTou": "Do not use shipping mark for all the items?",
    "ShiFouSuoYouShangPinDouShiYongMaiTou": "Use {0} shipping mark for all the items？",
    "ShiFouSuoYouShangPinBuShiYongTieZhi": "Do not use sticker for all the items？",
    "ShiFouSuoYouShangPinDouShiYongTieZhi": "Use {0} sticker for all the items？",
    "Ci": "time/times",
    "XinPinXuDengLuHouFangKeChaKan": "Only When You Log in, Will You Check New Arrivals.",
    "JinRuGongChang": "Factory Entrance",
    "XinPinYuShouShuYuGongChang": "New Pre-sale Products Are Not Pushed into Factory Production Now, Please Log in Your ESSA Varified Account to Check.",
    "XinPinYuShouMeiYue": "New Pre-sale Products Are Updated For One Time on 1st Day of Every Month,Latest Procusts on Markets Are For You Regularly.",
    "WoYaoDiJia": "Lower Price",
    "DengLuHouKeJian": "To be Checked After Login",
    "QingTianXieZhenShiJiaGeWuEYiYaJia": "Please fill in the real purchase quantity and price, please do not negotiate unreasonably, otherwise the factory will refuse the transaction.",
    "ZhanShiXinXiHuoQuYouHuiJiaGe": "When negotiating the price, we will show your information to the factory to facilitate the factory to give a more favorable price.",
    "GongChangBaoJia": "Factory Quotation",
    "YiXiangJiaGe": "Target Price",
    "CaiGouXiangShu": "Purchase Quantity",
    "QuXiaoShouCang": "Cancel The Collection",
    "ChaKanQianKuanMingXi": "Debt Detail Check",
    "JieSuanDanHao": "Settlement No.",
    "JieSuanRiQi": "Settlement Date",
    "ChuHuoRiQi": "Delivery",
    "HuoGuiTiJi": "Square Meters of Container",
    "ShangPinHeJi": "Goods Total",
    "CaiGouShangBianHao": "Purchaser ID",
    "POBiZhang": "PO Currency",
    "BenDanYingShouFeiYongMingXi": "Charge List for The Order",
    "FeiYongRiQi": "Charge Date",
    "FeiYongXiangMu": "Charge Terms",
    "FeiYongJinE": "Charge Amount",
    "DaiZhiFu": "Unpaid",
    "CaiGouShangLeiJiDaiZhiFuFeiYongHeJi": "Accumulative Unpaid Total Charge for Purchaser",
    "MeiYuanDaiZhiFu": "Unpaid USD",
    "RenMinBiDaiZhiFu": "Unpaid CNY",
    "PODanShangPinMingXi": "Goods List of PO",
    "ShangPinID": "Item No.",
    "GongChangBianHao": "Factory No.",
    "DingGouXiangShu": "Purchase Cartons",
    "ZongShu": "Total",
    "DengJiRiQi": "Registration Date",
    "YiShouKuan": "Receipt Done",
    "QianKuanJinE": "Debt Amount",
    "YuJiFuKuanShiJian": "Payment Time Prediction",
    "YiBianDong": "Already Changed",
    "BuHuoChiShangPinYouYiChang": "Abnormal Goods in Complement Pool",
    "POShangPinShengChanZhongYouYiChang": "Abnormal Production for Goods of PO",
    "WoYaoBuHuo": "I Want Goods Complement",
    "WoYaoDiaoRuShangPin": "I Want Transshipment",
    "YouGongChangFanKuiShangPin": "Goods with Factory Feedback",
    "WoDeDingDanYaoQiu": "Requests for My Orders",
    "ShouJiPaiWanJuZhaoGongChang": "Find factory instantly by toy's photos in mobile",
    "LiJiTiYan": "Try Now",
    "PaiTuZhaoYang": "Search toys by photos",
    "ZhaoDaoWanJuYangPinZhaoPian": "Select item's ( sample's ) photos/ Take photos for items in the Expo or shops, etc.",
    "SuiShiSuiDiShangChuanTuPianChaZhao": "Input \" m.essa.cn \" in your mobile browser at any time, click \" Search toys by photos\"，and upload the sample photos.",
    "ShangChuanHouTuiJianXiangSiKuan": "After you upload the photos, the items details will be searched automatically by system and ESSA will also recommend the similar items for you.",
    "HaiKeYiJingXingRenGongZhaoYang": "What to do if I can't find the item  by\"Search toys by photos\"?  Just submit your requirements and the ESSA professional team will search items for you.",
    "KeHuZongQianKuan": "Overdue payment",
    "DaiZhiFuDingJin": "Deposit Unpaid",
    "BuManGuiTxt": "Less Than Full Container",
    "HongSeDaiBiaoWeiDu": "The Red Represents Unread",
    "MeiYouZhaoDaoFuHeTiaoJianSP": "Sorry ! No matches found. Please try again or change Place of Origin",
    "BaoHanDuanTuYunFei": "Including Domestic Freight",
    "WeiHuoZhongMeiYouZhaoDao": "No matches found for {0} in stock",
    "GouWuCheZhongMeiYouZhao": "No matches found for {0} in your shopping cart. Please add what you want to cart for latest price and replenish it soon",
    "GouWuCheZanWuShangPin": "No Items in your shopping cart now. Please add your items to cart and get latest price",
    "ChongDanZhongMeiYouZhao": "No matches found for {0} in your shipping time",
    "ChongDanZanWuShangPin": "No matches found for your shipping date",
    "QiTeXinPin": "New Novelty Toys",
    "WeiNinJingXuan": "Just for you",
    "ShouFaMingYouPinPai": "Famous brands priority",
    "DaoDiLaKanKanQiTaShangPin": "PAGE END",
    "GongNeng": "Function",
    "BaoQianNinXuanZeDeShiJian": "Sorry!No matches found in this period",
    "WoMenWeiNinTuiJianZuiJinY": "The month's New arrivals recommended",
    "ZuiJinLiangGeYue": "Recent two months",
    "WoMenWeiNinTuiJianZuiJinYiZhou": "The week's New arrivals recommended",
    "GenJuShangMianDeShangPinJ": "Commodities That You May Like.",
    "ShangPinBianMaGongChangHu": "Item/ Factory No. Search",
    "XiaoShouDiQu": "Sales Regions",
    "DiYiShiJianTuiJianXinPinReXiaoPin": "You can be proposed with new & hot products up to your purchase categories and for your regions at the earliest time.",
    "NinDangQianHaiWeiYouErJiYongHu": "You have no second-level users until now",
    "YiChengGongFuZhiWoDeYaoQingLianJie": "My invitation link only has already been copied successfully.",
    "TuiGuangYaoQing": "Promotion Invitation",
    "ChengNuoBuHuiDuiWaiGongKaiXinXi": "Information privacy of formal invoice & receipt and so on should  follow confidentiality agreement and be protected by ESSA platform.",
    "ShenFenZhengHaoHuoHuZhao": "If your are from China Mainland please input ID Number,otherwise please input passport number.",
    "FenXiaoShangDengLu": "Distributors Login",
    "Wo": "Me",
    "JiangYaoQingMaGaoZhiHaoYou": "Informing Friends of Invitation Code",
    "ShangESSAZhuCeBingTianRuYaoQingMa": "To Registrate ESSA & Fulfill Invitation Code",
    "WeiBaoZhengZhangHaoYanZheng": "To make sure of your safe account,please firstly varify it by binding your cellphone No.",
    "SheZhiXinDeDengLuMiMa": "Setting up New Login Passwords",
    "WoDeFenXiaoZhongXin": "My Distribution Center",
    "LeiJiYiTiCheng": "Accumulative Commission Already Maken",
    "LeiJiTiCheng": "Accumulative Commission",
    "WuFaYanZhouQingLianXi": "Please contact customer consultant for help,if you cannot varify by cellphone.<a id=\"udesk_container_btn\" class=\"a-link\" href=\"javascript:void(0);\">contact customer consultant</a>",
    "WoDeTiCheng": "My Commission",
    "BenYueTiCheng": "Commission for This Month",
    "WanChengZhuCeGuanXiBangDing": "Registration Done,Relations Binded",
    "YaoQingHaoYouXinXiC": "3. You can check information of your purchaser friends by \"My Promotion Users\" once his/her registration done successfully. If that not able to be found, please contact ESSAONE online customer consultant for help. (Only when your binding successful , can you enjoy the commission of his/her deal)",
    "TiChengTongJi": "Total Commission",
    "TiChengJinE": "Commission Amount",
    "TiChengDianLv": "Commission Rate",
    "YuJiTiCheng": "Commission Predicted",
    "DingDanHuoKuan": "Order Amount",
    "YuJiTiChengJinE": "Potential Commission Amount",
    "YongHuDengJi": "User's Grade",
    "YuJiDingDanHuoKuan": "Potential Order Amount",
    "HeJiFanTiJinE": "Summary of Commission Amount Rebated",
    "WoDeTuiGuangYongHu": "Users by My Promotion",
    "HiJiYuJiTiChengJinE": "Summary of Commission Amount Potential",
    "YiJiYongHu": "1st Batch of Distributors",
    "ErJiYongHu": "2nd Batch of Distributors",
    "ZhuYaoChuHuoFangShi": "Main Way to Deliver",
    "WoDeTuiGuangYaoQingMa": "My Invitation for Promotion",
    "GongShangZhiZhaoHao": "Commerce & Industry License No",
    "ShuiWuHao": "Tax No.",
    "WoDeZhuanShuYaoQingLianJie": "My Invitation Link Only",
    "QingTianXieShuiWuHao": "Please fulfill with Tax No.",
    "FuZhiWoDeZhuanShuYaoQingLJ": "To Copy My Invitation Link Only",
    "QingTianXieGongShangZhiZhaoHao": "Please Fulfill with Commerce & Industry License No.",
    "WoDeYaoQingMa": "My Invitation Code",
    "YaoQingMaMoRenBangDingShouJi": "Invitation Code Impliedly Consented to Your Binding Cellphone",
    "QingXuanZheZhuYaoChuHuoFangShi": "Please Choose The Main Way to Deliver",
    "GuoJiDiQu": "Nationality/Region",
    "FenXiang": "To Share",
    "ShangPinXinXiJiLianJieYiJingFuZhi": "Info.& Link of Commodity Copied Already",
    "ZhengJianHaoMa": "Certificate No.",
    "NinKeYiZhanTieFaSongGeiPenYou": "You can paste and send to friends on chatting APP or email.",
    "ZhengJianZhaoPian": "Photo of Certificate",
    "JinJiLianXiRenXinXi": "Information of Urgent Contact Person",
    "WoShiCaiGouShang": "Purchaser I am.",
    "NinTiGongDeJinJiLianXiRenYaoQiuMiaoShu": "Your providing urgent contact person should be the one to reach you in time and more easily than others.",
    "WoShiFenXiaoShang": "I am distributor.",
    "WoDeTuiGuangXinXi": "My Promotion Info",
    "TuiGuangYaoQingJieShao": "Invitation Instruction for Promotion",
    "YaoQingHaoYouWoKeDe": "What I Get by Friends Invitation",
    "WoDeSuoYouTuiGuangYongHu": "All Users by My Promotion",
    "WoXiaJiaYaoQingHaoYouWoKeDe": "What I Get by My Distributor's Friends Invitation",
    "DingDanWanJieFanYong": "Commission Rebate for Complete Order",
    "WoHaoYouKeDe": "What My Friends Get",
    "NZheKou": "Discount at {0}",
    "ShouDanZheKouQuan": "Discount Coupon for Initial Order",
    "LianXiDianHua": "Contact Phone",
    "YaoQingTiXing": "Reminder of Invitation",
    "YaoQingHaoYouXinXiA": "1. You can copy invitation link to share with your purchaser friends and help them registrate ESSAONE member.",
    "YaoQingHaoYouXinXiB": "2. You should remind your purchaser friend that he/she should be aware to fulfill your cellphone invitation code,so that to be binded with your account.And you will enjoy the commission of his/her deal amount.",
    "EPLUSHuiYuan": "E-PLUS Members",
    "YaoQingLiuCheng": "Invitation Process",
    "LeiJiXiaDanShu": "Accumulative Volumn of Orders",
    "TongGuoLianJieYaoQingKeHuPengYou": "Purchaser Friends Invitation by Link",
    "LeiJiChengJiaoJinE": "Accumulative Deal Amount",
    "FuZhiYaoQingLianJie": "To Copy Invitation Link",
    "ZuiHouYiCiChengJiaoShiJian": "The Latest Deal Time",
    "TongGuoIMFenXiang": "To Share by Socializing APP",
    "NinDangQianHaiWeiTuiGuangYao": "You have no users invited by your promotion until now",
    "HuoTongGuoYouJianFenXiang": "Or to Share by Email",
    "HaoYou": "Friends",
    "QuTuiGuang": "To Promote",
    "DianJiLianJieWanChengZhuCe": "Registration Done by Clicking The Link",
    "NinDangQianHaiWeiYouTiCheng": "You have no commissions until now.",
    "GuanXiBangDing": "Relations Binded",
    "FenXiaoZhongXinShouYe": "Distribution Homepage",
    "TongGuoYaoQingMaYaoQingKeHu": "To Invite Purchaser Friends by Invitation Code",
    "TuiGuangYongHuChaXun": "My Promotion Users",
    "ContactQueryError": "Checking Error for Contact Person",
    "AccountQueryError": "Checking Error for Distributor's Account",
    "DistributorQueryError": "Checking Error for Distributors",
    "BankAcountQueryError": "Error for Getting Bank Account Info.",
    "ShouJiHaoMaBuNengXiangTong": "It should be different cellphone No.between primary account & urgent contact person.",
    "ShouJiHaoMaError": "Cellphone No. Error",
    "YanZhengShiBai": "Please try it again due to failed verification.",
    "ChongXinHuoQuYanZhengMa": "Renew Verification Code",
    "YiJi": "First-level",
    "ErJi": "Second-level",
    "SheZhiXinMiMa": "Setting New Passwords",
    "ShenFenYanzheng": "ID Verification",
    "GenHuanXinDeShouJiHao": "To Change Cellphone Number New",
    "GenHuanChengGong": "Successful Renewing",
    "GengHuanBangDingShouJi": "To Renew Cellphone Binding",
    "ChongXinDengLu": "Relogin",
    "QingYongShouJiHaoChongXinDengLu": "Please resign in with new cellphone number.",
    "NinDeZhangHaoYiQieWeiXinShouJiHaoMa": "Your user name/account has been transferred to be new cellphone number.",
    "BangDingDeShouJiGengHuanChengGong": "The renew cellphone binding is successful.",
    "DangQianYiBangDingShouJiHaoMa": "The Cellphone Number Binding Now Already",
    "TiJiaoRenZheng": "Uploading Authentication",
    "DangQianShouJiHao": "Cellphone No. Used Now",
    "MiMaZuHeGuiZe": "6 to 20 characters ,including combination with either two of  numbers,letters or symbols.",
    "KaiJuFaPiaoBingQieZunShouBaoMiXieYi": "Information of formal invoice & tax receipt and so on should be protected privately and obey ESSA privacy agreement rules.",
    "JinJiLianXiRenXingMing": "Emergency Contact Name",
    "JinJiLianXiRenHaoMa": "Cellphone for Emergency Contact Person",
    "KaiHuHang": "Opening Bank",
    "KaiHuMing": "Opening Name",
    "YinHangZhangHao": "Bank Account",
    "QingTianXieXingMing": "Please Fill up Name",
    "QingTianXieZhengJianHaoMao": "Please Fulfill Certificate Number",
    "QingTianXieJinJiLianXiRenXingMing": "Please Fulfill Emergency Contact Name",
    "QingTianXieJinJiLianXiRenHaoMa": "Please Fulfill Emergency Contact Cellphone Number",
    "MiaoHouZiDongTiaoZhuanDengluYeMian": "Automatically Transfer to Login Page in 0 Second",
    "QingBangDingShouJiHao": "Please Bind Phone Number",
    "TouXiang": "Headphoto",
    "YouHuiQuan": "Coupon",
    "WeiShiYongYouHuiQuan": "No Coupons Used",
    "YiShiYongYouHuiQuan": "Coupon Used Already",
    "YiGuoQiYouHuiQuan": "Already Expired Coupon",
    "ZanWuWeiShiYongYouHuiQuan": "Coupon Not Used Until Now",
    "ZanWuYiShiYongYouHuiQuan": "Now No Coupons Used Already",
    "ZanWuYiGuoQiYouHuiQuan": "No Coupons Expired Now Already",
    "ShouHuoRenXinXi": "Consignee Info.",
    "MianDingJinXiaDan": "Free Deposit For Order Placing",
    "ReMaiShangPinTuiJian": "Hot-selling Products Proposed",
    "GenJuDaShuJuFenXiAnDiQuAn": "Hot-selling products should be proposed to E-plus members up to regions and time,according to general data analysis",
    "ZhuanShuKeFu": "Unique Customer Consultant",
    "ZaiFuWuGuoChengZhongYuDao": "Any question from E-Plus is prior to be answered during service offered by ESSA.",
    "XinZengShouHuoRen": "Consignee Newly Added",
    "XinZengShouHuoRenXinXi": "New Consignee Information",
    "BianJiShouHuoRenXinXi": "Edicting Consignee Info.",
    "ShanChuShouHuoRenXinXi": "Delete Consignee Info.",
    "ShiFouShanChuShouHuoRenXi": "To delete consignee info. or not",
    "GengDuoLianXiRen": "More Contact",
    "ZanWuShouHuoRenXinXiNinKe": "The lack of consignee information now should be fulfilled by you.",
    "ShouHuoRen": "Consignee",
    "QingShuRuShouHuoRen": "Please Input Consignee",
    "QingShuRuShouJi": "Please Input Cellphone No.",
    "MuDeDiChengShi": "City of Receiving good",
    "QingXuanZeMuDeDiChengShi": "Please select the city of receiving good",
    "XiangXiDiZhi": "Detail Add.",
    "QingShuRuXiangXiDiZhi": "Please input detail Add.",
    "WeiLeXiangHeXinKeHuTiGong": "To offer ESSA main purchasers better shopping experience, E-plus of ESSA members is promoted for more shopping benefits,including Free Deposit for Order Placing,Proprietary Favorable Products,Proposed Hot-selling Products,Discount Enjoying Only and Exclusive Customer Consultant and so on",
    "LaiYuanYongTu": "Origin/Usage",
    "HuoDeGengDuoQuanYi": "Get More Benefits",
    "MaiJiaChengJiaoDingDan": "LTD Orders Completed by Buyer",
    "LianXiKeFu": "Customer Service",
    "WanChengYiXiaQiZhongYiGeT": "You can be E-plus the time you meet any condition as below",
    "YaoQingManRenZhuCeBingRen": "Once you invite {0} to register & finish verification or invite one friend & make a deal,you are E-Plus enjoying free deposit",
    "JiaRuXiangZhuanShuTeQuan": "To join in E-Plus and enjoy special benefits only.",
    "QingShangChuanZhaoPinHeDuiXinXi": "Your personal information should be protected by ESSA Privacy Policy, and please upload your certificate photo so that convenient for us to verify your real information.",
    "YinHangKaXinXi": "Bank Account Info.",
    "FenXiaoShangYinHangZhangHaoYongYuFanLi": "Distributors should offer correct bank account information for later rebates.",
    "QueRenQiYeXinXi": "To Confirm Enterprise  Info.",
    "QueRenShouHuoDiZhi": "To Confirm Add. for Delivery",
    "SheZhiDingDanYaoQing": "Order Requirements Setting",
    "ZhuCeZhengShuBianHao": "Registered Certificate No.",
    "QingTianXieZhuCeZhengShuBianHao": "Please Fulfill Registered Certificate No.",
    "TiGongZhengGuiDePiaoJu": "The info. you fulfill is necessary and will be used to make receipt like formal contract,invoice and so on by us",
    "ZunXunPingTaiBaoMiXieYi": "Your info. must be protected & strictly followed Privacy Policy on ESSA Platform",
    "DDPFuWuGuoJia": "DDP receiving good country",
    "YuJiDaoGangShiJian": "Estimated Delivery Time",
    "ShangPinHuoKuan": "Value of Goods",
    "WuLiuQingGuanFei": "Logistics & Customs Clearance Freight",
    "WeiBuYingXiangDingDanYuJiDaoGangShiJian": "Attention! In order not to break estimated delivery time,please pay the deposit as soon as possible,because the estimated delivery time will be delayed up to exact date that deposit received.",
    "Zhou/Sheng": "State/Province",
    "ChengShi": "City",
    "GaiChengShiZanWuShouHuoDiZhi": "There's no Add. for delivery now,which can be added firstly",
    "QiTaGuoJiaTuoZhanZhongHouXuKaiFang": "Other countries and cities are under development and covered later",
    "GaiYouHuiQuanYiBeiQiTaZhangHaoXuanYong": "The Coupon has already been used for other branch account",
    "BuShiYongYouHuiQuan": "Not to Use Coupon",
    "ManN": "Full US{0}",
    "YuJiDingJin": "Predicted Deposit",
    "ZongHuoKuan": "Total Value",
    "ShiYongYouHuiQuan": "To Use Coupon",
    "ZanWuKeYongYouHuiQuan": "No Available Coupon Now",
    "XuanZeYouHuiQuan": "Choose Coupon",
    "DDPBuZhiChiPinWeiHuo": "The consolidation of neither the remaining stock or custom materials commodities is not allowed by DDP. What's more, once quotation changed meanwhile related commodities deleted automatically. Are you sure to change?",
    "ZanShiMeiYouChangYongBaoJiaFangShi": "The Lack of Usual Terms of {0} Quotation Now",
    "SanDanJiChuJianJie": "DDP is a full service that delivering consolidated small orders together weekly to buyer's warehouse,meanwhile customs clearance and payment of tax are done.The wholesalers abroad for small amount can directly purchase toys from Chinese factories",
    "WoYiYouZhangHaoDengLu": "Already Have Account ,<a class=\"red\" href=\"/login\"> Sign-in Right Now</a>",
    "XiaYiBuQueRenShouHuoXinXi": "Next Step, to Confirm Consignee Info.",
    "GengHuanMuDiDiZhiYingXiangJiaGe": "Please pay attention that the shipping cost and delivery time will be changed if you change the city of receiving good.",
    "QingTianXieXiaDanRenXingMing": "Please Fulfill Name of The Order Part",
    "QingTianXieXiaDanRenShouJi": "Please Complete Cellphone of The Order Part",
    "QingXuanZeShouHuoRenXinXi": "Please Select Consignee Info.",
    "QingXinZengBingXuanZeShouHuoRen": "Please Newly Add & Select Consignee Info.",
    "XiaDanRenXinXi": "Info. of The Order Part",
    "ShouJiHaoMao": "Cellphone No.",
    "MuDiDiXinXi": "City information of receiving good",
    "JinZuoWeiShouHuoRenWuFaLianXiShi": "Please complete & confirm Info. of the order part if there's abnormal order later which should be dealt with by reaching them",
    "LiaoJieGengDuo": "To Know More",
    "SanDanJiChuFuWuJianJie": "To help you enjoy direct toys purchase from China with the lowest cost by DDP Service.",
    "GenJuZhuXiaoShouDiQuPiPeiFuWuGuoJiaHeChengShi": "To get more exact offer please select your receiving city,and your current receiving country should be matched up to the sales regions registered already by you.",
    "QingZaiGongSiXinXiZhongXiuGaiDDPMuDiChengShi": "The receiving city you've selected this time will be a quotation basis of DDP,so please make it correct by Online Company Info. in Help Center",
    "GengDuoChengShiKaiTongDDPFuWu": "Please looking forward to more cities being covered.",
    "BaoJiaGuiZe7": "The Standard Principles of DDP Quotations",
    "BaoJiaGuiZe8": "EXW Price for Item + Logistics & Customs clearance (DDP quotation is not including local delivery from the destination warehouse to customer address , it is afforded by customer .",
    "MetaMiaoshu": "ESSA is a China factory toys sourcing & trading platform covering with over 20,000 factories and including 1 million non-repetitive SKU.",
    "FuWuGuoJia": "Receiving Country",
    "BianJiMuDiDiXinXi": "To Edict Consignee Info.",
    "QingXuanZeMuDiChengShi": "Please Select The Receiving City",
    "YuJiDaoGangShiJianTuiChiT": "Notice of estimated delivery time",
    "ZhuYiLiShiYuJiDaoGangShiJ": "Please note: that all delivery times should be checked in PO Tracking.",
    "XinYuJiDaoGangShiJian": "Newly Delivery Time",
    "YuanShiYuJiDaoGangShiJian": "The Original Delivery Time",
    "NiHaoWoShiNiDeFuWuGuWen": "Hello! I'm Your Service Consultant.",
    "ShouHuoXinXi": "Related Consignee Info.",
    "XinDingDanDouShiYongGaiBaoJiaZuHe": "All New Orders Should be with The Terms of Quotation",
    "QingJinKuaiZhiFuDingJinYu": "Please soonly pay the deposit, because the delivery time will be changed even delayed up to the time we receive your deposit.",
    "YouYuWeiShouDaoDingJinDin": "Because the order deposit was not paid on time, the order could not be placed on factory, the delivery time of the order was delayed to {0} (originally {1}), please pay the deposit as soon as possible.",
    "YouYuWeiShouDaoHuoKuanZao": "Because the order payment was not paid on time, the products will be delivered later than it was estimated originally, the delivery time of the order was delayed to {0} (originally {1}), please make the payment as soon as possible.",
    "ShangPinShengChanGuoCheng": "Products cannot be produced on time and the estimated delivery time of the order was postponed to {0} (original date {1}), please pay attention to the updates.",
    "ShiHuo": "HOT SELLERS",
    "NinDeDingJinYiShouDaoBing": "Your deposit is already received, please confirm PO and your order will be pushed into factory production",
    "NinDeDingDanYiTiJiaoQingZ": "Your order has been submitted, please pay the deposit promptly to confirm your order!",
    "QueRenPO2": "To Confirm PO",
    "NinDeDingDanShangPinYiJin": "The production of your order is already complete,so please pay the balance deposit soon to make usual delivery.",
    "NinDeDingDanYiJingZhuangJ": "Your order loading is ready and gone ,and please pay remaining balance in time to avoid abnormal commodities receiving.",
    "FuKuanZhiYin": "Guidelines for Payment",
    "YiZhiFuDingJin": "Deposit Already Paid",
    "DanHaoFaSongDaoShouJi": "PO No. Sent to Cellphone",
    "DanHaoYiJingFuZhi": "PO No. Already Copied",
    "DanHaoYiJingFaSongDaoShou": "PO No. Already Sent to Cellphone",
    "FaSongDaoShouJi": "To Send to Cellphone",
    "ZheHe": "Equivalent to",
    "GongXiNin_Shi": "Congratulations! PO submitted successfully and deposit received already. Please soonly click \"Confirm\" button to confirm PO before factory production started.",
    "GongXiNin_ShiYi": "Congratulations, you have successfully submitted the PO, our staff will contact with you later, after confirming your goods are correct, please pay the deposit to the bank account as below and confirm the PO again . The balance payment will be paid before the goods arrive at your destination port; if have any question, please Contact with your sales consultant.",
    "ShouKuanRen": "Consignee",
    "YouHuiJinE": "Favorable Amount",
    "ShouBiDingDanDingJinWei": "Deposit for the first DDP order is {0}.",
    "ShouBiDingDanQieDingDanZo": "The first DDP order with total volumn {0} and deposit {1}.",
    "QingZaiNTianNeiZhiFuDingJin2": "Please soonly pay the deposit, because the estimated delivery time will be changed even delayed up to the time we receive your deposit.",
    "BuHaoYiSiGuiSiDangQianWeiTiJiaoDdp": "Sorry. Please firstly submit DDP orders unsubmitted or modify the terms of quotation to be not DDP price,but sales regions forbidden to be modified because there's unsubmitted DDP orders for your company now.",
    "ChaKanShiLi": "To Check the Example",
    "FaSong": "Sending",
    "HuiKuanZhongXieDanHao": "Please fulfill  the corresponding PO No. in the remittance information to facilitate confirmation of the deposit and arrange production.",
    "YiXiangKuaiChu": "One-carton Fast Shipping",
    "XianShangZhanTing": "You May Like",
    "GuangYiGuang": "Go Around !",
    "ShouDanYuFuZhiXuN": "<b>Only 10%</b> Prepaid for Initial Order",
    "XuanZeDDPKeYiXiangWiDing": "MOQ 1 carton only when you choose DDP term, meanwhile enjoying ESSA service of the whole logistics & customs clearances done as well as fast shipping home.",
    "NNianDiNQi": "{1} Chapter in  {0}",
    "JuLiHuoDongJieShu": "The Remaining Time to The End",
    "WanJuGaiBan": "Revision service",
    "NGeJieGuo": "{0}results",
    "BangNinZhaoYangRuKouYiDong": "Here is New Entrance of Find Samples for You",
    "NinDeDingDanShuJuYiFaShengBian": "Please update the page before submitting due to info. of ur order has been changed.",
    "WeiNinTiGongZuiJiaDeDingZhiJieJueFangAn": "To offer the best custom methods of solving for you.",
    "ZhuanYeDeGaiBanTuanDui": "Professional Revision Group",
    "ChuSeDeChanPinTuanDuiNNianJingYan": "Outstanding Product Team , 10-year Revision Experience , Uncountable Successful Brand Cases",
    "YouZhiDeGaiBanFuWu": "Superior Revision Service",
    "QiangDaDeGongYingLianZhiChi": "The revision conditions good for u thanks to great support by supply chain of ESSA",
    "GaiBanShangPinYanMiBoaHuQiTaKeHuBuKeJian": "The primacy of revision products must be protected strictly, not shared with other customers.",
    "KuaiSuXiangYingNinDeXuQiu": "Your demands should be responded rapidly.",
    "YiJianTiJiaoKuaiSuXiangYing": "One-button Submit, 24-hour Fast Response",
    "YiXiangChuHuoDeShuoMingNeiRong": "All the products in One-carton Fast Shipping meet special requirements of both Min.Order=1 and Factory Delivery ≤ 10 Days. One-carton Fast Shipping is a guarantee of  available one-carton purchase & 10-day fast delivery.",
    "ZaiGouWuCheZhongTianJiaShangPin": "Add items into your shopping cart",
    "ChuHuoShiJian": "Fastest Delivery",
    "MeiGePoDanZuiDuoKeFa": "Send up to three text messages in seven days",
    "ZhangHuMingCheng": "Beneficiary Account Name",
    "ShouKuanRenDiZhi": "Beneficiary Address",
    "YinHangMingCheng": "Beneficiary Bank Name",
    "YinHangHaoMa": "SWIFT Code",
    "YinHangDiZhi": "Beneficiary Bank Address",
    "KeHuYinHang": "Opening Bank",
    "DaiLiZhangHao": "Agent Account",
    "YinHangTongYiDaiMa": "Union Bank Code",
    "ShangPinBuZhiChiDDP": "this product don't support DDP service price",
    "QingTianXieLianXiFangShi": "please fill in your contact information",
    "LianXiFangShiBiXuWeiShuZi": "contact information must be Number",
    "LianXiFangShiYiCunZai": "Contact information already exist ,please re-enter again",
    "DuanXinYiFaSong": "SMS has been sent",
    "ChaKanDingDanXiangQing": "Check order details",
    "ShangPinKuanShu": "Product items",
    "ShuLiangZongJi": "Total quantity",
    "DingDanSuoXuHuoKuanDanBaoEDu": "The amount of guarantee required for the orde",
    "PiLiangFuZhiPODanHao": "Copy order number",
    "PiLiangFaSongPODanDaoShouJi": "Send order number to mobile phone",
    "PiLiangFuZhiPoDanDeShuoMing": "Please fill in the PO number which sent to your mobile phone on the payment slip",
    "XuZhiFuDingJinHeJi": "Need to pay a total amount of deposit",
    "FuKuanXinXi": "Payment information",
    "ChaKanGuDingBaoZhengJinDengJi": "Check your fixed margin levels",
    "QueDingDingDan": "Confirm order",
    "DingDanYingFuZongJinE": "Total amount for the order you should pay",
    "GongXiNinYiTiJiaoPOQingJiShiQueRenPO": "Congratulations, you have successfully submitted your PO. We have split the order into {0} orders according to the delivery date of your purchase, so that you can receive the goods as soon as possible. Your current margin guarantee amount is enough, please click \"confirm\" order.",
    "YiTiJiaoPOQingLinXiZhuZhangHaoTiShengDengJiChaiDan": "Congratulations, you have successfully submitted your PO. We have split the order into {0} orders according to the delivery date of your purchase, so that you can receive the goods as soon as possible. However, your current margin guarantee amount is not enough, please contact your main account and increase your fixed margin level.",
    "YiTiJiaoPOQingTiShengDengJiYiMianYanWuShengChan": "Congratulations, you have successfully submitted your PO. We have split the order into {0} orders according to the delivery date of your purchase, so that you can receive the goods as soon as possible. However, your current margin guarantee amount is not enough, please raise your margin level as soon as possible.",
    "QingXuanZeKeDanBaoDeDingDanHuZeTiShenDengJi": "Congratulations, you have successfully submitted your PO. We have split the order into {0} orders according to the delivery date of your purchase, so that you can receive the goods as soon as possible. However, your current margin guarantee amount is not enough to guarantee all orders, please choose a guaranteeable order for guarantee or please raise the margin level as soon as possible.",
    "QingBuQiBaoZhengJinEDuYiMianYanWuShengChanChaiDan": "Congratulations, you have successfully submitted your PO. We have split the order into {0} orders according to the delivery date of your purchase, so that you can receive the goods as soon as possible. However, your current margin guarantee amount is not enough. Please recharge as soon as possible and raise your margin.",
    "YIBianNinJinKuaiShouDaoHuoWuQingJIShiZhiFuDingJin": "Congratulations, you have successfully submitted your PO. We have split the order into {0} orders according to the delivery date of your purchase, so that you can receive the goods as soon as possible. Please pay the deposit in time.",
    "NinDanQianWeiVIPMianDingJinKeHuQingZhiJieQueRenPOChaiDan": "Congratulations, you have successfully submitted your PO. We have split the order into {0} orders according to the delivery date of your purchase, so that you can receive the goods as soon as possible. Now,you are our currently VIP free deposit customer, please click \"Confirm\" order directly.",
    "ShouYeGuanJianCi": "ESSA.CN,Toys & Gifts,Baby items,Hot sale,New,Toys Suppliers, China Factory",
    "SouSuoYeBiaoTi": "Toys ,Gifts and Baby items direct purchase from China",
    "PinPaiYeBiaoTi": "Brand Zone -Find quality Factories,Manufacturers, Suppliers from China",
    "PinPaiYeGuanJianCi": "ESSA.CN,Toys&Gifts Suppliers,China Factory,Manufacturers",
    "ShouYeBiaoTi": "ESSA.CN - Toys & Baby items purchasing online,direct purchase from China",
    "ChaKanDaTu": "click the big picture",
    "ShuRuPinPaiMingChengShaiX": "Enter brand name to select",
    "QingKongSouSuo": "Clear search",
    "ZhaoBuDaoFuHeTiaoJianDePi": "Can't find a qualified brand",
    "NinKeNengHuiXiHuanDePinPa": "Brands you might like",
    "PingTaiRenZheng": "Platform approval",
    "GongChangRenZheng": "Factory certification",
    "SouSuoBenPinPaiShangPin": "Search for this branded item",
    "XiaZaiBaoJiaDan": "Download the quotation",
    "LianXiGongChang": "contact the factory",
    "DengLuHouChaKanGongChangL": "View factory contact after login",
    "MingXingShangPin": "Star product",
    "PinPaiShouZiMu": "Brand the first letter",
    "GuoLvJieGuo": "results of selection",
    "ShaiXuanXiang": "select item",
    "QingXuanZe2": "please choose",
    "ChanPin": "Product",
    "XuanZeZhengShu": "Select certificate",
    "ChaKan": "View",
    "NinYouZhangDaiDanBaoDeDinWuDengJiPiPei": "You have {0} orders to be guaranteed. The current margin level can only guarantee some orders. Do you want to confirm these some orders? Or contact your sales consultant to continue upgrading your level to guarantee all orders.",
    "NinHaiKeYiLianXiPingTai": "You can also contact the platform{0}",
    "ZaiXianKeFu": "online service",
    "XinPinDengLuHouKeJian": "Login to see New product",
    "ZhaoBuDaoFuHeTiaoJianDeSh": "Can't find meeting condition product , and you can return to view",
    "PinPaiQuanBuShangPin": "Brand all goods",
    "WuLiuShiJian": "shipping time",
    "TuiGuangDeKeHuSuoYouYiWan": "All invited registed customer the all completed orders total amount of commissions",
    "TuiGuangDeKeHuBenZiRanYue": "The total amount of all completed orders for the customers who have been invited registered at this month is subject to received the final payment .",
    "ZhiYaoYaoQingZhuCeDeKeHu": "the customers invited registered by the distributor .",
    "XiaShuYongHuYaoQingZhuCeD": "The customers invited by sub-user of the distributor",
    "GaiKeHuWanChengDingDanDeH": "The customer completes the order means subject to receive the final payment. The product payment refers to the factory price, not include any shipping and custom clearance cost .",
    "GaiKeHuWanChengDingDanKeY": "The all completed order commission is according to receive each order final payment.",
    "GaiKeHuYiFuDingJinWeiFuWe": "The customer had paid deposit but still not transfer final payment. The product payment refers to the factory price, not include any shipping and custom clearance cost .",
    "GaiKeHuYiFuDingJinWeiFuWe2": "The amount of the commission that the customer has paid deposit for the order but has not paid the final payment。",
    "GaiKeHuYiJingXiaDanDeDing": "The number of orders the customer has placed",
    "GaiKeHuYiJingXiaDanDeHuoK": "The total amount of the payment that the customer has placed ，this order payment means only the factory price, without any shipping and custom clearance cost",
    "DiQuShiChang": "area",
    "ShiPin": "video",
    "QingWuBiTianXieZhenShiDeD": "Please be sure to fill in the real phone number, and our staff will contact you for approving later.",
    "DDPBuZhiChiYiJia": "Bargaining Unavailable",
    "YongHuBianHao": "User code",
    "ZhuCeShiJian": "Registration time",
    "DengLuTianShu": "Login days",
    "ZuiHouDengLuShiJian": "last login time",
    "XuanPinKuanShu": "selected items quantity",
    "ZuiHouXuanPinShiJian": "Final selection time",
    "YongHuXiaDanXinXi": "Customer activity information",
    "KeHuXingWeiXinXi": "User order information",
    "TuiGuangDeKeHuSuoYouYiJin": "the customers had paid deposit but still not paid the final payment. The final commission is subject to the completion of the order.",
    "ZhuCeFuWuShang": "Trading company register",
    "TianXieZhangHaoXinXi": "fill in account information",
    "TianXieGongSiXinXi": "Fill in company information",
    "TiJiaoZhuCeRenZheng": "Submit registration certification",
    "ZiShaoNGeZiFuBuNengChunShuZi": "At least 8 characters, cannot be all number",
    "ShangChuanGongSiMenTou": "uploading the photo of company",
    "ShiLiTuPian": "sample picture",
    "ShangChuanGongSiYingYeZhiZhao": "Upload company business license",
    "ZhiChiDeWenJianGeshi": "Support jpg, png, photo size ≤ 5m",
    "GongSiJianCheng": "Company Abbreviation name",
    "GongSiDiZhi": "company address",
    "XiangXiDiZhiJieDaoMenPaiHao": "Detail address and street number",
    "SuoZaiSheng": "Province",
    "SuoZaiShi": "city",
    "SuoZaiQu": "city",
    "GongSiDianHua": "company phone",
    "QuHao": "Area code",
    "TongYiBingZhunShou": "Agree and Comply",
    "ESSAPingTaiFuWuShangTiaoKuan": "ESSA Platform trading company registration and Terms of Service",
    "ZhuCeZhangHao": "Register an account",
    "QingZhuYi": "Please Note",
    "WeiQueBaoXinXiZhenShiXingPingTaiJiangDuiNinXXXX": "To ensure your information is real, our company will review and check with you , and complete it within 1 working day.",
    "RenZhengShenHeJieGuoHuiYiXXXX": "The results of the certification review will be notified by SMS. Please pay attention to your SMS from our company.",
    "ZhiYouRenZhengTongGuoXXXX": "Just pass our company approve，your account can enjoy approve privilege.otherwise your account permission will be limited",
    "RuYouYiWenKeYuPingTaiXXXX": "If you have any questions, you can contact the platform customer service.",
    "ChaKanShangPinBaoJia": "Check product quotation",
    "HuoQuGongChangXinXi": "get the factory information",
    "XiangYongJiSuZhaoYanng": "Enjoy fast finding sample",
    "DuoYuYanDaoBaoJia": "multilingual download quotation",
    "GengDuoTeQuanTiYan": "More privileged experience",
    "FuWuShangDengLu": "trading company login",
    "WoShiFuWuShang": "I am trading company",
    "TuiJianChi": "Sample basket",
    "YiXiaShangPinWeiTuiJianChiL": "The following products are all in the sample basket",
    "WoDeTuiJianChi": "Your sample basket",
    "JiaRuTuiJianChi": "Put into the sample basket",
    "NKuanShangPinYiJiaRuTuiJianChi": "{0} items have been added to the sample basket",
    "ChaKanTuiJianChi": "View sample basket",
    "TuiJianChiZhongYiYouNKuanFuGai": "There is already {0}{1} in the sample basket, It ensure to the new quantity can recover the previous quantity at the same item in the sample basket",
    "CiKuanHuoDongShangPinNinYiQueRenGouMaiTuiJianChi": "You have confirmed the purchase of this event product, please check or adjust the quantity in the shopping cart.",
    "RenZhengYongHuCaiKe": "Only certified users can take part in activity. If you have any questions, please contact customer service.",
    "YuanGongDianHua": "Employee phone",
    "YuanGongDengLuMiMa": "Employee login password",
    "QingTianXieYuanGongDengLu": "Please fill in the employee login password",
    "YuanGongXingMing": "Employee name",
    "QingTianXieYuanGongXingMi": "Please fill in the employee name",
    "WaiYu": "Familiar with language",
    "ShuXiShiChang": "Be familiar with the market",
    "QingXuanZeWaiYu": "Please choose a familiar language",
    "QingXuanZeShuXiShiChang": "Please choose your familiar with the market",
    "GongSiMenTou": "company picture",
    "QingShangChuanGongSiMenTo": "Please upload the company photo",
    "YingYeZhiZhao": "business license",
    "QingShangChuanYingYeZhiZh": "Please upload a business license",
    "XiangXiDiZhiJieDaoMenPai": "Detailed address including street name and house number",
    "QingTianXieGongSiSuoZaiDi": "Please fill in the company's region, city, location, and detailed address.",
    "QueRenTiJiao": "confirm submission",
    "DengDaiShenHe": "waiting verify",
    "BianGengZhongYaoXinXiHouX": "After changing important information, it needs to be reviewed before it can take effect.",
    "YuanGongLieBiao": "Employee list",
    "ChuangJianShiJian": "Creation time",
    "SheZhiBossZhangHao": "Set a boss account",
    "QingXuanZeShuXiShiChangZu": "Please choose your familiar market, up to {0}",
    "QingXuanZeWaiYuZuiDuoGe": "Please select a familiar language, up to {0}",
    "BianJiYuanGongZhangHao": "Edit employee account",
    "XinZengYuanGongZhangHao": "Add employee account",
    "TiShengCiZhangHaoWeiZhang": "Upgrade this account to a BOSS account, you will be downgraded, can not manage company information and employee information",
    "ShanChuZhangHaoJiangWuFaH": "Deleting an account will not be restored. Are you sure you want to delete it?",
    "FuWuShangGuanLi": "trading company management",
    "QingTianXieYuanGongDianHua": "Please fill in the employee phone number",
    "WeiDengLuHuoWeiRenZhengQingRenZhengHouChaKanJiaGe": "Users who are not logged in or not authenticated, please log in or wait for authentication before you can check the price of the product.",
    "QingXianYueDuBingTongYiXXXX": "Please read and agree to the platform agreement before you can register",
    "TuiJianChiNeiZanShiMeiYouSh": "There are no items in the sample basket，you can add items to the sample basket",
    "QueDingCongTuiJianChiZhongS": "Are you sure you want to remove all selected items from the sample basket ？",
    "QueDingCongTuiJianChiZhongQ": "Are you sure to clear all expired items from the sample basket?",
    "QingTianXieZhengQueDeShouJi": "Please fill in the correct mobile number",
    "QingTianXieZhengQueDeQQ": "Please fill in the correct QQ number",
    "QingXuanZeMoBanYuYan": "Please select a model language",
    "MeiZhongTuiJianDanMoBanDo": "Each recommendation model supports Chinese, English and Russian languages. You can select the language according to your needs.",
    "ShangPinChuChangJiaGeSuiShiChaXunXXXX": "you can check product ex-factory price at any time, it is very convenient and fast",
    "ChangJiaLianXiFangShiQuanBuKaiFangXXXX": "All manufacturer contact information is all open, you are easy to get them .",
    "BaiWanShangPinKuZaiXianChaZhaoXXXX": "Million commodity library online search, at the same time still have offline service",
    "ZhiChiDaoQuZhongYingEBaoJiaDanXXXX": "Support download multilingual Language including Chinese, English and Russian quotations to meet your needs",
    "GengDuoQuanYiLuXuKaiFangXXXX": "More rights and interests are gradually open, experience prioritized",
    "RenZhengTongGuoHouNinJiangHuoDe": "After the approve is passed, you will get",
    "KanGuoDeRenYeKan": "Everybody's watching.",
    "YiTuZhaoXiangSiKuan": "Find similar models through the product  photo",
    "GaiGongYingShangDeChanPinLeiBie": "The supplier's product category",
    "AnLeiBieChaZhaoChanPin": "Find similar products by category",
    "DaJiaDouZaiSou": "Everyone is searching",
    "ChangJianZiXun": "Common consultation",
    "XunJiaJiLu": "Quotation Record",
    "ZanWuChangJianZiXun": "No common consultation",
    "ZanWuXunJiaJiLu": "No quotation record",
    "YongHu": "user",
    "XunJiaShiJian": "quotation record",
    "NGeChanPin": "{0} product",
    "ChaKanDuiBiShangPin": "View comparison products",
    "ChaKanDuiBiJieGuo": "Comparison results",
    "CanShuChongFu": "the parameter is repeat",
    "DuiBiShuJuYiJingDaDaoShangXian": "The comparison data has reached the Max limit of 5 , please delete and then add in it again",
    "YiJiaRuDuiBi": "already add compare",
    "YuGongChangTanJia": "Talk to the factory",
    "HeZuoNian": "Cooperation {0} years",
    "GongChangZiZhi": "Factory qualification",
    "XunJiaHuiFuLv": "Inquiry response rate",
    "JiaRuDuiBi": "Add compare",
    "ChaKanPinPai": "View brand",
    "QiWangJiangJia": "Expected reduce price",
    "JiangJiaHouJiaGe": "Price after reduction price",
    "KuanShiXuanZe": "Style",
    "BaoZhuangXinXi": "Packaging Information",
    "GaiBanXinXi": "Revised information",
    "CiKuanZhiChiGaiBan": "this item supports revision",
    "ZanWuDuiBiShangPin": "No comparison goods",
    "GongChangZaiPingTaiZhanSh": "The factory price on the platform is lower than other channels.",
    "YiXiangKuaiChuChanPinJiMa": "Fast sending products means it meet the \"Min.Order=1\" and \"shipment period ≤10 days\"",
    "ReXiaoChanPin": "hot selling product",
    "XunJiaHuiFuShiJian": "the reply time of quotation",
    "ShangPinChiCun": "product  size",
    "PingTaiXinPin": "Newly Released",
    "WoDeBianHao": "My ID",
    "ZanWuGouWuZiXun": "No purchase consultation",
    "GouWuZiXun": "Purchase Consultation",
    "ChiCunBaoZhuang": "Size and Packaging",
    "XunJia": "Add to cart",
    "QiDingLiang2": "MOQ",
    "EYuZhuanQu": "Russian packaging",
    "XiangYaoGengDiDeQingDianJ": "For a lower MOQ, please click 【Talk to the factory】",
    "XiangYaoGengDiDeQingDianJ2": "MOQ {0}",
    "MeiYouZhangHao": "No account",
    "ZhuCeFuWuShangZhangHao": "Registrar account",
    "EWenBaoZhuang": "Russian Packaging",
    "ChaKanGongSiZiZhi": "Qualification",
    "BoFangShiPin": "Play video",
    "YiXiangQiDing": "One Carton Available",
    "NTianFaHuoQi": "10 Days Delivery",
    "KuaiSuFaHuo": "Fast Shipping",
    "MeiYueTuanGou": "Group purchase",
    "RenZheng": "Confirm",
    "MeiYouZhaoDaoXXPiPeiNinKeYi": "No matching products found.  You can also choose :",
    "JianChaPinXie": "Check spelling",
    "ShiYongJiaoShaoDeGuanJianZi": "Use fewer keywords",
    "ShiYongBuTongDeDeGuanJianZi": "Use different keywords",
    "TianXieCaiGouXuQiu": "Fill out purchase requirements",
    "HuoZheGaoSuWoMenGengDuoXX": "Give more information about the product and within 24 hours you will receive an offer from the supplier",
    "MeiYouZhaoDaoPiPeiChanPinNinKeYi": "Can't find eligible items. U can also choose :",
    "ShiDangJianShaoShaiXuanTiaoJ": "Reduce selection criteria appropriately",
    "GengHuanQiTaGuanJianZi": "Replace other keywords",
    "FanHuiShangYiBu": "Go back",
    "MeiYouZhaoDaoPiPeiGongYingShangN": "No matching suppliers found.  You can also choose :",
    "BangNiZhaoYang": "Find samples for you",
    "GongYingShangTuiJianShangPin": "Supplier recommended products",
    "WoDeZuJi": "My search story",
    "ChaKanSuoYouZuJi": "View the entire search story",
    "MeiZhaoDaoXiangYaoDe": "Can't find eligible items",
    "HuoQuChanPinGongChangZiXu": "Get Product & Factory Information",
    "GuanZhuWoMenSuiShiLeJieZu": "Follow us and stay informed about the latest products, factory information and market trends",
    "JingZhunZhaoYang": "Finding the exact sample",
    "DengLuHouFaBuJingZhunZhao": "After registering and publishing the desired product, our purchasing specialist (with 5 years of experience ) will help with purchases",
    "FaBuZhaoYangXinXi": "Post information of sample",
    "AnLeiBieLiuLan": "Browse by list",
    "PaiXu": "Sort",
    "ZhaoDaoGeShangPin": "<b> {0} </b> products found",
    "GeGongYingShangZhaoDao": "{0} Supplier found",
    "TuiJianGongYingShang": "Recommended supplier",
    "BaoJia": "Officially set price",
    "GaoJiShaiXuan": "Advanced filtering",
    "GengDuoGuoLv": "Advanced filtering",
    "ShengYuNTian": "{0} days left",
    "XianHuo": "In-stock to ship",
    "DiQuBuZhiChiZhiJieXiaDanJ": "<b> {0} </b> Regions are without any support for direct order service. For destination delivery on {1}, please contact customer service to process the order.",
    "XiTongJianCeDaoYouWeiWanC": "There's consolidation undone under system operation. Whether switch to <a>{0}</a> and go ahead?",
    "DangQianKaiTongBaoQingGua": "Now Serving Destination Countries Including Customs Clearance & Logistics Available：{0}。",
    "KaiTongDiQuZhiChiXiaDanBa": "In the opened regions, order service is one-stop shipping  including customs clearance & logistics directly to the destination warehouse, which can be delivered to the designated destination by self-collection or additional local logistics costs.",
    "WeiKaiTongDeGuoJiaHeDiQu": "The Country/Region Out of Service",
    "TiJiaoDingDanShiQingLianX": "When submitting an order, please contact customer service for processing on your target delivery in China or not, meanwhile can or cannot provide relative logistics.",
    "FaHuoDiQu": "Shipper Country",
    "JiaoHuoDiQu": "Arrival Country/Region",
    "请选择城市": "Please choose the city",
    "SuoXuanJiaoHuoDiQuBuZhiCh": "If  \"door to door\" service is not available in your city, please <a href=\"https://essa.cn\"  rel=\"nofollow\">click here </a>to see the other options",
    "ZhongGuo": "China",
    "ShipTo": "Ship to",
    "XuanZeJiaoHuoDiQu": "Choose Arrival Country/Region",
    "BaoQingGuanWuLiuZhiSongXi": "Learn more",
    "GengGaiJiaoHuoGuoJiaDiQu": "Change Arrival Country/Region",
    "GengHuanJiaoHuoGuoJiaDiQu": "Items prices, delivery method and product category will also be changed ,after changing the arrival country/area .",
    "JiaGeQueRenZhong": "Under Factory Confirmation",
    "JiaoHuoChengShi": "Arrival Country/Region",
    "FanHuiDingBu": "Back to Top",
    "XianShiTeHui": "One Carton Order",
    "XiangShanGou": "Flash deals",
    "ZuiJinShangXin": "New Arrivals",
    "FaXianHaoHuo": "Discover best sellers",
    "XianDaoXianDe": "First come first served",
    "PaiXingBang": "Top-ranking Products",
    "RenQiShangPin": "Most Popular",
    "ReXiaoShangPin": "Hot Sale",
    "DangDiWangDian": "Local Web Spot",
    "NiShangWeiSheZhiJiaoHuoDi": "You have not set the arrival area on delivery. Commodity prices, delivery methods, and product categories will also be different according to differ arrival country/area.",
    "ChangJiaXianHuo": "In-Stock to Ship",
    "TuanGouYouHui": "Group Purchase",
    "ZhuanXiangYouHuiHuoYuan": "Enjoy exclusive discount",
    "ZaiShouJiChaKan": "Please check on mobile chain.",
    "QieHuanGuoJiaDiQu": "Switch Country/Region",
    "DingGouYuJiaoHuo": "Order & Delivery",
    "RuHeXiaDan": "How to order",
    "FaHuoFangShi": "Shipping Options",
    "GenZongHuoWu": "Tracking Your Items",
    "GuanYuESSAONE": "About ESSAONE",
    "FanHuiQuanBuShangPin": "Back to all products",
    "PinJuCaoZuoZhiYunXuXiuGai": "The \"assembly\" operation allows to change only the delivery city, if you need to change the delivery country, {0} change the delivery region, and then perform the \"assembly\" operation",
    "GuanZhuWoMen": "Follow Us",
    "HuanYingLaiDaoESSAONE": "Welcome to ESSAONE",
    "DangQianJiaoHuoDiQuBuZhiC": "The current delivery area does not support LCL operations or there are unfinished LCL. Please return to the shopping cart to operate again.",
    "QingXuanZeChengShi": "Please choose the city",
    "ZhuCeTiaoJian2ONE": "Buyer registration on ESSAONE and terms of service",
    "DengLuXinLaiONE": "New To ESSAONE?",
    "ZhengDanCaiGou": "Container Shipment",
    "NinYeKeYiZhuDongLianXiKeF": "You can also contact customer service staff to complete your certification quickly.",
    "SanDanCaiGou": "Small Orders",
    "PinGuiXiuGaiShouHuoGuoJia": "If you need to modify the arrival country, please return to the shopping cart page to modify.",
    "FanHuiXiuGai": "Back to modify",
    "ZhuCeESSAONE": "You will get...once you register and be a member of ESSAONE.CN",
    "ZhongGuoGCZhiCai": "China Factory Direct",
    "ZuiDiYiXiang": "One-carton can order",
    "YouLiCaiGouJiaGe": "Get Profitable Price",
    "QingGuanPeiSong": "Door to Door All Done",
    "Essaone_ShouYeGuanJianCi": "ESSAONE.CN,Toys & Gifts,Baby items,Hot sale,New,Toys Suppliers, China Factory",
    "Essaone_MetaMiaoshu": "ESSAONE is a China factory toys sourcing & trading platform covering with over 20,000 factories and including 1 million non-repetitive SKU.",
    "QieHuanBuTongDeGuoJiaDiQu": "Switch to various countries/ regions",
    "Essaone_ShouYeBiaoTi": "ESSAONE.CN - Toys & Baby items purchasing online,direct purchase from China",
    "SuiShiZhiJieYiJia2": "Freely & Directly Purchase from Factories",
    "KeJiShiChaKanXinPin2": "Check <b>Over 2,000 New Toys</b> Update Online Daily",
    "ShouCiDengLuXuYaoXuanZeJiaoHuoDiQu": "The first time you log in, you must select the delivery region. Product prices, delivery methods and product categories depend of the choice of delivery country.",
    "NinKeYiZaiShouYeYouShangJiao": "Вы можете изменить регион в правом верхнем углу главной страницы или в личном кабинете",
    "ZyWenXinTiShiONE": "Warm reminder: ESSAONE provides service of finding samples, by which, you can obtain the the detailed product information",
    "Essaone_WeiZhaoDaoShangPin": "ESSAONE is searching, please wait a minute",
    "Essaone_YiJingZhaoDaoShangPin": "ESSAONE is looking for your favorite",
    "Essaone_KuaGuoCaiGouPingTai": "essaone.cn, an international purchase platfrom",
    "Essaone_DianJiChaKanGengDuoYouZhi": "Click here for more good products-essaone.cn, an international purchase platform for toys",
    "Essaone_ChengNuoBuHuiDuiWaiGongKaiXinXi": "Information privacy of formal invoice & receipt and so on should  follow confidentiality agreement and be protected by ESSAONE platform.",
    "Essaone_ZhuCeTiaoJian2": "Регистрация покупателя на ESSAONE и условия предоставленных услуг",
    "Essaone_PingTaiZhuCeJiFuWuTiaoKuan": "Регистрация покупателя на ESSAONE и условия предоставленных услуг",
    "ShouHuoDiZhi": "Receiving Address",
    "ZiTiDianXinXi": "Place of cargo receipt ( pick-up by yourself )",
    "DaoHuoGangKouChengShi": "Arrival port city",
    "DingDanZongJiXinXi": "Total Info. for The Order",
    "YouYiWenLianXiKeFu": "Any doubt, please contact customer service",
    "XiaZaiHeTongFanBen": "Download the contract template",
    "FaSongFuKuanXinXiDaoShouJi": "Send payment information to mobile phone",
    "ChaKanDingDanLieBiao": "Check Order List",
    "YinHangHuiKuan": "Bank Transfer",
    "QueRenFuKuanXinXi": "Confirm payment information",
    "AnPaiShengChan": "Put into Production",
    "GongNDan": "Total {0} orders",
    "RuCaiGouShangPinSheJi": "Such as the purchase of goods related to the following functions, you can specify the production standards.If the following functions are not involved, they can be ignored.",
    "QingGouXuanYaoXiaDanDeSha": "Please tick the products you want to order, and click [Place Order]",
    "YiXiaShangPinGongChangYiQ": "The following product factories have been confirmed",
    "QuXiaDan": "Place Order",
    "ZhangJiaShangPin": "Items with Price Increase",
    "PiLiangQueRen": "Confirm the price again",
    "QueRenShengChanYaoQiuZhon": "Confirming production requirements",
    "YiQueRenKeXiaDan": "orderable",
    "ChaKanKeXiaDanShangPin": "View Goods Able for Ordering",
    "ZiXun": "To Consult",
    "PiLiangZiXun": "Group consultation",
    "YiRuShouZang": "Move to favorites",
    "DangQianJiaoHuoGuoJiaBuZh": "The current delivery country does not support direct transactions, please change the country.  If you want to receive the goods in the current country, contact customer service.",
    "YiXuanKuanShangPinGongXia": "Selected <b> {0} </ b> items, <b> {1} </ b> boxes, <b> {2} </ b> pcs",
    "YiXiaShangPinJiaGeYuNinJi": "The following items, prices can change when you add them to your shopping cart",
    "YiXiaShangPinJiaGeYiZhang": "The following product prices have increased",
    "CaiGouShangPinQingDan": "Purchasing Commodity List",
    "FanHuiGouWuCheXiuGai": "Back to Modify in Shopping Cart",
    "ZongGongKuanShangPinZongJ": "Total of {0} models ({1} PCS), the total price of goods: {2}",
    "WenXinTiShiQieHuanBuTongD": "Note: Switch the shipping address of different countries and regions, the items price will change. Some countries do not provide door-to-door service, so direct order is not supported. If you have any questions, please contact customer service.",
    "GengDuoDiZhi": "More Address",
    "MoRenDiZhi": "Default address",
    "XinZengShouHuoDiZhi": "Add shipping address",
    "DingDanXinXiTongZhiRen": "Order Notification",
    "DingDanFaShengBianHuaYouY": "If the order changes or there is abnormal information, etc., please contact",
    "JieSuanYe": "Checkout Page",
    "ShangPinBianHaoHuoMingCheng2": "Product №, Name of product or Factory item №",
    "XinXiYiGuoQi": "Information has expired",
    "TianXieHeDuiDingDanXinXi": "Fill out and confirm the order information",
    "SheWeiMoRenDiZhi": "Set as the default address",
    "QueRenZhong": "Under Confirmation",
    "ShouKGSi": "Company Name",
    "ShouKZHao": "Receiving Account",
    "ShouKDZi": "Payee Address",
    "YHanMC": "Deposit Bank",
    "YHangHMa": "Bank Number",
    "YHangDZ": "Bank Address",
    "YHangDM": "Bank Code",
    "ShuiWHao": "Tax No.",
    "DaiLZHao": "Agent Account",
    "ShouHuoRenXinXiChuangJianShangXian": "Information about the consignee, no more than 20 addresses",
    "ShouDanDingJinJinXuN": "First deposit required only {0}",
    "WuKeXiaDanShangPin": "No Orders",
    "GouWuCheNeiZanShiMeiYouSh2": "You have no items in your shopping cart. You can add them",
    "DangQianJiaoHuoGuoJiaXuYa": "The current delivery country needs to supplement the following information to continue the transaction",
    "FuKuanTiXing": "Payment Reminder",
    "YouYuHuiLvBianDongPinFan": "1. Until you pay the deposit, the total price of your order may change (pay more or less) due to the change of currency rate. 2. To avoid changes in the total order price, please pay the deposit as soon as possible. After payment of the deposit, your order will be confirmed and the total price of the order will not change. 3. If the total order price changes due to the change of currency rate after you pay the deposit, the balance will change (decrease or increase) according to the paid deposit. 4. We will begin to process your order upon receipt of your deposit.",
    "GongChangYuJiXiaoShiNeiQu": "Factory expected to confirm within 24 hours",
    "QueDingShanChuXunJiaShangPinOne": "Reconfirm all selected items?",
    "XiangQingYeWuQuanXianTiShiOne": "This product is new and requires account authentication to view the details. The authentication will be completed within 1-3 working days. Please keep your contact information and ESSAONE will contact you.",
    "GuoQiShangPinQingJinKuaiPOne": "Expired items, please reconfirm and place an order",
    "QingGouXuanXuYaoXiaDanDeS": "Please check the item you want to order",
    "GuoJiaChengShi": "Country / City",
    "QingTianJiaShouHuoDiZhi": "Please add delivery address",
    "BuZhou": "Step",
    "BuZhou1": "Step 1",
    "XunJiaZhuangTaiOne": "Confirm Status",
    "NingDePODanOne": "My Orders",
    "NinYouZhangDingDanDaiZhiFOne": "There're {0} orders awaiting your deposit. To push your order into factory production, please pay the deposit as soon as possible. Any question please contact your customer service.",
    "HuiLvTiXing1": "1. Until you pay the deposit, the total price of your order may change (pay more or less) due to the change of currency rate；",
    "HuiLvTiXing2": "2. To avoid changes in the total order price, please pay the deposit as soon as possible. After payment of the deposit, your order will be confirmed and the total price of the order will not change；",
    "HuiLvTiXing3": "3. If the total order price changes due to the change of currency rate after you pay the deposit, the balance will change (decrease or increase) according to the paid deposit；",
    "HuiLvTiXing4": "4. We will begin to process your order upon receipt of your deposit.",
    "ZanWuQuanXian": "No permission",
    "NinDeZhangHaoZanShiMeiYou": "Your account does not have permission to browse the products of this factory.  If you have any questions, you can contact our staff: QQ 3465941826",
    "YiGuoQi": "Expired",
    "SouSuoGuanJianZi": "Search for keywords",
    "KaiShiRiQi": "Start date",
    "JieShuRiQi": "End date",
    "FaBuXinDeZhaoYang": "Post a new sample",
    "ZhaoYangXiangQing": "Find sample details",
    "QuXiaoZhaoYang": "End sample",
    "ShengYuShiJian": "Time left",
    "BuJieShouXiangSiKuanYangP": "Do not accept feedback from similar samples. If you have poor quality feedback, you can give a negative feedback on the samples.",
    "QueRenYaoQuXiaoZhaoYangQu": "Are you sure you want to cancel sampling?  After canceling, this sample will no longer receive feedback from the factory.",
    "ZhaoYangZhuTi": "Find sample name",
    "QingShuRuZhaoYangZhuTi": "Please type the name of items",
    "QingShuRuZhaoYangZhuTiFan": "Please type the name of items",
    "TiGongGongChangHuoHaoKeJi": "Provide factory article number to find samples accurately",
    "ZuiDiJia": "Lowest price",
    "ZuiGaoJia": "Highest price",
    "ZhaoYangShuoMing": "Finding instructions",
    "MiaoShuXuYaoZhaoDeShangPi": "Describe the product you need to find, for example: appearance, function, sales area, etc.",
    "ZhiJieShouGengJingZhunPiP": "I hope the feedback of the product and my picture/item number will be same",
    "XuTiGongTuPianHuoGongChan": "Need to provide pictures or factory article number, accurate matching will take effect",
    "GaoSuGongChangNiXuYaoShen": "Tell the factory what you need",
    "ZhaoYangYouXiaoQiFaBuHouX": "Sample validity period: 48 hours after publication",
    "XinXiYueJuTiNiDeDaoDeJieG": "The more information of items you fill in, the more accurate your results will be",
    "XuRenZhengCaiNengFaBuZhaoYang": "Certification is required to post samples",
    "XuDengLuCaiNengFaBuZhaoYang": "Login required to post samples",
    "GongChangTuiJian": "Factory recommendation",
    "PingTaiYiYouYangPin": "The platform already has samples",
    "GongChangXinZengYangPin": "New samples from the factory",
    "JiangGenJuSuoTiJiaoDeZhao": "essa.cn will automatically match to the optimal factory according to the submitted sample search requirements.  Generally there will be results within 1 ~ 2 working days, please pay attention to the relevant feedback information.",
    "ChaKanWoDeZhaoYang": "Check my sample",
    "JiXuFaBuZhaoYang": "Continue to post samples",
    "FanHuiHuiYuanZhongXinShou": "Back to Member Center Homepage",
    "WeiXinGuanZhuGongZhongHao": "微信关注公众号:【宜采有货】",
    "ShiShiHuoQuFanKuiTongZhi": "Get feedback notifications in real time",
    "ShangPinSuoShuLeiMu": "Product category",
    "QingXuanZeShangPinSuoShuL": "Please select the category of the product",
    "YiBan": "General",
    "Hao": "Good",
    "FeiChangHao": "Excellent",
    "ZhaoYangXuQiuPingFen": "Sampling demand score",
    "FenShuYueGaoNiDeDaoDeFanK": "The higher the score, the more accurate the feedback you get. Too low a score may cause the feedback sample to be too general.",
    "KeDuoXuan": "Multiple choice",
    "TianXieGengDuoXinXi": "Fill in more information",
    "MoHuZhaoYang": "Fuzzy sample",
    "ShiYongFanYi": "Use Google translation",
    "ZheiGeZhaoYangMeiYouZhaoY": "There is no description for this sample search",
    "ZhuCeTianXieXinXiWeiWanZheng": "Please fill in the registration information and submit",
    "LiuXiaFanKui": "Leave feedback",
    "RuGuoNinZaiShiYongPingTai": "If you have any good or bad points when using the essaone platform, please let us know!  We will pay attention to your feedback, constantly optimize the product, and provide you with better service!",
    "HenManYi": "Very good",
    "FeiChangBuMan": "Very bad",
    "NinDuiPingTaiShouYeDeZhen": "What is your overall satisfaction with the ESSAONE.CN platform homepage?",
    "DuiNinDePeiHeHeZhiChiBiao": "Thank you for your cooperation and support!",
    "WeiLeJiNinTiGongGengHaoDe": "Чтобы предоставить Вам лучший сервис, мы будем рады получить Ваши отзывы и предложения по использованию платформы essaone",
    "YongHuTiYanFanKuiDiaoCha": "User experience feedback survey",
    "DengLuHouCaiNengTiJiaoFan": "You can only submit feedback after logging in. Do you want to log in now?",
    "RuGuoNinYouTeDingYiWenQin": "If you have specific questions, please contact {0} or visit our {1}",
    "KeHuFuWuTuanDui": "ESSAONE customer service team",
    "KaiShiLiaoTian": "Start chatting",
    "XuanGou": "Order Now",
    "XuanGouLe": "Ordered",
    "OneCartonFromChina": "Minimum order - one carton from Chinese factories ! First order deposit only 10%!",
    "FanHShouY": "Back to essaone homepage",
    "GanXieFanK": "Thank you for your time. We appreciate your feedback.",
    "YiGuanZhu": "Followed",
    "GuanZhu": "Folow",
    "GongChangShouYe": "Factory home page",
    "XinYong": "Credit",
    "GongChangShangPinFenLei": "Factory product categories",
    "ShangPinGuiGeCanShu": "Product specifications",
    "ShouJiShangChaKanFenXiang": "View share on mobile",
    "GongChangHuoYuan": "100% factory supply",
    "ZhenShiKeKao": "On-site certification of the factory, real and reliable",
    "DingJinKeTuiChengNuo": "Deposit refundable commitment",
    "HeLiTuiDan": "Reasonable refund,part of the deposit can be refunded",
    "JiaoHuoShiXiaoBaoZhang": "Delivery time guarantee",
    "DingDanQuanChengGenZong": "Full tracking of the order, the delay in delivery will be compensated",
    "ZhiBaoTuiHuan": "15 days warranty return",
    "TiGongWanShanDe": "Provide complete replacement and return service",
    "CongZhongGuoFaHuoJiaGeHan": "Shipping from China, price including customs clearance, logistics costs",
    "ZhongGuoFaHuo": "China shipping",
    "TongGuoHangYunDaoNiDeChen": "By shipping to your city",
    "TiGongSongHuoShangMenFuWu": "Logistics Time (Production Time: {0} days, Transportation Time: {1} days), excluding the waiting time at the border",
    "WuLiu": "Logistics",
    "CanJiaJiaGe": "DDP reference price",
    "JinGeYueYouRenXiHuan": "Recently added {0} months have {1} people like",
    "ChuangJianZhangHao": "Register an account",
    "QingShuRuNiDeDian": "Please enter your email as your account",
    "GongSiSuoZaiChengShi": "City of the company",
    "GongSiXiangXiDiZhi": "Company address",
    "XiaoShouQuDaoone": "Sales channels",
    "Essaone_ZhuCeTiaoKuanPrefix": "I agree to the rules for register an account",
    "Essaone_ZhuCeTiaoKuan": "ESSAONE platform buyer registration and terms of service",
    "GongXiNiYiChengGongZhuCe": "Congratulations, you have successfully registered！<br/>Our customer managers will contact you within 48 hours on working days to help you find the perfect products and the best discounts.",
    "NiDeZhangHao": "Your account number",
    "XianZaiQuGouWu": "Go shopping",
    "DiYiCiDingDanKeXiangShou": "Enjoy your first order",
    "HuoQuESSAONEGengDuoXinXi": "For get more information about ESSAONE, go to",
    "QingNinDengLuYouXiangJinXinYanZheng": "Submit successfully, please login email to verify",
    "YanZhengYouJianYiFaSongDaoYouXiang": "Verification email has been sent to the mailbox",
    "QingDengLuYouXiangWanChengYanZheng": "Please log in within 24 hours and follow the email prompts to complete the verification",
    "MeiShouDaoYouJian": "Did not receive email",
    "QingXianJianChaShiFouZaiLaJiXiangZhong": "Please check first if it is in the spam mailbox.",
    "RuGuoHaiWeiShouDao": "If you haven't received it",
    "ChongXinFaSongYouJian": "Resend email",
    "YiZhiShouBuDao": "Never received",
    "QingGengHuanQiTaYouXiang": "Please change your email address",
    "XinYongHuZhuanShuLiPin": "Exclusive Gifts For New Users",
    "XinYongHuDeReMenXuanZe": "Hot picks for new users",
    "GangGangJIaGou": "Recently added the product",
    "GangGangShouCang": "Recently collected the product",
    "GangGangGuanZhu": "Recently added the brand",
    "GongChangWeiWanShan": "Not added by supplier",
    "GongXiNiYiChengGongZhuCe2": "Congratulations! You've successfully registered!",
    "DiYiCiDingDanKeXiangShouD": "First order deposit <b>- 10%</b>",
    "ZhongGuoZhiCai": "Directly from China",
    "QuanBaoJia": "All-included price",
    "MenDaoMen": "From door to door",
    "JiaoYiBaoZhang": "Transaction guarantees",
    "BaoHu": "100% Guarantee",
    "NinDeZhangHaoZanShiMeiYou2": "You don't have permission to see this product for now, if you have any questions please contact out support service",
    "QingXuanZeXiaoShouQuDao": "Type of sales",
    "QingShuRuYingYeZhiZhaoHao": "Please, enter your license number",
    "GaiLianXiDianHuaYiCunZai": "This phone number is already registered",
    "GeiNinZuiJingZhunDeTuiJian": "Products you're interested in, for better recommendations",
    "QingShuRuChengSh": "Your city",
    "LingQuChengGong": "Success!",
    "XinShouLuoDiYe": "Novice zone",
    "JingZhunZhaoYangXuYaoTian": "Accurate sample need to add product pictures or fill the factory number",
    "QingShuRuDianZiYouXiangZu": "Please fill your email address as your account",
    "QingShuRuShouJiHaoMaZuoWe": "Please fill your mobile number as your account",
    "LiuDaoErShiGeZiFu": "6 to 20 characters",
    "ZhiNengBaoHanZiMuShuZi": "Only consists of letters, numbers and symbols",
    "ZiMuShuZiHeBiaoDianFuHaoZhiShao": "Contains at least two of the following: letters,numbers and sumbols",
    "EssaOneZhiShao6GeZiFu": "Invalid password",
    "RuGuoNinSouBuDao": "Didn't find what you're looking for? Now you can send your enquiry directly to the factories!",
    "ZhiDaYuanChang": "Accurate search according to your requirements",
    "AnTiaoJianGuoLv": "Results during 30 min",
    "ShuBaiJiaZhiMingMaoYi": "Reliable source",
    "FaBuZhaoYangXuQiu": "Describe your requirements",
    "XiTongZiDongPiPei": "N",
    "HeBeiCha": "Confirm and get some tea while waiting for the result",
    "GongChangZaiShouDaoXinXiHou": "N",
    "ChaKanFanKui": "Choose the pruduct you need from the list",
    "TiaoXuanHeShiDeShangPin": "N",
    "NinTianDeXuanXiangYueDuo": "The more options you fill the more accurate results you can get",
    "ZhaoYang": "Find sample",
    "RuGuoNinSouBuDaoShangPin": "Didn't find what you're looking for? You can send your request directly to the factories!",
    "YiCaiYouHuoJiangGenJuNinSuoTiJiaoDe": "The system will automatically send your request to the most suitable factories according to your submitted product requirements",
    "YiBan30FenZhongZuoYou": "The results will be ready in around 30 min",
    "RangGongChangGeiNinHuiFu": "The result will be ready in around 30 min",
    "TuiJianRenShouJi": "推荐人手机号",
    "ShouJiHaoMaGeShiBuZhengQu": "手机号码格式不正确，请重新输入",
    "RuHeRangShiTu": "How to make the search more accurate?",
    "ShangChuanBeiJing": "Choose image with simple and solid color background",
    "XuanZeQingXiDuJiaoGao": "Choose a clear picture with high resolution",
    "ChangShiCaiJianTuPian": "Try to crop the picture and leave only the subject you're looking for",
    "RuGuoFenBieYouDaiBaoZhuang": "If there are both results with and without package on photo, we recommend to try all of them",
    "JiaRuGouWuChe2": "Add to cart",
    "HuoDongGuiZe1": "1. During the promotion, you need to generate an invitation link + personalised coupon code and send it to the person you want to invite. The user must click on the link you sent or enter the coupon code when registering an account. The participation will be considered valid after the new user places the first order.",
    "HuoDongGuiZe2": "2. Требования к приглашенным пользователям：",
    "HuoDongGuiZe201": "（1）Пользователи которые ранее не были заристрированы на площадке и никогда не оформляли заказ",
    "HuoDongGuiZe202": "（2）The invited user must register by clicking on the link you sent or by entering your personalised coupon code.",
    "HuoDongGuiZe3": "3. Во время проведения акции, за каждого приглашенного пользователя вы получаете 5000р, количество приглашаемых пользователей неограничено.",
    "HuoDongGuiZe4": "4. Вознаграждение будет получено в течении 3-х дней с момента внесения новым пользователем депозита первого заказа",
    "HuoDongGuiZe5": "5. Вы можете посмотреть статус приглашенных пользователей в своем личном кабинете перйдя во вкладку “Пригласить друзей”",
    "HuoDongGuiZe6": "6. Данная акция проводится согласно правил, установленных платфрмой essaone",
    "YaoQingDeJiangLi": "Вознаграждения при приглашении",
    "YaoQingFanLi": "Пригласить друзей",
    "YaoQingMingXi": "Детали приглашения",
    "FuZhiChengGong": "Copy Success",
    "WoDeYaoQing": "Приглашенные пользователи",
    "ChaKanMingXi": "View Details",
    "JiangLiZongJinE": "Total Award Amount",
    "YaoQingZongRenShu": "Количество приглашенных пользователей",
    "XiaDanRenShu": "Количество пользователей, оформивших заказ",
    "ShengChengZhuanShuTuiJianMa": "Create an exclusive coupon code",
    "FenXiangTuiJianMaG": "Share coupon code with your friends",
    "HaoYouZhuCeBingXD": "Дождаться регистрации и первого заказа",
    "HuoDeJiangJin": "Получить вознаграждение",
    "WoDeYaoQingLianJie": "Пригласительная ссылка",
    "DianJiFuZhi": "Копировать",
    "WoKeHuoDe": "Вознаграждение для вас",
    "ShouDanChengJiaoKeDe": "После оформления первого заказа",
    "HaoYouKeHuoDe": "Вознаграждение для нового пользователя",
    "ShouDanDingJinYouHuiQ": "Депозит первого заказа",
    "WoDeXianJinJiangLi": "Ваше вознаграждение",
    "ZhangHuBianHao": "Номер учетной записи",
    "HaoYouYouXiang": "Эл. почта пользователя",
    "HaoYouDianHua": "Номер телефона пользователя",
    "DiYiCiXiaDanSJ": "Время оформления первого заказа",
    "JiaGeBaoHuQiShengYuNTian1": "The price is confirmed by factory, but can be changed due to currency rate fluctuations.",
    "GaiShangPinYiGuoJiaGeBaoH1": "Price is no longer valid, need to confirm again",
    "GaiShangPinYiGuoJiaGeBaoHuNC1": "Price is no longer valid, need to confirm again",
    "QingXuanShuRuFOBFeiYong": "请输入FOB费用",
    "QingXuanZeBiZhong": "请选择币种",
    "QingShuRuHuiLv": "请输入汇率",
    "QingXuanZeHuoGuiLeiXing": "请选择货柜类型",
    "QingXuanShuRuTiJi": "请选输入体积",
    "ShangChuanLogo": "报价单LOGOLOGO",
    "GongSiLogoJianYi": "公司logo建议尺寸80x80",
    "FOBFeiYong": "FOB费用",
    "JiaJiaLv": "加价率",
    "FanYi": "Translate",
    "YiWen": "Translation",
    "MeiYuanDuiHuanRenMinBi": "美元兑换人民币汇率",
    "HuoQiESSAONE": "Delivery time",
    "FanYiXiaoGongJuJiangGongC": "Translation tool for factories news",
    "XuanZeYuYan": "Choose the language",
    "ZuiJinShiYong": "Last time visited",
    "ZhiYunXuPingLunYiCi": "You can only leave one comment",
    "QingShuRuPingLunNeiRong": "Please enter the comment",
    "ShanChuPingLun": "Comment deleted",
    "YiPingLun": "Comment submitted",
    "PingLun": "Comment",
    "YiZan": "Liked",
    "Zan": "Like",
    "KuanChanPin": "{0}  products",
    "ChaKanShangPinXiangQing": "Product details",
    "GuanZhuChengGong": "following",
    "YiQuXiaoGuanZhu": "Unfollowed",
    "NinHaiMeiYouGuanZhuGongChang": "You're not following any factories, you should follow at least 1 factory",
    "YouZhiGongChangTuiJian": "Best recommendation",
    "GuanZhuChaKan": "Follow the brand updates",
    "GuanZhuQuanBuTuiJian": "Follow all the recommendations",
    "GuanZhuGongChangZuiXinDongTai": "Follow factory updates",
    "NinGuanZhuDePinPaiZanWuDongTai": "No activity from followed brands yet, follow more brands",
    "GuanZhuGengDuoGongChangPinPai": "Follow more factory's brands",
    "GongChangShangXinKuan": "Factory added{0}products",
    "GongChangJiangJiaKuan": "Фабрика понизила цену{0}товаров",
    "GongChangXinZengShiPinKuan": "Factory added{0}new videos",
    "ChaKanShangXin": "Check the updates",
    "ChaKanJiangJia": "See the lowered price",
    "ChaKanShiPin": "Watch the video",
    "QuXiaoGuanZhu": "Unfollowed",
    "BenCiShangXinKuan": "uploaded{0}new products",
    "BenCiJiangJiaKuan": "Price of{0}products was lowered",
    "BenCiGengXinShiPinKuan": "Uploaded{0}new videos",
    "TuiJianGongChang": "Factory recommendations",
    "ZuiJinShangXinKuan": "lately uploaded{0}products",
    "LiuLanGengDuoGongChang": "More factories",
    "XuanZeBaoJiaFangShi": "Select the price type",
    "XuanZeBaoJiaMoBan": "Choose tamplate first",
    "ZuiJinGengXin": "Last updates",
    "ShiPinQuan": "Videos",
    "GongChangQuan": "Factories Community",
    "JuLiKaiBoHaiYou": "Starting in",
    "Fen": "min",
    "Miao": "Sec",
    "ZhiBoShangPin": "Products",
    "HuiFang": "Replay livestream",
    "ZhiBo": "Live",
    "ZhaoBuDaoGaiShiPin": "The video could not be found",
    "ZhiBoHuiFang": "Livestream replay",
    "ZhiBoZhong": "В прямом эфире",
    "KanHuiFang": "Replay",
    "JiJiangKaiShi": "Upcoming",
    "Shi2": "hours",
    "LiJiLingQu": "Get It Now",
    "ShouDan3ZheKou": "Get the $500 coupons pack!",
    "ZhiXianYuXinKeHu": "New Buyer Promotion",
    "DeDaoYouHuiQuan": "GET COUPONS",
    "LaXinGuiZe1": "<p>1.Only registered buyers who have never placed an order can enjoy this offer.</p> <p>2. Each new user can only get the coupons pack once.</p>",
    "LaXinGuiZe2": "<p>3. The New Buyer Coupon Pack contains 4 coupons, which are given in 2 times: 2 coupons after registration; 2 more coupons after the first order.</p> <p>4. All coupons are not stackable and only one coupon can be used per order. When placing an order the system will use the coupon with the biggest discount based on the coupons available to you now; or you can choose to use another coupon.</p>",
    "LaXinGuiZe3": "<p>5. If an order is cancelled after using a coupon, the system will automatically return the coupon if all of the products enjoying the discount are cancelled. However, if the order is only partially cancelled and the discount is partially enjoyed, the coupon will not be refunded.</p> <p>6. New users enjoy the privilege of 10% deposit for the first order, but it is only valid for the first order.</p>",
    "XinYongHuTeBieCuXiao": "New Buyer Promotion",
    "ZhiDiYiGeDingDan": "Just For The First Order",
    "EssaBanQuan": "ESSAONE reserves all rights",
    "YXV0b19tYXJrZXRpbmdfZW1haWw=": "Product recommendations / Special offers",
    "YXV0b19tYXJrZXRpbmdfZW1haWw=_remark": "Regular new product recommendations, popular products and discounts.",
    "cmVndWxhcl9tYXJrZXRpbmdfZW1haWw=": "Latest activity / Promotion notifications",
    "cmVndWxhcl9tYXJrZXRpbmdfZW1haWw=_remark": "Latest news and promotions on the platform",
    "Y29uX2NvbnRhaW5lcl9sb2FkX2RvbmVfZW1haWw=": "Сontainer loading notification",
    "Y29uX2NvbnRhaW5lcl9sb2FkX2RvbmVfZW1haWw=_remark": "When all the items were loaded and ready to ship",
    "Y29uX2NvbnRhaW5lcl9iYWxhbmNlX2VtYWls": "Full payment notification",
    "Y29uX2NvbnRhaW5lcl9iYWxhbmNlX2VtYWls_remark": "Notification about the order arriving time and reminder to make the full payment",
    "b2xkX2J1eWVyX3JlY29tbWVuZF9lbWFpbA==": "Order completed notification",
    "b2xkX2J1eWVyX3JlY29tbWVuZF9lbWFpbA==_remark": "All the products are recived and the order is completed",
    "c3BsaXR0aW5nX25vdGljZV9lbWFpbA==": "Delivery time change notifications",
    "c3BsaXR0aW5nX25vdGljZV9lbWFpbA==_remark": "Your order was split due to different production time of the products",
    "GengDuoLianXiXinXi": "更多联系信息",
    "GongSiGuHua": "Company landline",
    "TianJiaShangPinZhiXuanYan": "添加商品至选样池，查看联系方式",
    "YiJianJiaRuXuanYangChiCha": "One click to join the [selected products], generate quotations to customers to do accurate promotion",
    "HuoQuBuDaoZhangHaoZiJinDeSuo": "The system is busy, please try again later",
    "WeiSheZhiZhiFuMiMa": "You cannot make a payment before setting the payment password",
    "ZhiFuMiMaBuZhengQue": "Wrong password",
    "ChaXunBuDaoZhangHaoZiJinXinxi": "Account balance information was not found",
    "ZhangHaoZiJinBuZu": "Insufficient balance",
    "JiuZhiFuMiMaBuZhengQue": "The old payment password is incorrect.",
    "PoDanYiZhiFuQinWuChongFuZhiFu": "PO has been paid, please do not repeat payment",
    "WoDeZiJin": "My Funds",
    "MingXi": "Detail",
    "QuHuiKuan": "Go Transfer Money",
    "DaiFuKuan": "Unpaid",
    "ShenMeShiESSAONE": "About deposit on ESSAONE",
    "AnDingDanJinE": "Percentage of deposit charged according to order amount",
    "NianChuHuoJinE": "{0} order quantity",
    "XinYongHuShouCiXiaDan": "Special offer for new users - deposit only 10%!",
    "DingDanEDuBuChaoGuo": "No order amount limit.",
    "TiJiaoDingDanHouQingJiShi": "Please pay the deposit in time after submitting the order. After the deposit is received, the order will be officially confirmed.",
    "XuYaoSheZhiZhiFu": "You need to set a payment password to pay.",
    "SheZhiZhiFuMiMa": "Set the payment password",
    "XiuGaiZhiFuMiMa": "Modify payment password",
    "ZhaoHuiZhiFuMiMa": "Retrieve payment password",
    "ShiYongGuiZe": "Use Rules",
    "ZiJinMingXi": "Funds details",
    "GuanYuZhiFuZhangHu": "About Payment Accounts",
    "RuHeHuiKuanChongZhi": "How to recharge",
    "RuHeZhiFuDingJin": "How to pay the deposit",
    "RuHeZhiFuWeiKuan": "How to pay the balance？",
    "ShenMeShiZhiFu": "What is the payment account?",
    "ZheShiYongHuZaiESSAONE": "With this account, you can pay the Deposit, make final payment, refund money and check payment information. This account is available to all the registered users of our platform.",
    "ZhangHuDeGongNeng": "Account function",
    "MuQianZhangHuZhiChi": "Now the payment account supports remittance recharge, order payment, cancellation refund.  All the remittances and order refunds  will enter your payment account.",
    "HuiKuanChongZhi": "Top-up: transfer money from your bank card to the account mentioned on ESSAONE platform. The top-up will be confirmed within 2 working days.",
    "DingDanZhiFu": "Order payment: you can use the funds in your account to pay the Deposit and make the final payment.",
    "QuXiaoTuiKuan": "Refund : if your order is canceled, the money will be returned directly to your payment account.",
    "ZhiFuLiuCheng": "Payment process",
    "ZhangHuZhiFuShiYongHu": "Top-up is a Bank transfer to your account balance. After the top-up, you can use transfered money to pay for your orders.",
    "ZhangHuDeShiYongGuiZe": "Account Usage Rules",
    "WeiLeQueBaoYongHuZiJin": "To ensure the security of using funds, you have to create a payment password before activating your personal account. Otherwise, you will not be able to use the account. This password will be used every time to confirm the payment.",
    "DangNinShiYongZhangHu": "Please be sure to check clearly when you use your account funds to make a deposit/final payment. Once payment has been made, funds cannot be refunded.",
    "YongHuZhiFuZhangHuBuShe": "The payment account balance doesn't have restrictions. Users can check the current account balance, top-up history, transfer history, and information about the account in  \"My balance\" tab.",
    "RuoDuiZiJinShiYong": "If you have any questions about your payment account, please contact our online support service",
    "DangNinDeZhangHuMeiYou": "If you don't have enough funds on your account, you can top up your balance with bank transfer. Below you can see more information about the top-up",
    "QingAnZhaoYiXia": "Please transfer money according to the following information and fill in your platform ID when transfer money:",
    "HuiKuanHou": "After the remittance, the payment will be confirmed within 2 working days.",
    "XianShiDaoZhangJinE": "[My balance] amount of money on the account",
    "QueRenDaoKuanHou": "After confirming the payment, you can check the remittance history in \"my balance”",
    "NinXuYaoXianJianCha": "Please check if there are enough money on your payment account",
    "ZhiYouDangNinDeZhiFu": "You can only pay the deposit if you have enough funds on your account balance. Here are 3 ways to pay the deposit",
    "DangNiChengGongTiJiao": "When you successfully submit your order, please click the{0}button.",
    "QuZhiFuDingJin": "Pay the deposit",
    "XuanZeYaoZhiFu": "Go to {0} to select the order for which you want to pay the deposit and click the {1} button.",
    "QuZhiFu": "Go to pay",
    "DaiZhiFuMingXi": "Pending payment list",
    "DangNinDeDingDanYiDao": "When your order has arrived to the destination, you need to pay the balance first and then pick up the products.",
    "TongYangZhiYouDang": "Also, if you have enough money on your balance, you can use them to pay the full cost of the order. Here are two payment methods:",
    "ZhiFuWeiKuanDe": "Please go to {0} and select the order, then press {1} button to pay the deposit",
    "ZhiFuZhangHuDeShiYong": "Payment Account Usage Guide",
    "DanJuHao": "Transaction Number",
    "ShouRu": "Income",
    "JinNTian": "Last {0} days",
    "QuanBuJiaoYiLeiXing": "All transaction types",
    "DaiZhiFuJinE": "Amount Unpaid",
    "ZuiChiFuKuanShiJian": "Payment deadline",
    "FanShiZaiESSAONEPingTai": "Each user of the platform has their own personal account for payment. Currently, we support balance top-up, order payment, and money refund.",
    "HuiKuanChongZhi2": "Top-up: money transfer from your Bank card to the account mentioned on the ESSAONE platform. The transfer will be confirmed within 2 working days.",
    "DingDanZhiFu2": "Order payment: you can use the money on your account to pay the order deposit and make final payment.",
    "QuXiaoTuiKuan2": "Refund : after the order is canceled, the money will be refunded directly to your account balance",
    "WeiLeQueBaoYongHuZiJin2": "To ensure the security of using funds, you have to create a payment password before activating your personal account. Otherwise, you will not be able to use the account.",
    "YongHuZiJinZhangHuBuSheXianE": "The payment account balance doesn't have restrictions. Users can check the current account balance, top-up history, transfer history, and information about the account in  \"My balance\" tab.",
    "ZhiFuMiMa": "Payment password",
    "ZhiFuMiMaWei6WeiShuZi": "Payment password is 6 digits.",
    "QueRenZhiFuMiMa": "Confirm payment password",
    "ShuRuZhiFuMiMaQueRenZhiFu": "Please enter the payment password to confirm",
    "QingXianShuRuYuanZhiFuMiMaYiYanZhengShenFen": "Please enter the original payment password to verify your identity, the new payment password will take effect immediately after it is successfully set",
    "WoDeDianZiYouXiang": "My e-mail",
    "JiuZhiFuMiMa": "Old payment password",
    "HeJiDaiZhiFu": "Total awaiting payment",
    "ZhangHaoZiJinChongZu": "Sufficient funds in the account",
    "BuZuYiZhiFu": "Not enough to pay",
    "DingDanYiShengXiaoZanBuZhiChiQuXiao": "The order has already been confirmed and cannot be canceled",
    "WoZaiXiangXiang": "Maybe later",
    "QingXuanZeQuXiaoYuanYin": "Please choose a reason",
    "QuXiaoShangPin": "Delete product",
    "QueRenQuXiaoHouGaiDingDanDuiYing": "After the order is canceled, the total price of the order and deposit might change.",
    "DingDanYiChaiFenBenDingDanJinE": "The order has been split, the price of this order",
    "BenDingDanJinE": "Price of this order",
    "DingDanZhengZaiJiaZaiZhong": "Loading order ...",
    "ZhanShiGengDuo": "View more",
    "ShouQiGengDuo": "Find more",
    "ZiDingDan": "Sub-order",
    "BenDingDanDeGeZiDingDanYiDaoHuo": "{0} of your orders are about to arrive, please make the final payment. At the same time, you can also pay the balance of other orders together.",
    "YiXiaDingDanYuJiDaoGang": "The following orders are expected to arrive on <i>{0}</i>, and the total balance payment: {1}.",
    "ZhiFu": "Pay money",
    "DingJin": "Deposit",
    "GeXingYaoQiu": "Special requirements",
    "YiQuXiaoShangPin": "Cancelled products",
    "BenChaiFenDingDanShangPinQingDan": "List of products after the order was split",
    "ZongGongKuanXiangShangPinZongJia": "A total of {0} items, {1} cartons, total amount: {2}",
    "QueRenQuXiaoHouWuFaHuiFu": "After cancellation is confirmed, it can not be restored.",
    "QuXiaoDingDan": "Cancel order",
    "ZaiCiCaiGou": "Order again",
    "ChaKanZongDingDan": "All orders",
    "ZuiJinNTian": "Last {0} years",
    "ZuiJinNNian": "Last {0} years",
    "DingDanZhengZaiChuLiZhongQing": "The order is being processed, please wait",
    "YouYuShangPinDeHuoQiBuTong": "Due to the different delivery times of the goods, in order for you to receive the goods as soon as possible, your order was split into{0}sub-orders, and they will be shipped separately.",
    "DaiZhiFuTiHuo": "Awaiting payment",
    "YouDingDanDaiZhiFuTiHuo": "You have awaiting payments",
    "QingJinKuaiZhiFuYiMianYingXiangTiHuo": "Please pay as soon as possible, to avoid delivery delay",
    "YouYuWeiShouDaoDingJinDingDanHaiWuFa": "Because the deposit was not payed in time, the order could not be produced, and as a result the shipment date is changed to <i>{0}< / i> (original date{1}), please pay the Deposit as soon as possible.",
    "JinXingZhong": "Processing",
    "DaiZhiFuWeiKuan": "Balance Unpaid",
    "YiWanCheng": "Completed",
    "DingJinDaiZhiFu": "Deposit to be paid!",
    "DingDanYouYiChangXuChuLi": "There are some problems with your order need to be solved",
    "BenDingDanShuYuChaiFenDingDanDeYiXiang": "If the order is a split sub-order, the deposit for the other associated sub-orders is payable at the same time as the payment.",
    "QingJinKuaiFuKuan": "Please pay as soon as possible, so as not to affect your pick-up.",
    "DingJinJiaoYiMoShi": "Deposit - is a certain percentage of your order price that is paid as an order guarantee, after the deposit is recieved, system will arrange the production of your order. The rest of the price should be paid before the products are delivered to your city. According to the rules, the deposit cannot be refunded without any reason, except problems with platform or factory production problems. If your order can not be carried out properly, you can refund 100% of the deposit.",
    "ZheShiZhiYongHuJiCun": "With this account, you can manage the funds on your account, top up your balance, pay for orders and refund money after in the order is canceled.",
    "yanZhengMaBuNengWeiKong": "The confirmation code cannot be empty",
    "QingXianSheZhiZhiFuMiMa": "Please set the payment password",
    "ZhiFuMiMaYuQueRenZhiFuMiMaBuYiZhi": "Passwords don't match. Please try again.",
    "QueRenZhiFuMiMaBuNengWeiKong": "The payment password cannot be empty.",
    "ZhiFuMiMaBuNengWeiKong": "Payment password cannot be empty.",
    "JiuMiMaBuNengWeiKong": "The old password cannot be empty",
    "JiuMiMaBuZhengQue": "Old password is incorrect.",
    "BenDingDanBaoHanNGeZiDingDanDingJin": "This order contains {0} sub-orders, the Deposit must be paid together",
    "ShangPinYiJingChongXinTianJiaDaoGouWuChe": "The item has been added back to the shopping cart.",
    "ZhaoXiangSi": "Find similar",
    "ZaiCiJiaRuGouWuChe": "Add to cart again",
    "QuXiaoShuoMing": "Cancellation instructions",
    "ShangPinShengChanZhongChuXianYiChang2": "There is a problem with product production",
    "ZhiFuMiMaSheZhi": "Payment password setting",
    "SheZhiNinDeZhiFuMiMaBaoZhangZiJinAnQuan": "For security reasons, you must create a payment password. This password will be used for each payment.",
    "QingNinZaiNTianNeiJiShiZhiFuDingJin": "Please pay the deposit within<i>{0}days</i> period",
    "DangNinDeDingDanTiJiaoWanGongHouWoMen": "1. When your order is successfully submitted, we will contact you to sign a contract.",
    "TiJiaoHouNinDeDingDanJiaGeJiangShouDaoJiaGeBaoHuYu": "2. After placing the order, the total cost is guaranteed for a period of {0} days. The order price will not change during this period. If the guarantee expires, the total cost and deposit may change.",
    "WoMenJiangZaiShouDaoNinDeDingJinHouCaiKaiShiChuLiNinDeDingDan": "4. Your order will be proceed after the deposit is payed",
    "JiaoYiBiZhongYuZhangHaoZiJinBiZhongBuYiZhi": "The transaction currency and account currency should be the same",
    "QingJinKuaiZhiFuDingJinYuJiDao": "Please pay the deposit as soon as possible to avoid changes in the order price beyond the price protection period.",
    "BenDingDanDeGeZiDingDanYiDaoHuo2": "{0} of your orders are about to arrive, please make the final payment.",
    "DaoESSAPingTai": "Transfer money to ESSAONE",
    "DangQianNinDeZhangHuYouZuGouDeKeYongZiJin": "Right now you have enough money in your account, click pay directly to use the available funds on your account to pay the deposit for the order.After the deposit is paid, the order will immediately be confirmed and production will be arranged.",
    "DangQianNinDeZhangHuMeiYouZuGouDeKeYongZiJin": "There are not enough money in your account, please top up your balance",
    "XinZhiFuMiMa": "New payment password",
    "LianXiGongChangKaiFang": "联系工厂开放权限",
    "DaiChuLiYiChangLieBiao": "The list of pending abnormal orders",
    "WeiBiMianDingDanJinDu": "To avoid affecting the order progress, please correct it as soon as possible",
    "JieShouBianDong": "Accept changes",
    "QuanBuJieShouBianDong": "Accept all changes",
    "TiJiaoChuLi": "Submit",
    "BenCiZhiFuHeJi": "Total of this payment",
    "FanHuiDingDanLieBiao": "Back to order list",
    "GongNDanDanYouYiChangDaiChuLi": "Total {0} orders, there are <i>{1}</i> the abnormal order to be processed.",
    "QingWuChongFuTiJiao": "Do not submit repeatedly！",
    "DingJinMoShi": "Deposit Mode",
    "AnQuan": "Safety",
    "ShangPinYiTingShou": "The item has been stopped for sale.",
    "ShangPinYiTingShou1": "Sorry, the item has been stopped for sale.",
    "HenYiHanYouKuanShangPinYi": "Unfortunately,  {0} items have been discontinued and the remaining {1} items have been added to the shopping cart.",
    "DaoChuShuJu": "Export Data",
    "ZhangHaoZiJinBuZu1": "The account is underfunded.",
    "TongJi": "Statistics",
    "c3VibWl0X3BvX2RlcG9zaXRfZGRwX3NwbGl0": "Order placing notification",
    "c3VibWl0X3BvX2RlcG9zaXRfZGRwX3NwbGl0_remark": "Successful placement of your order",
    "ZGRwX2RlcG9zaXRfb3ZlcmR1ZQ==": "Deposit notification",
    "ZGRwX2RlcG9zaXRfb3ZlcmR1ZQ==_remark": "Reminder after the deposit payment period is exceeded.",
    "cG9fcGF5X2RlcG9zaXRfZGRw": "Order confirmation notice",
    "ZGRwX3BvX2NhbmNlbA==_remark": "Email sent when the order expires without paying the deposit.",
    "cG9fcGF5X2RlcG9zaXRfZGRw_remark": "The email sent when the order deposit payment is successfully confirmed.",
    "ZGRwX3BvX2NhbmNlbA==": "The order cancelation notice",
    "GaiShangPingBuYunXuJiaGou": "此商品暂无权限加购",
    "QingShuRu6WeiShuZiDeZhiFuMiMa": "Please enter 6 digits.",
    "1006ARG1000000": "Sorry, there is a problem with the page!",
    "WeiKuan": "Final Payment",
    "TuPianChaoGuo4M": "Sorry, your picture has exceeded the limit (<4M), please adjust before uploading!",
    "QingXuanZeNinDingDanDeFaHuoFangShi": "Please choose the shipping method of your order",
    "ChaiDanTiShi": "Split Order Tips",
    "DingDanChaiFenFaHuo": "Order split delivery",
    "WoMenJiangGenJuNiDingDanZhongBuTong": "We will split the order according to the delivery date of the different products in your order, and ship them in batches. After the goods arrive, you need to pick them up in batches, so that you can receive the goods as soon as possible.",
    "BenCiDingDanGenJuShangPinHuoQi": "According to the delivery date of the goods, This order will be split into {0} sub-orders. They will be shipped separately.",
    "DingDanGongNKuanYuJiDaoGangShiJi": "Order {0}, a total of {1} items, {2}㎡. <i>Estimated delivery time: {3}</i>",
    "DingDanTongYiFaHuo": "Unified delivery of orders",
    "DingDanBuChaiFenDengDingDanZhongSuo": "Orders are not split. After all the products in the order are produced, they will be dispatched together to facilitate unified delivery.",
    "JiaGeBaoHuQiShengYuNTian2": "{0} days left for product price protection. The price will not change during the protection period.",
    "bG9hZF9jb250YWluZXJfZG9uZV9lbWFpbA2==": "The whole order is completed.",
    "MeiZhouTeHui": "Weekly Deals",
    "RuGuoChaoGuoNTian": "3. If the deposit is not paid for more than {0} days, the order will be invalid and the platform will automatically cancel the order.",
    "DingYue": "Subscription",
    "RenQi": "HOT",
    "KuanShi": "items",
    "ChuangXinJingXuan": "New arrivals ",
    "ReXiaoPaiHangBang": "HOT PRODUCTS",
    "QuanBuXinPin": "All new products",
    "YiXiangKeMai": "One carton order and shipping in 10 days. Don't miss it！",
    "YXV0b19tYXJrZXRpbmdfZW1haWw1": "product recommendation/special offer/event information",
    "QueDingTiJiao": "Confirm Submission",
    "NinQueDingYaoTuiDing": "Are you sure you want to unsubscribe from emails?",
    "WoBuXiangZaiJieShou": "I don't want to receive email notifications about {0}, thank you！",
    "TeHuiShangPin": "Weekly promotion",
    "YouXiangDingYueZuiXin": "Enter your email to subscribe",
    "Zhe": "DISCOUNT",
    "ManShiYong": "For orders over {0}",
    "LingQu": "Receive",
    "YiLingQu": "Received",
    "XiangXi": "More",
    "LiJiChaKan": "View now",
    "GongXiHuoDeYouHuiQuan": "Congratulations, get the coupon！",
    "YiJiangLi": "Rewarded",
    "WeiJiangLi": "Not rewarded",
    "ZhiDaoLe": "OK",
    "DingDanManKeYongZuiDuoZheKou": "For orders over {0} ,up to {1} off.",
    "DingDanManKeYongZheKouJinEBuXian": "For orders over {0}",
    "ManKeYong": "For orders over {0}",
    "ZengSongNiYouHuiQuanKeYongYuXiaCiXiaoFei": "A coupon - gift for  your next purchase",
    "GaiPinPaiQuanBu": "For All Products Of The Brand",
    "YaoQingYouLi": "You Share,You Earn!",
    "MeiYaoQing1WeiHaoYouZhuCeJiKeHuo": "Get 1 level of bonus for every 1 friend you invite to register. Friends who complete their first order will also get cash vouchers and up to ₽20,000 off the exclusive new user gift package.",
    "YaoQingJiangLi": "Sharing Rewards",
    "ZhiJieDianJiNinYaoFenXiangDeSheJiaoMeiTi": "Share 1: Directly click on the social media you want to share.",
    "FuZhiLianJieFaSongHaoYou": "Sharing 2: Copy the link to send to friends.",
    "FaXianYiGeHaoWangZhanessaone": "Let me recommend you a website I found for wholesale purchase from China, MOQ from 1 box! Just click on the link to register to receive the new users special offer. {0}",
    "FenXiangHuoDongGeiHaoYou": "Share events with friends",
    "HaoYouZhuCeWanChengShouDan": "Friends register to get the first level reward",
    "JiangLiLiQuanDaoZhang": "Friends place an order to get a secondary reward",
    "WoDeJiangLi": "My Reward",
    "ChaKanWoDeYouHuiQuan": "Check my coupons",
    "ZhuCeJiangLi": "Registration Reward",
    "XiaDanJiangLi": "Order Reward",
    "WoDeYouHuiQuan": "My  coupons",
    "YaoQingJiLu": "Share Record",
    "YouHui2": "Discounted",
    "XinRenYouHuiQuan": "New buyer coupons",
    "LiJiShiYong": "Use now",
    "BaoHanShuiFei": "VAT fee included",
    "DaoChuDingDanShangPin": "Export order products",
    "PODanDaoChu": "Products list export",
    "BaoHanDingDanShangPinXiangQingXinXi": "Include order product detail information",
    "DaoChuShangPinTuPian": "Download products pics",
    "JinBaoHanDingDanDeShangPinTuPian": "Only include product images of the order",
    "NZengZhiShuiE": "{0}% VAT amount",
    "WeiShiYongYouHuiQuan2": "Available coupons",
    "ZanWuWeiShiYongYouHuiQuan2": "No coupons available",
    "XinDaoZhang": "Last updates",
    "JiJiangGuoQi": "Expire soon",
    "GuiZeShuoMing": "Rule:",
    "YouHuiQuanLieBiaoShuoMin11": "Coupon instructions",
    "YouHuiQuanLieBiaoShuoMin12": "1. ESSAONE platform sometimes launches coupon activities , which can only be used on the platform.",
    "YouHuiQuanLieBiaoShuoMin13": "2. There are currently three types of coupons: discount coupons, full discount coupons, and cash coupons.",
    "YouHuiQuanLieBiaoShuoMin14": "3. How to get coupons:  coupons are automatically distributed by platform, return after the order, participate in activities to receive the form of access.",
    "YouHuiQuanLieBiaoShuoMin15": "4. One coupon per one order, and each coupon can be used only once. In case of special circumstances, please refer to the instructions for using the current coupon campaign for details.",
    "YouHuiQuanLieBiaoShuoMin16": "5. Если Ваш заказ был полностью отменен, то купон будет возвращен. Если заказ был отменен частично и скидка будет частично использована, купон не будет возвращен.",
    "YouHuiQuanLieBiaoShuoMin17": "6. Coupons cannot be redeemed, sold, transferred or otherwise used.",
    "YouHuiQuanLieBiaoShuoMin21": "Specific usage rules of various coupons",
    "YouHuiQuanLieBiaoShuoMin22": "1. Universal Coupon: these coupons are universal for all products on the platform, regardless of user, category or region restrictions, the total amount of products purchased in the order must reach the coupon limit to be used.You can only use one coupon per one order, the amount will be deducted according to the order amount. Each order is limited to one All Universal Coupon, which will be deducted from the order cost.",
    "YouHuiQuanLieBiaoShuoMin23": "2. Category coupon: The coupon is restricted by category and can only be used to purchase products in specific categories. Each order is limited to 1 category coupon.",
    "YouHuiQuanLieBiaoShuoMin24": "For example, a 5% off coupon for toys can only be used if the order contains products from the toys category and the total amount of products in the category reaches the coupon limit.",
    "YouHuiQuanLieBiaoShuoMin25": "3. Activity product coupon: The coupon is restricted by the product and can only be used to purchase specific products. Each order is limited to 1 product coupon.",
    "YouHuiQuanLieBiaoShuoMin26": "For example: $1,000 off a case of Fast Shipping items, the order must include a case of Fast Shipping items and the total amount of the items must reach the coupon limit before the coupon can be used.",
    "YouHuiQuanLieBiaoShuoMin27": "4. New Customer Coupon: This coupon is only available to new customers. New customers are registered customers who have never placed an order with ESSAONE. The coupon can only be used if the new customer is qualified and the order placed meets the requirements for using the coupon.",
    "HaoYouKeDeZuiGaoYouHui": "Friends can get: a voucher pack worth 40,000 rubles, maximum discount on a single order",
    "YaoQingYeGuiZeShuoMing1": "1. Time period: Effective from 9 April 2021.",
    "YaoQingYeGuiZeShuoMing2": "2. During this period, your friends can register and place an order through the invitation link you shared, which means you successfully invite 1 person.",
    "YaoQingYeGuiZeShuoMing3": "3. Every time you invite 1 person to order successfully, you will get the corresponding level 1 bonus, and your friend will also get the new user exclusive gift package.",
    "YaoQingYeGuiZeShuoMing4": "4. After the friend you invited completes the registration, you will first get a $260 coupon to be activated, which is not yet effective. After the friend places the first order, the coupon will be activated and can be used.",
    "YaoQingYeGuiZeShuoMing5": "5. Coupons will be automatically sent to your account according to the rules.",
    "YaoQingYeGuiZeShuoMing6": "6. You can view the coupons you have received on the \"My Coupons\" page. The coupon is valid for 180 days after it is issued.",
    "YaoQingYeGuiZeShuoMing7": "7. Any questions about this activity can be asked in online customer service, the right to explain the activity belongs to ESSAONE.",
    "YiJiJiangLi": "First-level Reward",
    "ErJiJiangLi": "Second-level Reward",
    "HaoYouZhuCeChengGongKeDe": "Friends who register successfully can get",
    "HaoYouWanChengShouBiDingDanKeDe": "Available when your friend completes the first order",
    "ZanWuShuJu": "No data",
    "QuShiYong": "Use now",
    "BuKeShiYong": "Unavailable",
    "SuiFei": "VAT charges",
    "YouHuiQuanZheGou": "Coupons/Discounts",
    "YiShiYongZuiYouZuHe": "The best coupons used",
    "XuanZeZuiYouZuHe": "Choose the best coupon",
    "ChongXinXuanZeQiTaYouHuiQuan": "Re-select another coupons",
    "QuanBuShangPinKeYong": "For All Products",
    "ZhiDingLeiMuKeYong": "For Specific Categories",
    "ZhiDingPinPaiKeYong": "For Specific Brands",
    "ZhiDingShangPinKeYong": "For Specific Items",
    "YouYouHuiQuanKeYong": "You have coupons available.",
    "NiYouNZhangYouHuiQuanKeYong": "You have {0} coupons available.",
    "JinTianGuoQi": "Expired today",
    "HaiShengNTian": "{0} days left",
    "HuoQuYouHuiQuan": "Get coupons",
    "FaXianYiGeHaoWangZhanessaone2": "Let me recommend you a great website for wholesale purchase from China, MOQ from 1 box! You can register just by clicking on the link and get the new users special offer.",
    "XinRenTeHui": "New Buyer Special Offer",
    "ShouDanJiKeShiYong": "Available for the first order",
    "ShouDanWanChengHou": "Receive after the first order",
    "LingQuanHouNTianNeiYouXiao": "Expired in {0} days after receiving",
    "YiPaiWan": "Sent",
    "DingDanZhengZaiJiSuanZhong": "Order is being calculated, it might take around 5 minutes, please be patient!",
    "totalDdpTaxesCost": "VAT fee included",
    "ChaKanYouHuiQuan": "Check coupons",
    "YiZhuCe": "Already registered",
    "Ren": "Users",
    "WuShiYongMenKanZuiDuo": "Available below {0}",
    "WuShiYongXianZhi": "No restriction on usage",
    "RuHeYaoQing": "How To Share",
    "CongZhongGuoFaHuoJiaGeHan2": "Ships from China：Price includes logistics, customs duty and {0} VAT.",
    "ZanWeiShengXiao": "Not yet effective",
    "YaoQingYongHuMingXi": "Detail",
    "DianZiYouJian": "E-mail",
    "JiangLiJinE": "Bonus",
    "RenZhengZhuangTai": "Certification status",
    "RenZhengZhong": "To be certified",
    "RenZhengChengGong": "Successful certification",
    "RenZhengShiBai": "Authentication failed",
    "WoDeYaoQingJiangLi": "My bonus",
    "LeiJiYaoQingYongHuShu": "Cumulative number of invited customers",
    "RenZhengTongGuoShu": "Number of certified customers",
    "TiCheng": "Commission",
    "ShouYeBiaoTi2": "宜采有货-全球贸易的数字化交易平台",
    "YongHuXingWei1": "Nearly 30 days",
    "YongHuXingWei2": "Nearly 60 days",
    "YongHuXingWei3": "Nearly 90 days",
    "YongHuXingWei4": "ALL",
    "MeiYaoQing1WeiHaoYouZhuCeJiKeHuo2": "Welcome to our invitation bonus program!Invite your friends (non-competitors) and share bonuses with them!<br> Every time you invite a friend to register and place an order, you can get a $260 coupon, and friends you invite to register can also get a $500 newcomer coupons pack.",
    "NiKeHuoDe": "Your Rewards",
    "HaoYouWanChengShouBiDingDanKeYong": "You can get it when friends register successfully.<br>It is available after friends place the first order.",
    "HaoYouKeDe": "Bonuses for your friends",
    "HaoYouZhuCeChengGongKeHuoDe": "Friends who register successfully can get a $500 coupons pack.",
    "NiKeDeYiZhangDaiJiHuoJuan": "After your friends register, you can get a $260 coupon to be activated, which is not yet effective. After friends places the first order, the coupon will be activated and can be used.",
    "HaoYouZhuCeDeDaiJiHuoYouHuiJuan": "Friends register to get coupons to be activated.",
    "YiXiaDan": "Place an order",
    "YiZhuCeWeiXiaDan": "Registered but not order",
    "HaoYouXiaDanYouHuiJuanKeYong": "Coupon is available after your friends order.",
    "YiJiHuo": "Coupons activated",
    "DaiJiHuo": "Coupons to be activated",
    "YiJiHuoYouHuiJuan": "Coupon activated",
    "RenZhengBuTongGuoYuanYin": "Non-platform target customers",
    "DaiJiHuoYouHuiJuan": "Pending activation coupon",
    "YongHuXingWei": "User usage data",
    "TuiGuangDeKeHuSuoYouYiWan1": "Commission for all new customers who have completed registration and were confirmed",
    "TuiGuangDeKeHuBenZiRanYue1": "Commission for new customers who have completed registration and were confirmed within this month",
    "TuiGuangDeKeHuSuoYouYiJin1": "Commission for new customers who are currently registered but not confirmed yet",
    "YaoQingHaoYouXinXiE": "1. You can copy invitation link to share with your purchaser friends and help them registrate ESSAONE member.",
    "YaoQingHaoYouXinXiF": "The new customers you invite will only be bound to your account if they fill in your invitation code or register through the registration link you provide",
    "YaoQingHaoYouXinXiG": "The final commission you receive is based on all he successful and confirmed registrations of new customers.",
    "YaoQingHaoYouXinXiH": "After the new customers you invited register successfully, you can check all of them in \"My commission\" list. If the new customers you invited register successfully and are not in your invited users list, please contact essaone online service for consultation.",
    "KeHuXinXi": "Customer information",
    "DianZiYouXiang": "Email",
    "FenXiaoShang": "Distributor",
    "FenXiaoShangLeiXing": "Distributor type",
    "KeHuGenJinXinXi": "Customer information",
    "LianXiRenZhiWu": "Position",
    "GongSiLeiXing": "Type of company",
    "JingYingLeiMu": "Business category",
    "NianXiaoShouE": "Annual sales",
    "XianXiaMenDianShuLiang": "Number of offline stores",
    "ZaiShouSKUShu": "Number of SKUs on sale",
    "GenJinRenYuan": "Follower",
    "ShouCiGenJin": "Follow up for the first time",
    "QuanBuYongHu": "All customers",
    "YiGenJinYongHu": "Follow-up customers",
    "XinYongHu": "New customer",
    "GongSiMingChengLianXiFangShi": "Name/Customer ID/Contact Information",
    "QingXuanZeQuDao": "Please select the source",
    "QingXuanZeFenXiaoShang": "Please choose a distributor",
    "QingXuanZeGenJinRen": "Please choose a follower",
    "YongHuDeGongSiMingChengHeChengShiXinXi": "Client’s company name and city",
    "YongHuDeLianXiYouXiangHeShouJiHaoMa": "Customer's email and mobile phone number",
    "ZhuCeQuDao": "Registration source",
    "YongHuDeZhuCeQuDaoLaiYuanHeFenXiaoShangXinXi": "Customer's registration source and distributor information.",
    "GenJinRen": "Follower",
    "GenJin": "Follow up",
    "QingXuanZeZhuangTai": "Please select status",
    "GangWei": "Position",
    "YiGenJinKeHu": "Follow-up customers",
    "ZhangHaoZhuangTai": "Account status",
    "TingYong": "Deactivate",
    "XinZengKeHuXinXi": "Add employee information",
    "BianJiKeHuXinXi": "Edit employee information",
    "QingShuRuYuanGongXingMing": "Please enter the employee's name",
    "QingSheZhiYuanGongDengLuZhangHao": "Please set up the employee's login account",
    "DengLuZhangHao": "Login account",
    "DengLuMiMa": "Login password",
    "QingSheZhiYuanGongDengLuMiMa": "Please set the login password of the account.",
    "QingXuanZeGangWei": "Please choose a position",
    "QingSheZhiYuanGongLianXiDianHua": "Please enter the employee's phone number",
    "ShiFouQiYongGaiZhangHao": "Do you want to enable the account?",
    "XinZengYuanGong": "New employee",
    "ShiFouTingYongGaiZhangHao": "Do you want to deactivate the account?",
    "QingShuRuYuanGongZhangHuXinMiMa": "Please enter a new password for the account.",
    "MuBiaoYongHu": "Target Customers",
    "GuanLiHouTai": "Management Platform",
    "KeHuLieBiao": "Customer Information",
    "KeHuXinXiBuChong": "Supplement customer information",
    "FeiMuBiaoYongHu": "Non-target customers",
    "QingShuRuGongSiWangZhi": "Please enter the company website",
    "QingShuRuKeHuLianXiRen": "Please enter the contact name",
    "QingShuRuZhengQueDeLianXiDianHua": "Please enter the correct phone number",
    "QingTianXieMenDianShuLiang": "Please fill in the number of stores",
    "QingXuanZeGenJinRenYuan": "Please select a follow-up person",
    "QingXuanZeGongSiLeiXing": "Please select company type",
    "QingXuanZeJingYingLeiMu": "Please select business category",
    "QingXuanZeLianXiRenZhiWu": "Please select a position",
    "QingXuanZeNianDuXiaoShouE": "Please select annual sales",
    "QingXuanZeZaiShouSKUShu": "Please select the number of SKUs on sale",
    "QuDao": "Source",
    "ShiFouMuBiaoKeHu": "Whether the target customer",
    "TuiGuangFangShi": "Source type",
    "YongHuGenJin": "Customer Follow-up",
    "YuanGongZhangHaoGuanLi": "Account Management",
    "ZhangHaoXiangQing": "Customer Information",
    "YouYeWuYuanZhengZaiGenJin": "A salesman is following up, please do not repeat the operation！",
    "QingShuRuZhangHao": "Please enter account",
    "LiJiDengLu": "SIGN IN",
    "EGuoYunYingPingTai": "ESSAONE Operating Platform",
    "BuShiLingShouKeHu": "The platform does not have customers' main categories of products.",
    "BuShiBenGuoYongHu": "Non-domestic customers",
    "QingShuRuYongHuMing": "Please enter user name",
    "QingShuRuMiMa": "Please enter the password",
    "QingShuRuShuiWuHao": "Please fulfill with Tax No.",
    "QingShuRuYingYeZhiZhao": "Please, enter your license number",
    "NinCaoZuoTaiKuaiLeQingTin": "Your operation is too fast, please stop for a drink.",
    "DaoChuShuJuShaiXuan": "Filtering of exported data",
    "QingShuRuCaiGouShangBianMaHuoMingCheng": "Please enter customer ID or name",
    "KeHuShuJu": "Customer behavior data",
    "ZuiJinJiaGouShiJian": "Last added to cart time",
    "JiaGouKuanShu": "The number of items added to cart",
    "ZuiJinFangWenShiJian": "Last visit time",
    "LeiJiDingDanShu": "Cumulative order quantity",
    "ZuiJinXiaDanShiJian": "Last order time",
    "CaiGouShangHangWeiShuJu": "Customer behavior data",
    "JiaRuShiJian": "Order time",
    "QingShuRuJiGuiDanHaoHuoGuiHao": "Please enter the container serial number or container number",
    "DengLuRenShu": "Number of people registered",
    "XinKeHuChengJiaoRenShu": "Number of new customers with transactions",
    "ZongChengJiaoRenShu": "Total number of transactions",
    "WeiChengJiaoKeHu": "Untraded customers",
    "YiChengJiaoDeKeHu": "Customers who have traded",
    "KeHuLeiXing": "Customer type",
    "JiaGouShangPinShu": "The number of items added to cart",
    "KeXiaDanShangPinShu": "Number of items that can be ordered",
    "WeiZhiFuDingJinDingDanShu": "Unpaid deposit order quantity",
    "JinNianCaiGouZongJinE": "The total amount of orders this year",
    "JinNianDingDanShu": "This year's order quantity",
    "WeiZhiFuWeiKuanDingDanShu": "Unpaid balance order quantity",
    "LeiJiCaiGouZongJinE": "Cumulative total order amount",
    "ShouCiChengJiaoShiJian": "First transaction time",
    "ZuiJinChengJiaoShiJian": "Last order time",
    "QingShuRuDingDanBianMaHuoShangPinBianMa": "Please enter the order number or product code",
    "ShuJuTongJi": "Data Statistics",
    "CaiGouShang": "Purchaser ID",
    "MaiJiaBaoZhang": "Buyer Guarantee",
    "MaiGuiBiPei": "Best Price Guarantee",
    "WanDaoBiPei": "Delivery Delay Compensation Guarantee",
    "PoSunBiPei": "Goods Damage Compensation Guarantee",
    "ZhengGuiQingGuan": "Door to Door Delivery",
    "XinKeYouHui": "New user Promotion",
    "GouWuCheGaiShangPinZaiXunPanZhong": "The cart already has the item in the request for quotation.",
    "YiGengXinWeiGongChangZuiXinTuiJianJia": "This item information in the cart has been updated.",
    "GongChangYouHaoTuiJian": "Factory quality products",
    "JiaGeYouXiaoQi": "Price validity period",
    "TuiJianLiYou": "Recommended reason",
    "JiaRuXuanYangChi": "Add to cart",
    "PaiYiPaiTiXingShangXin": "拍一拍，邀请工厂上新品",
    "JinQiYiTiXingShangXin": "近期已邀请上新",
    "ChaKanGongChangDongTai": "You can go to my followers to see what's new at the factory.",
    "JiaRuXuanYangChiChengGong": "加入选样池成功",
    "JiaRuGouWuCheChengGong": "Has been added to cart successfully.",
    "GuanZhuGongChangDongTai": "Follow factory updates",
    "CLAIM_DAMAGE_001": "The daily refund amount is calculated incorrectly.",
    "CLAIM_DAMAGE_002": "The total refund amount is calculated incorrectly.",
    "CLAIM_DAMAGE_003": "The refund amount cannot exceed 10% of the total value of the product.",
    "CLAIM_DAMAGE_004": "Our price is not more expensive than the prices of other suppliers.",
    "CLAIM_DAMAGE_005": "Price difference after negotiation cannot be less than 0.",
    "CLAIM_DAMAGE_006": "The total quantity is incorrect.",
    "CLAIM_DAMAGE_007": "The total refund amount is wrong.",
    "ShangPinZaiDaiGongChangQueRenZuiXinJiaZhong": "选样池商品在待工厂确认最新价中",
    "WuTuiJianShangPin": "No product recommendation",
    "HenBaoQianNinDeDingDanBiYuQi": "Sorry! Your order is delayed for {0} days than expected, and you will receive a compensation of {1}.",
    "ShenQingWanDaoBiPei": "Apply for delay compensation",
    "ShiFouShenQingSuoPei": "Do you want to apply for a claim?",
    "ShenQingSuoPei": "Apply for compensation",
    "NinDeDingDanBiYuQiWanDaoLe": "Your order is delayed for {0} days than expected, and you will receive a compensation of {1}.",
    "PoSun": "Broken",
    "MaiGui": "Expensive",
    "TiJiaoShenQing": "Submit application",
    "ShenHe": "Verification",
    "SuoPeiJieGuo": "Compensation result",
    "ChanPinWenTi": "Product problem",
    "QingXuanZeChanPinWenTi": "Please select a product problem!",
    "QingTiGongYouXiaoZhengMing": "Please provide valid proof (verifiable)",
    "GongHuoQuDao": "Supplier",
    "QingTianXieGongHuoQuDao": "Please fill in the supplier!",
    "GongHuoJiaGe": "Supply price",
    "QingTianXieGongHuoJiaGe": "Please fill in the supply price!",
    "QingTianXieZhengQueDeGongHuoJiaGe": "Please fill in the correct supply price!",
    "ShangChuanPingZheng": "upload certificate",
    "ZhiChiTuPianShiPinWenDang": "Picture/video/document, support (mp4,flv,jpeg,jpg,png,bmp,doc,docx,xls,xlsx,pdf) format files, a single file cannot exceed 20M, up to 5.",
    "TianXieShuoMing": "Please fill in the description!",
    "QingTianXieShuoMing": "Please fill in the description!",
    "JianYiBuChongGengXiangXiDe": "It is recommended to add a more detailed description of the problem, which will help us deal with your problem faster and better.",
    "LianXiRenXinXi": "Contact information",
    "QingTianXieZhengQueYouXiao": "Please fill in the correct and valid contact information, and we will call you when necessary to better deal with your problem.",
    "SuoPeiShenQingJiLu": "Compensation application record",
    "DingDanWanDaoTianShu": "Number of days late for the order",
    "YuJiPeiChangJinE": "Estimated compensation amount",
    "TiJiaoChengGongQingNaiXinDengDai": "Submitted successfully, please wait patiently.",
    "ShenHeJieGuoJiangYu7GeGong": "The application result will be completed within 7 working days, please pay attention to the email notification.",
    "FanHuiDingDanXiangQing": "Return order details",
    "ShenQingXinXi": "Application Information",
    "LeiXing": "Type",
    "ShouHouDanHao": "After-sales number",
    "CheXiaoShenQing": "Cancel application",
    "PingZheng": "Evidence",
    "NinDeSuoPeiZhengZaiShen": "Your claim is being reviewed, please wait patiently. The audit results will be completed within 15 working days.",
    "ShenHeTongGuoYiHuoPei": "The application is approved and the compensation has been successful. Compensation amount {0}.",
    "NinDePeiChangKuanYiTui": "Your compensation has been returned to your fund account, please go to <a href=\"/member/funds-detail\">Funds details</a> to view the record.",
    "ShenHeBuTongGuo": "The application is not approved",
    "ShenHeZhong": "waiting verify",
    "ShiBaiYuanYin": "Reason for failure",
    "DengDaiPingTaiShenHeChuLi": "Waiting for platform verification.",
    "NiSuoTiJiaoDeXinXiZhengZai": "The information you submitted is awaiting verification and will be confirmed within 7 working days. Please pay attention to the email notification.",
    "ShenQingYiCheXiao": "The application has been cancelled!",
    "NinYiCheXiaoCiCiSuoPeiShenQing": "You have cancelled this claim. If your problem is not resolved, you can apply again within the validity period.",
    "TuiKuanDanJiaPCS": "Refund prices / PCS",
    "ShiJiQueShaoSunHuaiShuLiang": "Actual missing/damaged quantity",
    "ZongTuiKuanJinE": "Total refund amount",
    "JieGuoShuoMing": "Explanation of results",
    "XieShangHouChaJia": "Price difference after negotiation",
    "ZongShuLiang": "The total amount",
    "TuiKuanJinE": "Refund amount",
    "QingShuRuChaJia": "Please enter the price difference",
    "QingShuRuShiJiQueShaoSunHuaiShuLiang": "Please enter the actual missing/damaged quantity.",
    "QingShuRuZongTuiKuanJinE": "Please enter the total refund amount.",
    "ShouHouGuanLi": "After-sales management",
    "ShouHouXiangQing": "After-sale details",
    "KeHuShenQing": "Customer application",
    "ShenHeChuLi": "Verification processing",
    "ShouHouBianHao": "After-sales number",
    "ShenQingKeHu": "Purchaser",
    "JuTiWenTi": "Concrete issue",
    "ShenQingShuoMing": "Application instructions",
    "ChaJia": "Price difference",
    "ZongChaJia": "Total price difference",
    "ChengNuoDaoHuoShiJian": "Promised arrival time",
    "RuKuQueRenShiJian": "Warehousing confirmation time",
    "WanDaoTianShu": "Number of days late",
    "YuJiTuiKuanJinE": "Estimated refund amount",
    "LaiKuanDengJi": "Incoming payment registration",
    "JinQiLaiKuan": "Recent incoming payment",
    "ChaKanLaiKuanJiLu": "View incoming payment records",
    "YinHangLiuShuiHao": "Bank serial number",
    "DaoKuanRiQi": "Payment date",
    "ShiJiDaoZhangJinE": "Actual amount received",
    "DengJiRen": "Register person",
    "FuKuanFangShi": "Payment method",
    "LaiKuanXiangQing": "Incoming payment details",
    "KeHuBianMa": "Purchaser ID",
    "KeHuMingCheng": "Purchaser",
    "QingShuRuCaiGouShangBianMa": "Please enter customer ID",
    "XuanZeKeHu": "Select customer",
    "KeHu": "Purchaser",
    "QingXuanZeDaoKuanRiQi": "Please select the payment date.",
    "QingShuRuYinHangLiuShuiHao": "Please enter the bank serial number",
    "QingXuanZeFuKuanFangShi": "Please choose a payment method.",
    "DaoZhangJinE": "Amount to the account",
    "QingShuRuDaoZhangJinE": "Please enter the payment amount",
    "QingShuRuBeiZhuXinXi": "Please enter remarks",
    "LaiKuanJiLu": "Incoming payment record",
    "QingQueRenLuRuDeDaoZhangJinEShiFouZhengQue": "Please confirm whether the entered incoming payment amount is correct?",
    "QingShuRuTianShu": "Please enter the number of days",
    "PeiChangJinEZuiGaoBuChaoHuoWuJinEDe": "The maximum compensation amount does not exceed {0}% of the value of the goods.",
    "ChuHuoDan": "Shipment",
    "JiGuiDanHao": "Container number",
    "HuoGuiXinXi": "Container Information",
    "GuiHao": "Container number",
    "CaiWuGuanLi": "Financial Management",
    "XiaoShouShuJu": "Sales data",
    "ShouHouSuoPei": "After-sales claim",
    "DingDanShu": "Quantity of order",
    "KeHuShu": "Number of customers",
    "FenXiaoShangTiCheng": "Distributor commission",
    "FenXiaoShangXingMing": "Distributor's name",
    "ZongGong": "Total",
    "YiZhiFuWeiKuan": "The balance has been paid",
    "QingShuRuKeHuBianMaHuoShangBinBianMa": "Please enter customer number or product number.",
    "QingShuRuPODanHao": "Please enter the order number",
    "QingShuRuShouHouDanHao": "Please enter the after-sales order number",
    "ChaXun": "Search",
    "SuoPeiFuWuLeiXing": "Compensation service type",
    "FuWuLeiXing": "Service type",
    "ChuLiRen": "Handler",
    "YingShouWeiKuan": "Balance receivable",
    "WeiChuLi": "Unfinished",
    "YiChuLi": "Processed",
    "QingXuanZeDingDanZhuangTai": "Please select order status",
    "ChuLiZhuangTai": "Processing status",
    "ZhiFuWeiKuanShiJian": "Time to pay the balance",
    "TiChengBiLi": "Commission ratio",
    "EXWZongJia": "EXW total price",
    "QuanXianSheZhi": "Permission settings",
    "QingXuanZeTuiKuanZhuangTai": "Please select refund status.",
    "TuiKuanZhuangTai": "Refund status",
    "TuiKuanShuJuTongJi": "Refund statistics",
    "DaiTuiKuan": "Pending refund",
    "YiTuiKuan": "Refunded",
    "ChuLiShiJian": "Processing time",
    "QuChuLi": "To deal with",
    "ShaoHouZaiChuLi": "Deal with later",
    "QingQueRenGaiBiTuiKuanXianXiaYiWanChengDengJi": "Please confirm that the refund has been registered offline.",
    "QingShuRuFenXiaoShangMingCheng": "Please enter the name of the distributor",
    "DingDanQingDan": "Order list",
    "RuKuDengJi": "Warehousing registration",
    "QueRenHuoWuRuKuShiJian": "Confirm the arrival time of the goods at the warehouse",
    "RuKuShiJian": "Arrival time at warehouse",
    "ShenHeJieGuo": "Verification result",
    "ShenHeTongGuo": "Verified successfully",
    "QianZaiCaiGouShang1": "A visual comparison of prices in one email.",
    "QianZaiCaiGouShang2": "We have something to surprise!",
    "QianZaiCaiGouShang3": "You can fill in your contact information here, and we will contact you as soon as possible.",
    "QianZaiCaiGouShang4": "Send",
    "QianZaiCaiGouShang5": "Request a call back",
    "QianZaiCaiGouShang6": "Please enter your WhatsApp/ Telegram account",
    "ShangChuanBaoJiaLogo": "上传报价LOGO",
    "QianZaiCaiGouShang7": "Please enter account",
    "QingShuRuShenHeJieGuo": "Please enter the verification result.",
    "GangGangBoFang": "Just played",
    "XuanPin": "Sample basket",
    "YiYouGuanZhu": "{0} people have followed",
    "GouWuCheYiYouWaiXiang": "There is already {0} box in the shopping cart, confirm to replace the existing quantity in the shopping cart with {0} cartons",
    "QuanXianXinXi": "Permission information",
    "ShiJiQueShao/SunHuaiDeShuLiangBuNengDaYuXiaDanShuLiang": "The actual missing/damaged quantity cannot be more than the order quantity.",
    "MaiGuiTuiKuan": "Refund of price difference",
    "WanDaoTuiKuan": "Refund of delayed compensation",
    "PoSunTuiKuan": "Refund of damage compensation",
    "QingShangChuanPingZheng": "Please upload credentials.",
    "QiTaGongHuoShangJiaGe": "Other supplier prices",
    "DingDanYiWanDaoNTianYu": "The order has been late for {0} days, and the estimated compensation is  {1}.",
    "ShenHeTongGuoDengDaiPeiFu": "Approved, waiting for payment.",
    "NinDePeiChangKuanJiangZaiXiaYiGeGong": "Your compensation of {0} will arrive in your fund account on the next working day.",
    "QingShuRuKeHuBianMa": "Please enter customer number",
    "PoSuiBiPei": "Goods Damage Compensation Guarantee",
    "BuZhiChiGaiGeShiShangChuan": "Does not support uploading in this format.",
    "HuoWuJinE": "Order Amount",
    "PeiFuBiLi": "Compensation ratio",
    "ZongGongNGeXiangMu": "Total {0} items",
    "DingDanWanDaoShiJianChaoGhuNian": "Orders delayed for less than 20 days (inclusive) belong to the scope of exemption, so no compensation will be made.",
    "NinDePeiChangKuanJiangZaiXiaYiGeGong2": "Your compensation of {0} will arrive in your fund account on the next working day after the final payment of the order.",
    "CLAIM_DAMAGE_120": "The product is not allowed to be approved due to infringement or cancellation.",
    "DaiRuKu": "Waiting for storage",
    "YiRuKu": "Has entered the warehouse",
    "QingShuRuDingDanHao": "Please enter the order number",
    "XiaoShouTongJiBiao": "Sales Statistics",
    "CLAIM_DAMAGE_100": "Order does not exist",
    "CLAIM_DAMAGE_101": "Claims already filed, please do not repeat",
    "CLAIM_DAMAGE_102": "Sorry, your application deadline has expired",
    "CLAIM_DAMAGE_103": "The order has not yet arrived in stock. It is possible to apply only after the order has arrived at the warehouse",
    "CLAIM_DAMAGE_104": "Order delay less than 20 days",
    "CLAIM_DAMAGE_105": "Evidence cannot be empty",
    "CLAIM_DAMAGE_106": "Maximum number of proofs 5 pic",
    "CLAIM_DAMAGE_107": "The description cannot be empty and the length is up to 600.",
    "CLAIM_DAMAGE_108": "Contact person cannot be empty",
    "CLAIM_DAMAGE_109": "Contact number cannot be empty",
    "CLAIM_DAMAGE_110": "The price of the other purchasing channel must be greater than 0 and less than the price of the item per 1 pc.",
    "CLAIM_DAMAGE_111": "The number of damaged items exceeds the total number of items",
    "CLAIM_DAMAGE_112": "Invalid parameters for product problems",
    "CLAIM_DAMAGE_113": "Order status is not in review",
    "CLAIM_DAMAGE_114": "Operation failed",
    "CLAIM_DAMAGE_115": "Invalid service type parameter",
    "CLAIM_DAMAGE_116": "The order has been processed, please do not repeat the operation.",
    "CLAIM_DAMAGE_117": "Claims not approved",
    "CLAIM_DAMAGE_118": "Please pay the deposit before applying \"Best price guarantee\"",
    "CLAIM_DAMAGE_119": "The order has not been completed yet, so it is temporarily unable to apply!",
    "ShenQingYiShiXiao": "Application is invalid.",
    "NinDeShenQinYinShangPinQuXiao": "Due to the cancellation of the product, the service compensation of \"Best Price Guarantee\" you have applied for will be invalid.",
    "DaiShenHe": "Pending review",
    "YiShenHe": "Reviewed",
    "ZhuangGuiShiJian": "Packing time",
    "ZhaoShangPinJieShao": "汇聚<b>30000+</b>澄海义乌工厂的<b>150万</b>商品，找商品、找工厂、找品牌！一键上传图片，极速识图搜索",
    "KanXinPinJieShao": "看新品，来宜采！每日<b>1000+</b>新品上线，玩具、餐具、文具、节庆用品，各类新品等你来挑",
    "XuanBaoKuanJieShao": "水枪、泡泡、积木、机器人...行业最新最热商品，<b>每周不定时更新</b>，带你掌握流行趋势！",
    "DaoBaoJiaJieShao": "选样池商品可批量导出报价单：英汉俄多语言可选，自行设置加价率，商品信息全，带公司Logo，导出就能直接发给客户做推荐用！",
    "QuXuanYangChi": "去选样池",
    "QuXuanBaoKuan": "去选爆款",
    "QuKanXinPin": "去看新品",
    "QuZhaoYang": "去找样",
    "KanXinPin": "New arrival",
    "zhaoGongChang/PinPai": "Brands",
    "ShiPinXuanPin": "Videos",
    "XuanBaoKuan": "选爆款",
    "DaoBaoJia": "导报价",
    "YiXiangKeCai": "One-carton",
    "GuoNeiZhuanGong": "Domestic Sales",
    "MeiZhouBaoKuan": "Weekly Best",
    "XinQiTe": "New Novelty Toys",
    "CaiNiXiHuan": "You May Like",
    "DingBu": "TOP",
    "QuanBuJiaRuXuanPinChi": "Add all to cart",
    "PiLiangXuanPin": "Bulk selection",
    "QuXiaoPiLiang": "取消批量",
    "JiaRuXuanPinChi": "Add to cart",
    "QingXuanZeLeiMuHouZaiJinXingShaiXuan": "First select product category and then set the filter",
    "ShiWuYuanReXiao": "All at 15RMB",
    "GaiYeMianShangPinYiQuanBuJiaRuXuanPinChi": "该页面暂无可加购的商品",
    "QingXianXuanPin": "请先选品",
    "RenQiBaoPin": "Popular items, new products",
    "PingJiaZhuanChang": "Special offers at low price are waiting for you",
    "ChaoJiXinPin": "Innovative picks not to be missed",
    "JingXuanPinPai": "Best factories, updated daily",
    "YinYiQingHeCaiGouWangJiYingXiang": "Recent international capacity constraints have prevented logistics from being arranged as scheduled.",
    "WuLiuYanQiTiXing": "Tip: For faster production and shipment of goods, check all information and pay for the order as soon as possible.",
    "ChaKanGuiZe": "View rules",
    "DDPStatus40": "The deposit payment is successful, your order has been scheduled for production, please pay attention to the abnormal notice.",
    "DDPStatus41": "The order has been completed and is waiting for quality inspection.",
    "DDPStatus110": "The balance payment is successful and the order has been completed.",
    "DDPStatus90": "Your order has been sent out and is being sent to <D/>.",
    "DDPStatus100": "Your order has entered <D/>, please pay the balance before picking up the goods.",
    "DDPStatus105": "Your order has reached <D/>, waiting for delivery.",
    "WuLiuXinXi": "Logistics information",
    "WuLiuYanQiTiShi": "Recent international capacity constraints have prevented logistics from being arranged as scheduled, and the estimated delivery time will be postponed to {0}(原{1})",
    "YiYouHuiN": "Saved {0}",
    "JiXuChouDan": "Continue to collect orders",
    "ZhaiGouNKeYouHui": "Order another {0}, you can save {1}.",
    "ShangPinBiaoQian": "Items Label",
    "NPaiHangBanDiNMin": "{0} ranked No. {1}",
    "NCaiGouBanDan": "{0} Ranking List",
    "JinXuanHaoHuoYiWangDaJin": "All the top products are here！",
    "ZhaoGongChang": "Factory",
    "ChongZhi": "Reset",
    "QuanBuJieGuo": "All results",
    "NinKeYi": "You can",
    "SKUPinMing": "SKU name",
    "GuanJianZi": "Keyword",
    "ShangJiaRiQi": "Added time",
    "XiaoShouMOQ": "MOQ",
    "BaoZhuangTiJi": "Packaging volume",
    "Tian": "Day",
    "GongChangChanDiQuYu": "Production area",
    "RenZhengBiaoZhun": "Certification Standards",
    "MeiZhaoDaoNiXiangYaoDeShangPin": "Can't find the product you're looking for? Leave information about the product or brand.",
    "ShangPinTeZhengBiaoTi": "You can provide product links, vendor details, product specifications, part quantities, and other information that will help you find the best terms.",
    "ShuRuNinXiangZhaoDeShangPinTeZheng": "Enter the characteristics of the product you are looking for",
    "YouXiangBiaoTi": "Please enter your email address and we will notify you of the results by email",
    "ShuRuNinDeYouXiang": "Please enter your e-mail",
    "TuXingYanZhengBiaoTi": "Verification Code",
    "ShuRuYanZhengMa": "Enter the verification code",
    "MeiYouZhaoDaoNinXiangYaoDeShangPinMa": "Can't find the product you want?",
    "ShouManQiangGuangLe": "Too late, the items are sold out",
    "KuCunBuZu": "Insufficient inventory",
    "GaiShangPingXianGouXXiang": "This product is limited to {0} carton",
    "NinZhangHaoBuFuHeTiaoJian": "The current activity is limited to designated users, your account does not meet the conditions",
    "GaiHuoDongJinXianYouHuiYiDanNinYiXiaDan": "The promo is limited to one order, you have placed an order",
    "GaiHuoDongZhiNengXuanGouXKuanMeiKuanXianGouXXaing": "The activity can only purchase {0} items, each limited to {1} cartons",
    "HuoDongYiJieJieSuQingShuaXinYeMian": "The current city's activities have ended, check the rule description or refresh the page",
    "NinXuanGouDeShangPingYiQuanBuQiangGuangXiaCiQingZaoDianXiaDan": "All the items you have purchased have been sold out, so please place your order early next time!",
    "NCaiGouBanDan2": "{0}TOP Popular Products",
    "JinXuanHaoHuoYiWangDaJin2": "All the top products are here！",
    "ReMenSouSuo": "Popular Search",
    "MeiYouZhaoDaoXiangGuanShangPin": "No related products found",
    "HuoZheTianXieFanKuiBiaoDan": "Or fill out the feedback form",
    "FanKuiGeiKeFu": "Feedback to Customer Service",
    "GaoJiSouSuo": "Advanced",
    "ShangJiaShiJianShengXu": "Added time ▼",
    "ShangJiaShiJianJinDaoYuan": "New first",
    "GaoJi": "Advanced",
    "MeiZhaoDaoXiangGuanGongChang": "No related factory found",
    "NiKeYi": "You can",
    "BenDingDanDe3GeZiDingDanYiDaoHuo": "There are currently {0} orders pending payment, please pay before pickup.",
    "YouHuiYiQiangGuang": "Sold out",
    "HuoDongShengYuYouHui": "Activity discount remaining",
    "MeiKuanXianZhi": "Each restriction",
    "YiYouHui": "Discounted",
    "QuJieSuan": "Checkout",
    "YiQiangGuang": "Sold out",
    "BuyGoodsTipTitle": "The following items you shopped for have been snatched up. Do you want to exclude the following items and proceed to checkout?",
    "NinYouWeiZhiFuDeXinYongHuDingDan": "You have unpaid orders for new customers",
    "QingXianJiaGouShangPin": "Please add items to cart first",
    "KuCunYouXianJinKuaiXiaDan": "Items in stock are limited, please place your order as soon as possible",
    "ChuKuGuanLi": "Delivery Order Management",
    "DaiChuKu": "Waiting for delivery",
    "YiChuKu": "Already shipped",
    "KeHuBianHao": "Customer ID",
    "ShouHuoRenXingMing": "Consignee Name",
    "ShouHuoRenShouJi": "Consignee contact number",
    "DingDanHao": "Order ID",
    "PiLiangChuKu": "Batch delivery",
    "ChuKuShiJian": "Delivery time",
    "CaoZuoRen": "Users",
    "ChuKuXiangQing": "Shipping details",
    "QueRenChuKu": "Confirm delivery",
    "AnPaiChuHuo": "Arrange shipment",
    "ChuHuo": "Ex warehouse",
    "ShengYuZhiFuShiJian": "Remaining payment time",
    "MeiZhaoDaoXiangGuanShangPin": "No related products found",
    "JiangBenYeShangPinPiLiangJiaRuXuanYangChi": "Add all items on this page",
    "QuXiaoQuanXuan": "Cancel All",
    "TuiChuPiLiangXuanPin": "Exit bulk selection",
    "JiJiangShouQing": "Selling out soon",
    "KuCun": "Inventory",
    "XinYongHuTeJiaXianHuo": "Special offer in stock",
    "YiJieSuan": "Checkout",
    "XinYongHuYouHuiZhuanXiang": "Coupon Pack",
    "DaiZhiFuQuanKuan": "Pending full payment",
    "DinDanJinE": "Order amount",
    "QuanKuan": "Full Payment",
    "ZhuangTaiShuoMin1": "ESSAONE will arrange delivery for you immediately after you pay in full",
    "ZhuangTaiShuoMin2": "Please pick up your order from our Moscow warehouse within 3 days after successful payment.",
    "ZhuangTaiShuoMin3": "Pickup is complete and the order has been fulfilled",
    "QuanKuanHeJiN": "Total full amount",
    "SouSuoGongChang": "Search Factory",
    "YuJiFaHuoShiJian": "Estimated shipping time",
    "KeHuQuXiaoDengJi": "Customer cancellation record",
    "XinZengDengJi": "Add Record",
    "DengJiShiJian": "Creation time",
    "DingDanDanHao": "Order ID",
    "DengJiDanHao": "Form ID",
    "DanHao": "Form ID",
    "GuanLianDanHao": "Order number",
    "JiXuJieSuan": "Continue",
    "CaiGouJia": "Purchase price",
    "DengJiXinXi": "Registration details",
    "ZhengChangDengJi": "Intact",
    "PoSunDengJi": "Breakage",
    "KeHuQuXiaoDengJiXiangQing": "Customer cancellation details",
    "DingDanChuKuXiangQing": "Order Shipping Details",
    "ShengChengDengJiDan": "Save",
    "YuanDingDanJinE": "Original Order Amount",
    "GaiHuoDongZhiNengXuanGouXKuanZuiDuoGouMaiXXaing": "The campaign can purchase up to {0} items, {1} Carton",
    "QingXianShuRuDingDanHaoChaXun": "Please enter your order ID to search",
    "QingXuanZeQuXiaoYuanYin2": "Please choose a reason",
    "WoMenJiangZaiShouDaoNinDeDing": "3. Orders will not be processed until after you have paid",
    "PiLiangChuHuo": "Bulk delivery",
    "QueRenSuoXuanDingDan": "Confirm the selected {0} orders",
    "YingFuJinEZongJi": "Total",
    "DingDanYuanJia": "Order amount",
    "DengJiZongXiangShuBuNengDaYuDingDanShangPinShu": "The total number of boxes registered cannot be greater than the number of items ordered",
    "XinZengChengGong": "Added successfully",
    "GaiHuoDongYiJieShu": "This activity has ended",
    "ChuKu": "Shipment",
    "KuCunChaXun": "Stock Inquiry",
    "GongSiKuCun": "Goods in stock",
    "KeHuKuCun": "Customer Goods",
    "ShangPinZongJi": "Total amount of goods",
    "ShangPinZongKuCun": "Total stock of goods",
    "ZhengChangKuCun": "Number of normal goods",
    "PoSunKuCun": "Quantity of damaged goods",
    "KeYongKuCun": "Available stock",
    "ShengYuKuCun": "Remaining stock",
    "ZongKuCun": "Total stock of goods",
    "ZhengChangXiangShu": "Number of normal goods",
    "PoSunXiangShu": "Quantity of damaged goods",
    "ShangPinKuanChu": "Number of items",
    "DingDanXiangQing": "Order details",
    "ShangPinXiangShu": "Amount of goods",
    "NEWBORN_ZONE_006": "No search for this order",
    "NEWBORN_ZONE_007": "This order has been registered",
    "YiChengGongTiJiaoDingDanQingJiShiZhiFu": "Order has been successfully submitted, please pay promptly",
    "GongNXiang": "Total {0} Carton",
    "MeiKuanXianGou": "Product purchase restrictions",
    "ChuKuChengGong": "Shippment Successful",
    "NEWBORN_ZONE_001": "The item details are not in the inventory and cannot be registered",
    "NEWBORN_ZONE_002": "The number of cancelled PO order details (normal + broken) cannot be greater than the total number of PO details",
    "NEWBORN_ZONE_003": "The quantity of cancelled PO order details (normal + broken) cannot be greater than the stock lock quantity",
    "NEWBORN_ZONE_004": "The full amount due for an active order is unpaid and cannot be cancelled for registration.",
    "NEWBORN_ZONE_005": "Please fill in the number of cartons to be cancelled",
    "ZhiShaoTianXieYiGeShangPinDengJi": "Fill in at least one commodity registration",
    "HeJiYingShouKuan": "Total receivables",
    "DingDanJinE": "Order amount",
    "DaiShouKuanJinE": "Amount pending collection",
    "ZuiJinCuiKuan": "Recent Record",
    "JiLuCuiKuanShiJian": "Record operation time",
    "YiXuanZhuanXiangShangPin": "Selected items",
    "QingTianXieYaoQuXiaoShangPinDeXiangShu": "Please fill in the number of carton to be cancelled",
    "LaoRenGuiZe": "1. About members: Buyers who have completed the first order at ESSAONE are regarded as members. </p> <p>2. Every member can participate in \"Super Member Day\" every month. </p> <p>3. Each member can purchase a total of 5 boxes of special merchandise at most during the monthly activity period. There is no limit to the style and the number of purchases. </p>   <p>4. Special products are all in stock, and the stock quantity is limited, first-come-first-served. </p> <p>5. Payment must be completed within 3 days after the order is submitted for special offers, and the system will automatically cancel the order if it is overdue. </p> <p>6. Coupons cannot be used for special products. </p>",
    "GouMaiShuLiang": "Purchase quantity",
    "LaXinGuiZe": "<p>1. Only buyers who have registered with ESSAONE but have not placed the first order can enjoy this offer. </p> <p>2. Each new user can only receive one coupon package and order one special offer. </p> <p>3. After each new user chooses to use the coupon, he can no longer order special offers. </p> <p>4. The newcomer coupon package contains 4 coupons, which are given in 2 times: 2 coupons will be obtained after registration is completed; 2 coupons will be obtained after the first order is paid. </p> <p>5. All coupons cannot be used in stacks, and each order is limited to one coupon. When placing an order, the system will use the coupon with the largest discount by default based on the coupons currently available to you; or you have the right to choose other coupons. </p> <p>6. The order is cancelled after the coupon is used. If all the products that enjoy the discount are cancelled, the system will automatically return the corresponding coupon. However, if it is only partially canceled and part of the discount is enjoyed, the coupon will not be refunded. </p> <p>7. New users enjoy the privilege of 10% prepayment of deposit for the first order, but it is only valid for the first order (except for special merchandise orders). </p>",
    "XinRenGuiZe": "<p>1. Only buyers who have registered with ESSAONE but have not placed the first order can enjoy this offer. </p> <p>2. Each new user can only receive one coupon package and order one special offer. </p> <p>3. After each new user chooses to use the coupon, he can no longer order special offers. </p> <p>4. A new user can order up to 3 special offers at the same time at a time, each of which is limited to 1 carton. </p> <p>5. Special products are all spot goods, the stock quantity is limited, first come first served. </p> <p>6. Payment must be completed within 3 days after the order is submitted for the special offer, and the system will automatically cancel the order if it is overdue. </p> <p>7. After a new user submits an order, it means that he has enjoyed one order, regardless of whether the order is finally cancelled. </p> <p>8. Coupons cannot be used for special products. </p>",
    "JiaGeShengXu": "Ascending price",
    "JiaGeJiangXu": "Descending price",
    "HuoQiShengXu": "Descending delivery date",
    "HuoQiJiangXu": "Descending delivery date",
    "NEWBORN_ZONE_008": "There are exceptions in processing, please contact the administrator",
    "CanShengTuiKuan": "Generate refunds",
    "CangKuGuanLi": "Warehouse Management",
    "ChuKuDan": "Shipments",
    "ChuKuWuLiuXinXi": "Shipment",
    "CuiWeiKuan": "Reminder of the final payment",
    "QuXiaoDengJi": "Cancel register",
    "ZhuanGuanShiJian": "Transit time",
    "TiJiaoHouNinDeDingDanJiaGeJiangShouDaoJiaGeBaoHuYu2": "2. After submitting the order, please pay the full amount of the order within 3 days, otherwise the system will automatically cancel the order after the deadline.",
    "RenQiShengXu": "Rarely chosen",
    "RenQiJiangXu": "Popular",
    "GouWuCheWuShangPinKeXiaDan": "No products in the shopping cart, can not place an order",
    "YiTuiKuanBingGengXinDingDanJine": "The order generated a refund and updated the amount",
    "GongXiHuoDe": "Congratulations",
    "PinPaiZhuanShuYouHuiQuan": "Exclusive brand coupons",
    "LingYongChengGong": "Obtained",
    "LingYongShiBai": "Failed to apply, please try again",
    "LingYong": "Receive",
    "YiLingYong": "Received",
    "YiLingWan": "Finished",
    "YiZiDongShiYongZuiYouYouHuiQuan": "The best coupon has been used automatically, and the discount amount will be deducted when the final payment is settled.",
    "ChaKanQuanBuYouHuiQuan": "View all coupons",
    "DingDanHeJi": "Total orders",
    "YouHuiQuanGuiZeShuoMing": "Coupon rules",
    "HuoKuanHeJi": "Total payment",
    "XinYongHuZhuCeLuoDiYeShuoMing1": "New users register to get 6 coupons (total value of 1500 USD)",
    "XinYongHuZhuCeLuoDiYeShuoMing2": "Purchase goods to place an order",
    "XinYongHuZhuCeLuoDiYeShuoMing3": "You can use the coupon when you meet the conditions for using the coupon, and the discount amount will be automatically calculated at the end of the order",
    "XinYongHuZhuCeLuoDiYeShuoMing4": "Only one coupon can be used for one order",
    "HaiChaJiKeShiYongYouHuiJuanJian": "You still have {0} to use the coupon minus {1}",
    "ShangPinJinE": "Total products",
    "KeYouHui": "Expected discount",
    "ZhiDingKeYong": "Designated container type can be used",
    "DangQianDingDanYiShiYongManXiangZheYuJiKeYouHui": "{0} has been used for the current order, {2} off for orders over {1}, discounts are expected to be {3}",
    "DangQianDingDanYiShiYongManJianYuJiKeYouHui": "{0} has been used in the current order, {1} minus {2}, is expected to be discounted {3}",
    "HaiChaJiKeShiYongYouHuiJuanXiangZhe": "There are {0} you can use coupons to enjoy {1} off",
    "XinShouZhiYin1": "ESSA Information Privacy and Important Protection Statement",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong1": "Coupon instructions",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong2": "1. ESSA platform sometimes launches coupon activities , which can only be used on the platform.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong3": "2. There are currently three types of coupons: discount coupons, full discount coupons, and cash coupons.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong4": "3. How to get coupons: coupons are automatically distributed by platform, return after the order, participate in activities to receive the form of access.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong5": "4. One coupon per one order, and each coupon can be used only once. In case of special circumstances, please refer to the instructions for using the current coupon campaign for details.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong6": "5. The order is cancelled after the coupon is used. If all the products that enjoy the discount are cancelled, the system will automatically return the corresponding coupon.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong7": "6. Coupons cannot be redeemed, sold, transferred or otherwise used.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong8": "Specific usage rules of various coupons",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong9": "1. Universal Coupon: these coupons are universal for all products on the platform, regardless of user, category or region restrictions, the total amount of products purchased in the order must reach the coupon limit to be used.You can only use one coupon per one order, the amount will be deducted according to the order amount. Each order is limited to one All Universal Coupon, which will be deducted from the order cost.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong10": "2. Category coupon: The coupon is restricted by category and can only be used to purchase products in specific categories. Each order is limited to 1 category coupon.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong11": "For example, a 5% off coupon for toys can only be used if the order contains products from the toys category and the total amount of products in the category reaches the coupon limit.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong12": "3. Activity product coupon: The coupon is restricted by the product and can only be used to purchase specific products. Each order is limited to 1 product coupon.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong13": "For example: $1,000 off a case of Fast Shipping items, the order must include a case of Fast Shipping items and the total amount of the items must reach the coupon limit before the coupon can be used.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong14": "4. New Customer Coupon: This coupon is only available to new customers. New customers are registered customers who have never placed an order with ESSAONE. The coupon can only be used if the new customer is qualified and the order placed meets the requirements for using the coupon.",
    "DingDanShangPinYinNiDeTiaoZheng": "Due to your adjustment (cancel / transfer to other POs / transferred to leftover stock page, etc.), which could not meet the use conditions of coupons. Please replenish products or transfer in products from other POs to meet the usage conditions of coupons.",
    "YouHuiQu": "Coupon",
    "WeiManZuTiaoJian": "The usage conditions of coupons are not met",
    "sili1": "广东**贸易有限公司成立于1989年，是一家专注于**产品外贸的企业，公司设立于**地区，实力雄厚，积累了众多优质海外客户，长期耕耘**地区市场，拥有**个专业外语员工，获得客户多次优秀评价。",
    "sili2": "本公司已经营3年，积累众多优质客户，订单多。2021年度，向奥**钻玩具工厂下了一个大单，10款商品，金额超过10万元； 同时与某某工厂、某某工厂进行深度合作。",
    "ReMaiDanPin": "Hot hits",
    "YiLingQuChengGongQingWuChongFuLingQu": "The voucher has been received. Please, do not repeat the action.",
    "ZhiDingNGePinPaiKeYong": "Only available for {0} brands",
    "DangQianDingDanYiShiYongManXiangZheYuJiKeYouHui_NEW": "This order has used coupon, {1} discount off with order amount above {0}, estimated discount amount {2}",
    "DangQianDingDanYiShiYongManJianYuJiKeYouHui_NEW": "This order has used coupon, {1} minus off with order amount above {0}, estimated discount amount {2}",
    "ZaiMaiKeYouHuiJinE": "Purchase further {0} then could get discount amount {1}",
    "HaiChaTiJiJiKeShiYongYouHuiJuanJian": "Purchase further {0} CBM then could use coupon to get discount amount {1}",
    "HaiChaTiJiJiKeShiYongYouHuiJuanXiangZhe": "Purchase further {0} CBM then could use coupon to get {1} discount off",
    "HeTongZhuangTai": "Contract status:",
    "ChaKanHeTong": "View the contract:",
    "JieShuHeTong": "End the contract:",
    "HeTongBianJi": "Contract editor:",
    "QianDingRiQi": "Signing date:",
    "HeTongWenJian": "Contract scan documents:",
    "DianJiHuoJiangWenJianTuoZhuaiDaoZheLiShangChuan": "Click or drag the file here to upload:",
    "ZhiChiKuoZhanMing": "Support extension:",
    "ShuRuSouSuo": "Enter search:",
    "FuKuanPingZheng": "Voucher of payment:",
    "WeiFuKuanPingZheng": "Unpaid payment voucher",
    "YiFuKuanPingZheng": "Payment vouchers paid:",
    "PingZhengLeiXing": "Vouchers Type:",
    "YingFuZongJinE": "Total amount payable:",
    "FuKuanPingZhengShengChengShiJian": "Payment vouchers creation time:",
    "ChaKanFuKuanPingZheng": "View payment vouchers",
    "ShouKuanShouJu": "Payment vouchers",
    "ZanWuWenJian": "No files yet:",
    "QingShuRuPODanHaoHuoZheJiGuiDanHao": "Please enter the order number or container number.",
    "XinZengHeTong": "New contract:",
    "HeTongQiXian": "Contract period:",
    "HeTongJieShuRiZi": "Contract end date:",
    "HeTongBianMa": "Contract No.",
    "HeTongYiCunZai": "Contract already exists.",
    "HeTongGuanLi": "Contract Management",
    "WangZhanDiTu": "Site Map",
    "XinWenZhongXin": "Helpful Information",
    "WeiWanShanWuFaJiaGou": "未完善无法加购",
    "ZheGeGongChangHenJiuMeiShang": "这个工厂很久没上新品了。",
    "Jin3TianYongHuHangWei": "Customer behaviour in the last 3 days",
    "Jin3TianDengLuTianShu": "Number of days logged in the last 3 days",
    "Jin3TianLiuLanXiangQingShangPinKuanShu": "Number of products viewed in detail in the last 3 days",
    "Jin3TianJiaGouKuanShu": "Number of add-ons in the last 3 days",
    "QuanBuXinWen": "All News",
    "ShangYiPian": "Previous",
    "XiaYiPian": "Next",
    "30TianMianFeiCangChu": "30 Days Free Storage",
    "YiChangHaoShiPaiXu": "Sort by waiting time",
    "YiChangShangPinShu": "The number of abnormal items",
    "ChaKanYiChang": "View the details of the abnormal",
    "YiChangShiJian": "Exception Time",
    "YiChangHaoShi": "Waiting time",
    "QianZaiKeHuDengJiDanChuangBiaoTi": "Sign in now and get $1500 USD coupon",
    "BaoGuanTieZhiGuanLi": "Order sticker processing",
    "QinQuanQueRen": "Infringement confirmation",
    "QinQuanShenHe": "Infringement review",
    "TianXieHaiGuanBianMa": "Fill in the customs code",
    "ZhengShuShenHe": "Certificate review",
    "SheZhiTieZhiPinPai": "Set the product name on the sticker",
    "WuZhengShuGuanLi": "Certificateless management",
    "DingDanTiJiaoShiZhang": "Waiting time for orders",
    "ShangPinShu": "Number of items",
    "HaiGuanBianMa": "Customs code",
    "ShangChuan2": "Upload",
    "BaoGuanPinMingJinDuGenZong": "Progress tracking for stickers",
    "DingDanShiJian": "Order time",
    "YouZhengShu": "With certificate",
    "WuZhengShu": "No certificate",
    "certificateEncoding": "Certificate code",
    "ZuiJinShenHeShiJian": "Last review time",
    "ShangYiJiShenHeRen": "Previous reviewer",
    "ShenHeShiJian": "Review time",
    "TieZhiMoBan": "Sticker type",
    "PinMing": "Name",
    "TieZhiPinMing": "Product name on sticker",
    "QingTianXieWuZhengShuShuoMing": "Please fill in the description",
    "XuanZeTieZhiMoBan": "Choose sticker type",
    "ChaKanYingWenPinMing": "View English product name",
    "ChaKanEWenPinMing": "View product name in Russian",
    "WuZhengShuShangPin": "Uncertified items",
    "ShenHeRen": "Reviewer",
    "ShangPinJiangYuHouGuXiaoCaiGou": "The item will be cancelled after <b>{0}</b>.",
    "DangQianJieDian": "Status",
    "DangQianChuLiRen": "Current handler",
    "LiKaiDangQianYeHouSuoBianJiDeShuJuJiangBuKeHuiFu": "Data edited after leaving this page will not be recovered.",
    "DaiChuLi": "To be processed",
    "ZhengChang": "Normal",
    "QinQuan": "Infringement",
    "ShangYiGe": "Previous",
    "XiaYiGe": "Next",
    "BuQinQuan": "Not infringing",
    "QueRenXiaYiGe": "Confirmed infringement",
    "XiaYiDan": "Next order",
    "GaiDingDanQuanBuShangPinYiChuLi": "All items in this order have been processed.",
    "QingTianXieWeiShuDeHaiGuanBianMa": "Please fill in the {0}-digit customs code.",
    "NaShuiRenDengJiDaiMa": "Geerbox",
    "YinHangDaiMa": "Bank Code",
    "ZuiJinChuLiShiJian": "Latest processing time",
    "LiKaiDangQianYeHou，SuoBianJiDeShuJuJiangBuKeHuiFu": "After leaving the current page, the edited data will not be recovered",
    "QinQuanShangPinShu": "Number of copyright violation goods",
    "QingQueRenShiFouDuiXuanZeDeShangPinQuXiaoCaiGou": "Please confirm whether to cancel the purchase for the selected product",
    "QingXuanZeShangPinHouZaiDaoChu": "Please select the product and then export",
    "DangQianWuKeXiaZaiShangPin": "Unable to download of goods without certificate",
    "ShangPinPiPeiShiBai": "Product match failed, please check the changes and re-upload",
    "ShangChuanChuLiJieGuo": "Upload processing results",
    "WenJianGeShiBuZhengQue": "The file format is not correct and cannot be uploaded",
    "QingXuanZeShangPinHouZaiXiaZai": "Please select the product before downloading",
    "QingTianXieZhengShuBianMa": "Please fill in the certificate code",
    "WeiShu": "Number",
    "QueRenJieGuo": "Verification result",
    "SuoShuLeiMu": "Product category",
    "QinQuanQueRen2": "Infringement confirmation",
    "TuCaoYiXia": "吐槽一下",
    "ShangShiShiJian": "Launch date",
    "ChuHuoDanGuanLi": "Delivery order management",
    "YuJiChuHuoDingDan": "Expected shipping orders",
    "YiChuHuoDingDan": "Shipped orders",
    "ZongTiJiM3": "Total volume m³",
    "XiaZaiLiuMianTu": "Download 6-sided packaging pictures",
    "ChaKanTieZhiPaiBanTu": "View sticker layout pictures",
    "XiaZaiZhiJianTuPian": "Download quality control pictures",
    "BaoZhuangLiuMianTu": "6-sided packaging pictures",
    "ZhuangGuiFaYunShiJian": "Loading and shipping time",
    "ChaKanZhuangGuiTuPian": "View pictures of the loaded container",
    "YiChuHuoDingDanYouDaiQueRenDeSuiCheDan": "Shipped orders pending confirmation of the container invoice, please download the container invoice as soon as possible to confirm",
    "ChuangJianYu": "Created",
    "QueRenSuiCheDan": "Confirm the container invoice",
    "ZhongXinShangChuan": "Re-upload",
    "YuZhuangXiangDan": "Pre-packing list",
    "XuanZeBaoBiaoMoBan": "Select a report template",
    "DingDanGuanLi": "Order management",
    "KeHuGuanLi": "Customer management",
    "ZanWeiShangChuan": "Not uploaded yet",
    "ChuHuoHouQuXiao": "Cancelled after shipment",
    "Jin7TianYouBianHuaDingDan": "Changed orders in the last 7 days",
    "YiChuHuoDingDanYiQueRenSuiCheDan": "The container invoice confirmed",
    "ChuHuoHouQuXiaoShangPin": "Cancelled items after shipment",
    "DDPStatus101": "The balance has been paid",
    "DDPStatus102": "In storage, pending final payment",
    "SuiCheDanQRueRenHouJiangWuFaZaiCiSiuGai": "After confirmation, the confirmed container invoice can't be modified again, in accordance with which the customs declaration will be made.",
    "KeHuGouWuChe": "Client shopping cart",
    "KeHuDingDan": "Customer orders",
    "ZongGongNKuanNXiang": "Total of {0} items, {1} cartons",
    "DaiTiHuo": "Pending pickup",
    "YuJiChuHuoDingDanXiangQing": "Expected shipping order details",
    "CLAIM_DAMAGE_012": "The customs transit operation needs to be completed for the order first before it can be registered in the warehouse",
    "ShangPinBianMa2": "Product Code",
    "Jin3TianYouBianHuaDingDan": "Changed orders in the last 3 days",
    "PODingDan": "PO number",
    "WanChengShiJian": "Completion time",
    "YuJiChuHuoShiJian": "Estimated time of loading",
    "DaiQueRenSuiCheDan": "The container invoice to be confirmed",
    "YiChuHuoDingDanXiangQing": "Shipping order details",
    "QingShuRuJiGuiDanHaoHuoKeHuBianHao": "Please enter the container serial NO. or customer NO.",
    "ShangPinShengChanYaoQiu": "Commodity production requirements",
    "DingDanTieZhiXinXi": "Sticker information for the order",
    "TieZhiPaiBan": "Sticker printing typography",
    "GongZhangTieZhiPaiBanTu": "Total: {0} sticker typography pictures.",
    "XiaZaiPaiBanTu": "Download typography images",
    "PaiBanYouWenTi": "Typography is wrong",
    "QueRenWuWu": "Confirmed",
    "MiaoShuNiDeWenTi": "Describe your issue",
    "QuanBuYiJianCha": "All have been checked, are you sure?",
    "ShangPinDanDuTieZhi": "Additional stickers are added to the product, and the fee is subject to additional charges.",
    "MaTouYaoQiu": "Carton Mark Requirements",
    "MiaoShuPaiBanCunZaiWenTi": "Describe problems with typographic images",
    "ZanBuSheZhi": "Setup later, skip",
    "QueRenBianGeng": "Confirm changes",
    "BeiZhuDingDanGeXingHuaYaoQiu": "Remarks to order personalization requirements",
    "GongChangJiangAnZhaoNinDeYaoQiuGenJinShengChan": "For example: battery specifications, packaging requirements and other matters needing attention in the production process of goods, the factory will follow up production according to your requirements",
    "TeBieYaoQiu": "Special requirements for order follow-up, quality inspection, and container loading",
    "ShangPinQingDan": "Product list",
    "QingZaiTianNeiZhiFuDingJin": "Please pay the deposit within {0} days and confirm the order",
    "ShangChuanWenJianYaoQiu": "Support {0}, max {1}",
    "PaiBanYouWenTiYiFanKui": "Typesetting image errors: already reported",
    "CHANGE_SALE_PO_ITEM_PRODUCT_REQUIRE_ERROR": "Orders are in production, please contact your account manager if you need to make changes.",
    "GongNZhangTieZhiPaiBanTu": "Total {0} sticker layouts",
    "ShanɡPinShenɡChanYaoQiu": "Commodity production requirements",
    "HuoQuZiXun": "Get advice",
    "LiuXiaNiDeLianXiFangShi": "Leave your contact details and we will get in touch with you and send you the best selling products on the market",
    "YiXiangCaiGouXiangShu": "Quantities of cartons want to be ordered",
    "QiWangJiaGe": "Expected price",
    "BiGongChangBaoJiaJiangJia": "{0} less than factory offer",
    "ChaKanDianHua": "View phone number",
    "ZhongXinHuoQu": "Reacquire",
    "JinTianQianBoDaYouXiao": "今天{0}前拨打有效",
    "YiChaoShiShiXiao": "Timeout expired",
    "Zhuan": "转",
    "YinSiHao": "隐私号",
    "ZhuCeESSAONEBiaoTi": "Registration",
    "DuanXinYanZhengMa": "SMS verification code",
    "QingShuRuDuanXinYanZhengMa": "Please enter the SMS verification code",
    "TianXieGengDuo": "more",
    "GongSiXinXiZhiYongYuYanZheng": "Company information is only used for verification, we will protect your private information",
    "LianXiZaiXianKeFu": "Live chat",
    "QingShuRuDianZiYouJian": "Please enter email",
    "QingXuanZeQuYu": "Please select region",
    "DiYuGongChangZuiXiaoCaiGouShuLiang": "Below the factory minimum purchase quantity, the factory may reject the transaction.",
    "DiYuMOQ": "Less than minimum purchase volume",
    "ZhengZaiXiangGongChangQueRenShengChanYaoQiu": "Production requirements are being confirmed to the factory, and orders can be placed after factory confirmation",
    "NiDeZhangHuShangWeiRenZheng": "You have not yet filled in your company information, so you cannot place an order.",
    "MaShangQuWanShan": "Supplementary Information",
    "XuYaoBangZhuMa": "Need help?",
    "RuGuoNiYouRenHeWenTiXuYaoBanZhu": "If you have any questions and need help, leave your cell phone number and we will take the initiative to contact you and answer your questions.",
    "ZhaoBuDaoShangPin": "Can't find the product?",
    "LiuXiaNiDeDianHua": "Leave your phone number and customer service will contact to help you solve your problem or contact us 8-800-550-3301",
    "YiTuSouSuo": "Search by image",
    "ChaKanGongChang": "View Factory",
    "GaiShangPinYouShengChanJiaoFu": "This item is produced and delivered by {0}",
    "2ZhouNianHuoDongGuiZe": "1. Time of the event: from May 11, 2022 to June 11, 2022. <br /> 2. All registered users on ESSAONE (new and existing users) are eligible to participate in this promotion. <br /> 3. Each user can use the 3.3% discount only once during the promotion period, i.e. Discount can only be applied to 1 order. Discount cannot be applied to promotional items and cannot be combined with other promotions or coupons. <br /> 4.If during the promotion period the accumulated amount paid for the order reaches the required amount, on June 12, we will offer an additional coupon for the highest discount to those who qualify. <br /> 1）Accumulation of the actual payment amount. <br /> If the sum of all your orders during the promotion period was: <br /> • more than 100,000 RUB, you get a coupon with a face value of 2,000 RUB. <br /> • more than 500,000 RUB, you get a coupon with a face value of 6,000 RUB. <br /> • more than 1,000,000 RUB, you get a coupon with a face value of 10,000 RUB. <br /> 2）One user can only get one coupon. Coupons are valid for purchases over 20,000 RUB. <br /> 3）Coupon will be valid from June 12 to July 12, 2022 and will expire after this period. <br /> 4. Received coupons can be viewed in your account, in the \"My Coupons\" section. <br /> 6.For any questions related to the promotion, you can contact the online customer service. The right to interpret the event belongs to ESSAONE.",
    "DingDanXiangGuanYaoQiu": "Relevant Order Requirement",
    "NiKeYiChangShiJiaRuGouWuCheDingGouYiXiang": "You can try adding to your cart to order 1 case.",
    "MiMaTiShi": "Password requirements",
    "ZiMuYuShuZiZhuHe": "Letter and number combinations, not all numbers",
    "ZiShaoNGeZiFu": "At least {0} characters",
    "YanZhengYouJianYiFaSongDaoYouXiang2": "Verification email has been sent to email {0}",
    "DianJiJiangTongBu": "Clicking on the [Inquiry] button will simultaneously notify the trading company that you want to buy this product and the intended quantity.",
    "WoYaoXunJia": "Inquiry",
    "QuanBuXunJia": "All Products Inquiry",
    "DaoChuTuPian": "Download product images",
    "ShangPinShuLiang": "Number of items",
    "TuiJianZhuTiMingCheng": "Search by Topic Name",
    "QingShuRuFangWenMiMa": "Please enter the access code",
    "FanHuiLiShiLieBiao": "Back to List",
    "XiaoShou": "Sales Consultant",
    "TongZhiChengGong": "Notify success",
    "YiGaoZhiMaoYiGongSi": "The sales consultant has been informed of the item and the quantity to be purchased",
    "WoDeTuiGuang": "Promoted Customers",
    "TuiGuangYaoQingJiaoCheng": "Tutorial",
    "ZhangHuZiLiaoWeiWanShan": "The account information is not complete and the client cannot be invited.",
    "LiJiQuWanShanZhuanQuTiCheng": "Complete the profile immediately and invite customers to earn commission",
    "TuiGuangKeHuNaTiCheng": "推广客户拿提成",
    "TuiGuangKeHuNaTiChengJieShaoNeiRong": "推广客户拿提成介绍内容",
    "FaSongNiDeZhuanShuLianJieGeiKeHu": "Send your exclusive link to customers",
    "ShouJiDuanFenXiang": "Share on mobile",
    "KeHuZhuCeShiTianXieNiDeYaoQingMa": "Fill in your invitation code when customers register",
    "FaZhanFenXiaoShangNaTiCheng": "Development Distributors Get Commissions",
    "FaZhanFenXiaoShangNaTiChengJieShaoNeiRong": "发展分销商拿提成介绍内容",
    "ChaKanFenXiaoShang": "View Distributors",
    "XinZengFenXiaoShang": "Add Distributor",
    "QingXianWanShanZiLiaoQuBuChong": "Please complete the information first and then add >>",
    "MoRenNiDeShouJiHaoMa": "Default your mobile number",
    "BenZhouYuJiShouRu": "Estimated income for the week",
    "YaoQingKeHuShouRu": "Commission for inviting clients",
    "XiaJiFenXiaoShangYaoQingKeHuHuoDeShouRu": "Income earned by sub-distributors inviting customers",
    "DaiJieSuan": "Pending settlement",
    "LeiJiYiJieSuan": "Cumulative settled",
    "BianJiZhangHaoXinXi": "Edit account information",
    "ShiYongShouJiSaoMiao": "Scan with your phone and share your registration link on your phone",
    "ChaKanJiaoCheng": "View tutorial",
    "FaSongYaoQingLianJieYaoQingKeHuZhuCe": "Send an invitation link to invite customers to register. After the system authenticates the customer's registered account, you can get a commission. Distributors can also be developed, and rewards can also be obtained.",
    "MeiZhouSanQianShenQingDeTiXianShenQing": "For withdrawal applications applied before Wednesday, ESSA will complete the remittance before next Wednesday. In case of holidays, there may be delays, if you have any questions, please consult customer service staff.",
    "YaoQingHaoYouXinXiI": "您邀请的新客户只有通过您提供的注册链接或在注册时填写了您的手机邀请码，他才会跟您的账号进行绑定，这样您才有机会获得新客户成功注册的提成",
    "YaoQingHaoYouXinXiK": "The commission you finally get is subject to the successful registration and certification of the new customer.",
    "TongGuoYaoQingYouXiaoZhuCeYongHuHuoDeTiCheng": "Get commissions by inviting valid registered users",
    "TongGuoYaoQingYouXiaoZhuCeYongHuHuoDeTiChengJieShaoNeiRong": "通过邀请有效注册用户获得提成介绍内容",
    "TongGuoFaZhanFenXiaoShangHuoDeTiCheng": "Get commissions from developing distributors",
    "TongGuoFaZhanFenXiaoShangHuoDeTiChengJieShaoNeiRong": "Get commission through the development of distributors Introductory content",
    "JieSuanZhong": "Settlement",
    "YiTiJiaoTiXianShenQingZhengDengDaiPingTaoHuiKuan": "The withdrawal application has been submitted and is waiting for the platform to remit",
    "YaoQingDeKeHu": "Invited customers",
    "KeHuZhangTai": "Customer status",
    "LeiJiYaoQingRenYiRenZhengTongGuoRenHuoDeTiCheng": "Accumulatively invited {0} people, and passed the certification of {1} people, and got commission {2}",
    "XiaJiFenXiaoShang": "Sub-distributor",
    "CaiGouShangRenZhengZhuangTai": "Buyer Certification Status",
    "QingXuanZeCaiGouShangRenZhengZhuangTai": "Please select buyer certification status",
    "YaoQingKeHuShu": "Number of invited clients",
    "LeiJiJiangLi": "Accumulated rewards",
    "Nan": "Male",
    "Nu": "Female",
    "ShiLi": "Example",
    "QingShuRuDengLuMingZi": "Please enter your login name",
    "ShouRuMingXi": "Income Details",
    "TiXianMingXi": "Withdrawal Details",
    "TiXianXianJin": "Cash out",
    "YinHangKaXinXi2": "Bank card information",
    "YinHangKaXinXiShuoMing": "Bank card information description",
    "XiuGaiDengLuMiMa": "Change login password",
    "QueRenTiXian": "Confirm cash withdrawal",
    "RuGuoYouWuQingJiShiGengXin": "Please update if there is an error",
    "QuXiuGai": "Go to revision",
    "QuBuChong": "Go to supplement",
    "HaiMeiYouZhangHuXingXi": "No account information yet",
    "ShouJiDengLuMing": "Mobile Phone (Login name)",
    "ChuShiMiMa": "初始密码",
    "QingXuanZeGuoJia2": "Please select a country",
    "JiuMiMa": "Old Password",
    "LiuKongBuXiuGaiMiMa": "Leave blank without changing password",
    "FuZhiZhangHaoMiMa": "Copy account and password",
    "FenXiangZhangHao": "Share account",
    "ZanWuQuanXianXinZengFenXiaoShang": "No permission to add distributors",
    "ChengGongYaoQingYiGeKeHuHou": "After successfully inviting a customer, you can get the permission to add a distributor.",
    "XinMiMaBuYiZhi": "New password is inconsistent.",
    "FenXiaoShangGuanLi": "Distributor Management",
    "FenXiaoShangJieSuan": "Distributor Settlement",
    "TiXianShenQingChengGongQingDengDaiPingTaiJieSuen": "Cash withdrawal application is successful, please wait for platform settlement.",
    "ZuiDaZhiChiShangChuanWenJianYaoQiu": "Maximum support for {0}, support for {1} format",
    "TuiGuangKeHuShu": "Number of invited customers",
    "LeiJiYongJin": "Commission Accumulation",
    "TuiJianRen": "Referrer",
    "LeiXingZhuangTai": "Type & Status",
    "TuiGuangXiangQing": "Promotional details",
    "XiaoShouQuYu": "Sales region",
    "FenXiaoLeiXing": "Distribution type",
    "ZhangHuZhuangTai": "Account status",
    "YiJieSuan2": "Settled",
    "FenXiaoShangZhangHao": "Distributor account",
    "DaiJieSuanJinE": "Amount to be settled",
    "HeXiao": "Write-offs",
    "ShenQingShiJian": "Application time",
    "SouSuoLiuShuiHaoFenXiaoShangZhangHaoXinMing": "Search by line number/distributor account/name",
    "TuiHuiShiJian": "Return time",
    "YiJieSuanJinE": "Amount settled",
    "JieSuanShiJian": "Settlement time",
    "TuiHui": "Return",
    "QueRenHeXiaoGaiBiDaiJieSuanMa": "Confirm the write-off of the pending settlement?",
    "TuiHuiJieSuanShenQing": "Return of settlement request",
    "QingGouXuanTuiHuiJieSuanShenQingYuanYin": "Please check the reason for requesting a refund of the settlement amount",
    "JiuFenXiaoShangTongJi": "旧分销商统计",
    "FenXiaoShangTuiGuangXiangQing": "Distributor promotion details",
    "FenXiaoShangChengGongYaoQingKeHuLeiJiJiangLiTiShi": "Your accumulated commission after a distributor successfully invites a customer.",
    "ShengChengFenXiaoShang": "Create a distributor",
    "ShengChengChengGong": "Create successfully",
    "FenXiaoShangChengGongYaoQingKeHuLeiJiJiangLiTiShi2": "His accumulated commission after a distributor successfully invites a customer.",
    "BianJiZiLiao": "Edit profile",
    "XiaJiTuiGuangKeHu": "Subordinate invited customers",
    "AnChangJianShiJianDaoXu": "Reverse order by creation time",
    "AnTuiGuangKeHuShuDaoXu": "Reverse order by number of customers",
    "AnTuiGuangKeHuShuShunXu": "Order by number of customers",
    "AnXiaJiFenXiaoShangDaoXu": "Reverse order by number of customers of lower level distributors",
    "AnLeiJiYongJinDaoXu": "Reverse order by cumulative commission",
    "AnLeiJiYongJinShunXu": "In order of accumulated commissions",
    "YaoQingKeHu": "Invite customers",
    "YouXiaoKeHu": "Effective customers",
    "DengTongShouJiHaoMa": "Equivalent to phone number",
    "QingShangChuanFenXiaoShangDeZhengJianZhaoPian": "Please upload the distributor's ID photo",
    "FenXiaoShangDeYinHangZhangHuXinXiTiShi": "分销商的银行账户信息，用于后续的返利，务必请分销商提供正确的账户信息。",
    "MiMaGuiZe": "请输入6-20位字符，由数字、字母和符号两者以上组合",
    "ShiFouYaoTingYongGaiFenXiaoShangMa": "是否要停用该分销商吗",
    "YiTuiHuiJinE": "已退回金额",
    "XiaJiYongHuDingDanHaiMeiChuHuo": "Subordinate user %s Order not yet shipped",
    "FenXiaoShangHaiYouDaiJieSuanJieSuanZhongDeJinE": "分销商还有待结算/结算中的金额",
    "TuiHuiYuanYin": "Reason for return",
    "FenXiaoShangXiangQing": "Distributors' details",
    "ZiJinZhangHaoYiChang": "Fund Account Exception",
    "TiXianQingQiuYiChang": "Withdrawal request exception",
    "QingShuRuZhengQueDeXiuGaiQianMiMa": "Please enter the correct password before modification",
    "FenXiaoShangYouDaiJieSuanJinE": "Distributor pending settlement or amount in settlement, not allowed to deactivate",
    "BianJiFenXiaoShang": "Editorial Distributors",
    "FenXiaoShangMingChengZhangHao": "Distributor name/account",
    "MiMaGuiZe2": "Please enter 6-20 characters",
    "QieHuan": "Toggle to",
    "TuiJianJiLu": "Recommended Records",
    "TuiJianXiangQing": "Recommend details",
    "YaoQingHaoYouXinXiJ": "The final commission you receive is based on the successful registration and certification of new customers.",
    "QingDengDaiWenJianZhengZaiDaBaoZhong": "Please wait, the files are being packed",
    "JianChaZhiJianTuPian": "Checking quality control pictures",
    "ZhiJianTuPianQueRen": "Quality control picture confirmation",
    "BiaoJiCiShangPin": "Mark this product",
    "QuanBuZhuangTai2": "All status",
    "ZhiJianYouWenTi": "Quality control problem",
    "ZhiJianMeiWenTi": "Quality control passed",
    "ZhiJianDaiChuLi": "Quality control pending",
    "JinRuXiaYiKuan": "Go to next item",
    "YiBiaoJi": "Flagged",
    "YouWenTi": "Problem",
    "QuXiaoBiaoJi": "Unmarked",
    "ChuHuoShiJianiYouGaiBian": "Shipping time has changed",
    "ShangYiCi": "Last time",
    "ShangYiZhang": "Previous",
    "XiaYiZhang": "Next",
    "NinLiuLanDeYeMianYiGuoQi": "The page you are viewing has expired. Jumping to the home page, Discover more great toys！",
    "WanJuCaiGouXuanZe": "Toys purchasing selection",
    "NiLaiDuiDiFangLe": "You've come to the right place",
    "ZhuanYePingTai": "Professional platform",
    "WanJuGengQingSong": "Make toys procurement more hassle-free",
    "XuanZeGengRongYi": "Make product selection faster and easier",
    "ChanPinZhiNengChaZhao": "Intelligent products finding function",
    "YiZhanShiJieJue": "one-stop solution to the selection problem",
    "ZhuZhaZhongGuoGongChang": "More than 20,000 Chinese source factories are stationed",
    "WanZhengDeChanPinKu": "The latest and most complete toy category product library",
    "ZhuanYeMaiJiaTuiJian": "Professional buyers to recommend",
    "ShiHeNiMenDeChanPin": "The most suitable products for your market",
    "JiaGeTouMing": "Price transparency",
    "QuanPingTaiJiaGeWei": "All product prices on the platform are",
    "GongChangDuLiBaoJia": "factory independent quotes",
    "CaiGouDeFuWuChengBen": "Transparent procurement service costs",
    "GengHaoDeKongZhiChengBen": "allowing you to better control your procurement costs",
    "GengQingSongDeGouMaiTiYan": "A more hassle-free purchasing experience",
    "YiDuiYiDeZhuanMenFuWu": "1-to-1 professional customer service with over",
    "ZhuLiuFuWuJingLi": "100 mainstream language service managers at your",
    "GenZongDinDanChuLi": "disposal to track your orders throughout the process",
    "GaoJiCaiGouTuanDui": "First-line supply chain senior procurement team",
    "WeiNiTiGongDingZhiHeQiTa": "to provide you with OEM customization and other",
    "GeXingHuaFuWu": "personalized services",
    "WoMenDeBaoZheng": "Our Guarantee",
    "ChanPinZhiLiangBaoZheng": "Product Quality Guarantee",
    "PingTaiQueBaoAnBiaoZhunPeiChang": "Platform ensure factory will take penalty as per compensation standards if any damage or lack of goods.see detailed standards.",
    "HuoWuPeiChangBiaoZhun": "Goods Compensation Standards",
    "JiaoHuoShiJianBaoZheng": "Delivery Time Guarantee",
    "BaoZhengTiaoJian": "If could not delivery on time,start calculate compensation after 7 days delay,then penallty on 0.1% of delayed order amount every 1 more day delay.Apart from the delay cases on customer’s reason( such as booking delay,customer  require not ship on time,payment not arriverd on time,etc) and other force majeure caused delay.",
    "FuKuanBaoZhengJin": "Payment Security Guarantee",
    "QueBaoHuoKuanAnQuan": "We only place order and pay to reliable and qualified factory, ensure your payment security.",
    "RuHeGongZuo": "How ESSA Work",
    "YouXvQiuHuoJiaRu": "Have a purchasing need? Or just want to see the new toys in the industry? Come to ESSA！",
    "ChaKanTuiJianShangPin": "You can view the new products selected for you at ESSA, or you can tell ESSA about your purchasing needs.",
    "ZhaoDaoHeShiDeShangPin": "ESSA will recommend the most suitable set of products for you based on market data.",
    "XuanZeZhiJieCaiGou": "If you would like to purchase directly through ESSA, you can enter into a trading contract with us.",
    "QueRenDinDanLiJiShengChan": "Once the purchase order is confirmed, the factory will arrange production for you immediately.",
    "ZhiJieCaiGou": "ESSA will provide you with a rigorous quality check of the platform and complete the transit shipment for you.",
    "RuGuoNiYouWenTi": "If you have any questions, please contact",
    "DinYueChengGong": "Subscription successful",
    "YouXiangYouWu": "您填写的电子邮件地址有误，请填写正确的地址！",
    "WhatsAppLianXiRen": "WhatsApp Contacts",
    "DinYue": "Subscription",
    "HuiYuanZhongXin": "Membership Centre",
    "KaiShiXuanGou": "Start Shopping",
    "WanJuHuiChang": "Hall for toys",
    "ShiLiGongChang": "Фабрика качества",
    "WenJu": "Stationery",
    "TiYuYongPing": "Sporting goods",
    "JieRiYongPing": "Party supplies",
    "RiYongPingHeCanChuJu": "Daily necessities and kitchen utensils",
    "GengDuoXinPin": "View new products",
    "RuMenZheKou": "Introductory Discount",
    "BenRi": "Yesterday",
    "BenZhou": "This Week",
    "BenYue": "This Month",
    "MiaoZiDongShouQi": "{0} seconds. - Put it away automatically.",
    "TongGuoShiBieTuPianShouSuo": "Search for products by identifying pictures, try to keep the main body of the picture clear and the background simple",
    "MeiRiXinPin": "Daily New Arrivals",
    "LiaoJieXiangQing": "Learn more",
    "BaoQingGuanWuLiuMenDaoMen": "Turnkey door-to-door service,",
    "ZongGongKuanXiangShangPinZongJia2": "Total of {0} items, {1} cartons",
    "QingTianXieYouXiaoYouXiang": "Please enter your valid email address, a verification email will be sent later",
    "WoYiYouZhangHao": "Already have an account?",
    "QuDengLu": "Go to login",
    "QingShuRuMiMaJiShuZhi": "Please enter a password of 8 digits or more, including letters and numbers",
    "YaoQingMa": "Coupon Code",
    "ZhengZaiShenHeZhong": "Auditing in progress, ESSA will complete the audit within 24 hours",
    "ShengHeZhong": "In Review",
    "WeiRenZhengZhiNengChaKan": "Without certification you only have 3 days access to view prices and shop for items without initiating a request for quotation from the factory. Certified will give you a more complete experience.",
    "QingTianXieZhenShiShouJi": "Please fill in your real mobile phone number for ESSA to contact you",
    "QingShuRuShouJiHaoMa": "Please enter your  phone number",
    "ZhuyYaoXiaoShouQuYu": "Main sales areas",
    "ZhengGui": "Full Container Load (FCL)",
    "ZhuYaoCaiGouPinLei": "Main purchasing categories",
    "DiYiShiJianTuiJianXinPin": "Be the first to recommend new and hot items",
    "XuanZePinLei": "Choose your purchasing category",
    "QingXuanZeCaiGouPinLei": "Please select a purchase category. Select up to five",
    "NinTianXieDeDianZiYouXiangYouWu": "The email address you filled in is incorrect",
    "YaoQingMaWuXiao": "Current invitation code is invalid, please check your invitation code",
    "QingTongYiTiaoKuan": "Please read and mark your agreement to the above registration terms",
    "QingShuRuLianXiRen": "Please enter your name",
    "QingShuRuNinDeGongSiMing": "Enter your company name",
    "QingXuanZeChuHuoFangShi": "Please select shipping method",
    "QingXuanZeGuoJiaHeQuYu": "Please select sales areas and country",
    "QingShuRuNinDeDianZiYouXiang": "Enter your Email",
    "QingShuRuNinDeMiMa": "Enter your password",
    "ZhangHaoJiHuoChengGong": "Account activation success",
    "QuRenZheng": "Go for accreditation",
    "YouXiangLianJieShiXiao": "The email verification link is no longer available",
    "YouXiangYanZhengChongXinZhuCe": "Email verification link valid for 24 hours, please re-register",
    "QianWangDianZiYouXiang": "Go to your e-mail address",
    "ChaShouYouJian": "Check your emails and activate your account",
    "RuGuoMeiYouShouDaoYouJian": "If you do not receive the email",
    "ZhuCeWanCheng": "Registration complete",
    "FaSongChengGong": "Sent",
    "QingJianChaNinTianXieDeXinXi": "Please check the information you have filled in",
    "ZhuCeHouChaKanGengDuoJieGuo": "Register to view more",
    "MianFeiZhuCeZhangHao": "Create a free account",
    "ZhaoDaoNKuanShangPin": "Found {0} items for you",
    "ZhuCeGongSi1": "Dania Import & Export Ltd.",
    "ZhuCePinLun1": "\"Sourcing platforms vertically focused on the toy category are very rare. ESSA is by far the most professional I've seen. It's hard to go to China nowadays and there's no way to go to the showroom. ESSA has a full range of products and the pictures are very clear, which gives us a good solution to the problem of choosing products and looking at samples.\"",
    "ZhuCeGongSi2": "Shantou Science & Technology Co.",
    "ZhuCePinLun2": "The ESSA sample library is very well stocked and it's very easy to find samples on the go by logging in on your mobile phone!",
    "ZhuCeGongSi3": "ALISA TOYS",
    "ZhuCePinLun3": "It has been a pleasure to work with ESSA for many years. I am very positive about this company. Their team is very dynamic, everyone is very smart and very motivated. Their idea of using the internet to reform this foreign trade process is something I really appreciate, and they are gradually doing it now!",
    "ZhuCeGongSi4": "Shinco Toys Co.",
    "ZhuCePinLun4": "The ESSA team is very welcoming, the platform is highly comprehensive and simple to use, so I can easily find the products I want on it.",
    "RenZhengBuTongGuo": "Failure of accreditation",
    "EWen": "Русский",
    "YingWen": "English",
    "HaiMeiYouZhangHao": "Don't have an account?",
    "WeiRenZhengZhiNengChaKan2": "Uncertified only have 3 days access to view prices and will not initiate a request for quotation from the factory when shopping for an item.",
    "HuoDeWanZhengDeTiYan": "Authenticate your account for a more complete experience.",
    "ChangShiChongXinFaSongYouJian": "If you haven't received it, try resending the email.",
    "YiZhiShouBuDaoQingLianXiKeFu": "Never received, please contact customer service.",
    "DengLuChengGong": "Login successful",
    "RuGuoMeiYouKeYiBuTianXie": "If not, you can leave it out",
    "DanJuGuanLi": "Documents Management",
    "SuiCheDan": "Invoices",
    "BiaoJi": "markings",
    "ChanPinTiaoMa": "Product barcode",
    "ZhongWenPinMing": "Product name in Chinese",
    "YinWenPinMing": "Product name in English",
    "ErWenPinMing": "Product name in Russian",
    "NeiHe": "inner box",
    "DDPDanJia": "DDP unit price",
    "DDPZongChengJiaoJia": "DDP total amount",
    "EXWDanJia": "EXW unit price (CNY)",
    "EXWZongChengJiaoJia": "EXW total amount (CNY)",
    "FOBDanJia": "FOB unit price (RUB)",
    "FOBZongChengJiaoJia": "FOB total amount (RUB)",
    "XiaDanLuBuHuiLv": "Rouble exchange rate for orders",
    "CIFJiaGe": "CIF price (CNY)",
    "TieZhiBianHao": "Sticker No.",
    "BanBen": "Versions",
    "ShengChanGuo": "Producer",
    "JianShu": "Количество штук",
    "MaoZhong": "Вес брутто",
    "ZhongJia": "Общая стоимость",
    "LiShiJiLu": "Historical record",
    "XiaZaiExcel": "Export to Excel",
    "XiaZaiGaiZhangPDF": "Скачать PDF с печатью",
    "ShiZhuangGuiRiQi": "Actual loading date",
    "FaPiaoHao": "номер документа (инвойса)",
    "HeTongBianHao": "Номер договора",
    "JiaoHuoTiaoKuan": "Delivery terms",
    "MaiFang": "Buyer",
    "MuDiDiGuoJia": "Страна назначения",
    "JiGui": "Container",
    "MuDiDiCheZhan": "Пункт назначения",
    "FaJianRen": "Shipper",
    "TuoYunRen": "Shipper/Seller",
    "WeiQueRen": "Not confirmed",
    "PinPaiReMen": "Brand Popular",
    "TongLeiMuPaiHangBang": "Similar Products Ranking",
    "ShangCiBuTongGuo": "Failed last time",
    "GongChangJiaGe": "Factory Price",
    "ESSAJiaGe": "Trading Price",
    "ZaiYeMianYouShangJiaoKeYiQieHuan": "In the upper right corner of the webpage, you can switch the quotation method EXW / FOB.",
    "ChaKanJiaGe": "View Price",
    "ShangPinJiaGe": "Product Price",
    "ZhangHaoWeiRenZheng": "If the account is not authenticated, you cannot initiate a price inquiry to the factory.",
    "DengLuHouXianShiJiaGe": "Show price after login",
    "GenGongChangZhiJieCaiGou": "Register an account for free, purchase directly from the factory, and update more than 2,000 new products every day",
    "KaiPiaoXinXi": "Invoicing Information",
    "ESSAPingTaiChengNuo": "The ESSA platform is committed to not disclosing information to the public and to abide by the ESSA platform confidentiality agreement.",
    "QueRenHouBuYunXuQieHuan": "Confirmation does not allow switching, please choose carefully! The selection is only for placing orders and does not affect the price display on the page.",
    "QueRenJiaoYiXinXi": "Confirmation of transaction information",
    "QueRenSuoXuanJiaoYiBiZhong": "Please reconfirm your selected trading currency as:",
    "YangPinZhuangXiangDan": "Packing list of samples",
    "YangPinSuiCheDan": "Invoice for samples",
    "YunFeiDan": "Shipping bill",
    "YunFeiHuiKuanDan": "Shipping remittance bill",
    "HaiGuanXinHan": "Customs letters",
    "JiaGeBiao": "Price table",
    "ShangPinBiao": "Product table",
    "YangPinShangPinBiao": "Sample product table",
    "MaiJia": "Продавец",
    "FuWuMiaoShu": "服务描述",
    "JiaoHuoYongShi": "交货用时",
    "FaHuoDian": "Shipping location",
    "MuDiDian": "Destination",
    "LuXian": "Route",
    "FuKuanTiaoJian": "Payment terms",
    "OuYaJingJiLianMengLuXianYunFei": "Eurasian Economic Union route shipping costs",
    "ZongJiYunFe": "Total shipping costs",
    "YunFeiDanLuXianMiaoShu": "<p>1.到{0}海关关卡通行检查站：{1}（{2}公里）;</p> <p>2.欧亚经济联盟路线：{3}（{4}公里）;</p> <p>百分比：</p> <p>中国 -{5}%; 俄罗斯 - {6}%。</p>",
    "ShangPinYuanChanGuo": "Country of origin of goods",
    "ZhiZaoShang": "制造商",
    "QingYueDuJiaChaDanJuShuJu": "请阅读检查单据数据，确认此单据无问题？",
    "HeTongHaoHeRiQi": "合同号和日期",
    "MiaoShu": "描述",
    "ZongYunFei": "总运费",
    "YunFeiHuiKuanDanGuiHaoLiZi": "EX:85/003",
    "YunFeiHuiKuanDanHeTongHaoHeRiQiLiZiRu": "EX:ESSA-TR 003 от «26» мая 2022 г.",
    "YunFeiHuiKuanDanRiQiLiZiRu": "EX:«02» Августа 2022 г.",
    "YunFeiHuiKuanDanMiaoShuLiZiRu": "EX:Доставка товара по маршруту1.в т/п ПП Забайкальск: Гуанчжоу – т/п ПП Забайкальск (2652.2 км); 2. по ЕАЭС: т/п ПП Забайкальск – Белый Раст (5125.7 км), контейнер № OOLU8357922, инвойс № RU20220012 от 22.06.2022 на сумму 10,000.00 USD",
    "YunFeiHuiKuanDanZongYunFei": "10,000.00",
    "YunFeiHuiKuanDanHeTongHaoHeRiQiLiZiEn": "EX:ESSA-TR 003 dated May 26, 2022",
    "YunFeiHuiKuanDanRiQiLiZiEn": "EX:«02» August 2022",
    "YunFeiHuiKuanDanMiaoShuLiZiEn": "EX:Delivery of goods along the route 1.to the P/P Zabaikalsk: Guangzhou – P/P Zabaikalsk (2652.2 km); 2. on the EAEU: P/P Zabaikalsk – Beliy Rast (5125.7 km), container no. OOLU8357922, invoice no. RU20220012 dated 22.06.2022 in the amount of 10,000.00 USD",
    "HuiFuCiBanBen": "Restore this version",
    "DangQianBanBen": "Current version",
    "PiLiangBianJiEWenPinMing": "Batch edit Russian name",
    "PiLiangBianJiYingWenPinMing": "Batch edit English name",
    "WeiQueRenWuFaXiaZaiPdf": "Not confirmed, cannot download PDF with seal",
    "BianJiYunFeiHuiKuanDan": "Edit freight remittance",
    "BianJiHaiGuanXinHan": "Edit Customs Letter",
    "BianJiJiaGeBiao": "Edit Price List",
    "BianJiShangPinBiao": "Edit product list",
    "BianJiYangPinShangPinBiao": "Edit Sample Goods List",
    "JiZhangXiangHuoHao": "Container item number",
    "ZongGeShuZhuangLiang": "Total number of units (loading)",
    "DaoHaiGuanGuanKaJianChaZhanYunFei": "Freight to {0} customs checkpoint",
    "DiZhi": "Address",
    "DaiQueRenDanJu": "Pending confirmation documents",
    "QueRenDanJu": "Confirmation documents",
    "MiaoShuNiYaoZhaoDeShangPin": "Please describe the item you are looking for",
    "GaoSuWoMenShangPinDeXinXi": "Tell us about the item, e.g. features, colour, material, specified brand, packaging requirements, etc.",
    "ShangChuanWenJianZhiChi": "Upload files, support images/compressed packages/Excel, single file support up to 200M, up to 5 files",
    "XuYaoYuTuPianShangPinYiZhi": "Needs to be consistent with the product pictured",
    "JinZhunFanKui": "Precise feedback",
    "JinKeNengDuo": "As many as possible",
    "JinkeNengJinZhunDe": "Recommend as accurate as possible",
    "JiaGeYaoQiu": "Price requirements",
    "ChanPinXuYaoYongYouYiXiaZhengShu": "Products need to have the following certificates",
    "XiaoShouGuoJia": "Country of sale",
    "QingXuanZeXiaoShouGuoJia": "Please select the country of sale",
    "QingMiaoSuNiYaoZhaoDeShangPin": "Describe the item you are looking for",
    "KeJieSouLeiShi": "Similar acceptable",
    "QingXuanZeZhengShu": "Please select a certificate",
    "BuXianZhiShuLiang": "No limit to the number of recommendations, recommend as many as possible",
    "GengDuoDeYaoQiu": "More details",
    "GengShaoDeYaoQiu": "Fewer requests",
    "YiYouZhiLiao": "Information/images already available",
    "ZhengZaiZhaoYang": "Looking for samples",
    "FanKuiShuLiang": "Number of feedbacks",
    "TuiJianDeShangPin": "Recommended Items",
    "PiLiangJiaRuGouWuChe": "Add to cart in bulk",
    "QueRenYaoQuXiaoZhaoYangQu2": "After cancellation, you will no longer receive product recommendations. Do I cancel my sample search?",
    "ZhaoYangYouXinDeFanKui": "Find new feedback",
    "QiTianNeiBuZaiDanChu": "No more pop-ups within 7 days",
    "QuanBuZhaoYang": "All records",
    "TiJiaoNiDeXuQiu": "Can't find an item? Try and let us help you find it.",
    "TuiJian": "Recommend",
    "LiShiTuiJian": "Historical recommendations",
    "TuiJianLiangDian": "Reason for recommendation",
    "JiaRu": "Add",
    "XiangZhao": "Want to find",
    "DengLuHouFaBuZhaoYangXuQu": "After logging in, start posting requests to find samples",
    "JiaoYiJia": "Trading Price",
    "ZhaoYangJiLu": "Find sample history",
    "ZhaoYangZhong": "Looking for samples",
    "YouXinYangPin": "There are new samples",
    "SouSuoZhaoYangMiaoSu": "Search for description content",
    "EWenMiaoShu": "Description in Russian",
    "HaiYouKuanShangPinMiaoShuWeiWanShan": "There are {0} items left to complete, do you want to confirm?",
    "KuanShangPinMiaoShuWeiWanShan": "There are {0} products with incomplete descriptions",
    "PiLiangBianJiMiaoShu": "Bulk edit description",
    "PiLiangBianJiEWenMiaoShu": "Bulk Edit Description",
    "ChanPinYiTingShou": "Stop Selling",
    "ZanWuQuanXianChaKan": "No permission to view",
    "ZiXunChanPin": "Consulting Products",
    "NiXiangZiXunShenMeWenTiNe": "What question do you want to ask?",
    "GongChangYiBanHuiZai1GeGongZuoRiNeiHuiFuNi": "The factory will usually reply you within 1 working day. You can go to the shopping cart to see the factory's response.",
    "QingShuRuNiDeWenTi": "Please enter your question",
    "FaSongTiWen": "Send Question",
    "XianShiYuanWen": "Show original text",
    "QingXuanZeQinQuanYuanYin": "Please select the reason for infringement",
    "QinQuanYuanYin": "Reason for infringement",
    "QinQuanQuXiao": "Infringement Cancellation",
    "DengLuHouShiTuZhaoYang": "Please log in to start identifying images to search for products",
    "NeiBuGuiHao": "ESSA container number",
    "WuLiuGuiHao": "Logistics container number",
    "GongChangMOQ": "Factory MOQ",
    "KouJianDengJi": "Deduction registration",
    "JinQiTuiKuan": "Recent Deduction Registration",
    "TuiKuanDengJi": "Deduction registration",
    "QingQueRenLuRuDeKouJianJinEShiFouZhengQue": "Please confirm whether the entered deduction amount is correct?",
    "SuoYouKouJianJiLu": "All deduction records",
    "KouJianJinE": "Deduction amount",
    "QingShuRuKouJianJinE": "Please enter the deduction amount",
    "HuiKuanRiQi": "Remittance date",
    "QingXuanZeHuiKuanRiQi": "Please select a remittance date",
    "TuiKuanFangShi": "Refund method",
    "QingXuanZeTuiKuanFangShi": "Please select a refund method",
    "GaiCaoZuoJiangKouJianKeHuDeYuE": "This action will deduct the customer's balance",
    "QuanBuKouJianJiLu": "All deduction records",
    "KouJianJiLu": "Deduction record",
    "SouSuoKeHuBianHao": "Search customer number",
    "KeHuYuE": "Customer balance",
    "BianDongJinE": "Changed amount",
    "BianDongHouYuE": "Balance after change",
    "QingXuanZeLeiXing": "Please choose the type",
    "KeHuZaiDengJiLeiTongYangDeJinE": "Customer {0} has registered the same amount {2} at {1}.",
    "ShiFouJiXuDengJi": "whether to continue registration?",
    "KouJianJinEYiChaoChuKeHuYuE": "The operation failed, the deduction amount has exceeded the customer balance {0}",
    "ZanWuWuLiuShuJu": "No logistics data yet",
    "DangQianKeHuYuE": "Current customer balance {0}",
    "LianXiWoMen2": "Contact",
    "PiPeiShangPin": "Matching Product",
    "NiYaoZhaoShenMeShangPin": "what are you looking for",
    "LiuXiaNiDeYouXiang": "Leave your email",
    "YiGeQingQiu": "One request, many quotes",
    "QinMiaoSuNiYaoZhaoDe": "Please describe the product you are looking for, such as name, color, material, etc.",
    "GongChang": "Factory",
    "WoMenYiShouDaoNiDeXunJiaQingQiu": "We have received your inquiry request and will reply to you within 1~2 working days, please pay attention to check your email.",
    "XunJia2": "Inquiry",
    "RuGuoNinYouWenTi": "If you have questions, you can ask your account manager to help you",
    "XueXi": "study",
    "Zi2006NianYiLai": "SINCE 2006",
    "ShiYuChengHai": "ESSA was founded in 2006 and started in Chenghai",
    "ZhongGuoWanJuHeLiPinZhiDou": "the capital of toys and giftsin China",
    "JingGuoDuoNianDeFaZhan": "After years of development, we now have branches in Shantou",
    "YiWuGuangZhouHeXiangGang": "Yiwu Guangzhou and Hong Kong",
    "WeiWanJuTiGongCaiGouFuWu": "providing sourcing services for toys",
    "TiYuYongPinWenJuRiYongPin": "sporting goods, stationery, daily necessities",
    "YiJiXuDuoQiTaLeiBie": "and many other categories",
    "WeiQuanQiuKeHuTiGongDeChanPin": "of products for global customers",
    "ZhouNianJiNianRi": "Anniversary",
    "ZhouNianJiNianHuoDong": "ESSA big family anniversary event",
    "GanXieNinFangWen": "Thank you for visiting ESSACHINA online purchasing platform.You can leave us any comments or suggestions",
    "WoMenJiangZai24XiaoShiNeiHuiFuNin": "via email or online customer service at the bottom left corner.We will reply to you within 24 hours.",
    "WoMenHuanYingNinDangDiGongSiGouTong": "We also welcome you tocommunicate with our local companies.",
    "GuangDongESSA": "Guangdong ESSA Technology Co.",
    "GuangZhouShiNanShaQu": "Room 6, Room 2320, No. 5, Shuangshan Avenue, Nansha District, Guangzhou",
    "XiangGangFanRongDianZiShangWu": "Hong Kong Fanrong E-Commerce Co.",
    "XiangGangJiuLongHongKanMaTouWeiDao": "A37, 9/F, Yida Industrial Building, 21 Wharf Wai Road, Hung Hom, Kowloon, Hong Kong",
    "ShanTouShiChengHaiQuGuangYiJieDao": "No. 01, 1st Floor, Guangfeng Industrial Zone, Dengfeng Road, Guangyi Street, Chenghai District, Shantou City",
    "ShanTouESSAGongYingLian": "Shantou ESSA Supply Chain Management Co.",
    "YiWuESSAMaoYiYouXianGongSi": "Yiwu ESSA Trading Co.",
    "ZheJiangShengYiWuShiFuTianJieDao": "Room 1708, 17/F, International Business Center, 399 Yinhai Road, Futian Street, Yiwu, Zhejiang",
    "RenShiWoMenDeTuanDui": "Meet our team",
    "YeWuTuanDui": "Operation and maintenance team",
    "CaiGouTuanDui": "Purchasing Team",
    "YunYingTuanDui": "Operations team",
    "JiShuTuanDui": "Technical team",
    "ZhanTing": "Exhibition hall",
    "CangKu": "Storehouse",
    "YiZhanShiCaiGou": "One-stop shopping",
    "WeiNinTiGongZhuLiuLeiBie": "ESSACHINA.COM offers you 8 mainstream categories. ESSA's extensive product library consists of 2 million items from over 20,000 Chinese factories that we work with.",
    "WeiNinTiGongHangYeYiXianXinXi": "ESSACHINA.COM provides you with the first-line information of new products in the industry, so that you don't miss any new products with market potential.",
    "ZhaoBuDaoChanPinXiWangTiGongJianYi": "Having trouble finding a product or want ESSA to provide product suggestions? No problem at all, we'll get back to you within 1 business day !",
    "GaoXiaoDi": "Efficiently",
    "ESSACongShiWaiMaoHangYeYiYou16Nian": "ESSA has been engaged in the foreign trade industry for 16 years and has served different types of customers such as traditional wholesalers, large supermarkets and brand owners. Therefore, we can provide the best quotation and service  solutions to meet the individual needs of buyers.",
    "ZaiXianPiFaCaiGouPingTai": "Your 24/7  online wholesale sourcing platform",
    "TiChuBaoJiaQingQiu": "You can make a request for quotation on our website at any time. Your inquiry will be processed by ESSA within 24 hours.",
    "YouJingZhengLiDeJiaGe": "Competitive Prices",
    "GongYingShangShiYuanGongChang": "ESSACHINA's suppliers are 100% source factories.",
    "ESSADeJiaGeShiTouMingHeGongKaiDe": "Compare prices first, then purchase.  ESSA's prices are transparent and open. Customers are also welcome to compare product prices to ensure that ESSA  customers always get a competitive offer from us.",
    "WeiNinTiGongJiaGeTanPanFuWu": "ESSA has a professional costing staff to provide you with price negotiation services.",
    "JiLeiLeYiZhiHeXinTuanDui": "Years of industry accumulation has allowed ESSA to accumulate a core group   of supplier partners that can provide ESSA's customers with advantageous  prices.",
    "TiGongGongYingShangHeZuoHuoBan": "Price guarantee: within one week from the completion of your inquiry to the  order, if there is a price increase for the product, ESSA will still provide you with  the original offer within the 5% increase.",
    "RuHeCongQiTaGongSiZhongTuoYingErChu": "How we stand out from other sourcing companies",
    "QueBaoGongChangJiangGenJu": "ESSACHINA ensure factory will take penalty as per",
    "RuGuoHuoWuSunHuaiHuoQueShao": "compensation standards if any damage or lack of goods.",
    "LiJiFaBuWoDeXuQiuRenWu": "Post my requirement task now !",
    "JiaoFuShiJianBaoZheng": "Delivery Time Guarantee",
    "essaDeChengNuo": "ESSACHINA guarantees you the delivery time of your goods, If  could not delivery on time, start calculate compensation after 7  days delay, then penalty on 0.1% of delayed order amount every  1 more day delay.Apart from the delay cases on customer’s  reason( such as booking delay, customer require not ship on  time, payment not arrived on time, etc) and other force majeure  caused delay.",
    "GuanYuESSAUrl": "About essachina.com",
    "GuanYuESSAUrlSub": "A quick look at how essachina.com stands out in the toy trading industry",
    "GuanYuESSASub": "Meet ESSA, a company that has been deeply involved in the Come meet our team! Looking forward to working with you!",
    "BangZhuZhongXinSub": "Having trouble using our website? Maybe you can take a look here",
    "BoKe": "Blog",
    "BoKeSub": "The latest news in the toy industry, shared by the industry's frontline staff on our platform",
    "ESSADeGongZuo": "How ESSA work?",
    "XinKeShouNianYouHui": "New Customer First Year Offer.",
    "ZaiYeMianYouShangJiaoKeYiQieHuanDuiBiJia": "Switch the quotation mode EXW/FOB in the upper right corner of the page. The current price is exclusive for the first year of new customers.  New Customer First Year Offer.",
    "LaiKuanMingXi": "Payment details",
    "KouKuanMingXi": "Deduction Details",
    "KeHuYuEMingXi": "Customer balance details",
    "MaiShouGuanLi": "Account Manager Management",
    "HaiMeiYouKeHuJingLiWeiNiFuWu": "There is no account manager serving you yet",
    "TiaoXuanKeHuJingLi": "Pick an account manager",
    "ShiFouBuXuYaoKeHuJingLiLe": "Is there no need for an account manager?",
    "ZongHePingFen": "Overall Rating",
    "GeRenTeSe": "Personal characteristics",
    "WoBuXiangYaoKeHuJingLiLe": "I don't want an account manager anymore",
    "KuHuJingLiYinGeRenYuanYinWuFaJiXiFuWu": "The account manager cannot continue to serve due to personal reasons, you need to re-select the account manager.",
    "KuHuJingLiYinGeRenYuanYinWuFaJiXiFuWu2": "The account manager is unable to continue the service due to personal reasons.",
    "HenBaoQianGaiKeHuJingLiYiFuWuDuoGeKeHu": "Terribly sorry! This account manager has served multiple clients and is temporarily unable to serve you. Please try another account manager.",
    "XianZaiYouXinKeHuJinLiWeiNiFuWu": "Now at your service with a new account manager.",
    "KeHuJinLiJiangWeiNiTiGongFuWu": "Account manager will provide you with service.",
    "WenJianGeShuBuZhengQue": "The number of files cannot exceed 10.",
    "NiQuXiaoLeFuWu": "You canceled the service.",
    "NiDuiGaiKeHuJingLiPingJiaBuTaiYouHao": "You do not have a good opinion of the account manager, do you want to replace a new account manager to serve you?",
    "KuHuJingLiQuanChengFuZeGenJin": "The account manager is responsible for follow-up throughout the process. If you are not satisfied with the account manager service, you can cancel the account manager service and choose a new account manager.",
    "NinYouJinXinZhongDePoDanWuFaJieBanMaiShou": "You have a PO in progress and cannot untie the buyer.",
    "LiShiKeHuJingLi": "Account managers who have worked with in the past",
    "XiangXiZiLiao": "Details",
    "XiTongZiDongFenPei": "Automatic system assignment",
    "YiXiaKeHuJingLiBuFenPiPei": "Check out other account managers",
    "XiTongWeiNinXuanZeMaiShou": "Whether to let the system automatically assign buyers for you",
    "FenPeiChengGong": "Assignment successful",
    "KeHuJingLiXiangQing": "Account Manager Info",
    "JiNengTeChang": "Special skill",
    "ZhuPinLei": "Main categories",
    "ShanChangPinLei": "Specialized categories",
    "WaiMaoCongYeShiChang": "Time in foreign trade industry",
    "ShiChang": "Markets of expertise",
    "KeHuXiaoShouQuDao": "Customer Sales Channel",
    "FuWuKeHuShu": "Number of customers served",
    "XuanZeGaiKeHuJingLi": "Choose this account manager",
    "ShuoLiangJu": "say something",
    "PingJiaYiXiaKeHuJingLi": "Comment on the account manager will only be provided to the platform for internal viewing, in order to find problems in time and improve the service quality of the account manager.",
    "XiTongJiangDuiNiDePingJiaNiMingChuLi": "Your feedback will be handled anonymously. We hope to receive your honest evaluation so we can provide better service!",
    "ChaKanPingJia": "Check the comment",
    "PingFenBuNengWeiKong": "Rating cannot be empty",
    "ShiFouQueRenTiJiaoPingLun": "Confirm the comment and submit?",
    "QuTiaoXuan": "Choose an account manager",
    "PingLunChengGong": "Comment Success!",
    "YiPingJia": "Commented",
    "PingJiaKeHuJingLi": "Comments to Account Manager",
    "TiJiaoPingJia": "Submit comments",
    "NiYiJingYouKeHuJingLiWeiNiFuWu": "You already have an account manager to serve you, selecting a new account manager will replace the original account manager.",
    "MaiShouXiangQing": "Account Manager Info",
    "KeHuJingLi": "Account manager",
    "FuWuZhong": "In-service",
    "QingQianWangRenZheng": "Your account has not been verified yet, be verified before select an account manager.",
    "KeYiKanKanYiXiaBuFenPiPeiDe": "Can't find an account manager that matches your information exactly, you can look at the following partial matches.",
    "KeHuJingLiQuanChengFuZeGenJin": "The account manager is responsible for follow-up throughout the process. If you are not satisfied with the account manager service, you can cancel the account manager service and choose a new account manager.",
    "TiHuan": "Replace",
    "MianFei": "Free",
    "KeHuJingLiFuWuZhong": "Customer Service Manager in service",
    "KeHuPingTaiJingLi": "Account manager",
    "HaiMeiZhuCe": "Not yet registered",
    "ZhuCeChengGong": "Register successfully",
    "DiYiDanZheKouYouHuiTiShi": "10% deposit on your first order",
    "KaiShiCaiGou": "Start purchasing",
    "HuoDeJiangLi": "Get Reward",
    "ShangPinZhanShi": "Product Details",
    "SouSuoShangPinGongChang": "Search Product / Factory",
    "PinPaiZhuYe": "Brand Home",
    "ChaKanGouWuCheTiShiM": "<a style=\"color:#fff\" href=\"https://www.essaone.com/cart\">View cart, currently only supported on PC side. https://www.essaone.com/cart</a>",
    "GouWuCheYiYouWaiXiang2": "There are already {0} boxes in the shopping cart, does it overwrite the quantity in the cart",
    "JiaGeShuoMing": "Price Description",
    "ESSAONEJiaGeShuoMingNeiRong": "ESSAONE deals with the price of the outer box unit, other prices are only used as a cost reference when purchasing.",
    "LiRuMouShangPin": "For example: an item",
    "ZhanShiXiang": "Display box",
    "ShangYiYe": "Previous",
    "XiaYiYe": "Next",
    "GongXiNiYiChengGongZhuCe3": "One of our account managers will contact you within 48 hours of the business day to help you find the right product and the best discount.",
    "HuoQuZuiZhunQueZhao": "Ways to get the most accurate photo search results",
    "ShangChuanDeZhaoPian": "The photos uploaded must be clear",
    "ShiYongChunSeBeiJing": "Use a clean background to make the product stand out",
    "KeYiQieGeChanPinDe": "Cropping out the main part of the product image",
    "RuYouBaoZhuang": "If the product has packaging, try removing it before searching",
    "ShiBieTuPianSouSuoTongKuan": "Identify images to search for the same or similar items",
    "ShiYongCtrlV": "Or use Ctrl + V / CMD + V to paste",
    "KuangXuanZhuTi": "select subject",
    "JieGuoBuZhun": "Incorrect results?",
    "DianJiKeQieHuanSouSuoTuPian": "Click to toggle the search image",
    "QingKongBingChongXinShangChuan": "Clear all",
    "HuiYuanShouYe": "Members Home",
    "WoDeJiFen": "My Points",
    "YouXiaoDingDan": "Valid orders ≥{0}",
    "LeiJiChengJiaoE": "Cumulative order amount {0}{1} {2}",
    "GouWuXiaDan": "Place an order",
    "ChengWeiHuiYuan": "Become a member",
    "XiangShouQuanYi": "Enjoy the benefits",
    "ShengJiJiangLiJiFen": "Points for upgrade rewards",
    "DingDanJiangLi": "Points back for orders",
    "ZuiGaoDiKou": "Points paid up to",
    "WoDeDengJi": "My Grade",
    "JiFenMingXi": "Points Record",
    "HuoQuJiFen": "Earn points",
    "100%WanShanGongSiXinXi": "100% Complete company information",
    "QuWanShan": "Go to improve",
    "GuanZhuGuanFangSheMeiPingTai": "Follow the official social media",
    "GuanZhuHouJieTuFaSongGeiKeFuShenHeHouJiangLiJiFen": "After subscribing, send a screenshot to our managers and we will credit you with points.",
    "ChaKanShangPinXiangQingYeMian": "Check the item page and you can be rewarded once a day.",
    "JiaGouShangPin": "Add an item to your order",
    "BaShangPinJiaRuDaoGouWuChe": "Add an item to your cart, points are awarded for each item added.",
    "QuXuanGou": "Go to cart",
    "WanChengDingDan": "Complete orders",
    "ShiFuDingDanJinE": "You can pay for part of your order with points (percentage depends on the membership grade)",
    "LianXuXiaDan": "Place orders monthly",
    "DuiBiShangYueXiaDan": "Bonus points compared to the previous month (valid orders)",
    "HaiMeiYouJiFenJiLu": "No points record yet",
    "KeDiKouN": "Points can be paid {0}{1}",
    "YuJiJiJiangDaoZhang": "Expected to arrive soon {0}",
    "ZuiJinNTianJiFenTongJi": "Last {0} days points stats",
    "WanChengXiaDan": "Complete the order",
    "JiFenZhiFuDingDanShu": "Number of orders paid with points",
    "JiFenDiKouJieSheng": "Pay with points and save",
    "ZuiJinJiFenMingXi": "Recent Points Record",
    "ChaKanQuanBuMingXi": "View details",
    "XinZhuCeYongHu": "New register user",
    "DingDanJiangLiJiFen": "Points back for orders",
    "JiFenZuiGaoDiKou": "Points paid up to",
    "ZhuanShuKeHuFuWu": "Exclusive customer service",
    "YouXiaoDingDanZhiDeShiXiaDan": "* A valid order is an order for which a deposit has been paid and the cumulative order amount is the total order amount for a valid order.",
    "DengJiJiSuanYuBianGeng": "Grade Calculation and Change",
    "DengJiJiSuanYuBianGeng1": "1. The membership grade of the website will be updated on the 1st of each month.",
    "DengJiJiSuanYuBianGeng2": "2. The system will calculate the number of orders and total transaction amount within the last 6 months. If the number of orders and total transaction amount within 6 months reach the corresponding membership grade threshold, the membership grade will be upgraded or downgraded automatically.",
    "DengJiJiSuanYuBianGeng3": "3. If no orders are placed within 6 months, the membership grade will be reduced directly to Lv.1.",
    "DengJiJiSuanYuBianGeng4": "4. When the membership level is changed, members enjoy the membership benefits of the new grade.",
    "HanMeiMei01YueZhuCeZhangHao": "Petya registered in January",
    "HanMeiMei01YueZhuCeZhangHao1": "In January, he placed an order and his total purchases amounted to 50,000 roubles (or more). On 1 February, Pete's membership grade will be raised to Lv.3.",
    "HanMeiMei01YueZhuCeZhangHao2": "If Petya has not placed any more orders between February and July (in the last 6 months), or if his total order amount is less than 50,000 roubles, his membership grade will be dropped to Lv.1 on 1 August.",
    "HuiYuanYuJiFen": "Membership & Points",
    "JiFenShiYongHuDingGouHuoWanCheng": "Points are awarded to the user for ordering or completing a specified task on the website and can be used to pay for the next order, 1 point = 1 rouble.",
    "SuoYouYongHuDouKeYiCanYuJiFenDe": "All users can earn points, but only members can use them. The level of membership is closely related to the acquisition and use of points. The higher the level, the higher the percentage of points earned and paid. Points are also awarded for membership upgrades.",
    "LiaoJieJiFenGengDuoXinXi": "Learn more about points",
    "HuiYuanChangJianWenTi": "Membership FAQ",
    "HuiYuanChangJianWenTi1": "1. How do I progress through the membership levels?",
    "HuiYuanChangJianWenTi2": "The system will count the number of orders and the cumulative amount of orders within the last 6 months on the 1st of each month, and members will be upgraded automatically if the number of orders and the total amount of transactions within 6 months reach the higher level.",
    "HuiYuanChangJianWenTi3": "2. Does the membership level drop?",
    "HuiYuanChangJianWenTi4": "Yes. The system will change the grade every month. If the number of orders and the total transaction amount do not reach the current level within 6 months, the level will be automatically downgraded. If no orders are placed in 6 months, the level will be reduced to the lowest level V1.",
    "HuiYuanChangJianWenTi5": "3. How long are the membership levels valid?",
    "HuiYuanChangJianWenTi6": "The validity of the membership grade is related to the member's transactions. It does not have a fixed expiry date. The maximum validity period is 6 months. The system will update the data and reconfirm the membership grade every month.",
    "HuiYuanChangJianWenTi7": "4. Will membership benefits be adjusted?",
    "HuiYuanChangJianWenTi8": "Membership benefits are related to the grade of membership. The higher the level, the greater the benefits. It follows that membership benefits will vary with membership grade.",
    "HuiYuanChangJianWenTi9": "5. Will new benefits be added?",
    "HuiYuanChangJianWenTi10": "Yes. We will continue to offer more valuable benefits to our members, so stay tuned!",
    "YouXiaoDingDanLeiJiChengJiaoE": "Valid orders {0},cumulative orders {1}{2}",
    "QuXiaDanChengWeiHuiYuan": "Go to place an order to become a member!",
    "DengJiShuJuMeiYue1Ri0DianGengXin": "Membership grade data updated on the 1st of every month.",
    "RuGuoBaoChiDangQianDeChengJiaoLiang": "If the current order amount is maintained, the membership grade will become Lv.{0} next month.",
    "XinKeHuShouCiXiaDanKeXiangShou": "Special offer for new customers on their first order! Learn more >>",
    "TaiBangLeNiYiJingManJiLe": "Отлично! Вы стали участником программы лояльности.",
    "GongXiNiXiaYueJiangShengJiDaoN": "Congratulations! You will be upgraded to Lv.{0} next month.",
    "ShengJiDaoLvNHaiXuXiaDanNCi": "Upgrade to Lv.{0}, <b>{1}</b></span> more orders to be placed this month.",
    "ShengJiDaoLvNHaiXuXiaDanN": "Upgrade to Lv.{0} and you need to order {1} {2} this month.",
    "NiHaiBuShiHuiYuan": "You are not a member yet, become a member with just {0} order.",
    "ESSAONEShouY": "ESSAONE Homepage",
    "JiFenBianDong": "Change of points",
    "JiFenYuE": "Points Balance",
    "DangQianYiXiaDanNCi": "Current Orders {0}，{1} {2}",
    "JiFen": "Points",
    "ShengJiHuiYuanXiangShouGengDuoQuanYi": "Upgrade your membership to enjoy more benefits.",
    "DingDanJiangLiZuiGaoDiKou": "Points back for orders {0},points paid up to {1}",
    "ZengJia": "Add",
    "DangQianJiFen": "Current Points",
    "JiFenXiang": "Points items",
    "QingXuanZeJiFenXiang": "Please select the points item",
    "JiFenGuanLi": "Points Management",
    "JiFenZhi": "Points Score",
    "JiFenTiXiWanShanGongSiXinXiKeYiHuoDeJiFen": "Point system - Improve your company information and you can earn points.",
    "NinDeDingDanYiTiJiaoQingZ2": "Your order has been submitted, please pay the deposit within <i>{0}</i> days to confirm your order!",
    "XuZhiFuDingJin": "Deposit to pay",
    "JiFenDiKou": "Payments with Points",
    "DangYueHeQian5Yue": "Cumulative order amount for this month and the previous 5 months",
    "DangQianJiFenNBenDanWeiKuan": "Current points {0}. The final payment of the order is expected to be paid with {1} point for  {2} {3}.",
    "ZhiFuWeiKuanShiShiYongJiFen": "When paying the final amount, use the points to pay the corresponding amount.",
    "ShiJiDiKouJiangYiZhiFuWeiKuan": "Note: The actual number of points that can be used is based on the points balance at the time of final payment.",
    "ZhiFuDinDanXianYiZhiChiJiFen": "Now orders can be paid for with points for the final payment of up to 8% of the order amount.",
    "QianWangJiFenZhongXin": "Go to Points Centre",
    "NDan": "Number of orders {0}",
    "JiFenChangJianWenTi": "About points",
    "JiFenChangJianWenTi1": "1、What are points?",
    "JiFenChangJianWenTi2": "Points are a reward that the user receives for ordering or completing a task specified by the platform and can be used to pay the final amount of the next order. Russian Federation: 1 point = 1 ruble; Belarus: 30 points = 1 white ruble.",
    "JiFenChangJianWenTi3": "2、How to get points?",
    "JiFenChangJianWenTi4": "Участники могут зарабатывать баллы, размещая заказы или выполняя задания, представленные на площадке.",
    "JiFenChangJianWenTi5": "3. When will the points be issued?",
    "JiFenChangJianWenTi6": "Points are issued in 2 ways.",
    "JiFenChangJianWenTi7": "(1) Points earned by completing specified tasks on the website or upgrading members are automatically issued by the system. This part of the points can be used by the user after they are issued.",
    "JiFenChangJianWenTi8": "(2) Points from orders will not be issued until the order has been completed, i.e. after the final payment has been made. When the user submits an order the system will display the points to be issued, at this point the points are unavailable until the order is completed and the points are issued and become available.",
    "JiFenChangJianWenTi9": "4. How many points can be used per order?",
    "JiFenChangJianWenTi10": "The number of points available per order is related to the membership grade and how many points the user currently holds.",
    "JiFenChangJianWenTi11": "The maximum points available for an order = the total amount of the order x the percentage of points payable for the user's current membership grade. If the points currently held by the user are less than the maximum points available for the order, then only the points currently held will be deducted.",
    "JiFenChangJianWenTi12": "5. How do I use my points?",
    "JiFenChangJianWenTi13": "It is up to the user to decide at the time of order submission whether or not to use points for that order. If you do not select it, the system will not use the points by default. If points are applied when placing an order, the amount of the order will automatically be reduced by the maximum number of points that can be applied, the balance of points will be reduced accordingly.",
    "JiFenChangJianWenTi14": "6. Can I return my points after they have been used?",
    "JiFenChangJianWenTi15": "Once used, points will only be refunded if the order is cancelled in full for reasons other than the customer. All other cases will not be refunded.",
    "XuZhiFu": "Payable to",
    "JiFenKeDiKou": "Points payble",
    "QingGouXuanDingDan": "Please tick the order first",
    "ShiYongJiFenDiKou": "{0} points have been used to pay {1}.",
    "XiuGaiGongSiXinXiChengGongJiFen": "Successfully complete company information and get points +{0}",
    "WanChengGaiDingDanYuJiKeYiJiangLiJiFen": "Expect to get <b>+{0}</b> points for completing this order",
    "WoMenTiGong30TianMianFeiCangChu": "We offer free 30-day storage.",
    "LiuLanShangPinJiFen": "Browse items and get points  +{0}",
    "JiFenChangJianWenTi16": "7. Когда истечет срок действия баллов?",
    "JiFenChangJianWenTi17": "Points will be redeemed on the website at 2 fixed times each year.",
    "JiFenChangJianWenTi18": "- On 30 June, any unused available points from the second half of the previous year are cleared. For example, on 30 June 2023, any unused points from 1 July 2022 to 31 December 2022 will be counted and the points will become invalid.",
    "JiFenChangJianWenTi19": "- On 31 December, any unused points from the first half of this year are cleared. For example, on 31 December 2023, any unused points from 1 January 2023 to 30 June 2023 will be counted and the points will become invalid.",
    "JiFenChangJianWenTi20": "8. Can only members use points?",
    "JiFenChangJianWenTi21": "Yes, you can only use points to pay for the final payment of your order if you are a member.",
    "JiFenChangJianWenTi22": "9. Will the points rules be adjusted?",
    "JiFenChangJianWenTi23": "The website will adjust the points rules according to the business development and will be announced on the date of the rule change, the new rules after the adjustment will take effect subject to the announcement. If you have any questions, please contact customer service for consultation.",
    "JiaRuGouWuCheChengGongJiFen": "Add to cart successfully and get points +{0}",
    "GongXiNiShengJiDao": "Congratulations on upgrading to",
    "DuiBuQiShangPinYiTingShou": "Sorry, product {0} has been discontinued",
    "XuanZeLiNiZuiJinDeTiHuoCangKu": "Select the nearest pick-up warehouse",
    "CangKuDiZhi": "Warehouse address :",
    "ShiHe": "Recommended regions:",
    "HuoWuSongDaoCangKuHou": "Once the goods reach the destination warehouse, you can choose to pick them up by yourself or have them delivered to the designated location at your own expense.",
    "YouYuYunShuFangShiHeLuTuBuTong": "Switching destination warehouses can affect the price of goods, delivery methods and product categories because of different transportation methods and routes.",
    "BaoQingGuanWuLiuMenDaoMenFuWu": "VAT, customs duties and delivery from the manufacturer in China to the warehouse in Moscow/Vladivostok are included.",
    "QueRenTiHuoCangKu": "Confirm the pick-up warehouse",
    "XiaDanFanJiFen": "Points back for orders",
    "JiFenDangQianHua": "Pay with points",
    "ShengJiYouJiangLi": "Upgrade rewards",
    "ZhuanShuKeFu1": "Exclusive Customer  Service 1 vs 1",
    "JuTiQuanYiShiHuiYua": "* The specific benefits depend on the membership level. The higher the level, the greater the benefits. Stay tuned for more benefits!",
    "JiaoYiChengGong": "Внесите платеж",
    "YiCiDingGouZhongShenHuiYuan": "One order and you get lifetime member benefits.",
    "RuHeChengWeiHuiYuan": "BECOME MEMBER",
    "HuiYuanJiFen": "MEMBERSHIP POINTS",
    "WanShanXinXiSongJiFen": "Improve information Reward points",
    "GuanZhuSheJiaoZhangHaoSongJiFen": "Follow social media Reward points",
    "MeiTianLiuLanShangPinSongJiFen": "Browse products daily Reward points",
    "MeiCiJiaGouSongJiFen": "For each item added to cart Reward points",
    "MeiBiDingDanFanJiFen": "Points back per order",
    "MeiYueXiaDanJiangJiFen": "Place orders monthly Reward points",
    "LiaoJieGengDuoJiFenXinXi": "Learn more about the points",
    "TeBieShuoMing": "NOTICE",
    "TeBieShuoMing1": "1. The ESSAONE membership system is effective from the date of publication.",
    "TeBieShuoMing2": "2. Membership system and points rules details can be found in “{0}” and \"“{1}”.",
    "TeBieShuoMing3": "3. The website will adjust the membership system and points rules according to the business development, and will be announced on the date of the adjustment of the rules. After the adjustment of the new rules to take effect on the announced time shall prevail.",
    "TeBieShuoMing4": "4.  If you have any questions, please contact our customer service for consultation. The final interpretation of the activity belongs to ESSAONE.",
    "TeBieShuoMing5": "Welcome to become an ESSAONE member  to make you more profitable!",
    "HuiYuanDengJi": "MEMBERSHIP GRADE",
    "LeiJiJiaoYiEWeiQueRen": "* The cumulative amount is the amount of the order confirmed for payment.",
    "Lv1YaoQiu": "<div><p>One</p><p>successful order</p></div>",
    "Lv2YaoQiu": "<div><p>Three</p><p>successful order</p></div>",
    "Lv3YaoQiu": "<div><p>Cumulative amount</p><p>≥500,000₽</p></div>",
    "Lv4YaoQiu": "<div><p>Cumulative amount</p><p>≥1,000,000₽</p></div>",
    "L51YaoQiu": "<div><p>Cumulative amount</p><p>≥2,000,000₽</p></div>",
    "Lv6YaoQiu": "<div><p>Cumulative amount</p><p>≥3,500,000₽</p></div>",
    "Lv7YaoQiu": "<div><p>Cumulative amount</p><p>≥5,000,000₽</p></div>",
    "ChaXunWoDeHuiYuanDengJi": "Check my member grade",
    "EssaOneVip": "ESSAONE VIP-CLUB",
    "CangKuTuiJian1": "For all customers in the Central Federal District, Northwest Federal District, Southern Federal District, Volga Federal District, Urals Federal District, North Caucasus Federal District.",
    "CangKuTuiJian2": "For all customers in the Siberian Federal District and the Far Eastern Federal District",
    "MskCangKu": "Московская область, Ленинский городской округ, рабочий посёлок Горки Ленинские Зелёное шоссе, 4с1. Склад №35",
    "HswCangKu": "690074, Primorsky Krai, Vladivostok, Pervorechensky District, 54 \"A\" Vyselkovaya St.",
    "KouJian": "минус",
    "JiFenXiangYiChaoChuShangXian": "Points items have exceeded the limit",
    "JiFenXiangPeiZhiYouWu": "Incorrect configuration of points items",
    "WoDeHuiYuanDengJi": "My Grade",
    "NiHaiBuShiHuiYuan2": "You are not a member yet.",
    "YaoQingYouLi2": "Get the discount",
    "ShiFu": "Actual payment",
    "1059PR10027": "There's a problem with the order.",
    "QingXuanZeCangKu": "Please select a warehouse",
    "NiDeWenTiDeDaAnKeYiZaiZheLiZhaoDao": "The answer to your question can be found here.",
    "ReMenNeiRong": "Hot Content",
    "ESSAONEJianJie": "Essaone.com intro",
    "ZhongGuoB2BZaiXianJiaoYiPingTai": "CHINESE WHOLESALE MARKETPLACE",
    "DingGou": "Order",
    "FuKuan": "Payment",
    "QianBaoShiYongZhiNan": "Payment Account Usage Guide",
    "BaoZhang": "Guarantee",
    "JiaGeShiXiaoZhiLiangBaoZhang": "Price / Delivery Time / Quality Assurance",
    "FenXiaoTuiGuang": "Agency Program",
    "ShouDanZuiGaoYouHui": "First order deposit only 10%!",
    "MeiGeRenDouKeYiTongGuoESSAONEZhengQian!": "Everyone can earn with ESSAONE!",
    "ZhaoBuDaoWenTiDeDaAnMa": "Can't find an answer to your question?",
    "ZaiXianLiaoTianGeiWoMenLiuYan": "Send a message in the online chat and we will respond promptly.",
    "PingTaiYuHeZuo": "About ESSAONE & Cooperation",
    "ShangPinYuJiaGe": "Product & Price",
    "DingGouYuZhiFu": "Order & Payment",
    "JiaoFuYuShouHou": "Delivery & Aftersales",
    "HelpTab1Question1": "ESSAONE.COM is a website! Which company is it? Where is it?",
    "HelpTab1Question2": "I have never heard of you, how can I trust you?",
    "HelpTab1Question3": "Does ESSAONE have a physical office, a warehouse in Moscow?",
    "HelpTab1Question4": "Does ESSAONE have product certificates?",
    "HelpTab1Question5": "Does ESSAONE deliver goods via ”no customs clearance“?",
    "HelpTab1Question6": "How do you guarantee that I will get the order?",
    "HelpTab1Answer1": "ESSAONE.COM is owned by GUANDONG ESSA TECHNOLOGY CO., LTD. We are based in China, with our head office in Guangzhou. But there is also a resident company in Moscow: ESSAONE Ltd.",
    "HelpTab1Answer2": "Eight years have passed since the creation of ESSAONE. We are one of the leading suppliers of goods for children in the Russian Federation. We strive to give small and medium-sized customers the opportunity to work directly with Chinese factories, to get better prices and more original and practical products as an add-on channel. Through this channel you can see products you haven't seen before, to expand your range and increase your competitiveness in the market.",
    "HelpTab1Answer3": "Yes,we have.",
    "HelpTab1Answer4": "Yes, each delivery is accompanied by a complete package of closing documents, including the obligatory package of relevant certificates to TR TS 008/2011.",
    "HelpTab1Answer5": "We only deliver regular shipments with official customs clearance, tax payment and closing documents.",
    "HelpTab1Answer6": "Under the project, the buyer signs a supply contract with a representative office of ESSAONE.COM in the Russian Federation, i.e. with a resident company. Accordingly, all business activities are conducted between the two entities of the Russian Federation and, as a consequence, all activities take place within the applicable laws of the Russian Federation.",
    "HelpTab2Question1": "What is included in the price of the order?",
    "HelpTab2Question2": "Are the prices really in RUB?",
    "HelpTab2Question3": "Is the price final? Is there anything else you need to pay extra?",
    "HelpTab2Question4": "How can I find the product I want quickly?",
    "HelpTab2Question5": "What do I do if I can't find the product on the website?",
    "HelpTab2Question6": "What is one carton? Is it one piece?",
    "HelpTab2Question7": "Can you send a sample?",
    "HelpTab2Answer1": "<div> <p>Price for one carton  </p> <p>Delivery from China to Moscow's or Vladivostok's warehouse </p> <p>Export formalities and customs clearance (incl. VAT) </p> <p>Certificates of conformity </p> <p>No extra costs</p> </div>",
    "HelpTab2Answer2": "Yes, all prices are in RUB.",
    "HelpTab2Answer3": "Yes, the price showed on the website is final. Delivery is to our warehouse, then there is self-delivery or delivery by a transport company (at the buyer's expense).",
    "HelpTab2Answer4": "The quick search is located at the top of the website.  It can be searched by item number, item name or even by product image.  You can also search by category.",
    "HelpTab2Answer5": "Go to the category and click on \"Can't find the product you want?\" , fill in product or supplier details, product specifications, part quantities and other information.We will let you know the results by email.",
    "HelpTab2Answer6": "This is an export carton. The quantity per carton of each toy is shown on the item page.",
    "HelpTab2Answer7": "We don't send out samples. but all factories are checked and we have a quality control department to check the goods before they are shipped.We provide guarantees on the goods and their transportation from China to Moscow's warehouse.",
    "HelpTab3Question1": "How to place an order?",
    "HelpTab3Question2": "Can I order a few pieces?",
    "HelpTab3Question3": "For some products the minimum order is 2-3 boxes, can I order just one carton?",
    "HelpTab3Question4": "How to pay?",
    "HelpTab3Question5": "Do you work with deferred payment?",
    "HelpTab3Question6": "I have placed an order without paying the deposit and I want to cancel the order. How do I do this?",
    "HelpTab3Question7": "Can I change my order after paying the deposit?",
    "HelpTab3Question8": "When will I receive my order after paying the deposit?",
    "HelpTab3Question9": "If I pay today, when will my order be shipped from China?",
    "HelpTab3Answer1": "Select the desired products on the site, specify the quantity, colour, size, add to the cart and wait for confirmation from the factory, after completing the request, click \"Place Order\". On the order page, fill in your information and click \"Send Order\".",
    "HelpTab3Answer2": "No. The minimum order is one carton.",
    "HelpTab3Answer3": "You can select the quantity of one carton when you add an item to your cart, and in the cart you ask the factory for your request, if the factory responds and agrees, you can order it.",
    "HelpTab3Answer4": "<div> <p>1. Before payment, the buyer signs a supply contract with ESSAONE.COM's representative office in the Russian Federation, i.e. with a resident company.</p> <p>2. We will send the buyer a payment invoice and wait for the buyer's transfer.</p> <p>3. When we receive the buyer's payment, we will credit the funds to his ESSAONE payment account (i.e. \"wallet\") and he will need to use the \"wallet\" to pay the deposit and the balance.</p> </div>",
    "HelpTab3Answer5": "No, all orders are transferred to production upon payment of a deposit and delivered to the customer upon completion of full payment.",
    "HelpTab3Answer6": "You can cancel your order directly in \"My order\".",
    "HelpTab3Answer7": "No, so you need to check all items carefully before paying the deposit.",
    "HelpTab3Answer8": "Orders are confirmed after deposit and an updated estimated time of arrival is displayed.",
    "HelpTab3Answer9": "This depends on the production and delivery times to the loading yard. On the site, each item page shows the production time and the approximate delivery time.",
    "HelpTab4Question1": "How to deliver? How do I pick up the goods?",
    "HelpTab4Question2": "Can I track my order on the website?",
    "HelpTab4Question3": "What is the guarantee?",
    "HelpTab4Question4": "Is quality guaranteed? What should I do if I am not satisfied with the quality?",
    "HelpTab4Question5": "What are the closing documents?",
    "HelpTab4Answer1": "Containers are delivered via 2 routes: high-speed trains via China-Moscow or sea freight via China-Vladivostok. After the goods arrive at the warehouse, there is self-delivery or collection by a transport company (paid by the customer).",
    "HelpTab4Answer2": "Yes,you can track the order process online.  Please click on \"My account\" - \"My order\" in the top right corner of the homepage. On the order list page you can see the current status of your order. If you click on the order status, more information will appear.",
    "HelpTab4Answer3": "<div> <p>We provide a guarantee for the orders and their transportation from China to Moscow/Vladivostok's warehouse.</p> <p>Best Price Guarantee - If buy cheaper,we'll pay you the difference.</p> <p>Shipping Guarantee - Compensation for late delivery.</p> <p>Quality Guarantee -Compensation or refund.</p> </div>",
    "HelpTab4Answer4": "We have a quality guarantee and if there are quality problems, we will compensate or refund according to the detailed situation.If you find faults or shortages, you should send the claim to us on the website, enclose appropriate photos/videos  to review and find the best solution.",
    "HelpTab4Answer5": "We provide the following documents: The UDP and certificates are in electronic format, and the UDP includes the goods declaration number.",
    "PingTaiJiaoYiShuJu": "Platform trading data",
    "YiZhiFuDingJinDingDanTongJi": "Статистика заказов с внесенным депозитом",
    "WeiZhiFuDingDanTongJi": "Unpaid Orders Statistics",
    "WeiFuKuanJinE": "Amount outstanding",
    "WeiFuKuanYongHuShu": "Количество клиентов не внесших оплату",
    "BenYueYongHuTongJi": "User statistics for this month",
    "XiaDanKeHu": "Number of customers placing orders",
    "ZhuCeYouXiaoKeHu": "Зарегистрированные активные клиенты",
    "DangJi": "За квартал",
    "DangNian": "За год",
    "ChengJiaoXinKeHu": "Number of new customers who have ordered",
    "DaiWanShan": "To be improved",
    "YiWanShan": "Завершено",
    "ShouSouShangPinBianHao": "Search by item number",
    "XinYiPi": "New batch",
    "ShuXin": "Attribute",
    "ZhiFuWeiKuan": "Оплата окончательного платежа",
    "QingShuRuShangPinPinMin": "Введите название товара",
    "JiaFu": "Delivery",
    "YunShuYuPeiSong": "Logistics and delivery",
    "HuiYuanTiXi": "Membership Program",
    "JiaRuHuiYuanZunXiangTeQuan": "Join the membership, enjoy the privilege!",
    "HuoWuGenZong": "Shipment tracking",
    "QuChaXun": "Go to view",
    "GengXinShiJian": "Update time",
    "TiDanXinXi": "B/L information",
    "DianFang": "Telex release",
    "DianFangDanYuanZheng": "Electric discharge of the original document certificates",
    "KuaiDi": "courier",
    "KuaiDiDanSaoMiaoJian": "Scanned documents of logistics",
    "YiQueRenZengJiaGouMaiXiangShuKeXiaDan": "Confirmed, add more boxes to your order",
    "ManJianMianQiSongFei": "Free delivery fee of {1} for {0} cartons or more",
    "BuManJianGongYingShangXuJiaShouQiSongFei": "For less than {0} cartons, this supplier will add {1} delivery fee. If you order more than {0} cartons from this supplier, the delivery fee will be waived.",
    "HunPiCaiGou": "Mixed purchase",
    "YiJiangJia": "Price reduced",
    "GouMaiXiangShuXiaoYuGongChangYaoQiu": "Awaiting factory confirmation as the quantity purchased is less than the factory's MOQ.",
    "ShangPinYiShiXiao": "Товар больше не доступен",
    "GaiShangPinYiGuoJiaGeBaoH2": "The price protection period for this product has expired, please reconfirm the price with the factory.",
    "SouSuoGouWuShangPin": "Search for shopping products",
    "YouHaoTuiJian": "Recommendation",
    "JiaGeYouXiaoQiZhi": "Prices valid until",
    "YiZaiGouWuChe": "Already in the cart",
    "GaiGongYingShangDeShangPinBuManJian": "A delivery fee of {1} will be charged for orders of less than {0} cartons from this supplier.",
    "JiXuXiaDanHuiChanShengEWaiDeQiSongFei": "If you check only these items to place order, a delivery fee will be added.",
    "HanZengZhiShuiFei": "Includes VAT fee",
    "QiSongFei": "Delivery fee",
    "GaiGongYingShangDeShangPinBuManJian2": "This supplier will add {0} delivery fee. If you order more than {1} cartons from this supplier, the delivery fee will be waived.",
    "LianHeDingGou1": "You can order a smaller quantity in a joint purchase. The waiting time for participants is {0} days. If there is enough interest, the order will be placed.",
    "LianHeDingGou2": "Participate in Group Purchase",
    "GongYingShangHunPinQiYunFeiTiShi": "Tips on delivery fee for mixed purchases from suppliers",
    "GongYingShangSuoYouChanPin": "All products of the supplier",
    "ManMianQiSongFei": "Free delivery for {0} boxes",
    "HuanYingDengLuGongZuoTai": "Welcome to Workbench",
    "JiFenYuJiKeDiKou": "Points are expected to be paid",
    "HanQiSongFei": "Delivery fee included",
    "PinTuanChengGongHouFanHui": "Points can be used as collateral for group purchases. The points will be returned when you have paid the deposit.",
    "JiFenDiYa": "Points payble",
    "JiFenDiKouWeiKuan": "Paying the final payment with points",
    "ZengZhiShuiE": "VAT amount",
    "YiDingGou": "Ordered",
    "YiGengShaoZhuangLiangLianHeDingGou": "You can order a smaller quantity in a joint purchase. The waiting time for participants is {0} days. If there is enough interest, the order will be placed.",
    "CanYuLianHeDingGou": "Participate in Group Purchase",
    "GroupTip": "To ensure that every customer who wishes to join a joint order, a waiting period of 7 days has been set, if enough customers are added during the purchase period, the order will be successfully formed and sent to the factory for production. Otherwise the order will not be formed. The deposit paid or points used will be refunded.",
    "ManJianMianQiSongFei2": "Free delivery fee of {1} for {0} cartons or more",
    "ChaoJiYouHui": "Super Discount",
    "XinKeHuZhuanXiang": "Exclusive for new customers",
    "XinKeHuZhuanXiangBiaoTi1": "Sign up and get {0} coupons. Minimum 4% off your first order！",
    "XinKeHuZhuanXiangFuBiaoTi1": "The coupons is issued from the time of successful registration and is valid for 30 days.",
    "XinKeHuZhuanXiangBiaoTi2": "Only {0} deposit for your first order! Risk free trial order.",
    "XinKeHuZhuanXiangFuBiaoTi2": "The privilege is valid for the first order only (except for orders of special offers). Only 1 time per new customer",
    "XinKeHuZhuanXiangBiaoTi3": "Get {0} more coupons after your first order.",
    "XinKeHuZhuanXiangFuBiaoTi3": "The coupons is issued after the deposit has been paid from the first order and is valid for 90 days.",
    "XinKeHuZhuanXiangBiaoTi4": "After placing your first order, you will become a member the following month.",
    "XinKeHuZhuanXiangFuBiaoTi4": "One order and you get lifetime member benefits. Members enjoy more discounts on points and better deals on orders!",
    "MaShangXiaDan": "Take advantage of all the offers and place your order now!",
    "ZhuYiShiXiang": "Notes",
    "XinKeHuZhuanXiangZhuYiShiXiangNeiRong": "1. Only users who have registered with ESSAONE but have not placed their first order can enjoy this offer. <br />2. All coupons are not stackable and only one coupon can be used per order. The system will default to the largest coupon amount when placing an order based on the currently available coupons. <br />3. Once a coupon has been used, it will only be refunded if the order is cancelled for all items. If the order is only partially cancelled, the coupon will not be refunded.",
    "DiYiBiDingDanBaoZhengJin": "First order deposit",
    "DingDanJinEBuXian": "Orders of any amount",
    "YiZeKou": "Points have been paid",
    "XianShiXiaoShouJia": "Display the sale price",
    "XiaoShouJiaGeSheZhi": "Sales price configuration",
    "WoDeXiaoShouJia": "My sale price",
    "MaoLiLv": "Gross margin",
    "ZengZhiShuiLv": "VAT rate",
    "HaiGuanShuiLv": "Customs duty rates",
    "ShaoHouZaiShi": "Try again later",
    "MaShangSheZhi": "Set up now",
    "SheZhiWoDeJiaGe": "Set my prices",
    "ShiShiYuLanXiaoShouJiaGe": "Real-time preview of the sale price, which is visible only to you and does not have any impact on your purchasing price.",
    "XiaoShouJiaGongShi": "Sale price = (FOB price + sea freight cost/PCS + customs clearance cost/PCS) × (1+ customs duty rate) × (1+ markup rate) × (1+ value-added tax)",
    "GenJuZhongGuoRenMinYinHangDeHuiLvMei24XiaoShiGengXin": "The exchange rate is updated every 24 hours.",
    "MeiYuan": "US Dollar",
    "HaiYunFei / LuYunFei": "Sea freight / Land freight (USD)",
    "ZaiYeMianXianShiWoDeXiaoShouJia": "Display my sale price on the page",
    "QingGuanFei（HuoDaiFeiYong）": "Customs clearance fee (freight forwarder fee) (USD)",
    "YuJiXiaoShouJia": "Estimated sale price",
    "QingTianXieWanZhengDeBiTianXiang": "Please fill in all required fields",
    "KaiQiShiShiYuLanWoDeYuJiXiaoShouJia": "Enable real-time preview of my estimated sale price",
    "ShiYongJiFenDiKouMaShangShengQian": "Use points to pay, shop profitably!",
    "DangQianJiFenKeShiYong": "A balance of {0} points, you can use {1}  points to pay {2} {3}.",
    "DanQianHuiYuanDengJiZuiDaDiKou": "Your membership grade is Lv.{0} now, and you can pay with points up to {1}% of your order.",
    "DingJinBiLi": "Deposit payment rate",
    "GouXuanDeShangPinHanYouPinTuanShangPin": "You cannot initiate a request for quotation because the checked item contains the group purchase.",
    "BuManZuGongChangQiDingLiangYaoQiu": "Does not meet factory MOQ requirements.",
    "PinTuanShangPinBuNengChongXinXunJia": "Group purchase items cannot be re-quoted.",
    "JiFenBuZu": "Not enough points",
    "ShiYongJiFen": "Use the points",
    "YiDingJinDeFangShi": "Pay with deposit",
    "XuDiYaNJiFenChengGongShiBaiFanHui": "This order contains a group purchase and requires a deposit of {0} points to place the order. Points will be refunded if the order is unsuccessful or if the order is successful and you make a deposit.",
    "XuNJiFenJiFenBuZuN": "The order contains group purchase goods, the order needs to pledge {0} points. Current points {1}, not enough for collateral. You can participate in the group purchase by paying a deposit within 3 days.",
    "WoMenJinTiGong30TianMianFeiCangChu": "Please pay the final payment as soon as possible, we only provide 30 days free storage.",
    "TiHuoCangKu": "Pick-up warehouse",
    "DangQianJiFenNBenDanDiYa": "Current points {0}, this order needs to pay {1} points.",
    "ZanWuFaQueRen": "Unable to confirm",
    "DinDanTongJi": "Order statistics",
    "SouSuoKeHuBianHaoHuoMinCheng": "Search by customer id or name",
    "ShengChangZhongDinDan": "Orders in production",
    "DaiFuWeiKuanDinDan": "Pending final payment orders",
    "YiTiHuoDinDan": "Picked-up orders",
    "KeHuDeYuE": "Customer's balance",
    "ShengChanZhongDingDan": "Orders in production",
    "DaiFuWeiKuanDingDan": "Pending final payment orders",
    "YiTiHuoDingDan": "Picked-up orders",
    "ShouDan": "First order",
    "JiFenMeiXiangKeDiKou": "Points can reduce the price of each carton by {0}",
    "RuGuoYouSanCuWenJian": "If there are deleted files, they cannot be undone or restored after confirmation.",
    "JiGuiWenJianGuanLi": "Container document management",
    "ZhiCiWenJianGeShi": "Supports {0} file formats, up to {1}M",
    "HuanGuiWenJian": "Documentation for the return of containers",
    "YiHuanGui": "Containers returned",
    "YunDanWenJian": "Shipping documents",
    "QiTaWenJian": "Other documents",
    "ShangChuanWenJian": "Uploading documents",
    "DangQianJiFenNBenDanDiYaJiFenBuZhu": "Currently have points {0}, this order requires a deposit of {1} points. However, the current points balance is not sufficient to pledge, please use the paid deposit to participate in the group purchase.",
    "QueRenShengChanYaoQiuZhon2": "Production requirements are being confirmed,so the quantities cannot be adjusted.",
    "WoTongYi": "I agree",
    "YiZhiFuDingJinDaiChengTuan": "Have paid the deposit, waiting for the group purchase success.",
    "GouMaiXiangShuXiaoYuGongChangYaoQiu2": "Production requirements are being confirmed and quantities cannot be adjusted.",
    "SouSuoKeHuDingDanJiGui": "Search for Customer/Order/Container Number",
    "JiFenShuoMing": "Подробнее о баллах",
    "GenJuYongHuZhuYaoShiYongYuYanShuRuJiKe": "Just enter it in the user's primary language",
    "FaPiaoShangDeBianHao": "Invoice number",
    "HaiGuanDaiMa": "Код таможни",
    "ChanPinMiaoShu": "Описание товара",
    "ShangBiao": "Торговая марка",
    "XingHao": "Модель",
    "DaiMaDanWei": "Code unit",
    "JiLiangDanWei": "Unit of measure",
    "ZongXiangShu": "Общее количество коробок",
    "ChengBen": "Стоимость",
    "JiaGeZhuanHuan": "Пересчет цены",
    "YunShuChongXinJiSuan": "Пересчет стоимости доставки",
    "ZengZhiShui(ChongXinJiSuan)": "НДС (перерасчет)",
    "XuKeZhengWenJian": "Разрешительный документ",
    "ShangChuanTianCong": "Upload",
    "FeiYongChongXinJiSuan": "Стоимость (пересчет)",
    "YuanYuJiZhuangGuiRiQi": "Original estimated loading date",
    "MingSKCangKu": "Minsk District, Borovlansky Village Council, 40 Let Pobedy Street, 19",
    "CangKuTuiJian3": "Minsk warehouse serves customers in all regions of Belarus.",
    "BaiEXinRenYouHuiQuanTiShi1": "Exclusive for new customers",
    "BaiEXinRenYouHuiQuanTiShi2": "Get {0} discount coupon right after registration. Get up to 5% off your first order!",
    "BaiEXinRenYouHuiQuanTiShi3": "The coupons is issued from the time of successful registration and is valid for 30 days.",
    "MaShangXiaDan2": "Offer is limited, order now!",
    "XinKeHuZhuanXiangZhuYiShiXiangNeiRong2": "1. This promotion is only available to new users registered on ESSAONE from October 1, 2023. <br />2. Coupons are not cumulative; only one coupon can be applied to one order. When placing an order the system will by default offer the coupon with the largest amount, out of all the available.<br />3. Once the coupon is used, it will only be refunded if the order is cancelled for all items. If only some items are cancelled, the coupon will not be refunded.",
    "BaiEGouWuCheAnNiu": "Orders will be accepted from June 1",
    "BaiEMeiYaoQing1WeiHaoYouZhuCeJiKeHuo": "Welcome to our invitation bonus program!Invite your friends (non-competitors) and share bonuses with them!<br> Every time you invite a friend to register and place an order, you can get a 750 BYN coupon, and friends you invite to register can also get a newcomer coupon.",
    "BaiEHaoYouZhuCeChengGongKeHuoDe": "Friends who register successfully can get a 750 BYN coupon.",
    "BaiENiKeDeYiZhangDaiJiHuoJuan": "After your friends register, you can get a 750 BYN coupon to be activated, which is not yet effective. After friends places the first order, the coupon will be activated and can be used.",
    "ZuiJin": "Recent searches",
    "GongZuoShiJian": "Working hours",
    "YiChang": "Exceptions",
    "DingDanXiaoXi": "Order Messages",
    "SouSuoDingDanBianHao": "Search Order Number",
    "XiaDan": "Order",
    "DingDanYiQuXiao": "Order canceled",
    "NKuanNXiang": "{0} items, {1} cartons",
    "YiShangWeiBenDingDanXinXi": "The above information is for this order.",
    "DingGouShuLiang": "Order Quantity",
    "ZengZhiShui": "VAT",
    "JinEHanShui": "Amount (including tax)",
    "QingGuanDanHao": "Customs Clearance No.",
    "SuoYouCangKu": "All warehouses",
    "SheZhiQuanXian": "Setting up Permissions",
    "KeYiShiYongNaXieGongNeng": "What functions are available",
    "KeYiCaoZuoNaXieGuoJiaDeShuJu": "Which countries' data can be manipulated",
    "CanYuNaXieRenWuFenPei": "What tasks are involved",
    "MuDiCangKu": "Destination warehouse",
    "QueRenRuKu": "Confirmation of arrival at warehouse",
    "QingGuanDanDanHao": "Customs Clearance Number",
    "SuoZaiCangKu": "Warehouse",
    "ShengChengDanJu": "Generate documents",
    "DiaoBo": "Channel (goods)",
    "DaiDiaoBo": "To be allocated",
    "DiaoBoZhong": "in the pipeline",
    "SouSuoPODanHaoHuoKeHuBianHao": "Search for order number or customer number",
    "DangQianCangKu": "Current warehouse",
    "YiDaoDaiChuKu": "Move to \"Waiting for delivery\"",
    "HeJiNGeKeHuNGeDingDan": "Total {0} clients, {1} orders",
    "SouSuoGuoJia": "Search countries",
    "PiLiangDiaoBoDeDingDanCangKuShuJuXuYaoYiZhi": "The warehouse data needs to be the same for orders that are deployed in bulk!",
    "QueDingYiDaoDaiChuKu": "Determine to move to \"Waiting for delivery\"",
    "DiaoBoShiJian": "Timing of transfers",
    "CheXiaoDiaoBo": "Cancel the transfer",
    "QueDinCheXiaoDiaoBo": "Confirmation of de-deployment",
    "RuKu": "Arriving at the warehouse",
    "QueRenDiaoBoRuKu": "Confirmation of redeployment to warehouse",
    "RuKuRiQi": "Date of warehouse",
    "RuKuChengGong": "Successful arrival at the warehouse",
    "JiFenZhangHu": "Point account",
    "WoYaoZhaoYang": "Looking for a sample",
    "MiaoShuNiYaoZhaoDeShangPin2": "Describe the product you are looking for",
    "MiaoShuXuYaoZhaoDeShangPi2": "Please enter a description",
    "YiYouZhiLiao2": "Provide information / pictures",
    "JieZhiRiQi": "Deadline",
    "QingXuanZeJieZhiRiQi": "Please select a deadline",
    "NGeGongZuoRi": "{0} working days",
    "SheDingRenWuBiXuZaiDuoShaoGeGong": "Set the number of working days in which the task must be completed in (days)",
    "JiXuFaBu": "Continue posting",
    "ZhaoYangRenWuYiFaBuChengGong": "The sample search task has been posted successfully, you can go to My Sample Search to view it.",
    "DangQianZhangHuWeiRenZheng": "If your account is not certified, you will not receive a response to your task.",
    "QianWangRenZheng": "Go to Authentication",
    "DangQianZhangHuDaiRenZheng": "If your account is not certified, you will not receive a response to your task.",
    "RenWuFenPeiZhong": "Task Assignment",
    "YiGuaQi": "Suspended",
    "QingXuanZeYaoCaoZuoDeShuJu": "Пожалуйста, выберите данные",
    "KeHuQianBao": "Кошелек клиента",
    "KeHuDangQianQianBaoSuoShuGuoJia": "Страна текущего кошелька клиента",
    "ZanMeiQueRen": "Пока не подтверждено",
    "SuoShuGuoJia": "Страна",
    "WuQuanXian": "Нет разрешения",
    "ZhangHuGuoJia": "Страна учетной записи",
    "YiChuHuoJiGui": "Shipped containers",
    "YuChuHuoJiGui": "Контейнер, ожидающий отправки",
    "DengLuMing": "Логин",
    "JiFenDuiHuan": "Обмен баллов",
    "ShangPingZhengShuBianHaoChongFu": "Duplicate Product Certificate Number",
    "QingShuRuZhengShuBianHao": "Please enter the certificate number / remark to search",
    "YouXiaoQiZhi": "Valid until",
    "QingXuanZeShiFouYouShangPinZhengShu": "Please select whether there is a product certificate",
    "QingXuanZeShangPinZhengShu": "Please select the product certificate",
    "HaiGuanShangPinBiaoMiaoShu": "Description of customs commodity table",
    "ShiYongLeiMu": "Applicable category",
    "ZhengShuBianHao": "Certificate number",
    "ZhengShuBeiZhu": "Certificate remark",
    "ZhengShuWenJian": "Certificate file",
    "ZuiDuoShangChuan5Zhang": "Maximum 5 files, less than 10 MB .pdf, .jpg, .jpeg, .png",
    "QingXuanZeShiFouYouZhengShu": "Please select whether there is a certificate",
    "NinShangWeiXuanZeZhengShu": "You have not selected a certificate",
    "WuZhengShuChuHuo": "Shipment without certificate",
    "ZhengShuGuanLi": "Certificate Management",
    "XinZengZhengShu": "Additional Certificates",
    "ShuXing": "Properties",
    "SouSuoShangPinBianHao": "Search item number",
    "ZuiDuoZhiNengShangChuan5GeWenJian": "Maximum of 5 files can be uploaded.",
    "ChongXinSheZhiTieZhi": "Reset the sticker",
    "HuanYingDengLu": "Welcome to login",
    "ZhuCeXinZhangHao": "Register a new account",
    "PinTuanShuoMing": "Совместная закупка",
    "HuaGengShaoDeQianCaiGouGengDuoKuanShi": "Приобретайте больше стилей, тратя меньше денег",
    "QuXiaoZhaoYang2": "Cancel Sample Search",
    "ZhaoDaoDeShangPin": "Found products",
    "DaoChuQuanBuShangPin": "Export all products",
    "DaoChuSuoXuanShangPin": "Export selected products",
    "QuXiaoXuanZe": "Cancel selection",
    "BuChongZiLiaoTuPian": "Additional information/images",
    "YanQiZhi": "Postponed to {0}",
    "JueDeDangQianJieGuoBuGouManYi": "Feel that the current results are not satisfactory enough",
    "BuChongMiaoShu": "Additional description",
    "QingBuChongMiaoShu": "Please add a description",
    "ShangChuanWenJian2": "Upload files, support images/compressed packages/Excel, single file support up to 200M, upload up to 5 files",
    "YanQi": "Extension",
    "QingXuanZeYanChiDuoShaoGeGongZuoRi": "Please choose how many working days to delay",
    "YanQiXinXi": "Extension Information",
    "RenWuYanQi": "Mission extension",
    "YanQiChengGong": "Postponement successful!",
    "MeiYouTuiJianShangPin": "No product recommendations",
    "NTianHouRenWuJieShu": "Task ends in {0}  days",
    "YiZhaoDao": "Found",
    "KuaJingB2BXinPinCaiGouPingTai": "B2B New Product Procurement Platform - Made in China, Toys, Sports & Fitness Products, Outdoor Activity Products, Festival Products",
    "XinYongHuMianFeiZhuCeZhangHao": "Free sign up for my account",
    "QingShuRuYouXiang": "Please enter your email",
    "YouXiang2": "Email",
    "YiYouZhangHao": "Already have an account?",
    "YouXiangYanZhengMa": "Email code",
    "YiFaSong": "Sent",
    "QingShuRuYouXiaoDeGongSiMingCheng": "Please enter a valid company name.",
    "FaQiZhaoYang": "Requesting product search",
    "TuiJianZhuTiMingCheng2": "Searching for past recommendations",
    "JinTian": "Today",
    "YiZhaoWan": "Completed",
    "HaiGuanGuanQiaTongXingJianChaZhan": "<p>1. To {0} Customs barrier pass checkpoint: {1} ({2} kilometers);</p>",
    "HangXianMingCheng": "Route Name",
    "BuManYiYuanYin": "Reasons for dissatisfaction",
    "QingTianXieBuManYiYuanYin": "Please fill in the reason for dissatisfaction.",
    "JieGuoBuManYi": "Unsatisfactory results",
    "FaQiRenDuiZhaoYangJieGuoBuManYi": "Initiator is not satisfied with the results of the sample search.",
    "KeYuYueTiHuo": "Pickup available by appointment",
    "YiFaHu": "Dispatched",
    "DaiYuYue": "Waiting for Appointment",
    "YuYueTiHuo": "Pickup Appointment",
    "NiZhunBeiRuHeTiHuo": "Please choose the pickup method from the warehouse:",
    "TiJiNZhongLiangN": "Volume {0} , Weight {1}",
    "NGeDingDan": "{0} orders",
    "ZiJiYuYueWuLiuGongSiDaoCangKu": "Pick up from the warehouse by booking a logistics company on your own.",
    "ZiTiFangShi": "Self-pickup method",
    "GeRenZiTi": "Self-pickup",
    "ZiJiKaiCheQianWangCangKu": "Drive yourself to the warehouse.",
    "ShiYongWoMenHeZuoDeWuLiuGongSi": "Choose our recommended logistics company",
    "QianWangTiHuoShiJian": "Pickup time",
    "LianXiRenXingMing": "Name of contact person",
    "WuLiuGongSiMingZi": "Logistics Company Name",
    "ShangPinShiFouXuYaoDaMuJia": "Do you need additional protective packaging?",
    "DaMuJiaTiShi": "Please indicate whether additional protective packaging (e.g. wooden racking) is required according to the nature of the goods. Depending on whether the shipment is wooden-framed or not, the volume/weight of the shipment and transportation costs may increase accordingly.",
    "XuYaoDaMuJia": "Additional protective packaging required",
    "MeiGeMuJiaFeiYongTiShi": "Please specify additional packaging requirements.",
    "QuanBuBuXuYao": "None of it.",
    "YinWuLiuHuoSunZiJiChengDan": "Please note that we are not responsible for any damage that may occur to the goods during their next transit.",
    "XuanZeWuLiuGongSi": "Selecting a Logistics Company",
    "WuFaJiaZaiDiTuZuJian": "Unable to load map component",
    "PiLiangYuYue": "Batch Reservation",
    "PiLiangYuYueTiHuo": "Bulk booking for pickup",
    "YuXiaMianDingDanYiQiTiHuo": "Pick up with the order below.",
    "DingDanSongZhi": "Orders delivered to",
    "PinTuanShengYuShiJian": "Remaining time of the group purchase",
    "ZanBuYuYue": "No Reservation",
    "YiXiaDingDanYiRuKu": "The following orders have arrived at the warehouse, please make an appointment to pick them up as soon as possible.",
    "YiXiaDingDanYiZhiFuWeiKuan": "The following order has been paid for and is in transit and is expected to arrive in {0}. Would you like to schedule an appointment to pick it up together?",
    "XuanZeDingDan": "Select Order",
    "TiJiaoYuYue": "Submit an Appointment",
    "RuKuTingCangTiShi": "There is a free storage period of {0} after arrival at the warehouse, after which {1}/m³/day will be charged.",
    "ChaKanDingDan": "View Order",
    "WoMenHeZuoDeWuLiuGongSiYou": "We work with these logistics companies.",
    "GenJuNiDeDingDan": "Depending on your order, the following logistics companies may be suitable.",
    "ZiJiDaoCangKuTiHuoMianFei": "Pick up at the warehouse yourself, free of charge!",
    "WuLiuGongSiXinXi": "Logistics Company Information",
    "ZiJiLianXiDiSanFangWuLiuGongSiDaoCangKuTiHuo": "Contact the logistics company by yourself to pick up the goods at the warehouse.",
    "WuLiuDanHao": "Logistics Order Number",
    "WuLiuGongSiLianXiBuShangKeYiLianXiYiXiaRenYuan": "If you are unable to contact the logistics company please contact the following",
    "ShiYongPingTaiZhiDingDeWuLiuGongSi": "Save money by using our recommended logistics companies for delivery services!",
    "HuoSunFeiYongXieYi": "“Agreements on the parties' liability”",
    "PoSunZiFuXieYi": "Agreements on the parties' liability",
    "DaMuJiaTiShi2": "If you do not install a wooden frame, please be responsible for any damage to fragile goods during transportation.",
    "HuoSunFeiYongXieYiNeiRong": "Contents of “Agreements on the parties' liability”",
    "BuTongYi": "Disagree",
    "XuanZeShouHuoDiZhi": "Select shipping address",
    "ZuiZhongYiWuLiuGongiShouFeiWeiZhun": "Prices are for reference only and subject to the final charges of the logistics company.",
    "WuLiuFaChuRiQi": "Date of dispatch",
    "ShiYongSongHuoFuWu": "Use of delivery services",
    "QingXuanZeDingDan": "Please select order",
    "ZhunBeiYuYueDeDingDan": "Preparing orders for reservations",
    "CangKuGongZuoShiJian": "Warehouse hours",
    "TiHuoDan": "bill of lading (for goods)",
    "TiHuoXinXi": "Pickup information",
    "QuXiaoYuYue": "Cancel Appointment",
    "YiWanChengTiHuo": "Pick-ups completed",
    "ZaiCiYuYue": "Make another appointment",
    "TiHuoFangShi": "Pickup method",
    "MianFeiTingCangQi": "Free Warehousing Period",
    "KaiShiShouFeiYiChanShengNTianFeiYong": "Started to charge, already incurred {0} days of costs",
    "RuKuTingCangTiShi2": "{0} to {1}. {2} m³ has incurred {3} storage costs ({4}/m³/day).",
    "NZhiN": "{0} to {1}",
    "RuKuTingCangTiShi3": "Free storage up to {0}, after that time you will be charged {1} per day.",
    "XuSongChe": "Delivery to a logistics warehouse is required.",
    "YiTiHuo": "Pickup completed",
    "QuanBuLeiXing": "All types",
    "MianFeiTingCangZhi": "Free warehousing until",
    "TiHuoShiJianShengYu": "There is only {0} time left for pickup, no pickup will continue to be charged for storage.",
    "YiChanShengNTianFeiYong": "Costs incurred for {0} days",
    "QingGuanDengJi": "Customs clearance registration",
    "QingGuanZhuangTai": "Customs clearance status",
    "KaiShiQingGuan": "Starting customs clearance",
    "QingGuanWanCheng": "Customs clearance completed",
    "QingGuanBeiChaGui": "Customs is inspecting containers.",
    "GengXinQingGuanXinXi": "Updated Customs Clearance Information",
    "YiDaDao": "Arrived",
    "WuLiuGenJin": "Logistics information follow-up",
    "GengXinWuLiuXinXi": "Updated logistics information",
    "GengXin": "Update",
    "JiGuiJuLiCangKu": "Container distance to warehouse",
    "WuLiuXinXiGuanLi": "Logistics Information Management",
    "ZhiChiSouSuoFuWuChengShiWuLiuGongSi": "Search City/Logistics Company",
    "WuLiuGongSi": "Logistics Company",
    "FuGaiChengShi": "Covered cities",
    "XinZengWuLiuGongSi": "New logistics companies",
    "BianJiWuLiuGongSi": "Edit Logistics Company",
    "WuLiuGongSiMingCheng": "Logistics Company Name",
    "LianXiRenMinCheng": "Contact Name",
    "LianXiRenDianHua": "Telephone Number",
    "ChePaiHao": "License Plate Number",
    "SiJiXingMing": "Driver's name",
    "QueRenWuLiuGongSi": "Confirmation of logistics company",
    "ESSAONETiGongMianFeiSongCheFuWu": "ESSAONE offers a free delivery service, i.e. we will deliver your goods to the logistics point, allowing you to save on transportation costs from our warehouse to the logistics point. However, our delivery time is only once a week on Wednesdays. If you check the box, it means you accept and agree to it.",
    "XinZengLianXiRen": "Add Contacts",
    "ShanChuHouBuYingXiangYiTuiJianDeDingDan": "Please confirm whether you want to delete this logistics company? Deleting it will not affect orders that have already been recommended.",
    "DangQianJiGuiYouBuTongCangKuDeDingDan": "Current container has orders from different warehouses.",
    "QingXuanZeQingGuanZhuangTai": "Please select the clearance status",
    "KaiShiQingGuanHouCaiNengCaoZuoQingGuanWanCheng": "Customs clearance can only be completed after the start of customs clearance.",
    "XinZengJiLuChengGong": "New record added successfully.",
    "QingShuRuJuLiCangKuGongLiShu": "Please enter the number of kilometers from the warehouse.",
    "QingGuanJiLu": "Customs clearance records",
    "JiGuiYiQingGuanWanCheng": "The container has been cleared.",
    "YiQingGuanWeiRuKu": "Customs cleared but not warehoused.",
    "WuLiuTuiJian": "Logistics Recommendations",
    "YiGuoZhongGuoBianJingNTian": "It's been over the Chinese border for {0} days.",
    "TiJiZhongLiang": "Volume & Weight",
    "BuNengChongFuKaiShiQingGuan": "Customs clearance cannot be duplicated.",
    "ChuHuoFangShi": "Shipment method",
    "TuiJianWuLiuGongSi": "Recommended Logistics Company",
    "TianXieYuJiWuLiuFeiYong": "Fill in the estimated logistics cost for 1 m³ (in {0})",
    "YiTuiJian": "Referred",
    "WeiTuiJian": "Not recommended",
    "QingXuanZeWuLiuGongSi": "Please select the logistics company.",
    "QingShuRuDaYuLingDeShuZi": "Please enter a number greater than 0, up to two decimal places.",
    "HuoWuDaoNiSuoZaiChengShiWuLiuFeiYong": "Estimated logistics costs for delivery to your city （{0}） is  {1}.",
    "SongZhiNiZhiDingShouHuoDiZhi": "Delivered to your designated delivery address.",
    "FeiYongWeiZhiFu": "Costs unpaid",
    "XinZengJiLu": "New record",
    "QinShuRuYouXiangYanZhengMa": "Please enter the email verification code",
    "MeiZhaoDaoJieGuo": "No results.",
    "WuLiuGongSiGuanWang": "Logistics Company Official Website",
    "JiSuanWuLiuFeiYongQingZhuanDao": "To calculate logistics costs, please go to",
    "ChengGongGengXinNTiaoShuJuNTiaoShiBai": "Update {0} data success, {1} failed",
    "XuanZeDiZhi": "Select an address",
    "XinZengHouWuFaXiuGaiQingQueRen": "Cannot be modified after adding, please confirm",
    "MeiYouGaiChengShiShiPeiDeWuLiu": "No suitable logistics company in this city",
    "YuYueXinXi": "Reservation Information",
    "TuiJianWuLiu": "Recommended Logistics",
    "HeZuoWuLiu": "Cooperative Logistics",
    "GenJuNiSuoZaiChengShiKeNengHeShi": "Depending on your city, it may be appropriate.",
    "TongYiPiCiYuYueZhiNengXuanZeTongYiGeMuDiCangKu": "Only one destination warehouse can be selected for the same lot reservation.",
    "JiSuanCuoWUJinEWei0": "Calculation error, the amount is 0.",
    "YiZhiFuGuoFeiYongBuNengQuXiao": "You can't cancel a reservation after the fee has been paid.",
    "GongSiMingChengYiCunZai": "The company name already exists.",
    "YiJingQingGuangWanCheng": "Customs clearance completed",
    "QingWuChongFuDengJi": "Please do not re-register",
    "CunZaiWeiZhiDeTingCangFeiYong": "The order has unpaid storage charges and is not allowed to be shipped.",
    "YiCunZaiYuYueBuXuYaoJiXuTuiJian": "No referrals needed for existing appointments.",
    "RuKuTingCangTiShi4": "{0} to {1}. {2} m³ has incurred {3} storage costs ({4}/m³/day). Please schedule a pickup as soon as possible.",
    "QingXuanZeRenWu": "Please select a task",
    "PeiSongFuWuZhiNengYuYueZhouSan": "Delivery service can only be booked on Wednesdays.",
    "DingDanYiJingYuYue": "The order has been booked, please go to the pending pickup list to operate the shipment.",
    "XiaoShouJiaGongShi2": "My Sales Price = FOB Price + Sea Freight + Customs Clearance Fee + Customs Duty + Profit",
    "QingKong": "Clear",
    "XiaoShouJiaGongShi3": "Sales Price = (FOB Price + Sea Freight/PCS + Customs Clearance Fee/PCS) × (1 + Customs Duty Rate) × (1 + Profit Margin) × (1 + Value Added Tax)",
    "XianShiDeBiZhong": "Displayed currency",
    "XiuGaiBiZhong": "Change the currency",
    "XiuGaiXiaoShouGuoJia": "Change the sales country",
    "ZuiHouGenJinShiJian": "Last modification time",
    "ChaKanGongChang2": "More products",
    "GengDuoChanPin": "More products",
    "GenJinXinXi": "Customer information",
    "QinShuRuGenJinXinXi": "Please enter important information about the customer after each contact.",
    "GenJinJiLu": "Communication records",
    "ShuiWuHao2": "Tax No.",
    "ShouJiHao": "Cellphone No.",
    "FaSongShiJian": "Transmission time",
    "YouXiaoZhi": "Valid until",
    "TongGongChangChanPin": "Products from the same factory",
    "QiTaPinPaiXiangSiChanPin": "Similar products from other brands",
    "LiJiHuoQuBaoJia": "Get a quote now",
    "ZuiZao12XiaoShiNeiDaFu": "Reply within 12 hours at the earliest",
    "ZhiJieCongYuanTouWeiNinXuanZeZuiZhunQueDeChanPin": "ESSA selects the most accurate products directly from the source.",
    "ShouYeXunJiaBiaoTi": "Request For  Quotation",
    "SouSuoTuPianTongKuanChanPin": "Search for products matching the image.",
    "1080MSG0001": "Verification code verification failed.",
    "1080MSG0002": "Incorrect phone number",
    "1063MSG0004": "Incorrect or missing country dialing code",
    "1080MSG0003": "The verification code has expired, please obtain it again",
    "ZhiFuShiBai": "Payment Failed",
    "DaBaoYaoQiu": "Packaging requirements",
    "CLAIM_DAMAGE_130": "The order has not been received in the warehouse, so compensation cannot be initiated.",
    "SuoPeiYouHuiJuanShiBai": "Failure to claim the compensation coupon.",
    "ChuangJianYouHuiJuanShiBai": "Failed to create the coupon.",
    "XieShangZhongXuYaoBuTongYiJiLuCaiNengGuanBi": "Disagreement record is required in order to close the negotiation.",
    "CLAIM_DAMAGE_131": "This product has no claimable quantity left.",
    "CLAIM_DAMAGE_132": "This item is either not in stock or has already been shipped, and therefore, a return or after-sales operation cannot be initiated.",
    "YiXiaShangPinYiPoSun": "The following items have been broken.",
    "YiXiaShangPinMaiGuiLiao": "The following items are overpriced.",
    "PoSunShuLiang": "Quantities of damages",
    "TianXiePoSunChanPinShuLiangQingLiuYiDanWei": "Fill in the quantities of damaged products, and please pay attention to the units（of measure）.",
    "BuChongXinXi": "Additional information",
    "MiaoShuChanPinPoSunQingKuang": "Please describe the details of product damage and upload relevant photos (photos should be able to see the product and damage clearly)",
    "SuoPeiFangShi": "Methods of compensation",
    "ShouXuMaFanXuYaoTianXieFuZaDeShenQingBiaoGe": "This solution is cumbersome, firstly requiring you to fill out a complicated application form, and secondly waiting for financial clearance before paying you.",
    "XiaZaiShenQingBiaoGe": "Download the application form",
    "ShouXuJianDanShenHeTongGuoHou": "This solution is a simple procedure. When it has been approved, we will send a coupon to your account for the same amount of compensation, up to 50% off your order.",
    "ShangChuanShenQingBiao": "Upload the application form",
    "WenDang": "Files",
    "KeSuoPeiShuLiang": "Compensable quantities {0}",
    "LiShiYiShenQingPeiFuLe": "In the past, we've claimed {0}.",
    "FanHuiDingDan": "Return orders",
    "SuoPeiXiangQing": "After-sale details",
    "PeiChangJiangTongGuoYouHuiQuanFaFangDaoNiZhangHu": "Compensation will be made by issuing a coupon to your account, valid for {0} days, receipt of which constitutes agreement to the compensation program.",
    "PeiChangFangShi": "Methods of compensation",
    "YouHuiQuanKeYiDieJiaShiYong": "Coupons can be stacked for up to 50% off your order.",
    "LingQuWanDaoPeiFuYouHuiQuan": "Get a coupon of delay compensation",
    "SuoPeiChengGong": "Claims successful",
    "WanDaoSuoPeiChengGongMiaoShu": "Late Arrival Successful Description",
    "ShouHou": "After-sales claim",
    "JingPingTaJianChaFaXianNiDeHuoWuPoSun": "We check your goods have been broken, now we send you a compensation plan, please confirm in time.",
    "ShangPinYiPoSun": "Merchandise is broken.",
    "ShangPinMaiGuiLiao": "Goods are overpriced.",
    "ShiFouYaoCheXiaoSuoPeiShenQing": "Whether to cancel the claim",
    "ShouHouTuiKuan": "Compensation amount",
    "KeHuFaQi": "Initiated by the customer",
    "CangKuFaQi": "Initiated by the warehouse",
    "FaQiShouHouTuiKuan": "Apply for compensation",
    "DangQianShangPinYi PCSJiaGeWeiZhun": "Currently based on the PCS price of the item, ESSAONE Price: {0} / PCS.",
    "ShouHouTuiKuanChanPinShuLiang": "Quantities of products claimed",
    "KeHuGouMaiGongN": "Customer ordered a total of {0}.",
    "GaiBuFenHuoWuKeHuBuYaoLeXuYaoTuiKuan": "The customer abandoned the part of the merchandise and asked for a refund.",
    "QueRenPoSunQingKuang": "Quantity of damage confirmed (total {0})",
    "ZhengChangChanPin": "Intact products",
    "PoSunChanPin": "Damaged products",
    "ZhengChangChanPinJiangZiDongZhuanKuCunShangPin": "Intact products will be automatically converted to stock items and will be converted to full cartons.",
    "ShouHouFangAn": "Claims program",
    "ShouHouTuiKuanYiXianJinFangShiTuiGeiKeHu": "Compensate the client in cash and wait for the client to upload the application form before making payment.",
    "ShouHouTuiKuanYiYouHuiQuanFangShiTuiGeiKeHu": "Compensate customers by sending a coupon for {0} minus {1}.",
    "TiJiaoChengGongQingDengDaiKeHuChuLi": "Successful submission, please wait for customer confirmation.",
    "YiChuHuoJiGuiDanLieBiao": "List of shipped containers",
    "GuanBiPeiChang": "Closure compensation",
    "ShiFouYaoGuanBiSuoPeiShenQing": "Whether to close the claim",
    "PeiShenChuLi": "Compensation processing",
    "ShouQuanPeiShen": "Agree to compensation",
    "ZongPeiChangJiaZhiJinE": "Amount of compensation",
    "QingShuRuJieGuoShuoMing": "Please enter a description of the results",
    "JuLiShangCiChuLiYiDengDaiNTian": "Waiting {0} days since last processed.",
    "KeHuFaQiLieBiao": "Listings initiated by the customer",
    "CangKuFaQiLieBiao": "Listings initiated by the warehouse",
    "QueRenYiJingHuiKuanGeiKeHuJiangSuoPeiDanBiaoShiWeiYiHuiKuan": "Confirm that a transfer has been made to the customer and mark the claim as paid?",
    "ZongShouHouTuiKuan": "Compensation amount",
    "PeiFuJinE": "Amount of compensation",
    "QingShuRuJiaCha": "Please enter the price difference",
    "QingShuRuJinE": "Please enter the amount",
    "TiaoZhengShouHouTuiKuan": "Modify compensation",
    "DengDaiKeHuChuLi": "Waiting for customer confirmation",
    "QingXuanZeShouHouYuanYin": "Please select the reason for the claim.",
    "ShouHouYuanYin": "Reason for claim",
    "ShouHouChanPinShuLiang": "Quantities of products claimed",
    "DaiHuKuan": "Pending transfers",
    "QuanBuLeiXin": "All types",
    "PiLiangChuLi": "Batch solution",
    "YiHuiKuanDaoNiTianXieDeYinHan": "It has been transferred to the bank account you have filled in, please pay attention to the bank receipt information!",
    "YiPeiFuJiaZhiNDeYouHuiQuan": "We have compensated {0} coupon, valid for {1} days, please use it as soon as possible.",
    "YouWenTiChanPinShuLiangN": "Quantities of damaged products {0} {1}, have compensated a coupon of {2}, valid for {3} days, please use it as soon as possible.",
    "YouWenTiChanPinShuLiangN1": "The quantities of damaged products {0} {1}, you will be compensated with a coupon of {2} , valid for {3} days.",
    "FaQiPeiChangFangAn": "Send the compensation programs",
    "YiTongYiPeiChang": "Compensation has been agreed.",
    "YiHuiKuan": "Already payed",
    "YiTongGuoXianJin": "Payment of {0} has been made, please note the bank information!",
    "XieShangLiShi": "Record of consultations",
    "TongYiPeiChangFanAn": "I agree",
    "ShangChuanXianJinShenQinBiao": "Upload the application form",
    "XiaZaiShenQinBiaoGe": "Download the application form",
    "ShangChuanTip": "Support (xls,xlsx,pdf) format files, a single file cannot exceed 20M.",
    "ShenQinPeiChang": "Apply for compensation",
    "ShangChuanTip2": "Picture/video/document, support (mp4,flv,jpeg,jpg,png,bmp,doc,docx,xls,xlsx,pdf) format files, a single file cannot exceed 20M, up to 5.",
    "ChengGongGengXinNTiaoShuJuNTiaoShiBai2": "A total of {0} data were processed, {1} were successful.",
    "YouWenTiChanPinShuLiangN2": "Quantities of damaged products {0} {1}, have compensated a coupon of {2} , valid for {3} days, please use it as soon as possible.",
    "YouWenTiChanPinShuLiangN3": "Quantities of damaged products {0} {1}, have been compensated in cash  {2}, please note the bank information!",
    "GaiShangPinYiJingWuKeSuoPeiShuLiang": "This product has no claimable quantity left.",
    "DangQianShangPinYiQuanBuQuXiaoDengJi": "The product has been registered for cancellation, please <span class=\"color-blue\">close compensation</span>.",
    "ChePaiHaoMa": "License Plate Number",
    "TianXieLianXiXinXi": "Fill in your contact information",
    "ShouJianRenQuanMing": "Recipient's name",
    "ShuiWuHaoHuZhaoXinXi": "Tax No./Passport Information",
    "ShouJianRenSuoZaiChengShi": "Recipient's city",
    "YunShuGongSiZhongDianZhan": "Terminal address",
    "ChengShiJiaoHuoDiZhi": "Delivery address by city",
    "ShuiWuHaoHuZhaoXinXiTiShi": "Fill in the Tax NO. of the company (if the recipient is a legal entity) or passport information of the client (if the recipient is an individual).",
    "QingShuRuChengShiMinCheng": "Please enter the city name",
    "QingZhuMingSuoXuDeYunShuGongSiZhongDianZhan": "Specify the desired terminal",
    "SongHuoShangMen": "Door-to-door delivery",
    "ShangChuanChuHuoZhaoPianWenJianTiShi": "Picture/video, support (mp4,flv,jpeg,jpg,png,bmp,zip) format files, a single file cannot exceed 50M, up to 20.",
    "ShangChuanChuHuoZhaoPian": "Upload photos",
    "IntroduceBanner1": "Factory direct supply platform in China",
    "IntroduceBanner2": "About ESSACHINA.COM",
    "IntroduceBanner3": "We serve more than 720 buyers worldwide, helping them to source their favorite products from Chinese factories efficiently and at a good price",
    "GongChangTuiJianTiDaiKuan": "Factory-recommended alternative!",
    "GongChangYouHaoTuiJian2": "New recommendation for {0} items.",
    "FangYangZhanTing": "Sample exhibition hall",
    "ZaiBaiDuDiTuChaKan": "View on Baidu Maps",
    "AnShouZiMuShaiXuan": "Filter by first letter",
    "BuXian": "All",
    "TanWei": "Stand",
    "DianJiFuZhiDiZhi": "Click to copy the address",
    "DianJiFuZhiDiZhiDianHuaHaoMa": "Click to copy the phone number",
    "BianJiZhengShu": "Modify certificate",
    "JiaGeBaoKuoZengZhiShuiTiShi": "The price includes value-added tax, duties and freight from the manufacturer in China to the supplier's warehouse.",
    "MianFeiDinYueESSA": "Subscribe to the ESSA Product Monthly for free",
    "QinXuanZeGanXinQuDeChanPinLeiMu": "Please select the category you are interested in",
    "BuZaiTiShi": "No more tips.",
    "QueRenDinYue": "Confirm subscription",
    "DangQianYouXiangYiZhuCe": "Email already registered, please go to Login.",
    "ChanPinYueKan": "Product Monthly",
    "DenLuChaKanJiaGe": "Please sign in to check the price",
    "YueKan": "Monthly",
    "SuoXuanRiQiYChaoGuoMianFeiTingCangQi": "Please note that the selected date has exceeded the free storage period (free storage up to {0}) and will incur a fee of approximately {1}.",
    "WeiZhiFuBuYunXuChuKu": "No pickup allowed without payment.",
    "JianMianFeiYong": "Cost reduction",
    "TiaoZhengDingDan": "Modify Order",
    "QuanMian": "No charge",
    "GouXuanDeDingDanBaoLiu": "Checked orders are retained; unchecked orders require the customer to make a new appointment for pickup.",
    "YiQuanMianFeiYong": "It's all free!",
    "ShiFouYaoQuanMian": "Is it really free?",
    "ShiFouYaoYouHuiJinE": "Are discounts offered?",
    "QingShuRuYouHuiJinE": "Please enter the discount amount",
    "QueDingYaoTiaoZhengDingDan": "Sure to modify the order?",
    "ZhongGuoZhiDaDingDan": "TK delivery from Manufacturer",
    "QingLianXiKeFuWanChengFuKuan": "Please contact customer service to complete payment.",
    "QingXuanZeYaoQuXiaoDeShangPin": "Please select the product to be canceled",
    "YuJiDaoGang": "Estimated Delivery Time",
    "QueDingYaoQuXiaoShangPinMa": "Sure you want to cancel the product?",
    "ZhengDanQuXiao": "Cancel all",
    "HeJiQuXiao": "Total cancellations",
    "QingXuanZeDingDanFuKuanFangShi": "Please select the order payment method",
    "QingXuanZeDingDanFuKuanKaHao": "Please select the order payment account",
    "KeYongEDu": "Available amount",
    "ChaoChuKeFanWei": "Out of the available range",
    "ZhiFuXinXi": "Payment Information",
    "QueDingShiJian": "Time of determination",
    "YiGuoNTian": "It's been {0} days.",
    "LeiJiDing": "Total",
    "ZhongGuoZhiFaDingDan": "TK delivery from Manufacturer",
    "SuoXuanXinXiShiFouYiJingYuKeHuQueRenGuo": "Has the selected information been confirmed with the customer?",
    "ESSAChanPinYueKan": "ESSA Product Monthly",
    "MeiYueJinXuanYouZhiChanPin": "A monthly selection of quality products to help you with your purchases.",
    "DingYueYueKan": "Subscribe to a monthly magazine",
    "ShangPinQinQuan": "Infringement",
    "YiTianJia": "Added",
    "MskCangKu2": "рабочий посёлок Ленинские горки, Зелёное шоссе 4. стр 1. Склад #35 ООО «Игрувер.ру»",
    "ChanPinYiQinQuan": "Infringement",
    "QueRenDingDanChengGong": "Order successfully confirmed.",
    "YiZhengDanQuXiao": "It's all canceled.",
    "KeHuBuYaoLe": "The client doesn't want it.",
    "ZhongGuoZhiFa": "TK delivery from Manufacturer",
    "YouXiaoQi": "Validity period",
    "KeJieSouTuiJianXiangShiKuan": "Acceptable recommendations for similar models",
    "QinShuRuDaBaoYaoQiu": "Please enter packing requirements",
    "JianDan": "Simple",
    "SheZhiWoDeXiaoShouJia": "Set my selling price",
    "XiaoShouJiaGongShi4": "My selling price = FOB price × FOB markup × Profit margin",
    "XiaoShouJiaGongShi5": "Selling price = FOB price × (1 + FOB markup rate) × (1 + Profit margin rate)",
    "LiRun": "Profit",
    "FOBJiaJia": "FOB markup",
    "HuoBi": "Currency",
    "GongZuoRi": "Working days",
    "ZhaoYangShenYuShiJianBuBaoHanZhouMo": "Remaining Time to Find Samples (Excluding Weekends)",
    "DuoShaoGeGongZuoRiNeiXuHuiFu": "Number of Workdays to Respond",
    "YiJianFaBu1": "One-Click Publish",
    "YiJianFaBu2": "Multiple Sources of Requirements? Upload Now, Quickly Unify Sample Inquiry!",
    "ZhuanYeTuiJian1": "Professional Recommendation",
    "ZhuanYeTuiJian2": "Identify Demand Information, Accurately Recommend Suitable Products",
    "YiJianJiaGou1": "Add to Cart",
    "YiJianJiaGou2": "Bulk Purchase of High-Quality Goods, Time-Saving and Efficient",
    "ZhongGuoZhiFaShangPin": "Products of \"TC Delivery from Manufacturer\"",
    "ZhongGuoZhiFaShangPinTiShi1": "Orders of \"TC Delivery from Manufacturer\" , no invoices and customs clearance documents available.",
    "ZhongGuoZhiFaShangPinTiShi2": "Invoices and customs clearance documents are not available for \"TC Delivery from Manufacturer\" items. If you don't want to purchase this type of goods, click Settings to close.",
    "ChanPinZanBuXiaoShou": "This product is not available for sale.",
    "TuiKuanMingXi": "Refund details",
    "DaiTuiKuanJinE": "Amount to be refunded",
    "QueRenFaHuoFangShi": "Please confirm delivery method",
    "LiangZhongFaHuoFangShi": "Two types of delivery",
    "QuanBuShangPinZhongGuoZhiFa": "All Products  require \"TC Delivery from Manufacturer\"",
    "LiangZhongFaHuoFangShiDeXiangXiShuoMing": "If an order contains \"TC Delivery from Manufacturer\" items, it will use two delivery methods, one for normal delivery from essaone and one for direct from manufacturer.",
    "RuGuoXiaDanShangPinBaoHanLeZhongGuoZhiFaDeChanPin": "If your order contains \"TC Delivery from Manufacturer\" items, you will be contacted by the platform to confirm again, so please pay attention to emails and phone calls after submitting your order.",
    "QuanBuShangPinCaiYongZhongGuoZhiFaFangShiFaChu": "All products require \"TC Delivery from Manufacturer\"",
    "BuTiGongFaPiaoHeQingGuanWenJian": "No invoices and customs clearance documents available.",
    "DangQianXiaDanShangPinBaoHanLeZhongGuoZhiFaDeChanPin": "Now the order contains \"TC Delivery from Manufacturer\" products, which cannot provide invoice and customs clearance documents. After submitting the order, they will be split into sub-orders and you will be notified. Is this acceptable to you?",
    "QueDingYaoShiYong": "Make sure to use {0} ？",
    "TuiKuanQueRen": "Confirmation of refunds",
    "DaiTuiKuanQueRen": "Pending refund confirmation",
    "QueRenXinXi": "Confirmation information",
    "TuiKuanChanShengShiJian": "Time of incurring refunds",
    "QueRenYiTuiKuan": "Confirmation of refunds",
    "DangQianDingDanKeHuYaoQiuZhongGuoZhiFaTiShi": "This order requires \"TC Delivery from Manufacturer\", please pay attention to the sticker template settings.",
    "KeHuYaoQiuZhiFa": "The customer requested \"TC Delivery from Manufacturer\".",
    "DangQianDingDanKeHuYaoQiuZhongGuoZhiFaTiShi2": "Currently these orders require \"TC Delivery from Manufacturer\" so they can be submitted directly!",
    "DangQianDingDanKeHuYaoQiuZhongGuoZhiFaTiShi3": "Now the order contains \"TC Delivery from Manufacturer\" products, which cannot provide invoice and customs clearance documents. After submitting the order, they will be split into sub-orders and you will be notified. Is this acceptable to you?",
    "JieShouBingJiXuS": "Accept and continue({0}s)",
    "JieShouBingJiXu": "Accept and continue",
    "GongZuoTaiZhuYe": "Home",
    "XuanPinChi": "Product Pool",
    "WoDeKeHu": "My Customers",
    "TuiJianBaoJiaDan": "Recommended Quotations",
    "KeFu": "Customer Service",
    "HuoDongZhuanQu": "Special Offers",
    "KeHuDeZhaoYang": "Customer Samples",
    "GongGongKeHuChi": "Public Customer Pool",
    "ZhangHuXinXiSheZhi": "Account Settings",
    "PingTai": "ESSACHINA Platform",
    "KeHuZhuYe": "Customer Homepage",
    "KeHuDongTai": "Customer Updates",
    "WeiWanShan": "Incomplete",
    "BangDingKeHuDaoGaiFenXiaoShangMingXia": "Move the customer under the distributor, which will change the customer's original affiliation.",
    "ShangChuanShiBai2": "Uploading failed!",
    "ZhengShuGuaKao": "Certificate affiliation",
    "ZhengShuGuaKaoGuiZe": "Certificate affiliation rules",
    "GuaKaoZunXunXianPiPei": "Certificate affiliation rules follow the order of match, then exclude. Once an item matches the exclusion rule, it is labeled \"No Certificate\".",
    "PiPeiGuiZe": "Match rules",
    "TianJiaGuiZe": "Add Rule",
    "DuoGeGuiZeShiYongHuoDeGuanXi": "Multiple rules use an or relationship, and a hit on any one rule is a successful match.",
    "PiPeiDeShangPinShiYongYiXiaHaiGuanBianMa": "Matching products use the following customs codes",
    "YiXingYiGeHaiGuanBianMa": "One number per line, with a 10-digit customs code in upper and lower case English or numeric characters.",
    "QingShuRuHaiGuanBianMa": "Please enter the customs code",
    "QingShuRuZhengQueDeHaiGuanBianMa": "Please enter the correct customs code",
    "PaiChuGuiZe": "Exclusion rules",
    "PaiChuDiaoZhiDingShangPinBianHao": "Exclude the specified product number",
    "YiXingYiGeBianHao": "One number per line",
    "ShiFouQueDingBaoCun": "Sure about the save?",
    "FuZhiPiPeiGuiZeChengGong": "Copy, and Match Rule {0} Success",
    "FuZhiPaiChuGuiZeChengGong": "Copy, and Exclusion Rule {0} Success",
    "ShiFouYaoShanChuTiaoJian": "To delete conditions?",
    "ShangPinShuYuYiXiaLeiMu": "The product belongs to the following categories",
    "QingXuanZeLeiMu": "Please select a category",
    "QieFuHeYiXiaShangPinShuXing": "And meet the following product attributes (if you change the category, please check the attribute conditions)",
    "DianJiQieHuanTiaoJianZuHeFangShi": "Click to toggle the condition combination method",
    "Qie": "and",
    "TianJiaTiaoJian": "Add conditions",
    "ZhengShuXiangQing": "Certificate Details",
    "ZhengShuXuanZe": "Category Selection",
    "GuiZeLeiMuYuZhengShuLeiMuBuPiPei": "The prescribed category does not match the certificate category, please check before saving.",
    "FeiYongDan": "Expense List",
    "ChaoShiNTian": "Timeout {0} days",
    "ShenNTian": "{0} days left",
    "ZuiWanQueRen": "latest confirmed",
    "QinHeShiXinXiHouQueRenFeiYongDan": "Please verify the information and confirm the expense list. Confirmation will result in a receivable. If in doubt, consult your salesperson.",
    "WoDeFeiYongDan": "Order fees",
    "XinFaPiao": "Export  excel",
    "XinFaPiaoPCS": "Export  excel PCS",
    "DaoChuShiBai": "Export failed",
    "FaPiaoXuCaiWuQueRenHouZaiDaoChu": "Please contact your account manager to confirm the invoice before exporting it",
    "ChuLiTuiKua": "Get a refund.",
    "QingQueDingYaoRuHeChuLiTuiKuan": "Please determine how you will be refunded",
    "XianXiaHuiKuanGeiKeHu": "Refund transfers to customers",
    "TuiHuiKeHuQianBao": "Return customer's wallet account",
    "YaoQingMaYiCunZai": "Invitation code already exists, please re-edit",
    "FenXiaoShangZhongXin": "Distributor Center",
    "FenXiaoShangShouYe": "Distributors Home",
    "YuJiShouRu": "Estimated income",
    "ZiJiYaoQingKeHu": "Clients I invited",
    "JinNianYaoQingMuBiao": "Annual Targets",
    "XiaDanXinYongHu": "New users who have placed orders",
    "JinNianChengJiaoXinKeHu": "New clients this year",
    "XiaJiFenXiaoShangGongXian": "Sub-distributor contributions",
    "FuZhiLianJie": "Copy the link",
    "SaoMaFenXiang": "Scan QR code to share",
    "FenXiangHaiBao": "Share poster",
    "QingShuRuYaoQingMa": "Please enter the invitation code, four digits.",
    "XiuGaiYaoQingMa": "Modify invitation code",
    "LeiJiYaoQLeiJiYaoQingNRenXiaDanNRen": "Cumulatively, {0} customers have been invited and  {1} customer has placed an order.",
    "SouSuoKeHuMinChengBianHao": "Search for customer name/number",
    "YaoQingShiJian": "Date of invitation",
    "LeiJiDingDanTiCheng": "Cumulative order commissions",
    "YiBiaoPan": "Dashboard",
    "DingDanTiChengTiShi": "We will paid commissions for the previous month on the 10th of each month (e.g., commissions for January 1-31 will be paid on February 10).",
    "HeTongYiDaoQiHouDeDingDanJiangBuZaiChanShengShouYi": "The contract has expired. Therefore there will be no commissions for orders placed after {0}.",
    "DingDanTiCheng": "Order Commissions",
    "SouSuoDingDanHao": "Search order number",
    "HuiKuanXianJin": "Commissions remitted",
    "NNianYueYiWanJie": "{0} completed",
    "NNianYueTiChengYiHuiKuan": "Commission {0} has been remitted.",
    "KeHuYiBiaoPan": "Dashboard",
    "SouTu": "Search for images",
    "HeTongYouXiaoQiZhi": "Period of validity of the contract {0} to {1}",
    "MoRenShiNiDeShouJiHao": "The default is your cell phone number.",
    "MiMaGuiZe3": "Please enter 8-16 characters, a combination of numbers and letters.",
    "BianJiZhangHao": "Edit Account",
    "DingDanFenXiaoShang": "Order Distributors",
    "XinZengDingDanTiChengFenXiaoShang": "Add order distributor",
    "XinZengZhuCeTiChengFenXiaoShang": "Add register distributors",
    "HeTongXinXi": "Contract Information",
    "HeTongFuJian": "Annex to the contract",
    "GuoJiaDiQu2": "Country/Region",
    "MoRenShiShouJiHao": "The default is a cell phone number.",
    "QingShuRuYouXiaoQi": "Please enter the expiration date",
    "ShangChuanWenJianTiShi": "Support jpg/png/Word/Excel/PDF format, single file maximum support 10M, upload up to 5 files.",
    "KeHuXiaDan": "Customer to order",
    "XiaJiYongHu": "Secondary user",
    "JinNianChengJiaoMuBiao": "This year's order amount target",
    "YiChengJiaoJinE": "Transacted amount",
    "AnQuanTiShi": "Security tips",
    "ShouCiDengLuQingXiuGaMiMaHouJiXu": "First time logging in, please change your password and go on.",
    "QingShuRuXinMiMa": "Please enter a new password",
    "QingZaiCiShuRuXinMiMa": "Please enter the new password again",
    "MiMaGuiZe4": "Passwords need to be a combination of letters and numbers, between 8 and 16 digits in length.",
    "FenXiangDao": "Share to",
    "XiaZaiHaiBaoFenXiang": "Download the poster and share it.",
    "YuJiShouRuBaoHanJinXingZhongDingDanTiShi": "Total estimated commission includes 【estimated commission for orders in progress】 and 【commission for orders completed during the month】.",
    "ShangYueTiChengTiShi": "We will count the previous month's commission on the 1st and pay it on the 10th of each month. Payment will be postponed in case of weekends or holidays.",
    "JianGeShangYiCiDengLuNTian": "{0} days since last login",
    "JianGeShangYiCiDengLuNone": "Interval from last login -",
    "ESSAONEFenXiaoShangDaiLiYaoQingYeBiaoTi": "Agency program from ESSAONE",
    "ESSAONEFenXiaoJieShaoYu1": "Attract and motivate customers to order on ESSAONE",
    "ESSAONEFenXiaoJieShaoYu2": "Get a cash reward for every order",
    "ESSAONEFenXiaoJieShaoYu3": "Attract customers in different regions of Russia,",
    "ESSAONEFenXiaoJieShaoYu4": "geography doesn't matter and get a guaranteed reward for every order.",
    "ESSAONEFenXiaoJieShaoYu5": "Who are we?",
    "ESSAONEFenXiaoJieShaoYu6": "ESSAONE is a large online marketplace for legal entities and individual entrepreneurs who purchase goods directly from manufacturers with all accompanying services.",
    "ESSAONEFenXiaoJieShaoYu7": "What do you have to do?",
    "ESSAONEFenXiaoJieShaoYu8": "Search for potential clients in the regions of Russia",
    "ESSAONEFenXiaoJieShaoYu9": "Suggesting to the customer the categories of products presented on ESSAONE",
    "ESSAONEFenXiaoJieShaoYu10": "What we offer",
    "ESSAONEFenXiaoJieShaoYu11": "User-friendly interface for tracking your performance and reward amount",
    "ESSAONEFenXiaoJieShaoYu12": "Additional training and promotional materials",
    "ESSAONEFenXiaoJieShaoYu13": "Who can be an agent?",
    "ESSAONEFenXiaoJieShaoYu14HTML": "<li>You are an individual entrepreneur</li><li>Want to earn additional income</li><li>Ready to actively work with potential clients</li><li>Aimed at attracting and developing new clients</li><li>Work under an official contract</li>",
    "QinXuanZeYaoGengHuanDeMaiShou": "Please select the buyer you want to change",
    "FaSongZiXun": "Send inquiry",
    "YiZiXun": "Already inquired",
    "JiXuZiXun": "Continue Inquiry",
    "WeiHuiFu": "No reply",
    "GongChangYouFanKui": "Feedback from the factory",
    "GouMaiXiangShuShaoYuGongChangYaoQiu": "The number of boxes purchased is less than the factory's requirement",
    "XunJiaZhongZanWuFaGengGaiShuLiang": "Inquiry in progress, can not change the quantity for the time being",
    "ZengJiaGouMaiXiangShuKeXiaDan": "Increase the number of boxes to be purchased",
    "FenXiaoShangZhiNengChaKanShouCang": "Distributors can only view favorites",
    "ChangAnTuPianKeBaoCunDaoXiangCe": "Long press on the image to save it to an album",
    "XiaZaiBaoGao": "Download the report",
    "MeiYueJinTiGongShangYueJieSuanQiDeZhiXingQingKuangBaoGao": "Monthly performance reports are provided for the previous month's closing period only.",
    "ESSAONEFenXiaoJieShaoYu15": "Develop e-commerce together with ESSAONE - Get real income",
    "MingZi2": "Name",
    "YouJian": "E-mail",
    "XiangQingQingZhiDianLianXiWoMenHuoDianZiYouJian": "For more information, please contact us by phone or email:",
    "ESSAONEFenXiaoJieShaoYu16": "Develop e-commerce together with ESSAONE - Get real income",
    "PeiXunZhiChi": "Training Support",
    "ESSAONEFenXiaoPeiXunZhiChiBiaoTi": "Introduction to the company",
    "ESSAONEFenXiaoPeiXunZhiChiBiaoTi2": "Agency program",
    "TongYiGeKeHuWuFaChongFuBangDingTongYiGeMaiShou": "The same client can not be tied to the same buyer repeatedly",
    "FufilmentKey": "Fulfillment",
    "TongGuoXinFuWuTuoZhanNinDeYeWu": "Develop your business with a new service",
    "XinDeKeHuJingLiShenQingWeiNiFuWu": "New Account Manager Application for you",
    "ShenQing": "Apply for",
    "ZhaoYangYouXinDeHuiFu": "Find a sample with a new response",
    "ZaiZengJiaYiWeiKeHuJingLi": "Add another account manager",
    "BangDingKeHu": "Binding Customers",
    "DingDanShouRu": "Order Revenue",
    "ShuJuYiFaShengBianDongQingShuaXinYeMian": "Data has changed, please refresh the page",
    "XiaZaiYongJinBaoGao": "Download the commission report",
    "YunFeiBaoJiaDan": "Freight quotation",
    "HuanYingNi": "Welcome!",
    "XinDeKeHuJinLiWeiNiTiGongFuWu": "A new account manager will be at your service!",
    "GengHuanMaiShou": "Change of buyer",
    "TuiJianXin": "Testimonials",
    "WoDeKeHuJinLi": "My Account Manager",
    "QianWanGouWuCheChaKan": "Go to cart to view",
    "NiKeYiXuanZeBuTongDeKeHuJinLiGengJinXunJia": "You can choose a different account manager to follow up on your inquiry.",
    "YiQieHuanKeHuJinLiGenJin": "You have switched your account manager to follow up",
    "NiDeZhaoYangJiangYouYiXiaKeHuJinLiGengJin": "Your sample search will be followed up by the following account managers",
    "JieChuFuWu": "Release from service",
    "QuanXian": "Authorization",
    "TiHuanNaWeiXianYouKeHuJinLi": "Which existing account manager to replace",
    "ShenQinDeKeHuJinLi": "Requested Account Manager",
    "XuanZeDeKeHuJinLi": "Selected Account Manager",
    "XunJiaZhong": "Request for quotation",
    "YiJuJueLeGaiKeHuJinLiDeShenQing": "The application of the account manager has been rejected!",
    "GaiKeHuJinLiDeShenQinYiJinShiXiaoGuoQi": "The application for this account manager has expired!",
    "GaiXiaoShouJinLiShenQinWeiNiFuWu": "This sales manager has applied for your service, he wants to provide you with better service.",
    "JuJue": "Rejected",
    "XuanZeKeHuJinLiChengGong": "Select Account Manager Success",
    "XinDeKeHuJINLi": "New Account Manager",
    "TiHuanDeKeHuJinLi": "Replacement account manager",
    "ShangPinYiZaiHaoHuoJuZhon": "The product is ready for replenishment in container {0}, order {1}, please remove it from the container and the replenishment pool first.",
    "WoZiJi": "Myself",
    "ZuiShaiXuanZeYiGeZhangHao": "Choose at least one account",
    "NShangPinKeYiPinGui": "{0}m³ of goods can be consolidated",
    "DaoRuChengGong": "Imported successfully",
    "ChaKanQiTaZhangHaoDeShuJu": "View data from other accounts (only view)",
    "MaoShouYiJingBangDing": "Please do not repeat the operation if you have already bound buyers.",
    "WeiBangDingMaiShou": "No buyers bound, please bind buyers first.",
    "BangDingDeMaiShouShuLiangChaoXinaZhi": "The number of bound buyers is over the limit",
    "LingQuDaoNinDeJiFenZhangHu": "Points have been credited to your account and can be used to offset order amounts or redeem gifts.",
    "XuanPinJiangLiNJiFen": "Reward {0} points",
    "ShiYongZhiNan": "User Guide",
    "DingDanYuZhaoYang": "Orders and Sampling",
    "GongSiZiChan": "Company Assets",
    "GeRenZiChan": "Personal Assets",
    "JinGongGeRenChaKan": "For personal viewing only",
    "GouWuQuan": "Shopping Vouchers",
    "SiRenChaKan": "Private View",
    "MingTianJiangYouNJiFenDaoQi": "You have {0} points expiring tomorrow. Points have a validity period of {1} days from the acquisition date.",
    "NiHaiMeiYouJiFen": "You currently have no points.",
    "GongSiQiTaZhangHaoYuZhuZhangHaoJunWuFaChaKanTiShi": "Neither other company accounts nor the main account can view your shopping vouchers or redeemed items. Shopping vouchers can be used to redeem points when placing orders, and they are valid for 5 year.",
    "DuiHuanShangPin": "Redeemed items",
    "DuiHuanHouNiZhuanShuXiaoShouJingLiHuiZhuDongLianXiNi": "The items are generally delivered to the specified address within 30 days. After redemption, the account manager will contact you proactively, so please wait for the delivery. Some products may not be available for delivery to your region, but you can choose to pick up the item from China or redeem another gift.",
    "QiTaLiPinQingLianXiKeHuJingLi": "For other gifts, please contact your account manager.",
    "LianXi": "Contact",
    "XinZhengYiWei": "Add a new one",
    "QinXuanZeTiHuanDeKeHuJinLi": "Please select the replacement account manager",
    "FuWuZhongDeKeHuJinLiQinXuanZeShiFou": "For the current account manager, please choose whether to replace or add a new one Proactively applied account manager",
    "ZhuDongShenQinDeKeHuJinLi": "Proactively applied account manager",
    "QueRenYaoJuJueGaiKeHuJinLiZheCiDeShenQin": "Confirm rejection of this application by the account manager",
    "JiFenQAWenTi1": "How to earn points?",
    "JiFenQANeiRong1": "Click【Add Inquiry】add items to the shopping cart or search for products through【Initiate Sample Search】next to the search bar, you will have the probability to get points.  Adding up to 20 items to your cart daily will earn you points for sure.",
    "JiFenQAWenTi2": "Points are obtainable every day?",
    "JiFenQANeiRong2": "Points can be obtained for product selection/sampling from every day. Add 100 products to your cart to earn up to 5000 points.",
    "JiFenQAWenTi3": "How to use points?",
    "JiFenQANeiRong3": "Points can be used to offset order amounts or exchanged for shopping vouchers, with a maximum redemption of 1% of the order amount.",
    "JiFenQAWenTi4": "Validity of points",
    "JiFenQANeiRong4": "Points are valid for 60 days from the date of acquisition. Unused points will expire automatically. If points are used successfully and the order is canceled due to factory reasons, the points will be fully refunded.",
    "GouWuQuanQAWenTi1": "How to obtain shopping vouchers? When do they take effect?",
    "GouWuQuanQANeiRong1": "Shopping vouchers can be obtained by redeeming points when placing orders. They will take effect when the order is shipped.",
    "GouWuQuanQAWenTi2": "How to use shopping vouchers?",
    "GouWuQuanQANeiRong2": "On the personal asset shopping voucher page, confirm the voucher balance, and if there's sufficient balance, click directly on products to redeem.",
    "GouWuQuanQAWenTi3": "Validity of shopping vouchers",
    "GouWuQuanQANeiRong3": "Within 5 years from the effective date. If not used within the validity period, the shopping vouchers will automatically expire.",
    "GouWuQuanQAWenTi4": "How are redeemed gifts delivered?",
    "GouWuQuanQANeiRong4": "After redeeming gifts, your account manager will follow up with you. Any specific requirements can be discussed with your account manager.",
    "ZuiHouGengXin": "Last updated",
    "FaQiZhaoYangChengGong": "Sample request initiated successfully!",
    "WoDeJiFenHeGouWuQuan": "My points and vouchers",
    "MingTianJiangYouNJiFenDaoQi2": "Points are valid for {0} days from the time they are earned. Every day you can earn points for add Inquiry.",
    "ZiJiTiaoXuan": "Select Now",
    "YouXiuKeHuJinLiJunJinGuoShenHe": "The top account managers are all vetted",
    "BuTongDeBaoJiaZuHeYingXiangShangPinJiaGe": "Different combinations of quotes affect the price of goods, click on Settings",
    "QingQueRenYiXiaXinXi": "Please confirm the following information",
    "SheZhiBaoJiaZuHe": "Set price combination",
    "KeXiaDanShangPin": "Products that can be ordered",
    "QuanBuXuanBenYe": "None of this page",
    "QuanXuanBenYe": "Select all",
    "PiLiang": "Lot",
    "YiXuanNKuanNXiangZongJiN": "Selected {0}Model, {1}Case, Total {2}",
    "QingXianXuanZeYaoXiaDanDeShangPin": "Please select the product you want to order first",
    "DangQianXuanLeNGeKeHuJingLi": "Currently there are {0} account managers selected, please select only one to continue the order.",
    "ChaoGuoZuiDaPiLiangCaoZuoTiaoShuN": "Maximum number of batch operations exceeded: {0}",
    "QingXuanZeBaoJiaFangShi": "Please select a quote method",
    "QingXuanZeChuHuoCang": "Please select shipping warehouse",
    "QingXuanZeXiaShuiGang": "Please select the port of discharge",
    "QingXuanZeHuoGui": "Please select container",
    "YiXiaBaoJiaZuHeKeSuiShiZaiGouWu": "The following combinations can be set in the shopping cart page at any time.",
    "JiaoYiBiZhongYiDanQueRenHou": "Once the transaction currency is confirmed, it can not be changed, if you need to change the transaction currency, please contact customer service.",
    "QingXuanZeJiaoYiBiZhong": "Please select the transaction currency",
    "XuYaoYiQiXiaDanWeiHuo": "If you need to order tail goods together, please click",
    "TianJiaWeiHuo": "Add tail goods",
    "ZhuYaoCaiZhi": "Main Material",
    "QinXuanZeJiaoYiBiZhong": "Please select the transaction currency",
    "DangQianGongYinShangQiSongLiangNWaiXiang": "Current supplier starting quantity {0} Box, please check more items or increase quantity",
    "JiaoHuoRiQi": "Delivery Date",
    "DingDanMeiYouShuJuFanHuiGouWuCheZhongXinXiaDan": "There is no data for the current order, please return to the shopping cart to place a new order.",
    "DingDanShuJuYiJingBianDongQingShuaXinHou": "The current order data has been changed, please refresh, verify the information and resubmit the order.",
    "BuFenShangPinBuManZu": "If you continue to submit the currently selected product, the product will be skipped for the following reasons:",
    "QuanBuShangPinBuManZu": "Currently selected to go to order goods, there is no goods to meet the requirements of the order, the reasons are as follows:",
    "DingGouLiangDiYuMoqYaoQiu": "The order quantity is lower than the MOQ requirement",
    "JiXuTiJiao": "Continue to submit",
    "ShangPinBuManZuGongChangDeQiSongLiang": "Merchandise does not meet the factory's starting delivery quantity.",
    "ShangPinBuManZuGongChangDeMOQYaoQiu": "Merchandise does not meet the factory's MOQ requirements.",
    "DangQianPiLiangCaoZuoZhong": "An item has been skipped for processing in the current batch operation for the following reason:",
    "XunJiaZhongDiShangPinBuNeng": "Merchandise in inquiry cannot repeat inquiry.",
    "JiaBaoNeiShangPinBuNengChong": "The inquiry cannot be repeated for an item under price guarantee.",
    "CanYuHuoDongDeShangPinBuNeng": "An item that is participating in an event cannot be queried.",
    "ShiXiaoShangPinBuNengXunJia": "Invalid products cannot be queried.",
    "ShangPinBeiXiTongSuoDing": "The product is locked by the system and cannot be operated at the moment, please wait for the system to release it.",
    "ZhongGuoGongChang": "Chinese factory",
    "PinPaiShangPinFenLei": "Commodity category of the factory",
    "1001CT1001": "I can't add a product to my shopping cart",
    "CanJianXiangXiBiaoZhun": "See detailed criteria",
    "LiaoJieDuoKeHuJinLiJiZhi": "Understanding the mechanism of multiple account managers",
    "DangQianJiaGouDeShangPinJiang": "The current purchase will be followed up by the selected account manager, you can switch the follow-up account manager, if you are not satisfied with them, you can change at any time.",
    "ShangPinYouYiXiaKeHuJinLiGenJin": "Items will be followed up by the following account managers",
    "DangQianHaiMeiYouKeHuJinLi": "There is no current account manager, you can choose up to two account managers to provide services at the same time, and you can change them at any time.",
    "JingJinFuWuTiYan": "Refining the service experience: TWO TO ONE business model innovation",
    "WeiLeTiShengPingTaiDeFuWuHeCaiGouDeTiYan": "In order to improve the platform's service and purchasing experience, the platform has now launched the TWO TO ONE account manager mode, you can have two account managers to assist you in purchasing and enjoy more detailed service, or you can continue to retain a manager to serve you.",
    "JingZhunDuiJie": "Precise docking",
    "DangCaiGouBuTongDeChanPinXianShi": "When purchasing different product lines, you can select two account managers to purchase different products.",
    "TiGaoTiYan": "Improve the experience",
    "TiYanBuTongYeWuJingLiDeFuWu": "Experience the services of different account managers and compare the speed and quality of handling the requirements and finally place the order to the right person. The healthy competition between them will greatly improve the service level to you.",
    "JiangDiFengXian": "Reduce Risk",
    "JiangDiZhiJieGengHuanYeWu": "Reduce purchasing risks when changing account managers directly, no need to hand over order request information to the new account manager as all information is stored in our CRM so that your purchasing habits are not forgotten!",
    "DingDanBaoZhang": "Order Guarantee",
    "ZaiYouWeiWanChengDeDingDanShi": "The temporary absence of one of the managers (business trip, vacation or illness) will not affect the speed of processing applications and completing orders. In addition for unfinished orders, after selecting a new manager, the original responsible manager will still continue to follow up until the order is completed.",
    "CaoZuoZhiNan": "Operational Guidelines",
    "XuanZeJingLi": "Selecting Managers",
    "JinRuYeWuJingLiYeMianDianJi": "Enter the \"Account Manager\" page and click the \"+\" button to add a new account manager; click the \"Management\" button to replace the selected account manager.",
    "YeWuJingLiGouWuChe": "Account Manager Shopping Cart",
    "XuanZeLeLiangWeiJingLiShi": "When two managers are selected, the two shopping carts correspond to different managers, and they follow up their respective shopping carts separately.",
    "GouWuCheQieHuan": "Shopping cart switching",
    "JiaGouShangPinQian": "Before adding an item, select the corresponding account manager in the upper right corner to follow up for you. Two managers can be selected at the same time",
    "YueFenChengJiaoFenBuTu": "Monthly Transaction Distribution Chart",
    "YiShenQingDengDaiKeHuQueRenZhong": "Applied, waiting for customer's confirmation.",
    "ShenQingXiangQing": "Application details",
    "WoYiLiaoJieQuTiaoXuanKeHuJinLi": "I have understood, go to select account manager",
    "NiYiZhuDongFangQiGengJinGaiKeHu": "You have voluntarily given up following up this customer, waiting for unbundling in progress. The customer has entered the semi-public status, may be followed up by other sales managers.",
    "KeHuYiJinRuBanGongKaiZhuangTai": "The customer has entered semi-public status and may be followed up by other sales managers.",
    "YeJiZuZhang": "Performance Team Leader",
    "GengHuanKeHuJinLiChengGong": "Replacement of account manager was successful!",
    "DangQianZiLiaoWanShanDu": "Current information completeness {0}, completing information will help improve the image and the factory's trust in you",
    "BuFenShuYuGuanJianXinXiWeiBaoZhangNinDeXinXiZhengQueXing": "Some belong to key information to ensure the correctness of your information. After you change key information, it needs to be reviewed again before it can take effect. Key information items will be listed when you submit changes.",
    "GongSiJianJieShiLiXingXiang": "Company profile/strength/image",
    "WanShanGongSiDeJieShao": "Improving the company's introduction can prove your strength and trustworthiness, helping the factory to open more permissions and provide more product information to you",
    "WaiMaoZhuGongQuYuHeCiYaoQuYuYouChongFuDe": "There are duplicates in the main and secondary foreign trade areas",
    "ZhuGongQuYuYiNianZiRanNianZhiYunXuXiuGaiYiCi": "The main area can only be modified once a year (calendar year), and the last modification time was",
    "TiJiaoShiBaiQingShaoHouChongShi": "Submission failed, please try again later!",
    "YouZhuYuZengJiaGongChangDuiNiDeXinRen": "Helps increase the factory's trust in you",
    "DaoChuBaoJiaDanShiKeYiZhanShiNiGongSilogo": "When exporting quotations, you can display your company logo",
    "ShangChuanLogo2": "Upload quotation logo",
    "ZhuGongShiChang": "Main market",
    "ZhiChiDuoXuan": "Supports multiple selections",
    "QinXuanZeZhuGongShiChang": "Please select the main market",
    "WaiMaoZhuGongQuYu": "Main foreign trade area",
    "DanXuan": "Single selection",
    "QinXuanZeWaiMaoZhuGongQuYu": "Please select the main foreign trade area",
    "CiYaoQuYu": "Secondary area",
    "ZuiDuoZhiNengXuanZeNGe": "You can only select up to {0}",
    "QingTianXieGongSiDiZhi": "Please fill in the company address",
    "QuWanShanGongSiJianJie": "Go to complete company profile",
    "GongSiJianJie": "Company profile",
    "GongSiJianJieTiShi": "Please introduce the company, the factory can see this introduction, better introduction always brings a good impression. Maximum 800 characters.",
    "QinXuanZeGongSiNianYingShouGuiMo": "Please select the company's annual revenue scale",
    "GongSiNianYingShouGuiMo": "Company annual revenue scale",
    "GongSiRenYuanGuiMo": "Company staff size",
    "QinXuanZeGongSiRenYuanGuiMo": "Please select the company's staff size",
    "GongSiHeZuoGuoDeHuoBan": "Partners the company has cooperated with/large transactions the company has completed",
    "GongSiXingXiang": "Company image",
    "TuWenBingMaoZhanXianGongSiShiLi": "Graphically showcase company strength, images support jpg/png/gif formats, up to 6 images.",
    "QingShangChuanYongHuTouXiang": "Please upload user avatar",
    "QingTianXieZhenShiXingMing": "Please fill in your real name",
    "QingShangChuanShenFenZhengBeiMian": "Please upload the back of your ID card",
    "QingShangChuanShenFenZhengZhengMian": "Please upload the front of your ID card",
    "QingXuanZeShanChangYuYanBingQieZuiDuoXuanZeSanGe": "Please select proficient languages...",
    "QingXuanZeShanChangShiChangBingQieZuiDuoXuanZeLiangGe": "Please select proficient markets...",
    "QingTianXieWaiMaoCongYeShiChangBingQieBuNengWei0": "Please fill in the duration of foreign trade practice...",
    "QingXuanZeShanChangKeHuLeiXing": "Please select proficient customer types",
    "QingXuanZeYiGeZhuYaoPinLei": "Please select a primary category",
    "QingXuanZeCiYaoPinLeiBingQieZuiDuoXuanZeLiangGe": "Please select secondary categories...",
    "QingZuiShaoWanShanYiMenYuYanDeGeRenTeChang": "Please at least specify one personal proficiency in language",
    "BuFenYuYanXinXiYiTianXieDanWeiTianXieWanQuan": "Some language information has been filled in, but not complete",
    "GengHuanTouXiang": "Change avatar",
    "ShouJiZhangHaoMing": "Mobile (account name)",
    "YuanGongDaiHao": "Employee code",
    "ZhenShiXingMing": "Real name",
    "ShuRuZhenShiXingMing": "Enter your real name",
    "ShangChuanShenFenZheng": "Upload ID card",
    "YongYuRenZhengHeHouXuQianDingHeTongXieYi": "Used for authentication and subsequent contract signing, platform promises never to leak",
    "ZhiChiTuPianGeShi": "Support image formats",
    "GuoHuiMian": "Emblem side",
    "RenMianXiang": "Portrait side",
    "QingShuRuWhatsApp": "Please enter WhatsApp",
    "WeiXinWeChat": "WeChat",
    "QingShuRuWeiXinWeChat": "Please enter WeChat",
    "ShanChangYuYan": "Proficient languages",
    "ZuiDuoNGe": "Up to {0}",
    "QingXuanZeShanChangYuYan": "Select Language Proficiency",
    "ShanChangShiChang": "Expertise Market",
    "QingXuanZeShanChangShiChang": "Select Expertise Market",
    "QingShuRuWaiMaoCongYeShiChang": "Enter Years of Experience in Foreign Trade",
    "ShanChangKeHuLeiXing": "Preferred Customer Types",
    "ShanChangZhuYaoPinLei": "Main Product Categories Expertise",
    "QingXuanZeShanChangZhuYaoPinLei": "Select Main Product Categories Expertise",
    "HaiShanChangQiTaPinLei": "Other Product Categories Expertise",
    "QingXuanZeShanChangQiTaPinLei": "Select Other Product Categories Expertise",
    "GeRenTeChangJianJie": "Personal Specialty Introduction",
    "ZhiShaoWanShanYiZhongWaiYuZiLiao": "Improvement of information in at least one foreign language",
    "XinZengQiTaYuZhongJieShao": "Add Additional Language Introduction",
    "WaiYuMingNiCheng": "Foreign Language Name (Nickname)",
    "ShuRuDuiYingYuYanDeXingMing": "Enter Corresponding Language Name",
    "JianDuanJieShaoZiJiDeLiangDian": "A short introduction to your highlights, recommended to be no more than 240 characters.",
    "JieShaoZiJiGuoWangDeYiXieChengGongAnLi": "Introduce Past Successful Cases and Customer Feedback",
    "YiJuHuaLiangDian": "One-Sentence Highlight",
    "YuYanNengLi": "Language Proficiency",
    "FuWuTaiDu": "Service Attitude",
    "FanKuiXiaoLU": "Feedback Efficiency",
    "JieJueWenTi": "Problem Solving",
    "ShiFouQueRenTiJiao": "Confirm Submission",
    "QingGenJuZiShenShiJiQingKuangJinXingPingJia": "Please Rate According to Your Actual Situation",
    "NXing": "{0} Stars",
    "ZiWoPingJia": "Self-Evaluation",
    "GengXinTouXiang": "Update Avatar",
    "ShangChuanZhenShiGaoQingTouXiangLiKeHuXinRenGengJinYiBu": "Upload a Real High-Quality Avatar to Gain Further Trust from Customers!",
    "TuiJianShangChuanZhengFangXing1BiLiDeTouXiang": "Recommend Uploading a Square 1:1 Ratio Avatar",
    "ZanWuHuoDong": "No Current Activities",
    "NKuanJiaRuXuanPinChi": "{0} items added to the selection pool",
    "JiaRuXuanPin": "Add to selection",
    "YiXuanPin": "Selected items",
    "WeiWanShanWuFaXuanPin": "Incomplete, cannot select items",
    "JiaGeGengXin": "Price updated",
    "WoDeBaoJiaDan": "My quotation list",
    "SouSuoBiaoTi": "Search title",
    "WeiChaKan": "Unviewed",
    "KeHuChaKan": "Viewed by customer",
    "KeHuJiaGou": "Customer added to cart",
    "FenXiangLianJieGeiKeHu": "Share link with customer",
    "FangWenMiMa": "Access password",
    "WuFangWenMiMa": "No access password",
    "YiChongXinJiaRuXuanPinChi": "Re-added to selection pool",
    "QingQianWangXuanPinChiChaKanShangPin": "Please go to the selection pool to view the items",
    "WeiTianXieMiaoShu": "Description not filled in",
    "YiJiaGou": "Added to cart",
    "LaoBan": "Boss",
    "FuZhiFenXiang": "Copy share",
    "ChongXinJiaRuXuanPinChi": "Re-add to selection pool",
    "BianJiZhuTi": "Edit topic",
    "MeiYouGengDuoLe": "No more",
    "ShanChuBaoJiaDanKeHuJiangBuNengZaiFangWenCiBaoJiaDan": "Deleting the quotation, the customer will no longer be able to access this quotation, deletion cannot be undone, continue?",
    "GengXinChengGong": "Update successful",
    "QingTianXieBaoJiaDanZhuTi": "Please fill in the quotation subject",
    "BaoJiaDanZhuTi": "Quotation subject",
    "ShangPinChaKanShenQing": "Product viewing application",
    "YiTiJiaoShenQingQingDengDaiGongChangShenHe": "Application submitted, please wait for factory review",
    "YuanYin": "Reason",
    "ChongXinShenQing": "Reapply",
    "MaiShouShenQingZhongWuFaJiaGou": "Buyer application in progress, cannot add to cart",
    "BaoJiaDanXiangQing": "Quotation details",
    "JiaGouChengGong": "Added to cart successfully",
    "KeHuFuWuFei": "Customer service fee",
    "KeHuJiaJiaLU": "Customer markup rate",
    "ZaiXianFenXiang": "Share online",
    "KeHuYouYiXiang": "Customer has intention",
    "SouSuoShangPinHuoHao": "Search product/item number",
    "GongChangRangLiJia": "Factory concession price",
    "ZiDingYiBaoJia": "Custom quotation",
    "YiXiangNXiang": "Intention {0} boxes",
    "ZanWuSouSuoShangPin": "No products found",
    "QianBoDaYouXiao": "Previous call effective",
    "YuLanBaoJiaDan": "Preview quotation",
    "GongChangMingCheng": "Factory name",
    "YuLanMoShiXiaWuFaXunJia": "Inquiry not available in preview mode",
    "YuLanMoShiXiaDaoChuBaoJiaDan": "Export quotation not available in preview mode",
    "DangQianChuYuYuLanMoShiXunJiaAnNiuWuFaCaoZuo": "Inquiry button disabled in preview mode",
    "YuLanMoShiXiaWuFaDaoChuTuPian": "Image export not available in preview mode",
    "SouSuoShangPinBianHaoHuoHao": "Search product/item number",
    "XunJiaShiBaiQingShaoHouChangShi": "Inquiry failed, please try again later!",
    "ShangPinBaoZhuang": "Product packaging",
    "YuLanMoShiXiaWuFaXiuGaiQiDingLiang": "Minimum order quantity cannot be modified in preview mode",
    "NiLaiWanLeFenXiangDeBaoJiaDanYiJingBeiQuXiaoLe": "You're late, the shared quotation has been canceled",
    "TaRenTuiJian": "Recommended by others",
    "YiXuanNKuan": "{0} items selected",
    "SheZhiFenZu": "Set group",
    "DaoChuSuoXuanShangPinTuPian": "Export selected product images",
    "DaoChuGaiBanShenQingBiao": "Export modification application form",
    "NKuanShangPinJiaGeWeiGengXinDaoZuiXinJia": "Prices of {0} items have not been updated to the latest",
    "ChongXinXunZuiXinJia": "Re-inquire about the latest price",
    "DaoChuBaoJiaDanWuKeHu": "Export quotation (without customers)",
    "NKuan": "{0} items",
    "ChaKanLiShiDaoChu": "View historical exports",
    "FanHuiXuanPinChi": "Return to the selection pool",
    "SheZhiBingDaoChuBaoJiaDan": "Set and export quotation",
    "YiJiaWoMenHuiDuiGongChangZhanShiNinDeXinXi": "Negotiate and we will show your information to the factory for better prices",
    "BiGongChangBaoJiaN": "{0} lower than factory price",
    "JiangJiaN": "Price drop of {0}",
    "PiLiangCaoZuo": "Bulk operation",
    "ZiDingXiangShuHeQiWangJiaGeXiangGongChangFaQiYiJia": "Negotiate with the factory for custom quantities and expected prices",
    "YiFaQiZhiNengYaJia": "Intelligent bargaining initiated",
    "FaQiZhiNengYaJiaShiBaiQingShaoHouChongShi": "Intelligent bargaining initiation failed, please try again later!",
    "ZiDongXiangGongChangFaQiXunJiaBingYaJia": "Automatically inquire and bargain with the factory",
    "QingChuChengGong": "Clear successful",
    "QingChuShiBaiQingShaoHouChongShi": "Clear failed, please try again later.",
    "GongChangYuanJia": "Factory original price",
    "HuLüeGongChangBaoJiaYiZiJiBaoJiaZhanShiGeiKeHu": "Ignore factory quotation and display your own price to the customer",
    "ShanChuShiBaiQingShaoHouChongShi": "Deletion failed, please try again later!",
    "JiaRuXuanPinChiChengGong": "Successfully added to the selection pool",
    "JiaRuXuanPinChiShiBai": "Failed to add to the selection pool",
    "30Tian": "30 days",
    "GeiNiTuiJianQiTaXiangSiShangPin": "Recommend other similar products to you",
    "NXiang": "{0} boxes",
    "NTian": "{0} days",
    "QingXuanZeFenZu": "Please select a group",
    "WanZhuanXuanPinChiXiaoLUJiaBei": "Master the selection pool, double your efficiency",
    "XiaoLUJiaBei": "Double efficiency",
    "ShangPinFenZu": "Product grouping",
    "ZiDongZuiXinJia": "Automatically update prices",
    "JiaJiaYuLan": "Markup preview",
    "ZhiNengYaJia": "Intelligent bargaining",
    "ZiZhuYiJia": "Independent negotiation",
    "ZaiXianBaoJiaDan": "Online quotation",
    "KeHuChaKanBaoJiaDan": "Customer view quotation",
    "LiShiBaoJiaDan": "Historical quotations",
    "LingHuoChaKanXuanPinChiShangPin": "Flexible viewing of selection pool items, can be viewed by supplier classification or group classification, shopping cart item management is more clear and understandable;",
    "DuoChongShaiXuanShangPin": "Multiple filtering of goods: according to \"joining time\", \"quotation range\", \"inquiry status\", \"product category\" and other multiple dimensions, the status of purchased goods is clear and understandable;",
    "KeHuGuanLiWeiLeFangBianGuanLiKeHu": "Customer management: In order to facilitate customer management, you can add customer information, including customer code, customer nickname, quotation currency, quotation language, quotation method, inquiry profit distribution, assign sales personnel an",
    "FenZuGongNengShangXianLa": "Grouping function is online, which can improve the efficiency of goods management, try it now!",
    "XinZengFenZuJieShao": "[New group]: Method 1: Select the item to add to the selection pool, click \"New group\", you can customize the name of the new group, select the created group below, and then join the specified group; Method 2: Click \"New group\" directly on the label of th",
    "SouSuoFenZuJieShao": "[Search group]: When there are too many groups, you can use the search function to search for groups, and then join the selection",
    "ShanChuFenZuJieShao": "[Delete group]: After group details or search group, click \"X\" to delete the group, and the items in the group will also be deleted, please use it carefully!",
    "ZiDongZuiXinJiaNinTiaoXuanShangPinJiaGouDaoXuanPinChiZhiHou": "Automatic latest price: After you select items to add to the selection pool, the system will automatically send product information to the factory. The factory will confirm and reply to the latest quotation of the product as soon as possible. Try adding i",
    "JiaJiaYuLanYiJianGeiShangPinSheZhiJiaJia": "Markup preview: Set markup for items with one click, and preview the price after markup online. Try it now!",
    "ZhiNengYaJiaJieShao": "Smart bargaining: The system automatically negotiates to the historical lowest price for you based on the historical registered prices of suppliers. Try it now!",
    "ZiZhuYiJiaZhiMaoYiShangGenGongChangQuYiJia": "Independent negotiation: Refers to traders negotiating with factories",
    "XuanPinChiZaiXianBaoJiaDanJieShao": "Online quotation, quick and efficient sharing: Select items from the shopping cart, add new sharing customers or select existing ones, fill in the quotation title, recommendation reasons, define quotation templates and display information, export the onli",
    "XuanPinChiKeHuChaKanBaoJiaDanJieShao": "Customer view quotation, instant feedback on intended products: Customers open the sharing link, enter the password prompted in the sharing link, and can view the quotation, providing instant feedback on intended products.",
    "XuanPinChiGuanLiLiShiBaoJiaDanJieShao": "Manage historical quotations: Historical quotations allow you to see all the details of quotations recommended to specified customers in history, facilitating traders to copy and share historical quotations, view details, preview quotation contents, and r",
    "QingChuFenZuChengGong": "Group deletion successful!",
    "QingChuFenZuShiBaiQingShaoHouChongShi": "Failed to clear group, please try again later!",
    "ShanChuZiDingYiBaoJiaChengGong": "Custom quotation deletion successful!",
    "ShanChuZiDingYiBaoJiaShiBaiQingShaoHouChongShi": "Failed to delete custom quotation, please try again later!",
    "WuFenZu": "No group",
    "XunJiaWanCheng": "Inquiry completed",
    "DengDaiGongChangHuiFuYuJiNGeGongZuoRi": "Waiting for factory response, estimated {0} working days",
    "GongChangHuiFuMOQ": "Factory response: MOQ",
    "FenZu": "Group",
    "DaiGongChangQueRenZuiXinJiaGe": "Awaiting confirmation of latest prices by factory",
    "QingZhengQueDeJiaJiaLUZuiDuoBaoLiuLiangWeiXiaoShu": "Please enter a valid markup rate, with at most two decimal places and between 0-1000!",
    "KuaiSuYuLanJiaGeHouDeJiaGe": "The price after quick preview does not affect the final price of the exported quotation",
    "QingTianXieJiaJiaLU": "Please enter the markup rate",
    "GuiLing": "Reset",
    "QingZhengQueDeFOBFeiYongZuiDuoBaoLiuSiWeiXiaoShu": "Please enter a valid FOB cost, with at most four decimal places",
    "QingTianXieMeiYuanDuiHuanRenMinBiHuiLU": "Please enter the USD to RMB exchange rate",
    "QingZhengQueDeMeiYuanDuiHuanRenMinBiHuiLU": "Please enter a valid USD to RMB exchange rate, with at most four decimal places",
    "MeiYuanDuiHuanRenMinBiHuiLU": "USD to RMB exchange rate",
    "LianJie": "Link",
    "YuLan": "Preview",
    "JiaoYiXinXi": "Transaction information",
    "FuZhiDuanLian": "Copy short link",
    "DaoChuBaoBiao": "Export report",
    "DaoChuChengGong": "Export successful",
    "DaoChuChengGongZaiXianFenXiangGengGaoXiao": "Export successful, online sharing more efficient",
    "RuYouFangWenMiMaJiuShiKeHuDaiHao": "If there is an access password, it is the customer code. You can go to \"Historical quotation\" to view the export history.",
    "HanYu": "Chinese",
    "YingYu": "English",
    "EYu": "Russian",
    "EXWBiaoZhunBaoJiaGuiZe": "EXW Standard Quotation Rules",
    "ShangPinChanDiWeiShanTouShiZuHeBaoJia": "When the place of origin of the goods is Shantou: Shantou (shipping warehouse) - Shantou (port of shipment) - 40HQ (container) combined quotation",
    "ShangPinChanDiWeiGuangZhouShiZuHeBaoJia": "When the place of origin of the goods is Guangzhou: Guangzhou (shipping warehouse) - Guangzhou (port of shipment) - 40HQ (container) combined quotation",
    "ShangPinChanDiWeiYiWuShiZuHeBaoJia": "When the place of origin of the goods is Yiwu: Yiwu (shipping warehouse) - Ningbo (port of shipment) - 40HQ (container) combined quotation",
    "ZhuYiXiaDanShiRuoGuiZiChuHuoCang": "Note: Changes in the shipping warehouse, port of shipment, and container type when placing an order may affect the FOB averaging of goods and incur short-distance freight costs (when the shipping warehouse is not in the same area as the origin, short-dist",
    "DaoChuZhong": "Exporting",
    "FOBBaoJiaGenJuXuanZeDeChuHuoQuYu": "FOB quotation: Calculated based on the selected shipping area, port of shipment, and container type; DDP quotation: Calculated based on the standard shipping area, port of shipment, and container type of the selected route",
    "QingXuanZeChuHuoCangXiaShuiGangHeHuoGui": "Please select the shipping warehouse, port of shipment, and container",
    "QingXuanZeHangXian": "Please select the route",
    "XuanZeJunTanFuWuFeiLUHeBiZhong": "Please select the service fee rate and currency for averaging",
    "JunTanFuWuFeiLU": "Service fee rate",
    "FenZuFangShi": "Grouping method",
    "PaiXuFangShi": "Sorting method",
    "ShengXu": "Ascending order",
    "BaoJiaDanWei": "Quotation unit",
    "DanGe": "Single",
    "ZhongBao": "Middle package",
    "DanGePCSRuGuoShangPinYiGeBaoZhuangZhongHanYouDuoGePCS": "Single PCS: If there are multiple PCS in one package, the quotation is based on a single PCS, for example, if there are multiple PCS in a display box, the quotation is based on a single PCS",
    "ZhongBaoRuGuoShangPinYiGeBaoZhuangZhongHanYouDuoGePCS": "Middle package: If there are multiple PCS in one package, the quotation is based on the entire middle package, for example, if there are multiple PCS in a display box, the quotation is based on one display box",
    "TongYongDaYin": "Universal print",
    "ChongXinXunJiaShiBaiQingShaoHouChongShi": "Re-inquiry failed, please try again later!",
    "QueDingChongXinXunJiaXuanZhongDeShangPin": "Confirm re-inquiry for selected items",
    "QingXuanZeBaoZhuangYuYan": "Please select packaging language",
    "QingXuanZeTuiJianRen": "Please select recommender",
    "QingXuanZeTuiJianZhuTi": "Please select recommendation theme",
    "ShangPinLeiMu": "Product category",
    "SouSuoShangPinBianHaoHuoHaoGongYingShangMingZi": "Search for product/number/item number/supplier name",
    "AnGongYingShang": "By supplier",
    "AnFenZu": "Group by",
    "ZhuYiHeBingDaoXinFenZuDeShangPinJiangCongYuanFenZuYiChu": "Note: Items merged into a new group will be removed from the original group",
    "XuanZeYiYouFenZuHuoShuRuKeTianJiaXinFenZu": "Select existing group or input to add new group",
    "QingTianXiefobFeiYong": "Please fill in FOB cost",
    "QingXuanZeShuRuHuiLU": "Please select input exchange rate",
    "QingXuanZeYuYan": "Please select language",
    "QingShuRuJiaJiaLU": "Please enter markup rate",
    "BaoJiaDanShiLi": "Quotation example",
    "WanShanGongSiXinXi": "Complete company information",
    "GeiBaoJiaDanQiGeMingZi": "Give the quotation a name for easy management of historical exports and display when customers browse online",
    "KeHuZaiXianLiuLanBaoJiaDanShi": "When customers browse the quotation online, it is displayed and automatically translated according to the customer's language.",
    "KeHuChaKanShiKeZiZhuQieHuan": "Customers can switch independently when viewing. The current setting is the default display mode",
    "LieBiaoXingShi": "List format",
    "XinXiDuo": "More information",
    "TuPianDa": "Large images",
    "GuDingHuiLU": "Fixed exchange rate",
    "QingShuRuGuDingHuiLU": "Please enter fixed exchange rate",
    "QingTianXieZhengQueDeHuiLU": "Please fill in the correct exchange rate",
    "PingTaiHuiLU": "Platform exchange rate",
    "MeiRiGengXin": "Updated daily",
    "QingTianXieZhengQueDeJiaJiaLU": "Please enter the correct markup rate",
    "QingShuRuF0B": "Please enter F0B",
    "QingTianXieZhengQueFOBFeiYong": "Please fill in the correct FOB cost",
    "GongChangXinXi": "Factory information",
    "BuBaoHanGongChangHuoHao": "Does not include factory item number",
    "DaoChuDeBaoJiaDanBuBaoHanGongChangHuoHao": "The exported quotation does not include the factory item number",
    "ShanChuYiDaoChu": "Delete exported",
    "DaoChuDeShangPinZiDongShanChu": "Exported items are automatically deleted",
    "DaoChuBaoJiaDanHouShanChuYiDaoChuShangPin": "After exporting the quotation, delete the exported items",
    "ZhiNengXuanZeTongLeiXingKeHuPingTaiHuoSiYou": "Only same type of customers can be selected (platform or private)",
    "NianChuHuoN": "Annual shipment {0}",
    "BaoJiaDanJiangGenJuKeHuDangAnYuSheZhiJieShengChengDuiYingYuYan": "Select a customer, and the quotation will be generated directly according to the customer profile with corresponding language, currency, markup rate, etc. If no customer is selected, you can set the language, currency, markup rate yourself.",
    "XinZengKeHu": "Add customer",
    "SouSuoKeHuMingChengYouXiangBeiZhu": "Search customer name/email/remark",
    "QuanBuSiYou": "All private",
    "QuanBuPingTai": "All platform",
    "ZanWuKeHuXinXi": "No customer information",
    "JianLiKeHuXinXiTiShi": "Establish customer information to facilitate exporting quotations, inquiry and price negotiation",
    "NiDeKeHuXinXiJiangDeDaoYinSiBaoHu": "Rest assured, your customer information will be kept confidential",
    "LiJiTianJia": "Add immediately",
    "YiXuanKeHu": "Selected customers",
    "YiXiaShangPinWeiWanChengXunJia": "The following items have not been inquired",
    "XunJiaChengGong": "Inquiry successful",
    "WanShanKeHuXinXi": "Complete customer information",
    "QingWanShanYiXiaXinXiZaiJinXingPinGuiXiaDanCaoZuo": "Please complete the following information before placing a container order",
    "WanShanKeHuDeGongSiMingCheng": "Complete the customer's company name",
    "ShangChuanXiaoShouHeTongHou": "After uploading the sales contract",
    "QueDingYaoTiJiaoPiLiangXunJiaMa": "Are you sure you want to submit batch inquiries?",
    "NKuanZongTiJiNZongJiN": "{0} items, total volume {1}, total {2}",
    "QueDingShanChuSuoYouXuanZhongDeShangPin": "Are you sure you want to delete all selected items?",
    "GongChangGeiDeChengJiaoJia": "Factory's price",
    "QingShuRuDaYu0DeJinE": "Please enter an amount greater than {0}",
    "QueDingYaoShanChuZiDingYiJiaGeMa": "Are you sure you want to delete the custom price?",
    "ShanChuZiDingYiJiaGe": "Delete custom price",
    "GeiKeHuDeChengJiaoJia": "price for the customer",
    "GongChangDeCaiGouJia": "Factory purchase price",
    "LiRunLU": "Profit margin",
    "JiaRuGouWuCheShiBai": "Failed to add to cart",
    "YiJiaZhong": "Negotiating",
    "XunJiaJiaGeYiGuoQi": "Inquiry price has expired (order based on revised price)",
    "JiaGeYiGuoQiXiaDanXuChongXinQueRen": "Price has expired, order needs to be reconfirmed",
    "YiGaiJia": "Price has been revised",
    "FuLiRun": "Negative profit",
    "YiZhangN": "Increased by {0}",
    "YiJiangN": "Decreased by {0}",
    "GongChangHuiFu": "Factory reply",
    "GeiKeHuChengJiaoJia": "price for the customer",
    "YiJia": "Bargaining",
    "XiuGaiJiaGe": "Modify price",
    "QingZhuYiYouBuFenGaiJiaShangPinShiFuLiRun": "Please note: Some modified items have negative profit.",
    "ShaiXuanFuLiRunShangPin": "Filter products with negative profit",
    "QueDingYaoShanChuZiDingYiBaoJiaMa": "Are you sure you want to delete the custom quote?",
    "RenGongGaiJia": "Manual price change",
    "XunQianChuLiGongChangHuiFuHouGengXin": "Update after handling factory replies before inquiry",
    "YouXiaoQiZhi1": "Valid until {0}",
    "ShengNTian": "{0} days left",
    "YiXiangChengJiaoJia": "Intended price",
    "QingXianChuLiGongChangHuiFu": "Please handle the factory reply first",
    "HanXunJiaLiRun": "Includes inquiry profit",
    "HaiMeiYouShangPin": "No items yet",
    "XuanPinDaoChuZhuanShuNiDeZaiXianBaoJiaDan": "Select items, export your exclusive online quotation",
    "ZhiChiXianShangFenXiangGengFangBianKuaiJieKeHuHaiKeYiZhiJieFanKui": "Supports online sharing, more convenient and efficient, customers can also provide direct feedback",
    "MaShangQuXuanPin": "Go to select items now",
    "QuanXuanPingTaiKeHu": "Select all platform customers",
    "QuanXuanSiYouKeHu": "Select all private customers",
    "NKuanShangPinYiJiaRuTuiJianChi2": "{0} items have been added to the selection pool and added to the group",
    "TianJiaFenZu": "Add group",
    "ShanChuFenZu": "Delete group",
    "NiQueDingYaoShanChuNFenZu": "Are you sure you want to delete group {0}?",
    "XiuGaiFenZuChengGong": "Group modification successful",
    "ShuRuFenZuMingChengBiTianZuiChangNGeZi": "Enter group name (required), up to {0} characters",
    "XinZengFenZu": "Add new group",
    "QingXuanZeYiGeFenZuFangBianKuaiJieShaiXuan": "Please select a group for convenient and quick filtering",
    "SouSuoFenZuMingZi": "Search for group name",
    "ZanBuShiYongFenZu": "Do not use groups temporarily",
    "XiTongYiZiDongGenGongChangXunZuiXinJiaGe": "The system has automatically inquired the latest prices from the factory",
    "YiTianJiaFenZu": "Group has been added",
    "XiuGaiFenZu": "Modify group",
    "KeHuChi": "Customer Pool",
    "ShengYuKaiFaQuanYi": "Remaining Development Rights",
    "WeiYouGenJin": "No Follow-up",
    "YiYouGenJin": "Already Followed-up",
    "DangQianKeHuYiYouXiaoShouJingLiGenJin": "The current customer is already being followed up by a sales manager, but you can still apply to follow up. Once the customer accepts your application, you will be responsible for following up with the customer.",
    "ShenQingGuo": "Applied",
    "ShangPinTiCheng": "Product Commission",
    "XiaoShouE": "Sales Amount",
    "XiaoShouGuiMo": "Sales Scale",
    "QuNianChengJiao": "Last Year's Transactions",
    "JinNTianXuanKuan": "Selection in the Last {0} Days",
    "NWanYuan": "{0} Ten Thousand Yuan",
    "ShengYuMuBiao": "Remaining Target",
    "JinNianWeiWanChengMuBiao￥NHaiChaN%": "This Year's Uncompleted Target ¥{0} Still Short by {1}%",
    "JieShouYuJiNengZhuan": "Estimated Earnings upon Takeover",
    "ChaXunShiBai": "Account Not Activated, Please Activate Account First",
    "DaiQueRenShengChanYaoQiu": "Pending Production Requirements Confirmation",
    "DaiQueRenPaiBanTu": "Pending Layout Confirmation",
    "DaiSheTieMai": "Pending Labeling",
    "DingJinYuQi": "Deposit Overdue",
    "HuoKuanYuQi": "Payment Overdue",
    "NYue": "{0} Month",
    "NNianYueFenChengJiaoFenBuTu": "Monthly distribution of transactions for the year {0}",
    "DangQianKaiFaKeHuQuanYiShuLiangShengYuN": "Currently, N Development Rights for Clients Remain",
    "ShiFouJiXuKaiFaGaiKeHu": "Do You Want to Continue Developing this Customer?",
    "QingXianWanShan/QueRenKeHuJiDuMuBiao": "Please Complete/Confirm Customer Quarterly Goals First",
    "KeHuGongGongChi": "Public Customer Pool",
    "DaiKaiFaKeHuXiangQing": "Details of Pending Development Clients",
    "YiYouKeHuJingLiGenJin": "Already Followed-up by Sales Manager",
    "YeWuDengJi": "Business Grade",
    "CaiGouGuiMo": "Procurement Scale",
    "MoRenCaiGou": "Default Procurement",
    "GongSiGuanWang": "Company Website",
    "ShangYiCiXuanPin": "Last Selection",
    "ShangYiCiTuiJian": "Last Recommendation",
    "ShangYiCiDengLu": "Last Login",
    "JinNTianXuanPin": "Selection in the Last {0} Days",
    "ShengYuNianDuMuBiao（HaiChaN%)": "Remaining Annual Target (Still Short by {0}%)",
    "JiSuanFangShi": "Calculation Method",
    "JiaoYiHuiLv": "Exchange Rate",
    "DanBaoFangShi": "Guarantee Method",
    "FanDianLv": "Rebate Rate",
    "ZhengDan2": "Entire Order",
    "JunTan": "Average",
    "WeiQiYong": "Not Enabled",
    "JiaoYiTiaoKuan": "Transaction Terms",
    "YiShenQingDengDaiQueRenZhong": "Already Applied, Awaiting Confirmation",
    "ShenQingGenJin": "Apply for Follow-up",
    "TongXun": "Communication",
    "ZuiJinDengLuShiJian": "Recent Login Time",
    "DengLuCiShu": "Login Frequency",
    "XuanPinShu": "Number of Selections",
    "ChaKanShangPinShu": "Number of Viewed Products",
    "ZhaoYangShu": "Number of Sample Requests",
    "TianXieGengDuoZiLiao": "Fill in More Information",
    "ShouQiGengDuoZiLiao": "Collapse More Information",
    "NinTiJiaoXinXiYiChang": "Your Submitted Information is Abnormal",
    "KeHuDaiHao": "Customer Code",
    "BaoJiaBiZhong": "Quotation Currency",
    "BaoJiaDanYuYan": "Quotation Language",
    "KeHuDingJinFangShi": "Customer Deposit Method",
    "XunJiaXiangGuan": "Inquiry Related",
    "XunJiaLiRunZai": "Inquiry Profit In",
    "NeiZhiJieRangLiGeiKeHuChaoChuBuFenLiRunZaiFenPei": "Directly Give Discounts to Customers, Excess Profit Redistribution",
    "XunJiaLiRunFenPei": "Inquiry Profit Distribution",
    "GeiKeHuQiTaBaoLiu": "Give to the customer, the rest reserved.",
    "BianJiKeHuLiRunFenPeiShiLi": "Example: set up 5% and 20%, commodity quotes 10, inquiry 9, inquiry profit 10%, then 5% directly to the customer (10 * 5% = 5), the excess part of the allocation of 20% to the customer (5 * 20% = 1), a total of 5 + 1 to the customer, the remaining 4 retai",
    "XunJiaZhangJiaShenHe": "Inquiry Price Increase Review",
    "BuXuYaoShenHe": "No Audit Required",
    "XuYaoShenHe": "Audit required",
    "DangYiCaiCaiGouZhongXinXunJiaHouDeJiaGeBiXunJiaQianGaoShi": "When the price after ESSA Procurement Center's inquiry is higher than the price before the inquiry, choose \"No Review Needed\" if no further negotiation is required. If price negotiation with the factory is necessary after the inquiry, choose \"Review Needed.\"",
    "MoRenGeiGongChangXunJiaDeYiXiangCaiGouXiangShu": "Default Intended Purchase Quantity for Factory Inquiry",
    "MoRenCaiGouXiangShu": "Default Purchase Quantity",
    "WanJuCaiGouGuiMo": "Toy Purchase Scale",
    "QingXuanZeCaiGouGuiMo": "Please select the size of the purchase",
    "QingXuanZeXiaoShouGuiMo": "Please select sales size",
    "KeHuZhuYingLeiMu": "Customer Main Category",
    "QingXuanZeZhuYingLeiMu": "Please select the main categories",
    "XiTongJiangGenJuNiDeKeHuZhuYingLeiMuZhiNengTuiJianXiangGuanShangPin": "The system will intelligently recommend related products based on your customer's main category, making it easy to choose",
    "DanGuiDingJinBiLi": "Single Cabinet Deposit Ratio",
    "DanGuiDingJiaBiLi": "Single Cabinet Pricing Ratio",
    "CaiGouShangDangQianDeKeYongZiJin": "Current Available Funds of Purchaser",
    "MeiJin": "US Dollar",
    "RenMinBi": "Chinese Yuan",
    "ShiYongZhuangTai": "Usage Status",
    "DaiTiaoZhengBaoZhengJinJinE": "Pending Adjustment of Deposit Amount",
    "DanBaoDaiKuanEDu": "Guarantee Loan Limit",
    "ZhangHuGuDingBaoZhengJin": "Account Fixed Security Deposit",
    "DanGuiGuDingDingJin": "Single Cabinet Fixed Deposit",
    "DengJi": "Level",
    "MeiJinEDu": "US Dollar Amount",
    "RenMinBiEDu": "Chinese Yuan Amount",
    "GuiXing": "Container Type",
    "FOBFeiYong：": "FOB Cost:",
    "DengLuShiJian": "Login Time",
    "JianGeShangYiCiDengLu": "Interval Since Last Login",
    "XiaDanXiangShu": "Order Quantity",
    "JiQiFanYi": "Machine Translation",
    "FuZhiGuanJianZi": "Copy Keywords",
    "KeHuJin60TianWeiFangWenPingTai": "Customer Not Visited Platform in Last 60 Days",
    "QingXuanZeZhangHao": "Please Select an Account",
    "Jin60TianGuiJi": "Trajectory in Last 60 Days",
    "LiShiSouTu": "Historical Image Search",
    "XiaDanShangPin": "Ordered Products",
    "ShenHeZhuangTai": "Review Status",
    "XuanZeLianXiRen": "Select Contact",
    "GenJinLeiXing": "Follow-up Type",
    "QingXuanZeGenJinLeiXing": "Please Select Follow-up Type",
    "ShangChuanJieTuHuoBaoJiaDan": "Upload Screenshot or Quote",
    "JieTuShiLi": "Screenshot Example (Email screenshot, must include sender information xxx; quote must include xxxx...)",
    "GenJinWenJianShangChuan": "Supports uploading images, word, excel, pdf. Maximum 10 files, each file size limit is 10m",
    "QingShangChuanJieTuHuoBaoJiaDan": "Please Upload Screenshot or Quote",
    "YouJianJieTuShiLi：XuYaoBaoHan": "Email Screenshot Example: Must Include xxxxxxxx",
    "BaoJiaDanJieTuShiLi：XuYaoBaoHan": "Quote Screenshot Example: Must Include xxxxxxxx",
    "QingXuanZeLianXiRenZhangHao": "Please Select Contact Account",
    "QingXianSheZhiJiDuMuBiaoHou": "Please set quarterly goals before proceeding",
    "QueRenShiFouBuZaiFuWuCiKeHu": "Confirm if you no longer want to serve this customer? After unbinding, if the customer is not followed up by other salespersons, you can still be contacted when needed, but it will not occupy your customer quota.",
    "JieBangChengGong": "Unbind Successful",
    "KeHuPODaiBan": "Customer PO Pending",
    "GenJinDengJi": "Follow-up Registration",
    "LianXiRenGuanLi": "Contact Management",
    "XiaoShouHeTong": "Sales Contract",
    "TieZhiZiLiao": "Sticker Information",
    "MaiTouZiLiao": "Mark Information",
    "WenTiSheZhi": "Problem Setting",
    "ShengChanYaoQiuSheZhi": "Production Requirements Setting",
    "WuLiuChuanWuZiLiao": "Logistics and Shipping Information",
    "NianDuMuBiaoJinE": "Annual Target Amount",
    "NianDuDingHuoJinE": "Annual Order Amount",
    "NianDuChuHuoJinE": "Annual Shipping Amount",
    "NianDuWanChengBiLi": "Annual Completion Ratio",
    "NianDuJinE": "Annual Amount",
    "JiDuMuBiaoJinE": "Quarterly Target Amount",
    "JiDuDingHuoJinE": "Quarterly Order Amount",
    "YueDuMuBiaoJinE": "Monthly Target Amount",
    "YueDuDingHuoJinE": "Monthly Order Amount",
    "JiDu/YueDuJinE": "Quarterly/Monthly Amount",
    "LaoZiBuXiangFuWuTA": "I don't want to serve him/her",
    "WoYiJingSheZhi": "I have already set it",
    "ShenQingZhong": "In application",
    "ZuiJinDengLu": "Last Login",
    "ZuiJinCaoZuo": "Last Operation",
    "FengXianZhi": "Risk Value",
    "BianJiCaiGouGenJinFenZu": "Edit Procurement Follow-up Group",
    "XinZengCaiGouGenJinFenZu": "Add Procurement Follow-up Group",
    "WeiXuanZeCaiGouFenZu": "No Procurement Group Selected",
    "ZhuYe": "Home",
    "DongTai": "Dynamics",
    "DengLuPingTai": "Login Platform",
    "TiJiaoGouWuChe": "Submit Shopping Cart",
    "SheZhiTieZhi": "Set Stickers",
    "NinMeiYouCaoZuoQuanXian": "You do not have permission to operate",
    "RenZhengRiQi": "Authentication Date",
    "ZhuCeRiQi": "Registration Date",
    "QuanBuGuoJia": "All Countries",
    "QingXuanZeYeWuYuan": "Please Select Salesperson",
    "SouSuoKeHuMingZi/BeiZhu/YouXiang": "Search Customer Name/Note/Email",
    "QuanBuYeWuYuan": "All Salespersons",
    "SouSuoKeHuDaiHao/NiCheng": "Search Customer Code/Nickname",
    "QingXuanZeYaoShanChuDeKeHu": "Please Select Customer to Delete",
    "LiJiXinZeng": "Add Immediately",
    "JianLiKeHuXinXi": "Establishing customer information makes it more convenient to export quotations and negotiate prices. Rest assured, your customer information will be protected.",
    "GenDanYuanGong": "Follow-up Staff",
    "CaiGouGenJinXiaoZu": "Procurement Follow-up Group",
    "QingXianXuanZeGongYingLianFenZu": "Please select a supply chain group first so that subsequent inquiry follow-ups can be provided with corresponding supply chain groups.",
    "QingXuanZeYouXiaoQi": "Please Select Validity",
    "ShangChuanHeTong": "Upload Contract",
    "QingShangChuanHeTong": "Please Upload Contract",
    "HeTongWenJianShangChuan": "Supports uploading images, PDFs. Supports up to 10 files, each file size limit is 50 MB",
    "KeHuGongSiXinXi": "Customer Company Information",
    "YinHangXinXi": "Bank Information",
    "HeTongHeZuoYaoQiuBeiZhu": "Contract Cooperation Requirements Remarks",
    "ChuanWu": "Shipping",
    "CaiWu": "Finance",
    "YaoQiuBeiZhu": "Requirement Remarks",
    "GenDan": "Filing Clerk",
    "QCCangKu": "QC, Warehouse",
    "YeWu": "Salesman",
    "WoSiQianYueZhuTi": "Our Contracting Party",
    "QingXuanZeGongSi": "Please Select Company",
    "BianJiHeTong": "Edit Contract",
    "FuKuanTiaoJianShuoMing": "Payment Terms Explanation",
    "KaiFaQuanYiShuoMing": "Development Rights Explanation",
    "KaiFaQuanYiShuoMing1": "Each salesperson can follow up on the development of 50 customers who have not yet completed transactions, including new customers who have not placed orders in the past, and customers who have not had new orders for more than 365 days. When a salesperson",
    "ChengJiaoKeHuShuLiang": "Number of Transaction Customers",
    "KaiFaQuanYi": "Development Rights",
    "KaiFaQuanYiShuoMing2": "Development Interests: 10 (minimum of 10 interests on the back cover)",
    "QuanYiFanHai": "Rights Return:",
    "KaiFaQuanYiShuoMing3": "1. If the salesperson voluntarily unbinds the customer or the customer who has not completed the transaction actively unbinds, the system will replenish the corresponding development rights quota;",
    "KaiFaQuanYiShuoMing4": "2. If the transaction customer actively unbinds the salesperson, only one quota will be replenished;",
    "KaiFaQuanYiShuoMing5": "3. If the salesperson's assessment fails, the system will not replenish the quota;",
    "KaiFaQuanYiShuoMing6": "4. In any case, customers unbound beyond the quota will not be replenished.",
    "PingTaiKeHu": "Platform Customers",
    "SiYouKeHu": "Private Customers",
    "GongNTiaoJiLu": "Total {0} Records",
    "XinKe": "New Customers",
    "NianDuXiaoShou": "Annual Sales",
    "JiDuMuBiao": "Quarterly Target",
    "FengXianYuJing": "Risk Warning",
    "XiTongKaoHeWeiDu": "System Assessment Dimensions",
    "XiTongJianKongDaoYouFengXianShi": "When the system detects risks, if not followed up in time, customers may be assigned to other business managers",
    "WoDeDaiBan": "My Tasks",
    "KuanXiangCuiShou": "Payment Collection",
    "PODanDaiQueRen": "PO Confirmation Pending",
    "DaiShenHeXunJiaRenWu": "Pending Inquiry Task Review",
    "DaiQueRenTieZhiPaiBan": "Pending Sticker Layout Confirmation",
    "DaiSheZhiTieZhiMaiTou": "Pending Sticker Label Setting",
    "DaiShenHeJieDanYiChang": "Pending Order Exception Review",
    "ChuanWuZiLiao": "Shipping Documents",
    "ChuanWuYiChang": "Shipping Abnormality",
    "DaiQueRenFeiYongDan": "Pending Expense Confirmation",
    "ZhouRi": "Sunday",
    "ZhouYi": "Monday",
    "ZhouEr": "Tuesday",
    "ZhouSan": "Wednesday",
    "ZhouSi": "Thursday",
    "ZhouWu": "Friday",
    "ZhouLiu": "Saturday",
    "HanXinKeShouDan": "Including New Customer's First Order",
    "ChengJiao": "Completed",
    "Ji": "Urgent",
    "DaiYeWuQueRen": "Pending Approval",
    "DaiKeHuQueRen": "Pending Customer Confirmation",
    "YiChaoShi": "Overdue",
    "ShangPinBianHaoNBuCunZai": "Product number {0} does not exist",
    "XiuGaiFeiYongDan": "Edit Expense Bill",
    "XinZengFeiYongDan": "Add Expense Bill",
    "QingShuRuZhengQueDeFeiYongChengBen": "Please enter a valid cost, (0.01-999999999) with up to two decimal places!",
    "QingXuanZeKeHu": "Please select a customer",
    "QingXuanZeFeiYongXiangMu": "Please select an expense item",
    "FeiYongChengBen": "Expense Cost",
    "MoRenKeHuBiZhong": "Default customer currency, subject to PO currency after specified",
    "QingTianXieFeiYongChengBen": "Please fill in the cost",
    "ZhiDingPOShouQu": "Specify PO collection",
    "DangQianBuZhiDingPO": "Not specified PO, according to the system rules",
    "ZaiZhiDingPOWanChengFeiYongShouQu": "Cost collection completed with specified PO",
    "QingShuRuPODan": "Please enter the PO number",
    "NKuanShangPin": "N items",
    "QueRenFeiYongDanWenJianShangChuan": "Supports images, maximum file size is 10M, maximum of 4 files",
    "FuJian": "Attachment",
    "KeHuBeiZhu": "Customer Remarks",
    "GaiBeiZhuJiangBeiKeHuKanDao": "This remark will be visible to the customer, please write the remark in the customer's language",
    "QingShuRuBeiZhu": "Please enter remarks",
    "QueRenBuXiangKeHuShouQu": "Confirm not to charge the customer?",
    "QueRenShanChuGaiFeiYongDan？": "Confirm to delete this expense bill?",
    "YouBianGeng": "Changes",
    "ShiFouZhiDingPOShouQu": "Is PO specified for collection?",
    "XiangKeHuShiShou": "Collected from customer",
    "BaoCunJiangGengXinFeiYongDanXinXi": "Saving will update the expense bill information, and may also flip the status of the expense bill. If the actual collection amount of the expense bill is lower than the cost, it will affect the gross profit of the PO.",
    "RuGuoFeiYongDanShiShouDiYuChengBen": "If the chargeback is lower than the cost, it will affect the PO's gross margins",
    "ShiShouJinE": "Actual Collection Amount",
    "MoRenAnPODanHuiLvJiSuan": "Calculated at the PO rate, reference price",
    "QingTianXieShiShouJinE": "Please enter the actual collection amount",
    "BeiZhuGeiKeHu": "Remarks to customer",
    "QueRenXiangKeHuShouQu": "Confirm charging the customer",
    "BuXiangKeHuShouQu": "Do not charge the customer",
    "ChaKanBianGeng": "View Changes",
    "WuQuanXianXiuGaiQiTaJueSeFaQiFeiYongDan": "No permission to modify expense bills initiated by other roles",
    "KeHuYiQueRen": "Customer confirmed",
    "QueRenShuoMing": "Confirm Instructions",
    "FeiYongDanXiangQing": "Expense Bill Details",
    "HeJiNZhangFeiYongDanGongN": "Total {0} expense bills, {1} in total",
    "DaiKeHuQueRenFeiYongDan": "Customer confirms expense bill",
    "DaiKeHuQueRenFeiYongChengGong": "Customer confirmed expense bill successfully!",
    "DaiKeHuQueRenFeiYongDanWenJianShangChuan": "Upload Confirmation Certificate",
    "ShangChuanQueRenPingZheng": "Please upload the confirmation certificate",
    "QingShangChuanQueRenPingZheng": "Confirmation Instructions",
    "QingTianXieBeiZhu": "Please enter remarks",
    "QingXuanZePODan": "Please select a PO!",
    "ZhiDingPOJiangBuGenSuiShangPinHuoXiTongGuiZe": "Specified PO will not follow product or system rules, only used for cost collection when specified PO is completed",
    "ShuRuPODanHaoChaXun": "Enter PO number to query",
    "ChengSeXiangBiaoShiDuiBiShangYiCiYouXiuGai": "Current (Orange indicates changes compared to last time)",
    "ShuLiangKuan": "Quantity (Items)",
    "费用单合计": "Total Expense Bill",
    "无PO费用": "Expense without PO",
    "有变更": "Changes",
    "XiangKeHuShouQu": "Charge customer",
    "GuDingHuiLvBuNengWeiKong": "Fixed exchange rate cannot be empty",
    "QingXuanZeGangKouHeTianXieFOBFeiYong": "Please select port and fill in FOB cost",
    "QingXuanZeGangKou": "Please select port",
    "FOBFeiYongBuNengWeiKong": "FOB cost cannot be empty",
    "QingZhiShaoBaoLiuYiGeXiaShuiGang": "Please keep at least one port",
    "MoRen40HQGuiXing": "Default 40HQ container type, when multiple ports are selected, the unit price defaults to the first port",
    "TianJiaXiaShuiGang": "Add port",
    "KeHuDaiHaoBuNengWeiKong": "Customer code cannot be empty",
    "QingShiYongZiMuHuoShuZiZuoWeiDaiHao": "Please use letters or numbers as the code",
    "TianXieKeHuDeDaiHao/BianHao": "Enter customer's code/number (English or numbers)",
    "KeHuChaKanBaoJiaDanXuYaoShuRuDaiHao": "Customers need to enter a code to view the quotation, providing quotation privacy protection",
    "KeHuNiCheng": "Customer nickname",
    "TianXieKeHuDeNiCheng": "Enter customer's nickname",
    "GuDingHuiLv": "Fixed exchange rate",
    "ShouDongSheZhiHuiLv": "Manually set exchange rate",
    "QingShuRuGuDingHuiLv": "Please enter fixed rate",
    "BaoJiaDanJiaJiaLv": "Markup rate for quotation",
    "FenPeiYeWuYuan": "Assign salesperson",
    "GengDuoZiLiao": "More information",
    "RuDiYuShangPinMOQYiMOQShuLiangXunJia": "Default intended purchase quantity when inquiring with factory, such as inquiring with MOQ quantity if lower than product MOQ",
    "MoRenYaJiaBiLi": "Default bargaining ratio",
    "XiangGongChangXunJiaShiZiDongAnCiBiLiJinXingYaJia": "Automatically bargaining with this ratio when inquiring with factory",
    "XinZengZhaoYang": "Add sample request",
    "SouSuoKeHuBianHao/YouXiang": "Search customer number/email",
    "ZhaoYangFenXi": "Sample analysis",
    "FangAn/BaoJia": "Proposal/Quotation",
    "KeHuYouJiaGou": "Customer has add-on purchase",
    "WuXiao": "Invalid",
    "FuZhiShiBai": "Copy failed",
    "BenYueShengYuCuiBanCiShuNCi": "Remaining urgent reminders for this month {0} times, do you want to use urgent reminder?",
    "CuiBanChengGong": "Reminder sent successfully!",
    "BenYueShengYuCuiBanCiShu0Ci": "No remaining urgent reminders for this month, cannot expedite.",
    "QuXiaoRenWuHouJiangBuZaiShouDaoHuiFu": "After canceling the task, you will no longer receive responses. Are you sure you want to cancel?",
    "KeHuDeZhaoYangXiangQing": "Sample request details for customer",
    "QuXiaoRenWu": "Cancel task",
    "JiaJiCuiBan": "Urgent reminder",
    "ZhaoYangPingZheng": "Sample voucher",
    "WeiShangChuan": "Not uploaded",
    "ShangPinShuoMing": "Product description",
    "LiRuGongNeng": "For example, function, color, material, specified brand, packaging requirements, etc.",
    "FuZhiShuoMing": "Copy instructions",
    "KeHuPianHao": "Customer preference",
    "KeJieShouLeiSi": "Accept similar",
    "ZhiKanYiJiaGou": "Show only add-on",
    "RenWuidGeShiZhengQue": "Task ID format is correct!",
    "GongZuoTai": "Workbench",
    "KeHuZhaoYangJiLu": "Customer sample records",
    "RenWuID": "Task ID",
    "YouJiaGou": "Has add-on purchase",
    "DaiKeHuFaQiZhaoYang": "Customer-initiated sample request",
    "XuanZeZhangHao": "Select account",
    "FaBuZhaoYangWenJianShangChuan1": "Upload email/chat screenshots as proof of customer's genuine sample request",
    "FaBuZhaoYangWenJianShangChuan2": "Upload files, support images/compressed files/Excel, single file supports up to 200M, maximum 5 files",
    "QingXuanZeShangChuanYouJianHuoZheLiaoTianJieTu": "Please select to upload email or chat screenshots",
    "MiaoShuYaoZhaoDeShangPin": "Describe the desired products",
    "ShuoShuiKeHuDeYiXiePianHao": "Tell us some preferences of the customer to get more accurate and suitable products",
    "TiGongZiLiao/TuPian": "Provide documents/images",
    "FaBuZhaoYangWenJianShangChuan3": "Upload files, support images/compressed files/Excel, single file supports up to 200M, maximum 100 files",
    "KeJieShouTuiJianXiangSiKuan": "Accept recommended similar products",
    "ChaiJieRenWu": "Break down the task",
    "BianJiFenZu": "Edit group",
    "FenZuMing": "Group name",
    "QingShuRuFenZuMing": "Please enter group name",
    "FenZuWenJianShangChuan": "Upload files, support images, maximum 5 images",
    "QueRenShanChuGaiFenZu": "Confirm deletion of this group?",
    "ZanBuFenZu": "Not grouped yet",
    "XuanZeYiGeFenZu": "Choose a group",
    "MeiYouTuPian": "No images",
    "SouSuoFenZu": "Search groups",
    "ZhuanWeiWuXiaoXuQiu": "Convert to invalid demand",
    "TianXieYuanYin": "Fill in the reason",
    "QingTianXieLiYou": "Please fill in the reason",
    "YiDengNTian": "Waited for {0} days",
    "RenWuDaiFenJie": "Task pending resolution",
    "JiJiaJiChu": "Pricing basis",
    "ShengYuNTianJieShuJieZhiZhiN": "{0} days left, ending on {1}",
    "BuChongShangPin": "Supplement items",
    "BuManYi": "Dissatisfied",
    "TuiJianDangQianZuiDuoHuiFuNKuan": "Recommend a maximum of {0} items",
    "YiXuanPinNKuanRenWuZhiYunXuTuiJianNKuan": "Selected {0} items, the task only allows recommending {1} items, exceeding items will be ignored. Continue to recommend?",
    "YiXuanShangPin": "Selected items",
    "WeiTuiJianNKuan": "Not recommended {0} items",
    "ChongFuDeShangPinHuiFuKeHuShiXiTongHuiZiDongQuZhong": "The system will automatically deduplicate when replying to customers with duplicate items",
    "JiaRuChengGong": "Successfully joined",
    "PinPai/GongYingShang": "Brand/Supplier",
    "KeBanShangPin": "Customized products",
    "YiQuanBuHuiFuKeHu": "All customers replied",
    "YiHuiFuKeHu": "Customers replied",
    "BiaoJiYiQuanBuHuiFuKeHu": "Mark all customers replied",
    "BiaoJiYiHuiFu": "Mark as replied",
    "YouXinDeBuChong": "New supplements",
    "EXWBiaoZhunBaoJiaGuiZeWenBen": "EXW Standard Quotation Rules<br/>\nQuotations where the shipping warehouse is the place of origin of the goods\n<br/>FOB Standard Quotation Rules<br/>\nIf the origin of goods is Shantou: Shantou (outbound warehouse)-Shantou (launching port)-40HQ (container) ",
    "ShangPinChuHuoCangMoRenWeiShangPinChanDi": "Product Shipment Warehouse Default to Place of Origin",
    "ZhiDingShangPinBaoJiaFangShiDaoBaoJiaDan": "Specified Pricing Method Exported to Quotation",
    "GenJuXuanZeDeChuHuoQuYu": "FOB Quotation: Calculated based on selected shipment area, port of destination, and container type; DDP Quotation: Calculated based on standard shipment area, port of destination, and container type for the selected route",
    "ShangPinChuHuoJiangAnSuoXuanChuHuoCang": "Product shipment will be priced based on selected shipment warehouse, port of destination, and container type, which may affect FOB apportionment costs and may result in local freight charges",
    "XiaDanShiRuoGuiZiChuHuoCang": "Note: Changes in shipment warehouse, port of destination, and container type when placing an order may affect FOB apportionment costs and may result in local freight charges (when shipment warehouse and place of origin are not in the same region)",
    "XuanZeMuBanHeYuYan": "Select Template and Language",
    "DanGePCS": "Single PCS",
    "ShangPinChanDi": "Product Origin",
    "GuoJiaBuNengWeiKong": "Country cannot be empty",
    "DingJinCuiShou": "Deposit Collection",
    "WeiKuanCuiShou": "Final Payment Collection",
    "ChuHuoKuanXiangYiChangCuiShou": "Abnormal Shipment Payment Collection",
    "WeiKuanCaiWuRenGongCuiShou": "Final Payment Financial Manual Collection",
    "BenDanDingJinYiJingShenQingChaoXin": "The deposit for this order has been applied for an extension",
    "ZuiWanQueRenShiJian": "Latest Confirmation Time",
    "YiYuQiNTian": "Overdue for {0} days",
    "JiangHuiYanQiChuHuo": "Delivery will be delayed",
    "ShiJiZhuangGuiShiJian": "Actual Container Loading Time",
    "HuoGuiYiDaoGang": "Container has arrived at port",
    "HuoGuiHaiYouNTianDaoDaGangKou": "Container will arrive at the port in {0} days",
    "WeiAnShiShouKuanJiangYingXiangKeHuTiGui": "Failure to pay on time will affect the customer's container pick-up",
    "KaiChuanShiJian": "Departure Time",
    "HaiXuZhiFuDingJin": "Deposit Still Needed",
    "HaiXuZhiFuWeiKuan": "Final Payment Still Needed (including other fees)",
    "YuJiXuZhiFuWeiKuan": "Estimated Final Payment Still Needed (including other fees)",
    "GeQuYuZhongQingDouXuanZeYiZuGenDanRenYuan": "Please select a team of follow-up personnel in each region",
    "XiuGaiCaiGouGenJinFenZu": "Modify procurement follow-up group",
    "XunJiaKeFu": "Inquiry customer service",
    "JieDanKeFu": "Order receiving customer service",
    "GenDanKeFu": "Order follow-up customer service",
    "YiGenJinKeHuShu": "Number of customers followed up",
    "XunJiaHuiFu": "Inquiry response",
    "KeHuXuQiuGuanLi": "Customer demand management",
    "KeHuYiJingJinRuBanGongKaiZhuangTai": "The customer has entered a semi-public status and may be followed up by other sales managers",
    "BianJiDingCangQiTaShouHuoRenXinXi": "Edit other consignee information for booking",
    "XinZengDingCangQiTaShouHuoRenXinXi": "Add new consignee information for booking",
    "DangDingCangShouHuoRenYuHeTongMaiFangBuYiZhiShi": "When the consignee for booking is different from the buyer on the contract, auxiliary proof is required, such as emails or agreements",
    "ShuRuGongSiMingCheng": "Enter the company name",
    "ZhengMingWenJian": "Supporting documents",
    "ShouHuoRenTuPianShangChuan": "Supports uploading images, Word, Excel, PDF files. Up to 10 files are supported, with a maximum size of 50MB per file",
    "QingTianXieHuoDaiLianXiRenXinXi": "Please fill in the freight forwarder contact information",
    "QingShuRuZhengQueDeQQ": "Please enter the correct QQ",
    "QingShuRuZhengQueDeYouXiang": "Please enter the correct email",
    "BianJiHuoDaiLianXiRen": "Edit freight forwarder contact",
    "XinZengHuoDaiLianXiRen": "Add freight forwarder contact",
    "BianJiHuoDaiXinXi": "Edit freight forwarder information",
    "XinZengHuoDaiXinXi": "Add freight forwarder information",
    "GuoNeiHuoDai": "Domestic freight forwarder",
    "HuoDaiGongSi": "Freight forwarder company",
    "QingShuRuHuoDaiGongSiMingCheng": "Please enter the freight forwarder company name",
    "ShuRuHuoDaiGongSiMingCheng": "Enter the freight forwarder company name",
    "HuoDaiGongSiDiZhi": "Freight forwarder company address",
    "ShuRuHuoDaiGongSiDiZhi": "Enter the freight forwarder company address",
    "GuoNeiHuoDaiLianXiRen": "Domestic freight forwarder contact (at least one required)",
    "ZhiShaoYouYiGeGuoNeiHuoDaiLianXiRen": "At least one domestic freight forwarder contact is required",
    "QingShuRuZhengQueDeEmail": "Please enter a valid Email",
    "BianJiTongZhiRenXinXi": "Edit notifier information",
    "XinZengTongZhiRenXinXi": "Add notifier information",
    "QingZuiShaoGouXuanYiGeDingDan": "Please select at least one order",
    "DanGeDaoChu": "Export individually",
    "ChuanWuZiLiaoMuBanDaoChu": "Shipping document template export",
    "YiChaoShiNTian": "Overdue {0} days",
    "ChaoShiNTianJiangWuFaDingCang": "Exceeding {0} days will not be able to book",
    "HuiYanQiChuHuo": "Will delay shipment",
    "ZuiWanChuLiShiJian": "Latest processing time",
    "YuZhuangGuiRiQi": "Pre-stuffing date",
    "MaiFang1": "Seller 1",
    "QueRenYiJingJianChaSuoYouDeChuanWuZiLiao": "Confirm that all shipping documents have been checked? Once submitted, any changes may affect booking and dispatch.",
    "BianGengChuanWuZiLiaoKeNengYingXiangDingCangDingChe": "Changing shipping documents may affect booking and dispatch, please change the information carefully.",
    "HeTongXinXiWeiWanShan": "Contract information is incomplete. Please go to the customer homepage - Sales Contracts to complete the contract information before continuing.",
    "ChuanWuDaiBan": "Shipping pending tasks",
    "GengXinChuanWuZiLiao": "Update shipping information",
    "QueRenChuanWuZiLiao": "Confirm shipping documents",
    "DaoRuTianChong": "Import and fill",
    "ShouQuanDiaoHuo": "Authorize cargo delivery",
    "YunShuFangShi": "Mode of Transport",
    "HuoDaiXinXi": "Freight Forwarder Information",
    "GuoNei": "Domestic",
    "JingWai": "Overseas",
    "QingXuanZeYiGeHuoDai": "Please Select a Freight Forwarder",
    "RuXuZhiDingLianXiRenQingZaiYiXiaLianXiRenZhongJinXingZhiDing": "If you need to specify a contact person, please specify it among the following contacts, and the shipping department will contact the specified contact person",
    "QingXuanZeXiaoShouHeTong": "Please Select a Sales Contract",
    "FaHuoRenXinXi": "Shipper Information",
    "QingXuanZeYiGeFaHuoRen": "Please Select a Shipper",
    "DingCangShouHuoRen": "Booking Consignee",
    "QingXuanZeYiGeShouHuoRen": "Please Select a Consignee",
    "TongZhiFang": "Notifier",
    "QingXuanZeYiGeTongZhiFang": "Please Select a Notifier",
    "QingXuanZeYunShuFangShi": "Please Select a Mode of Transport",
    "HaiYun": "Sea Freight",
    "TieLu": "Railway",
    "KongYun": "Air Freight",
    "QiYun": "Road Freight",
    "ChuDanFangShi": "Bill of Lading Type",
    "TiDanLeiXing": "Bill of Lading Type",
    "QingXuanZeTiDanLeiXing": "Please Select a Bill of Lading Type",
    "GangKouXinXi": "Port Information",
    "MuDiGang": "Destination Port",
    "GuoJia-ZhiChiShuRuShaiXuan": "Country - Supports Input Filtering",
    "QingTianXieMuDiGang": "Please Fill in the Destination Port",
    "MuDiDi": "Destination",
    "QingShuRuMuDiDiChengShiMingCheng": "Please Enter the Destination City Name",
    "ZhiDingTiDanPinMing": "Specify Bill of Lading Cargo Name",
    "BuZhiDing": "Not Specified",
    "ZhiDing": "Specified",
    "QingShuRuZhiDingDePinMing": "Please Enter the Specified Cargo Name",
    "ZhiDingDePinMing": "Specified Cargo Name",
    "HuoWuMiaoShu": "Cargo Description",
    "BaoKuoDanBuXianYuHuoWuPinMing": "Including but not limited to cargo names, transit terms, and customer requirements. If not filled in, the shipping department will classify the cargo name",
    "QingXianChuLiZaiTiJiao": "Please Process First Before Submitting",
    "QingXianChuLiWanChengZaiTiJiao": "Please Process First Before Submitting",
    "YuanChuHuoQuYu": "Original Shipping Area",
    "YuanBaoJiaFangShi": "Original Quotation Method",
    "YuanXiaShuiGang": "Original Port of Loading",
    "YuanHuoGuiLeiXing": "Original Container Type",
    "XinChuHuoQuYu": "New Shipping Area",
    "XinBaoJiaFangShi": "New Quotation Method",
    "XinHuoGuiLeiXing": "New Container Type",
    "XinXiaShuiGang": "New Port of Loading",
    "TiaoZheng": "Adjustment",
    "ChuanWuFeiYongYiChang": "Shipping Fee Abnormality",
    "ChuanWuDingCangQiTaFuJiaZongFeiYong": "Total Additional Booking Fees for Shipping",
    "FuJiaHuoDaiFeiYong": "Additional Freight Forwarder Fees",
    "FeiYongShuoMing": "Fee Description",
    "WoSiQuanBuChengDan": "Our Company Bears All",
    "KeHuChengDan": "Customer Bears",
    "WoSiChengDan": "Our Company Bears",
    "WoSiChengDanBuFenJiangHuiYingXiangXiaoShouLiRunJiSuan": "Note: Our Company's Portion of the Responsibility Will Affect Sales Profit Calculation",
    "QueRenShanChuHuoDaiXinXi": "Confirm Deletion of Freight Forwarder Information?",
    "ShiFouYaoShanChuShouHuoRenXinXi": "Do you want to delete consignee information?",
    "ShiFouYaoShanChuTongZhiRenXinXi": "Do you want to delete notifier information?",
    "WuLiuChuanWuZiLiaoGuanLi": "Logistics and Shipping Information Management",
    "XinZengHuoDai": "Add Freight Forwarder",
    "TongZhiRenXinXi": "Notifier Information",
    "XinZengTongZhiRen": "Add Notifier",
    "DaiQueRenChuanWuZiLiao": "Pending Confirmation of Shipping Documentation",
    "ChuanQiBianDong": "Shipping Schedule Change",
    "PODanHuoHaoYanQiShangPinYiChuLi": "The delayed goods in the PO order have been processed and there is no need for replenishment for now",
    "ChuLiChengGong": "Successfully Processed",
    "DingCangYiChangChuLi": "Abnormal Booking Handling",
    "QuDiaoBuHuo": "Go to Replenishment",
    "ChuLiYiChang": "Handle Abnormalities",
    "HuoHaoYanQi": "Delay in Goods",
    "ShouHuoKuanXiangYiChang": "Abnormal Receipt Payment",
    "ZhuangGuiKuanXiangYiChang": "Abnormal Container Payment",
    "AnYuanShouHuoShiJian": "According to Original Receipt Time",
    "XiuGaiShouHuoShiJian": "Modify Receipt Time",
    "XiuGaiShouHuoShiJianZhi": "Modify Receipt Time to (Latest Receipt Time for this Booking {0})",
    "AnYuanYuZhuangGuiShiJian": "According to Original Container Loading Time",
    "DiaoBu/QuXiaoShangPin": "Adjust/Cancel Goods",
    "JieShouXinYuZhuangGuiShiJian": "Accept New Container Loading Time",
    "KuanXiangYiDaoAnYuanYuZhuangGui": "Payment Received, According to Original Container Loading Time",
    "ChaoXinChuHuoAnYuanYuZhuangGui": "Express Shipment, According to Original Container Loading Time",
    "YanQiZhuangGui": "Container Loading Delay",
    "XuanZeRiQi": "Select Date",
    "ChuLi": "Process",
    "YuZhuangGui": "Pre-stuffing",
    "Dai2KeHuQueRen": "Confirmation on behalf of the customer",
    "YuJiYouFengXian": "There may be risks",
    "YouFengXian": "There are risks",
    "ShuiHao": "Tax identification number",
    "MuBiao": "Objectives",
    "ShiJi": "Current situation",
    "JiDuWanChengBiLi": "Quarterly percentage of completion",
    "JiDuJinE": "Quarterly amount",
    "NQianYuan": "{0}K",
    "PinTaiZhangHao": "Platform account",
    "WuZhangHao": "No account",
    "XinBieWeiWanShan": "Gender not specified",
    "QiTaLianXiFangShi": "Other contact",
    "Jin30TianDengLuTianShu": "Login days in the last 30 days",
    "DangQianKaiFaKeHuQuanYiShuLiangShengYu": "Currently develop the number of customer rights remaining {0}",
    "YiFaSongShenQingKeYiQianWang": "You can go to [My Clients] to check",
    "ShenQingXinNeiRongBuNengWeiKong": "The content of the application letter cannot be empty",
    "QingXuanZeNiDeKeHuMuBiao": "Please select your client target",
    "QingXuanZeShiFouFaSongYouJian": "Please choose whether to send an e-mail or not",
    "FaSongShenQing": "Send request",
    "XiTongFaYouJian": "The system sends an e-mail",
    "XiTongBuYaoFaYouJian": "The system does not send e-mail, I send it myself.",
    "YuLanYouJian": "Preview Email",
    "FuZhiYouJianHTML": "Copy HTML",
    "RuGuoYaoZiJiFaSongYouJian": "If you want to send the email yourself, please copy the email HTML and paste it into the email editor (HTML view)",
    "WoYaoTiShengKeHuMuBiao": "I want to improve my customer's goals (multiple choices)",
    "TiShengXiaoShouE": "Increase sales",
    "TiGaoKeHuDengLuCiShu": "Increase the number of customer logins",
    "ZengJiaKeHuZiZhuXuanPin": "Increase the number of customer self-selection",
    "ZengJiaShangPinTuiJianCiShu": "Increase the number of product recommendations",
    "FaSongYouJian": "Send Mail",
    "RuGuoXuanZeZiJiFaSongYouJian": "If you choose to send an email, please copy the HTML and edit the content after sending the application.",
    "QingTianXieShenQingTuiJianXin": "Please fill out the application letter of recommendation, show your specialty is more likely to be accepted by customers, please pay attention to the language of customers.",
    "KeHuGenJin": "Customer Follow-Up",
    "QingXuanZeJieBangDeKeHu": "Please select the customer you want to unbind.",
    "NiXuYaoWanChengYiXiaCaoZuo": "You need to complete the following operations",
    "DaiJieBangKeHu": "Customers to be unbound",
    "YiXiaKeHuChuYuWuDingDanGenJinZhuangTai": "The following customers are in the status of no order follow-up, and can be safely unbound, please select the customer to be unbound",
    "JieChuBangDingNGeKeHu": "Unbind {0} customers",
    "DaiSheZhiCaiGouFenZu": "Pending setup of purchasing groups",
    "YiXiaKeHuWuCaiGouZu": "The following customers do not have purchasing groups, and all of them must be set up before you can access the workbench operation.",
    "QingJieBangNGeKeHuHouJiXuCaoZuo": "The current number of bound customers has exceeded the specified number of interests, please unbind {0} customers to continue the operation.",
    "BuBaoHanGongChangLianXiFangShi": "Factory contact information not included",
    "QuanBuYeJiZuZhang": "All performance team leaders",
    "QingXuanZeYeJiZuZhang": "Please select the performance team leader",
    "DaoChuDeBaoJiaDanBuBaoHanGongChangLianXiFangShi": "The exported quotation does not contain factory contact information",
    "PiLiangSheZhiFenZu": "Batch setup grouping",
    "TuPianXingShi": "Picture form",
    "MoRenPaiBanFangShi": "Default layout",
    "ChongXinJiaRuXuanPin": "Rejoining the selection",
    "PingTai1": "Platform 1",
    "TianJiaDaoFenZu": "Submitted to subgroup",
    "ZanBuJiaRu": "for the time being, do not join",
    "XiaoShouShiChang": "sales marketplace",
    "WuMuBiao": "No target",
    "QuanBuZuZhang": "All team leaders",
    "LianXiKeFu2": "Contact Customer Service",
    "YiCaiShouYe": "ESSA Homepage",
    "GuanZhuYiCai": "Follow ESSA",
    "APPXiaZai": "APP Download",
    "WeiXinSaoYiSaoTianJiaKeFu": "Scan to add customer service",
    "APPLiuLanGengBianJie": "Browsing on the APP is more convenient",
    "GongChangRuZhu": "Factory Entry",
    "WoDeYiCai": "My ESSA",
    "ZhanDianQuYu": "Site Area",
    "ShangPinPinLei": "Product Categories",
    "JiaGe（Yuan）": "Price (RMB)",
    "MOQ（WaiXiang）": "MOQ(Box)",
    "HuoQi (Tian)": "Delivery time (days)",
    "WaiXiangTiJi (m3)": "Box Volume (m3)",
    "BaoZhuangTiJi (m3)": "Packing Volume (m³)",
    "QingXuanZeBaoZhuangLeiXing": "Please select packaging type",
    "QingXuanZeRenZhengBiaoZhun": "Please select certification standard",
    "GongChangDaQuan": "Brands",
    "ZhanTingTuiJian": "Exhibition Hall",
    "HuanYingNin": "Welcome",
    "MianFeiZhuCeMianFeiShiYong": "Free Registration, Free Trial",
    "GongChangShangXin": "New Arrivals from Factories",
    "ChaKanXinPin": "View New",
    "XuanPinDongTai": "Product Selection Updates",
    "HaoGongChang": "Quality Plants",
    "BaiYuanGaoXingJiaBiHaoHuoGaoLiRunDanPinJinZaiYiCai": "Budget-friendly goods with high profit margins are available at ESSA",
    "ChaKanQuanBuGongChang": "View All Factories",
    "YouZhiGongChang": "High-Quality Factories",
    "ZhuYing": "Main Products",
    "GongChangTuiJianHaoHuoXunZhaoShangJiJinZaiQiZhong": "Factory-recommended goods, find business opportunities, all here",
    "SouSuoZhaoShangPin": "Search for Products",
    "ShiTuZhaoShangPin": "Image Recognition for Products",
    "LeiMuZhaoShangPin": "Category Search for Products",
    "DaoChuShangPinZiLiao": "Export Product Information",
    "FaZhanLiShi": "Development History",
    "PingTaiShiLi": "Platform Strength",
    "ChanPinTeSe": "Product Features",
    "QiYeWeiXin": "Enterprise WeChat",
    "FuWuShiJian": "Service Hours",
    "LianXiKeFu3": "Contact Customer Service",
    "YiCaiXuanPinNReXiaoPaiHangBangTuiJianSEO_T": "ESSABUY Top Selling Recommendations for {0}",
    "YiCaiXuanPinNReXiaoPaiHangBangTuiJianSEO_KW": "ESSABUY Recommendations for {0}, Top Selling Rankings {1}",
    "YiCaiXuanPinNReXiaoPaiHangBangTuiJianSE_DS": "On ESSABUY, based on user selection behavior, a hot-selling list of detailed toy categories is compiled, providing users with real product references",
    "YiCaiXuanPinYiXiangChuHuoSEO_T": "Wholesale \"One Box Fast Delivery\" - Page {0} - ESSABUY",
    "YiCaiXuanPinYiXiangChuHuoSEO_KW": "One Box Purchase Available on ESSABUY",
    "YiCaiXuanPinYiXiangChuHuoSEO3_DS": "On ESSABUY, find high-quality manufacturers, well-known factories, top suppliers, strong sellers, with over 3 million hot-selling products, at cheap prices for wholesale to customers in five major global regions: Toys, Sporting Goods, Stationery, Festive Supplies, Children's Outdoor Vehicles, Baby Products, and Tableware, supporting online product selection, inquiries, and exporting of quotation sheets on computer and APP to recommend to customers",
    "YiCaiXuanPinGuoNeiZhuanGongSEO_T": "Wholesale in Domestic Sales Area - Page {0} - ESSABUY",
    "YiCaiXuanPinGuoNeiZhuanGongSEO_KW": "Domestic Sales Area on ESSABUY",
    "YiCaiXuanPinGuoNeiZhuanGongSEO_DS": "On ESSABUY, find high-quality manufacturers, well-known factories, top suppliers, strong sellers, with over 3 million hot-selling products, at cheap prices for wholesale to customers in five major global regions: Toys, Sporting Goods, Stationery, Festive Supplies, Children's Outdoor Vehicles, Baby Products, and Tableware, supporting online product selection, inquiries, and exporting of quotation sheets on computer and APP to recommend to customers",
    "YiCaiXuanPinXinPinSEO_T": "{0} Wholesale Manufacturers - {1} Wholesale Platform - {2} Wholesale First-hand Source Website_ESSABUY",
    "YiCaiXuanPinXinPinSEO_T2": "{0} Wholesale Manufacturers - {1} Wholesale Platform - {2} Wholesale First-hand Source Website_ESSABUY_Page {3}",
    "YiCaiXuanPinXinPinSEO_T3": "Educational Toy Wholesale Manufacturers_Educational Toy Wholesale Platform_Educational Toy Wholesale First-hand Source Website_ESSABUY",
    "YiCaiXuanPinXinPinSEO_T4": "ESSABUY Page New Product Title 4: Educational Toy Wholesale Manufacturers_Educational Toy Wholesale Platform_Educational Toy Wholesale First-hand Source Website_ESSABUY_Page {0}",
    "YiCaiXuanPinXinPinSEO_KW": "Wholesale Toy First-hand Source Website, Educational Toy Wholesale Website, Educational Toy Wholesale Manufacturers, Educational Toy Wholesale Platform, Educational Toy Wholesale First-hand Source",
    "YiCaiXuanPinXinPinSEO_DS": "ESSA wholesale educational toy first-hand source website updates detailed parameters, real-time quotations, and price trends of new toys daily, providing important references for traders to recommend new products to purchasers.",
    "YiCaiXuanPinLeiMuSEO_T": "{0}-{1}Wholesale-{2}All manufacturers direct [Newest Quotation|One Box Quick Out]_ESSABUY",
    "YiCaiXuanPinLeiMuSEO_T2": "{0}-{1}Wholesale-{2}All Manufacturers Direct [Latest Quotation|One Case Fast Dispatch]_Page {3}ESSABUY",
    "YiCaiXuanPinLeiMuSEO_DS": "Found {0} products on ESSABUY. Here are the latest quotations, special promotions, suppliers, and related images for {1}.",
    "DiNYe": "Page {0}",
    "ShenQingChaKan": "Apply to View",
    "ZhangHaoWeiRenZheng2": "Account not authenticated",
    "QuanBuLianXiRen": "All Contacts",
    "GouWuCheBaoJiaDan": "Cart (Quotation Sheet)",
    "FaBuXinZhaoYang": "Publish New Sampling",
    "ChaKanCiKuanShangPinXiangQing": "View Details of this Product",
    "JiaRuXuanYangChiYiShiGongChangZuiJinGengXinJiaGe": "Added to Sampling Pool, factory's latest price updated",
    "JiaRuXuanYangChiChengGong2": "Added to Sampling Pool successfully, system has automatically inquired about the latest price from the factory",
    "XuanYangChiYiYouCiShangPin": "This product is already in the sampling pool, the factory's latest price has been updated",
    "XuanYangChiYiYouCiShangPin2": "This product is already in the sampling pool, the system has automatically inquired about the latest price from the factory",
    "JiaGeGengXinJiaRuXuanPinChiZiDongXunZuiXinJia": "Prices are updated and added to the selection pool to automatically ask for the latest price.",
    "GengXinJiaGe": "Price Update",
    "XuanYangChiZhongYiCunZaiCiShangPin": "This product already exists in the sample pool",
    "GongChangJianJie": "Factory Profile",
    "ChaKanLiShiZuJi": "View Historical Footprints",
    "WanShanZiLiao": "Improve Information",
    "BaoHuShangPinShenQingChaK": "Protected Product Application View",
    "ShuJuYinQing": "Data Engine",
    "YiDaCheng": "Achieved VIP",
    "JiJiangDaCheng": "Soon to be VIP",
    "NCiDengLu": "{0}+Logins",
    "NKuanXuanPin": "{0}Selection",
    "NKuanXunJia": "{0}Article Inquiry",
    "NCiDengLuTianYouDengLuSuan": "{0}Logins (1 login in 1 day is counted as 1 login)",
    "QingShuRuXuYaoSouSuoDeNei": "Please enter the content to be searched",
    "DaYin": "Print",
    "ShangPinTiWen": "Questions about products",
    "FaPiaoXuCaiWuQueRenHouZaiDaoChu2": "Invoices need to be confirmed by finance before exporting.",
    "FaPiaoZhongBao": "Invoice (Medium Pack)",
    "FaPiaoPcs": "Invoice (PCS)",
    "TieZhiDeZhiZuoXuYaoYiDingChengBen": "The production of stickers requires a certain cost, the sticker fee is determined by the number of goods used in the container.",
    "DingDanCaoZuoXuYaoRenGongChengBen": "Order operation requires labor costs, service fees are determined by the number of goods in the container.",
    "TongYiESSAXieZhuDiaoHuo": "Agree that ESSA will assist in the transfer of goods",
    "BuTongYiXuYaoTongZhiWo": "Disagree, need to notify me",
    "XiaDanHouHuoPinZaiShengChanGuoChengZhong": "After the order is placed, the goods in the production process, may be due to certain reasons for delays in delivery, in order to avoid delays in loading time due to a small number of goods delivery problems, is it permissible to authorize ESSA according to the production progress of the reasonable transfer of goods and notify me. (Note: When some goods have been delayed affecting the entire container shipment time, ESSA will help you to other production in the cabinet of goods and the cabinet for some of the goods exchange, to ensure that the cabinet can be in accordance with the scheduled time of shipment)",
    "TieZhiHeMaiTou": "Stickers and Marks",
    "XiuGaiDingDanYaoQiu": "Modify order requirements",
    "DiaoHuo": "Adjustment of goods",
    "BianGengChuanWuZiLiao": "change shipping information",
    "QueRenQuXiaoGaiShangPin": "Confirmation of cancellation of the product?",
    "JuYouBanQuanZhengYi": "Copyright dispute",
    "XiaDanRiQi": "Date of order",
    "CaiGouDeShangPin": "Purchased goods",
    "YouTiWen": "Have a question",
    "YouGongChangFanKui": "Have factory feedback",
    "QuXiaoDeShangPin": "Canceled items",
    "BuManGuiChuHuo": "Not shipped out of the cabinet",
    "QueDingQuXiaoGaiDingDan": "Are you sure you want to cancel this order?",
    "BuManGuiKeYiDiaoRuShangPin": "Cabinets are not full, you can transfer in items or restock them",
    "ShouQiQuanBu": "Collect all",
    "XianShiQuanBu": "Show all",
    "BuManGuiChuHuoChengGong": "Shipped out of the closet successfully!",
    "QueRenBuManGuiChuHuo": "Confirm shipping out of the container?",
    "SouSuoShangPinBianHaoHuoGongChangHuoHao": "Search by item number or factory number",
    "YiYuQiNTianWeiZhiFuDingJin": "Attention:The deposit has been overdue for {0} days, please contact the customer as soon as possible!",
    "YiYuQiKuanXianQiNei": "Attention:It has been overdue (within the grace period), please contact the customer to pay the deposit as soon as possible",
    "CaiGouShangDeGuDingBaoZhengJinHaiKeDanBaoHuoKuanEDu": "Attention: The buyer's fixed deposit may also guarantee payment for goods in the amount of {0}, please contact the buyer to confirm the PO as soon as possible, so as to avoid delays in the delivery date.",
    "CaiGouShangDeHaiKeDanBaoHuoKuan": "Attention: The buyer's fixed deposit can also guarantee the payment of {0}, which is not enough to guarantee this order, please contact the buyer to increase the guarantee amount.",
    "CaiGouShangDangQianWeiMianDingJinKeHu": "Note: The buyer is a deposit-free customer, please confirm the PO directly.",
    "CaiGouShangDeKeYongZiJinZuGouZhiFuGaiBiDingDanDingJin": "Attention: The purchaser's available funds are enough to pay the deposit {0}, please confirm the PO as soon as possible, so as not to affect the production.",
    "DangQianKeYongZiJinBuZuZhiFuBenDanDingJin": "Attention: the current available funds are insufficient to pay the deposit of this order {0}, please contact the buyer to increase the available funds, as soon as possible to complete the deposit payment, so as not to affect production",
    "ZhangHuBaoZhengJinJinEBuZu": "Attention: The account margin amount is insufficient, but also need to allocate {0} to the account margin, please complete the allocation as soon as possible, so as not to affect the guarantee.",
    "DingDanYiTiJiaoQingZhiFuDingJin": "Attention:The order has been submitted, please pay the deposit.",
    "QingZaiChuHuoQianZhiFuDingJinN": "Attention:Please pay the deposit {0} before shipment.",
    "GaiDingDanHaiXuZhiFuDingJinN": "Note:The order also need to pay the walk away deposit {0}.",
    "CaiGouShangDangQianWeiMianDingJinKeHu2": "Note: The buyer is a deposit-free customer, please confirm the PO directly.",
    "CaiGouShangDeDingDanYiTiJiao": "Attention:The buyer's order has been submitted, please contact the buyer to pay the deposit as soon as possible, so as not to affect the factory production.",
    "CaiGouShangDeDingJinYiZhiFu": "Attention: The buyer's deposit has been paid, please contact the buyer to confirm the order as soon as possible, so as not to affect the factory production.",
    "CaiGouShangDeDingDanShangPinJiJiangWanChengShengChan": "Attention:The order of the buyer is about to complete the production, please contact the buyer to pay the payment as soon as possible, so as not to delay the arrival date.",
    "CaiGouShangDeDingDanShangPinYiJingZhuangGuiFaWangMuDiChengShi": "Attention: The goods ordered by the buyer have been loaded and shipped to the destination city, please contact the buyer to pay the final payment as soon as possible.",
    "YiTiJiaoDingDanNTianWeiTiGongTieMaiXinXiDe": "Attention:The order has been submitted {0} days, beyond {1} days without the provision of sticker information, the shipment time will be based on the sticker to provide the time to be postponed.",
    "QingShuRuXuYaoSouSuoDeNeiRong": "Please enter the content you need to search",
    "QuanBuYuanGong": "All staff",
    "KeHuZhuDongTianJia": "Customer initiated additions",
    "ZuiJinGenJin": "Recently Followed",
    "MoRenPaiXu": "Default Sorting",
    "LiShiKeHu": "Historical Customers",
    "QingXuanZeXiaoShouQuYu": "Please select sales area",
    "ShengYuMuBiaoJinE": "Remaining Target Amount",
    "JinNTianXuanPinShuLiang": "Number of products selected in the last {0} days",
    "ZuiHouZhaoYangShiJian": "Last Sample Search Time",
    "XiTongKaoHe": "System Assessment",
    "SheZhiCaiGouFenZu": "Setting Purchasing Groups",
    "JiaZaiZhong": "Loading",
    "JinTianGenJinGuo": "Followed up today",
    "NTianQianGenJinGuo": "Followed up {0} days ago",
    "QingXuanZeChanDiQuYu": "Please select the region of origin",
    "GongChangHuoHao（KeHu）": "Factory stock number (customer)",
    "WeiQueRenDingDanHuoZheKongDingDanCaiNengQuXiao": "Cancellation can only be done if PO is not confirmed or PO is empty",
    "WeiQueRenDingDanDeShangPinCaiNengQuXiao": "You can only cancel the item if you have not confirmed the PO",
    "QingShuRuXuSouSuoDeNeiRon": "Please enter the content you need to search",
    "ChaKanCaiGouShangQianKuan": "View a breakdown of the amount owed by the purchaser",
    "ZhuWeiXiangKeHuShouQuWeiT": "Note: \"+\" is charged to the customer, \"-\" is refunded to the customer",
    "BenDanYingShouFeiYongMing": "Breakdown of fees for this bill",
    "BenDanHeJiDaiZhiFu": "Total for this order to be paid",
    "ShangPinBianHaoShangPinMi": "Product number, product name, Product number from factory, customer order number and other keywords",
    "QuXiaoZiDongTiaoZhuan": "Cancel Auto Jump",
    "ZhongBo": "replay",
    "YuZhuangJuRiQiBianGengJiL": "Record of date change for pre-assembled cabinets",
    "ShiFouYiSheZhiPinMing": "Is the item name set",
    "ShiFouManJu": "Whether the cabinet is full or not",
    "ShiFouYiChang": "Whether the anomaly",
    "ShiFouDingJinYuQi": "Whether the deposit is overdue",
    "ShiFouHuoKuanYuQi": "Whether the payment is overdue",
    "ShiFouXianShang": "Whether the online PO",
    "YuQiTianShu": "Number of days overdue",
    "QueRenShengChanYaoQiu": "Confirmation of production requirements",
    "EssaoneLianXiWoMenSEO_BiaoTi": "Contact",
    "EssaoneLianXiWoMenSEO_MiaoShu": "Contact ESSAONE",
    "EssaoneLianXiWoMenSEO_H1": "Contact",
    "DingDanWeiZhiFuWeiKuanBuYunXuChuKu": "%s Goods for which the balance of the order price has not been paid cannot be released from stock.",
    "DaoChuTuPianYiBianHaoMing": "Export SKU image, named after SKU number",
    "XuanZeBaoBiaoYuYan": "Choose the language of the report",
    "BaoBiaoDaYin": "Print report",
    "QingXuanZeTuPianGuiGe": "Please select the image specification",
    "YuanTu": "Original picture",
    "QingShuRuShangPinBianHaoH": "Please enter the item number or factory number",
    "TeBieYaoQiu2": "Special Request",
    "HongShengJiuBianHao2": "Hongsheng previous number",
    "QuXiaoJiLu": "Cancel record",
    "YeWuYuan": "Account Manager",
    "DingDanHouTaiChuLiZhong": "Order is being processed in the background",
    "BianGengYuZhuangJuRiQi": "Change pre-loading date",
    "YuanZhuangJuShiJian": "Original loading time",
    "DangQianZhuangJuShiJian": "Current loading time",
    "XinZhuangJuShiJian": "New loading time",
    "QingXuanZeXinZhuangJuShiJ": "Please select the new loading time",
    "BianGengYuanYin": "Reason for change",
    "QingXuanZeBianGengYuanYin": "Please select the reason for change",
    "QingShuRuBianGengYuanYinB": "Please enter the reason for the change",
    "DuanTu": "Short Distance",
    "SouSuoDingDanHao/ShangPinBianHao": "Search for order number/item number",
    "QuQueRen": "Go to Confirmation",
    "DaiQueRenChuHuo": "Pending shipment confirmation",
    "FaHuoQueRen": "Shipment Confirmation",
    "ShiFouYaoQuBuChongChuanWuN": "Do you want to supplement the shipping information sheet number {0}",
    "QueRenChuHuoXinXi": "Confirm shipment information",
    "DingCang": "Booking",
    "XuanZeWoSiDingCangShiHouX": "When you choose our booking, you need to upload shipping information for subsequent orders.",
    "QingXuanZeDingCang": "Please choose how to book shipping",
    "WoSiDingCang": "We book shipping",
    "BuDingCang": "No booking",
    "YiHeShiQueRenYiShangXinXi": "The above information has been verified and confirmed, confirmed to submit",
    "DingDanZhengZaiChuLiDiaoH": "Order is being processed for transfer, please process later",
    "ZanWuChaKanQuanXian": "No permission to view",
    "POZhuangTai": "Po Order Status",
    "XuHao": "Serial number",
    "BianGengRen": "Change personnel",
    "BianGengShiJian": "Time of change",
    "BianGengLeiXing": "Change Type",
    "XinYuJiDaoGangRiQi": "New Expected Arrival Date",
    "QuXiaoShuLiang": "Cancellation Quantity",
    "SouSuoShangPinBianHaoMing": "Search Item Number / Name",
    "DingDanShangPinQuXiaoJiLu": "Order Product Cancellation Record",
    "KuaiDiDanSaoMiaoJian2": "Scanned copy of courier order",
    "KuaiDiHao": "Courier number",
    "DianFangBianMa": "Electric discharge code",
    "KuaiDiGongSi": "Courier Company",
    "ZhiJianDan": "Quality control sheet",
    "DingDanJinEXinXi": "Order Amount Information",
    "ZhangHuYuE": "Account Balance",
    "ShangPinZongJia": "Total price of the product",
    "KeYongDanBaoHuoKuanEDu": "Amount of available collateral",
    "ESSAZhuYiShiXiangNotCn": "ESSA Notes",
    "ESSAZhuYiShiXiangNotCnBeiZhu": "You can fill in your order, quality control requirements and production is completed after the goods are loaded and placed in the cabinet combination of non-production process requirements.",
    "ESSAZhuYiShiXiangCn": "ESSA Notes",
    "ESSAZhuYiShiXiangCnBeiZhu": "Please fill in Chinese",
    "QiTaShengChanYaoQiuNotCn": "Other production requirements",
    "QiTaShengChanYaoQiuNotCnBeiZhu": "To the customer to see, you for the above order production requirements and other additions, you can fill in, for example: all goods with batteries need to be disassembled batteries",
    "QiTaShengChanYaoQiuCn": "Other production requirements",
    "QiTaShengChanYaoQiuCnBeiZhu": "To the factory requirements, please use Chinese to fill in the production requirements",
    "GeXingYaoQiuNotCn": "Personalized request",
    "GeXingYaoQiuCn": "Personalized request",
    "GeXingYaoQiuNotCnBeiZhu": "You can fill in some of the personalized production requirements of the goods in your order, for example: stickers on the goods in which position",
    "GeXingYaoQiuCnBeiZhu": "You can fill in some of the personalized production requirements of the goods in your order, for example: stickers on the goods in which position",
    "ShiFouRangKeHuQueRenPO": "Whether to let the customer confirm the PO",
    "ShiFouRangKeHuQueRenPOTiShi1": "The customer has points, coupons, after submitting the order, is it pushed to the customer to confirm the PO?",
    "ShiFouRangKeHuQueRenPOTiShi2": "If the customer uses points/coupons, it will not affect your profit.",
    "TuiSongGeiKeHuQueRen": "Push to Customer Confirmation",
    "BuTuiSong": "No Push",
    "QingShuRuKeHuDingDanHao": "Please enter customer order number",
    "FanHuiGouWuChe": "Return to Shopping Cart",
    "SheZhiKeHuDingDanHao": "Set Customer Order Number",
    "LaiYuan": "Source",
    "ChengJiaoDanJia": "Transaction Unit Price",
    "PiLiangSheZhi": "Batch Setting",
    "SouSuoShangPinBianHaoGongChangHuoHao": "Search item number/factory stock number",
    "NGe": "{0}pcs",
    "QingXuanZeHeTongXinXi": "Please select contract information",
    "SuoYouKeHuDeDingDan": "All Customer Orders",
    "QuanBuDingDan": "All Orders",
    "DaiQueRenPO": "Pending PO Confirmation",
    "HuoQiYuQi": "Overdue",
    "ZhuangGuiZhong": "Loading",
    "7TianNei": "Within 7 days",
    "NYueNei": "Within {0}months",
    "NYueHou": "After {0} months",
    "SouSuoDingDanHaoShangPinBianHao": "Search order number/item number",
    "PODanXinXi": "PO Information",
    "KeYongDanBaoEDu": "Available guarantee amount",
    "ESSABUY_ResultPageType8": "Based on the purchaser's good credit, ESSA has granted a credit amount of {0} to be used to temporarily pay the deposit for this order.",
    "ESSABUY_ResultPageType1": "The current account fixed guarantee amount is insufficient, please allocate funds into the margin as soon as possible to avoid shadow guarantee orders. Also need to allocate {0} to account margin.",
    "ESSABUY_ResultPageType2": "The purchaser's fixed deposit is also available for guarantee amount (0}, which is not enough to guarantee this order. In order to confirm the order, we can recommend that the buyer's margin should be increased to {1}.",
    "ESSABUY_ResultPageType3": "The current account fixed margin amount is sufficient to guarantee this order, please click Confirm directly. After confirming the PO, you can enter the PO list of the buyer to check the production progress of the order.",
    "ESSABUY_ResultPageType4": "Please confirm the PO to avoid affecting the factory production. In order to avoid affecting the shipment of the order, please notify the buyer to pay the deposit for this order before shipment:{0}.",
    "ESSABUY_ResultPageType5": "If the available funds in your account are sufficient to pay the deposit for this order, please complete the deposit payment as soon as possible.",
    "ESSABUY_ResultPageType6": "If the available funds in the buyer's account are not enough to pay the deposit for this order, please contact the buyer as soon as possible to increase the available funds.",
    "ESSABUY_ResultPageType7": "No deposit is required for this order, please confirm PO directly.",
    "ESSABUY_ConfimTips_1": "Confirmation of payment will be deducted from the available funds (0} as a deposit for this order, after the payment of the deposit, the available funds in the buyer's account will be:{1}.",
    "ESSABUY_ConfimTips_2": "Confirmation of payment will deduct (0} from the available funds as deposit for this order, after payment of deposit there are still available funds in the purchaser's account:{1}.ESSA has granted the amount of {2} for this order to temporarily fulfill the deposit payment, but actually there is still a deposit to be paid:{3}, which needs to be paid before the final payment for this order.",
    "ChaKanKeHuZiJinXinXi": "View Customer Funds Information",
    "ChaKanBaoZhengJinXinXi": "View deposit information",
    "ESSABUY_SubmitTips_1": "Sorry, the order has been {0} confirmed! 2s later jump to PO order details page!",
    "ESSABUY_SubmitTips_2": "Confirm the order successfully, the purchasing department will arrange the factory to produce as soon as possible! After 2 seconds, it will be closed automatically, and you can enter the PO details page to check the production progress.",
    "KeHuZiJinXinXi": "Customer's fund information",
    "GuDingBaoZhengJinXinXi": "Fixed margin information",
    "ZhangHuBaoZhengJin": "Account Margin",
    "GuDingDingJinEDu": "Fixed deposit amount",
    "DanBaoHuoKuanEDu2": "Guaranteed payment amount",
    "MeiYuanGuDingDingJin": "USD Fixed Deposit",
    "RenMinBiGuDingDingJin": "RMB Fixed Deposit",
    "GongChangShengChanYaoQiuZhongWenHeWaiWenBiXuTongShiSheZhi": "Factory Production Requirements Chinese and foreign language must be set up at the same time",
    "ESSAZhuYiShiXiangZhongWenHeWaiWenBiXuTongShiSheZhi": "ESSA Notes must be set up in both Chinese and foreign languages.",
    "ShangPinShengChanYaoQiuZhongWenHeWaiWenBiXuTongShiSheZhi": "Chinese and foreign language must be set up at the same time for commodity production requirements.",
    "ShangPinShengChanYaoQiuZhongWenHeWaiWenBiXuTongShiSheZhi2": "Both Chinese and foreign language must be set up for the production of goods, the current data is invalid/the current data will not be saved.",
    "DingDanShengChanYaoQiu": "Order Production Requirements",
    "WuPOFeiYong": "No PO Charge",
    "FeiYongDanHeJi": "Total Expenses",
    "JinTianXuGenJin": "Need to follow up today",
    "YeWuJinTianXuGenJin": "Account Manager needs to follow up today",
    "XiaCiGenJinNeiRong": "Next Follow Up",
    "XiaCiGenJinN": "Next Followup {0}",
    "WuWeiHuoShangPin": "No last-minute items",
    "NTianHou": "{0} days later",
    "GenJinLiShi": "Follow-up History",
    "XiaCiGenJin": "Next Follow-Up",
    "FenPeiDeRenWu": "Assigned Tasks",
    "XinZengGenJin": "Add Follow-Up",
    "XinZengGenJinDengJi": "Add Follow-Up Registration",
    "DaiQueRenPI": "PI to be confirmed",
    "ZiJinZhangHu": "Funding Account",
    "KuanXuanZongJi": "Total amount of payment options",
    "KeZiYouZhiPei": "Discretionary",
    "YiDongJie": "Frozen",
    "ChuHuoHouHuiKouJianDuiYin": "Deposit guarantee for order shipment, the corresponding deposit will be deducted after shipment.",
    "YingFuKuan": "Accounts Payable",
    "XinYongBaoZhengJinEDu": "Credit Margin Limit",
    "DingDanChuHuoHouTuiHaiEDu": "Deductions after orders are shipped",
    "YiSuoDing": "Locked",
    "YongYuDingDanDeDingJinDan": "Used to secure a deposit for an order, a locked credit margin amount. After the order deposit is paid, the corresponding locked credit line is released.",
    "DingDanFuKuanHouTuiHaiEDu": "Refundable credit limit after order payment",
    "HuanChongYinYinXingHuoHui": "Buffer for problems caused by bank or exchange rate",
    "YiDongJieMingXi": "Blocked Details",
    "XinYongEDuMingXi": "Credit Limit Details",
    "SouSuoJinE": "Search Amount",
    "SouSuoDingDanHaoFeiYongDa": "Search Order Number/Expense Bill Number",
    "LaiKuanHeJi": "Total Incoming Payments",
    "YingFuKuanHeJi": "Total Accounts Payable",
    "YiFuKuan": "Paid",
    "QianKuan": "Outstanding",
    "WeiFenPei": "Unallocated",
    "KeDanBaoDeHuoKuan": "Guaranteed payment(￥)",
    "QiChuYuE": "Opening Balance",
    "LaiKuan": "Incoming Payment",
    "LaiKuanFang": "Incoming Payments",
    "SuoYouWeiChuHuoDingDan": "All Unshipped Orders",
    "YiChuHuo": "Shipped",
    "ZhiFuDingDanDingJin": "Deposit paid",
    "ZhiFuDingDanWeiKuan": "Payment of final payment",
    "ZhiFuDingDanQiTaFeiYong": "Payment of other costs of the order",
    "NGeDingDanYiZhiFuN": "{0} Orders Paid {1}",
    "HaiQianN": "Still owe {0}",
    "TiJiaoDingDanSuoDingDingJ": "Submit order, lock deposit",
    "ChuHuoKouJianBaoZhengJin": "Deduction of deposit for shipment",
    "SuoDingEDu": "Locked Amount",
    "YiTuiHai": "Refunded",
    "ChuangJianRiQi": "Creation Date",
    "XuanZeGenJinLianXiRen": "Select a contact to follow up with",
    "ShangChuanFuJian": "Upload Attachment",
    "KuanXianQiNei": "Grace period",
    "NTianYiShang": "More than {0} days",
    "NGeYingFuYiZhiFuN": "{0}payables,paid {1}",
    "NGeYingFu": "{0} payables",
    "GenJinShuoMing": "Follow-up Note",
    "MeiYouKeDaoChuDeShangPin": "There are no exportable items",
    "ZiJiGenJin": "Self Follow-Up",
    "YeWuGenJin": "Account Manager Follow-Up",
    "XiaCiGenJinRiQi": "Next follow-up date",
    "XiaCiGenJinNeiRongBeiWang": "Next follow-up content memo",
    "XuanZeYaoGenJinDeYeWuYuan": "Select the salesman to follow up, support multiple choice(required)",
    "NDeDingDan": "{0}'s order",
    "QingXuanZeGenJinLianXiRen": "Please select the contact person to follow up",
    "QingShuRuGenJinShuoMing": "Please enter the follow-up instructions",
    "ChuHuo1": "Shipments",
    "GaiBuFenEDuNiKeJiXuYongYu": "Available = Credit Deposit - Locked, which you can continue to use to secure your order",
    "KeYongZhangHuZongJiBaoZhe": "Available = Total account amount - deposit, which you can use at your discretion",
    "KeDanBaoHuoKuanZongE": "Total amount of goods available for guarantee",
    "ShengYuKeYongDanBaoEDu": "Remaining available guarantee amount",
    "GaiBiDingDanSuoXuHuoKuanD": "Required payment guarantee for this order",
    "KeDing": "Customer order number",
    "ZhuangXiangShangPinQingDa": "List of items to be boxed",
    "WaiXiangZhang": "Box-Length",
    "WaiXiangKuan": "Box-Width",
    "WaiXiangGao": "Box-height",
    "NeiXiangShu": "Number of inner boxes",
    "Essaone_PingTaiYinSiZhengCe": "Privacy policy",
    "NinYouDingDanZaiDanBaoZho": "You have an order under guarantee, please process it first",
    "ShenQingChaoXin": "Apply for funds in excess of credit limit",
    "ChuLiChaoXinShenQing": "Processing a request for funds in excess of the credit limit",
    "ChaEShuMu": "Difference",
    "QingShuRuChaEShuMu": "Please enter the amount of difference",
    "YuJiHaiKuanRiQi": "Estimated Repayment Date",
    "QingXuanZeYuJiHaiKuanRiQi": "Please select the expected repayment date",
    "ShenQingYuanYin": "Reason for application",
    "QingShuRuShenQingYuanYin": "Please enter the reason for your application",
    "QingShuRuBuTongGuoYuanYin": "Please enter the reason for failure (required)",
    "ShenHeYiJian": "Audit Opinion",
    "TongGuo": "Passed",
    "BuTongGuo": "Failed",
    "DaiChuLiChaoXinShenQing": "Pending request for funds in excess of credit limit",
    "QueDingXiuGaiDingDanYaoQi": "Confirm/Modify Order Request",
    "YiShenQingChaoXinDengDaiS": "Funds in excess of credit limit have been requested and are awaiting review.",
    "ShangCiShenHeBuTongGuo": "Last audit failed",
    "DingDanXuYaoZhiFuDingJin": "Deposit required {0}",
    "DingDanXuYaoZhiFuWeiKuan": "Final payment is required {0}",
    "QingTianXieShenHeYiJian": "Please fill in the review comments",
    "QingShuRuBuTongGuoYuanYin2": "Please enter the reason for failure",
    "DingJinTuiHai": "Deposit refund",
    "QueRenBuManJuChuHuo2": "Confirmation of non-containerized shipment",
    "WaiXiangTiJiAndMaoZhong": "Volume & Box Weight",
    "ChaKanHeTongXinXi": "View Contract Information",
    "MeiZhiChanPinDouXuYaoTieTieZhi": "Stickers are required for each product",
    "YuZhuangJuRiQi": "Pre-loading date",
    "DaiSheZhi": "To be set",
    "YuJiZhuangGuiShiJian": "Estimated loading time",
    "QingShuRuZhengQueDeChaESh": "Please enter the correct amount of difference",
    "ChaEShuMuBuNengDaYuFeiYon": "The number of differences cannot be greater than the cost amount",
    "XinZengKeHuXinXi1": "Add Customer Information",
    "BianJiKeHuXinXi1": "Edit Customer Information",
    "DingDanDaiChuLi": "Order Pending",
    "ShenQingChaoXinJiLu": "Apply for records exceeding the credit amount",
    "ZhiChiDanGeWenJianBuNengC": "Support {0}, a single file can not exceed {1}M, support up to {2} files",
    "ShenHeXiangQing": "Review Details",
    "GouWuQuanKeDuiHuanLiPin": "Vouchers can be redeemed for gifts",
    "MaShangShengQian": "Save Now",
    "DiKouDuiHuan": "50% Off, 50% Redeem",
    "QuanBuDuiHuanGouWuQuan": "Redeem All Vouchers",
    "JiFenContent4": "Current points balance 0, please get points before using.",
    "JiFenContent1": "Current points balance {0}, use {1} points, 50% for order credit {2} for shopping coupon {3} (deposit shopping coupon).",
    "JiFenTip1": "50% Credit, 50% Redemption: Up to {0}% of the order amount per order, of which {1}% will be used for order credit and {2}% will be redeemed as shopping coupons.",
    "JiFenContent2": "Current points balance {0}, use {1} points to redeem all coupons {2}.",
    "JiFenTip2": "Redeem All Vouchers: Up to {0}% of the order value can be redeemed as vouchers for each order.",
    "JiFenContent3": "Current points balance {0}, points will not be used for this order. However, points are not valid indefinitely, so it is recommended to use them promptly.",
    "PingJia": "Evaluate",
    "FaBiaoPingLun": "Post a comment",
    "ChaKanWoDeGouWuQuan": "View My Vouchers",
    "BenDingDanPingJiaHouKeJia": "Reward {0} shopping coupon after evaluation of this order",
    "BenDingDanPingJiaJiangLiG": "Reward {0} shopping coupon for this order",
    "PingJiaChengGong": "Evaluation Success",
    "WoDeGouWuQuan": "My Vouchers",
    "GouWuQuanMingXi": "Shopping Coupon Details",
    "QueRenDuiHuan": "Confirm Redemption",
    "YiDanQueRenDuiHuanHouJian": "Once the redemption is confirmed, it cannot be revoked, please confirm the information before redemption. Your exclusive sales manager will contact you after redemption, and it will be delivered to your designated address within 30 days, please wait for receipt.",
    "DuiHuanChengGong": "Redemption success",
    "DuiHuanShiBaiGouWuQuanBuZ": "Redemption failed, insufficient vouchers",
    "JiaRuShiJian2": "Join time",
    "1001GP0019": "Product information does not exist",
    "DuiHuanJiaZhiYiChaoGuoNin": "Redemption value has exceeded your voucher balance",
    "YongJiuShanChuDingDanXinX": "Delete Order Information Permanently",
    "ShanChuDingDanJiLu": "Delete Order History",
    "GouWuQuanDingDan": "Shopping Voucher Orders",
    "FaHuo": "Shipment",
    "ChaKanFaHuoXinXi": "View Shipping Information",
    "BuTuiKuanYiZaiQiTaRenWuTu": "Refusal of return",
    "ChuFaDi": "Departure",
    "YunFeiFuKuanDan": "Freight payment slips",
    "YunFeiZongJi": "Total freight costs",
    "YunFeiDanShangWeiSheZhi": "Shipping charge has not been set",
    "AnXinPin": "By New Products",
    "AnJiaGe": "By Price",
    "AnHuoQi": "By Date of Delivery",
    "QingXuanZeShiFouRangKeHuQ": "Please select whether to let customer confirm PO",
    "YiXuanTiaoJian": "Selected conditions",
    "JiJiangDaoZhangGouWuQuan": "Shopping Voucher {0} coming soon",
    "FaHuoXinXi": "Shipping Information",
    "FaHuoDanPingZheng": "Shipment Voucher",
    "TuPianDanGeWenJianBuNengC": "Image jpeg,jpg,png,bmp, individual file can not exceed {0}m, maximum {1} sheets",
    "BuNengQuanBuPingJiaXing": "Can't rate all 5 stars",
    "KeHuShiYongLeYouHui": "Customer Used Discount",
    "JiFenContent5": "Current Points Balance {0}",
    "QingShangChuanFaHuoDanPin": "Please upload the delivery note voucher",
    "JinNTianChaKanShangPin": "View products in the last {0} days",
    "YongJiuShanChuDingDanXinX2": "Order information is permanently deleted, but the product is still shipped.",
    "QingXuanZeShiFouShiYongJi": "Please choose if you want to use your points or not",
    "YouHuiDeJinEYiJunTanDaoSh": "The discounted amount has been equalized to the unit price of the product.",
    "DengDaiKeHuQueRenShiFouSh": "Waiting for customers to confirm whether to use coupons or points. Please be careful to confirm the PO, once you confirm the PO, the customer will not be able to use the coupon or points again.",
    "BuHuoChiShangPin": "Product(s) for replenishmen",
    "DingDanShuJuYiJingBianDongQingShuaXinHou1": "1. You have stayed on the page too long, and the product for which you are submitting the order has changed.<br />2. The submitted product contains anomalies or does not meet the requirements for placing an order: the order quantity does not meet the factory's starting delivery quantity, the order quantity does not reach the MOQ.<br />3. Please refresh and re-check the product, or return to the shopping cart to re-submit the order.<br />",
    "ZhengJuPaiDan": "Whole cabinet scheduling",
    "RuXiGuanAnJiJuXiaDanKeXua": "If you are accustomed to the set cabinet order, you can select the 【whole cabinet scheduling】.",
    "PinJuZhiNengCaoZuoZiJiZha": "Pooling cabinet can only operate their own account to add the purchase of goods!",
    "ShuXiDeGongNeng": "Hi, familiar function!",
    "RuXiGuanAnZhengJuXiaDanKe": "If you are accustomed to ordering by the whole cabinet, you can choose 【whole cabinet scheduling】to place an order. If large quantities of goods ordered and then consider loading the cabinet shipment, it is recommended to order directly.",
    "DingDanDeShangPinZhuanXia": "%s of the %s order items will be returned as existing stock.",
    "DingDanDeShangPinZhuanZai": "%s of the %s order items will be returned as in-transit stock.",
    "XiaDanDuiHuanGouWuQuan": "Place an order on ESSA to redeem shopping vouchers.",
    "XiaDanDiKouJinE": "Place an order on ESSA to deduct the order amount.",
    "NTianQian": "{0} days ago",
    "NJiFenJiJiangZaiNGuoQiQing": "{0} points will reset on {1}. Please use your points in time!",
    "WenJianMingMingGeShi": "File naming format",
    "GongChangMingChengShangPi": "Factory Name_Product No.",
    "TuPianDaXiao": "image size",
    "ShangPinBianHao2": "Product Number",
    "XiuGaiBaoJiaDanXinXi": "Modify quotation information",
    "NiHaiMeiYouTianXieGaiKeHu": "You have not filled in the analysis report of the customer, the customer will be unbound if you do not fill in the report after the due date.",
    "TianXieFenXiBaoGao": "Fill in the analysis report",
    "XiuGaiFenXiBaoGao": "Modify Analysis Report",
    "XinZengFenXiBaoGao": "Add Analysis Report",
    "ShangYiNianDuChengJiaoFen": "Distribution of previous year's transactions",
    "XianYouMuBiao": "Existing Target",
    "PingGuDeMuBiao": "Evaluated Targets",
    "TuiJianPinLv": "Recommendation Frequency",
    "DingJiaCeLve": "Pricing Strategy",
    "QingShuRuTuiJianPinLvShiL": "Please enter the frequency of recommendations, example: 3 times a month.",
    "DiYiJiDu": "First Quarter",
    "DiErJiDu": "Second Quarter",
    "DiSanJiDu": "Third Quarter",
    "DiSiJiDu": "Fourth Quarter",
    "QingShuRuDingJiaCeLveShiL": "Please enter the pricing strategy, example: customer hot models do not increase the price, the other plus 8 points; customer demand for more changes, a price, to leave space, it is recommended to add 15 points.",
    "XuanPinCeLve": "Product Selection Strategy",
    "QingShuRuXuanPinCeLveShiL": "Please enter the product selection strategy. Refer to the following dimensions: 1、 the main push of the small category, packaging, price point. 2、the main type of commodity selection, such as: new products, cost-effective, looking for alternative goods, functionality, novel packaging, card price, etc. 3、the main push of a single product, or the main push of the series. 4、the number of each push of the product",
    "JiaoYiTiaoJianCeLve": "Trading Conditions Strategy",
    "QingShuRuJiaoYiTiaoJianCe": "Please enter the trading conditions strategy, example: the customer currently all suppliers support the customer account period, need to directly talk about the account period support; the customer is currently working together are in the form of 30% deposit, can be done directly before shipment of 30%, to give the customer funds more than one month of time turnover.",
    "ZhuanHuaZhouQiMuBiao": "Conversion Cycle Goal",
    "QingShuRuZhuanHuaZhouQiMu": "Please enter a conversion cycle goal, e.g., one month, two months, six months.",
    "KeHuGuanZhuDengJi": "Customer Attention Level",
    "QingShuRuKeHuGuanZhuDengJ": "Please enter the customer attention level",
    "TiJiaoFenXiBaoGao": "Submit analysis report",
    "JinNianDuMuBiao": "This year's target",
    "RuGuoLinJinNianMoYunXuTia": "If near the end of the year, 0 is allowed",
    "JunTanDaoJiDuMuBiao": "Distribute to quarterly targets",
    "RuGuoLinJinJiDuMoYunXuTia": "If near the end of the quarter, 0 is allowed",
    "ZanMeiLiShiMuBiao": "No historical targets for now",
    "NianDuMuBiao": "Annual target",
    "YiGuoBuYongTian": "Expired, no need to fill",
    "QingShuRuJinNianDuMuBiao": "Please enter this year's target",
    "ZhaoYangYiBanHuiZaiTianNe": "Usually responds within 5 days, so watch for notification of results.",
    "ZhengMian": "Front",
    "QingShangChuanZhengMian": "Please upload the front.",
    "BeiMian": "Back",
    "QingShangChuanBeiMian": "Please upload the back.",
    "QingShuRuMiaoShuLiRuGongN": "Please enter a description, e.g. function, colour, material, brand, packaging, product URL, etc.",
    "BiXuYuTuPianShangPinYiZhi": "Must be the same as the picture.",
    "BiXuDaiShangPinZhengShu": "Certificate of conformity required",
    "ShangPinJiaGeBuChaoGuo": "Price not exceeding",
    "ZhiShaoShangChuanYiZhangT": "Upload at least one picture or fill in a description",
    "ShangChuanShangPinTuPian": "Upload product pictures",
    "RenWuWanCheng": "End of mandate",
    "YouZhaoDao": "Found it.",
    "QueRenChuHuoChengGong": "Confirm shipment",
    "YuJiCaiGouLiang": "Estimated quantities of purchases",
    "QingTianXieYuJiCaiGouLian": "Please fill in the estimated quantities of purchases.",
    "NianDuMuBiaoYuJiDuMuBiaoJ": "The sum of annual and quarterly targets is inconsistent",
    "YouXiangXiaoYanChengGong": "Email verification successful",
    "YouChengJiao": "Transaction made",
    "ZhongYaoXiaoXi": "Important message",
    "ShengNTianTianXieKeHuKaiFa": "{0} days left to fill out the customer development report, overdue filling will unbind the customer",
    "QuTianXie": "Go to fill",
    "ShangWeiSheZhiXiaoShouHeT": "Sales contract not yet set",
    "NiYiZhuDongFangQiGenJinGa": "You have voluntarily given up following this customer, awaiting unbinding. The customer is now semi-public and may be followed by other sales managers.",
    "YiShenQingGenJinKeHuDengD": "Requested to follow the customer, awaiting customer confirmation.",
    "KeHuShuJuGaiLan": "Customer data overview",
    "GengDuoDongTaiXinXiQingQi": "For more updates, please visit {0}",
    "MuBiaoWanCheng": "Target achieved",
    "NianDuMuBiaoQingKuang": "Annual target status",
    "NianDuDingHuo": "Annual orders",
    "XiaoShouQuDaoXiangXiXinXi": "Detailed sales channel information",
    "ZhuCeCaiGouPinLei": "Registered purchasing categories",
    "RenZhengCaiGouPinLei": "Certified purchasing categories",
    "CaiGouPinLv": "Purchase frequency",
    "DanKuanCaiGouXiangShu": "Number of cases purchased per section",
    "YingYuJiaoLiu": "English communication",
    "QingGuanFangShi": "Customs clearance method",
    "HaiGuanJinKouGuiMo": "Scale of customs imports",
    "Hui": "Will",
    "BuHui": "Won't",
    "HuiGuan": "No customs clearance",
    "BaiGuan": "formal customs clearance",
    "YiNianZaiZhongGuoDeJinKou": "Annual import volume in China",
    "GongSiQiTaZhuTi": "Other entities of the company",
    "GongSiDianMianShuLiang": "Number of company stores",
    "GongSiDianMianZhanTingFen": "Cities with company stores/showrooms",
    "ZanWeiWanShan": "Not yet completed",
    "GongSiBanGongDaLouZhanTin": "Company office building/showroom/store images",
    "ShangPinJieGou": "Product structure",
    "ChanPinDangCi": "Product grade",
    "BaoZhuangLeiXingXiHuan": "Preferred packaging type",
    "TianJiaTuPian": "Add image",
    "KeHuPinPai": "Customer brand",
    "ZhuYaoXiaoShouChengShiDia": "Main sales city/store address",
    "BanGongDiZhi": "Office address",
    "KeHuTouXiangHuoHeYing": "Customer avatar or group photo",
    "ZuiXinBeiZhu": "Latest notes",
    "ChaKanQuanBuBeiZhu": "View all notes",
    "XunJiaYuJiaoYi": "Inquiry and transaction",
    "ShouQu": "Charge",
    "BuShouQu": "Do not charge",
    "ChongDan": "Push order",
    "BuChongDan": "Do not push order",
    "ZhongSuanJiaGeChongDan": "Recalculate price (for push order)",
    "XinKeShouNianYouHuiJiYouH": "New customer first-year discount (and discount end time)",
    "JieShu": "End",
    "HeTong": "Contract",
    "YouXiao": "Valid",
    "ShanChuHouBuKeHuiFuShiFou": "Deletion is irreversible, are you sure you want to delete?",
    "XiuGaiXinXi": "Modify information",
    "ZhuZhangHao": "Main account",
    "ZiZhangHao": "Sub-account",
    "ZhuYingCaiGouLeiMu": "Main purchasing categories",
    "MingPian": "Business card",
    "QingTianXieYouXiang": "Please enter email",
    "XinZengLianXiFangShi": "Add new contact",
    "XiuGaiLianXiFangShi": "Modify contact",
    "SheZhiGaiZhangHaoWeiZhuZh": "Setting this account as the main will replace the existing main account",
    "XuanZeShuLiangYiChaoGuoGe": "Selection exceeds 5 items, please deselect some to continue",
    "NinTianXieDeYouXiangYouWu": "The email you entered is incorrect",
    "SheZhiWeiZhuZhangHaoDangQ": "Set as main account, the current account is inactive",
    "SheZhiWeiZhuZhangHao": "Set as main account",
    "YouXiangZhenWeiWeiZhi": "Email authenticity unknown",
    "YouXiangYiYanZheng": "Email verified",
    "YouTianXieXiuGaiWuTianXie": "If filled out, modify; if not, do not modify",
    "QingXuanZeCaiGouLeiMu": "Please select the purchasing category",
    "DaiChuLiGouWuQuanDingDan": "Pending voucher orders",
    "NTiJiaoDengDaiZhuGuanShenH": "{0} submitted, awaiting supervisor review",
    "YiShenHeTongGuoXiuGaiJian": "Approved. Modifications will be re-reviewed.",
    "ShouJiHaoChongFu": "Duplicate phone number",
    "ZhangHaoChongFu": "Duplicate account",
    "YiShenQingGenJinChaKanXia": "Number of boxes per purchase",
    "ZhaoYangRenWuYouGengXin": "There's new news on the search mission.",
    "ShangPinJingLiYiGengXinZh": "The Product Manager has updated the search task, please check it out!",
    "QingWanShanWeiTianXieDeSh": "Please complete the unfilled social media information",
    "ShangPinJieGouPinLeiShuLi": "Maximum number of categories in the product structure is 5, please check the categories you have selected.",
    "QingWanShanKeHuXiangXiXin": "Please complete the customer details",
    "LianXiKeHuJingLi": "Contact the Product Manager",
    "GongSiSheMeiXinXiZhongFu": "Duplicate company social media information",
    "YiFenXiXuQiuPinLeiJingLiZ": "Requirements have been analysed and the product manager is looking for samples for you.",
    "QiTaLianXiFangShiZhongFu": "Other contact information duplicated",
    "WeiNiZhaoDaoDeYangPinGong": "Samples found for you, total {0} items.",
    "BianJiGongSiXinXi": "Edit company information",
    "YouXinHuiFu": "There's a new reply.",
    "QingXuanZeGongSiLeiXingYu": "Please select company type (original channel)",
    "ZhangHuWeiTongGuoPingTaiR": "The account has not been confirmed yet, the \"Product Search Request\" function is not yet available. Please wait for account confirmation.",
    "QingTianXieGongSiQiTaZhuT": "Please fill in other entities of the company",
    "LianXiShangPinJingLi": "Contact the Product Manager",
    "QingXuanZeZhuCeCaiGouPinL": "Please select the registered procurement category",
    "RenZhengZhuYaoCaiGouPinLe": "Certified Main Purchase Category",
    "QingXuanZeRenZhengZhuYaoC": "Please select the certified purchasing category",
    "ZhengJu": "Full Container Load (FCL)",
    "HuiYingYu": "Speaks English",
    "BuHuiYingYu": "Does not speak English",
    "TuPianShiPinDanGeWenJianB": "Images/videos (mp4, flv, jpeg, jpg, png, bmp), single file must not exceed 20M, up to 10 files",
    "KeHuShangPinJieGou": "Customer product structure",
    "QingMiaoShuPinLeiDeJiaGeQ": "Please describe the price range of the category, note the currency",
    "QingMiaoShuPinLeiDeChanPi": "Please describe the product grade of the category",
    "PinPaiZhuYingLeiMu": "Brand main category",
    "QingXuanZeKeHuPinPaiLeiMu": "Please select customer brand category",
    "PinPaiBeiZhu": "Brand remarks",
    "GongSiSheMei": "Company social media",
    "KeHuTouXiangHeYingXiangPi": "Customer avatar/group photo",
    "BiXuYuTuPianYiZhi": "Must be the same as the picture.",
    "BiXuDaiZhengShu": "Certificate of conformity required",
    "YuJiCaiGou": "Expected purchase of {0} PCS",
    "DiYu": "Less than  {0}",
    "XunJiaSheZhi": "Inquiry Settings",
    "QingShuRuFanDianLv": "Please enter the rebate rate",
    "BuQiYong": "Not enabled",
    "ShiFouZhongSuanJiaGeChong": "Whether to recalculate the price (punch list)",
    "XianZhiZhiNengXiuGaiHouXu": "Restrictions are limited to 3% - 15% and modifications need to be reviewed. For special requests, please contact your business manager.",
    "KeHuDingDanDuiGongChangDe": "The number of billing days for customer orders to the factory, if you fill in the inquiry, FO single order, etc. will be executed in accordance with this billing period, which will affect the time of the factory to ask for money to change the order.",
    "GongChangZhangQi": "Factory Accounting Period",
    "YuKeHuJieSuanDeZhangQiTia": "The number of days to settle the account with the customer, which will affect the due date of the customer's receivables, etc.",
    "KeHuZhangQi": "Customer Accounting Period",
    "DangYiCaiCaiGouZhongXinXu": "When the price after ESSA Procurement Center's inquiry is higher than the price before the inquiry, choose \"No Review Needed\" if no further negotiation is required. If price negotiation with the factory is necessary after the inquiry, choose \"Review Needed.\"",
    "RenMinBiJiaoYi": "RMB Transaction",
    "MeiYuanJiaoYi": "US Dollar Transaction",
    "QingTianXieZhangQiXinXi": "Please fill in the billing period information",
    "QingXuanZeFanDianLv": "Please select the rebate rate",
    "XiuGaiXunJiaHeJiaoYiXinXi": "Modify inquiry and transaction information",
    "QianWanChengHuiFu": "Reply by {0}",
    "DangJiMuBiaoQingKuang": "Quarterly target status",
    "DangJiMuBiao": "Seasonal target",
    "DangJiDingHuo": "Seasonal Order",
    "GuanLiHeTong": "Management Contract",
    "PinLeiJingLiZhengZaiWeiNi": "The product manager is looking for samples for you.",
    "BaoQianWoMenMeiYouZhaoDao": "Sorry, we didn't find any suitable items.",
    "YiQuanBuZhaoWanGongZhaoDa": "All {0} items have been searched and {1} items have been found.",
    "YouGengXinGongZhaoDaoKuan": "{0}  items updated, {1}  items found",
    "QingWanShanWeiTianXieDeQi": "Please complete the unfilled other contact information",
    "QingQueRenZhangHaoXinXiDe": "Please make sure the cell phone number of the account information is complete?",
    "QingXianXuanZeRenZhengCai": "Please select the certified purchasing category first",
    "YuanYouMuBiao": "Original target",
    "WeiShengXiao": "Not effective",
    "ZhangHaoLianXiRenXinXi": "Account/contact information",
    "FenXiBaoGao": "Analysis report",
    "GongGongChi": "Public pool",
    "KeHuXiangQing": "Customer details",
    "TianXieDeBeiZhuBuNengWeiK": "The note cannot be empty",
    "QuanBuBeiZhu": "All notes",
    "TianJiaBeiZhu": "Add note",
    "ShiFouShanChuGaiBeiZhu": "Do you want to delete this note?",
    "ShangChuanPinPai": "Upload brand logo",
    "WanChengBiLi": "Completion rate",
    "PiLiangJiaRuXuanPinChi": "Add to selection pool in bulk",
    "DaiShenHeFenXiBaoGao": "Review analysis report",
    "ChanPinDangCiShiZhiKeHuSu": "The product grade refers to the quality and market positioning of the products sold by the customer. You can assess the grade by considering factors like materials, technology, brand awareness, and target market.",
    "HeTongeffectiveTimeMsg": "Please note that the validity period of the contract is within the validity period before submitting the order to select the corresponding contract.",
    "HeTongcompanyNameMsg": "When using invoices and other documents, please fill them in correctly.",
    "HeTongcontactNameMsg": "When using invoices and other documents, please fill them in correctly.",
    "HeTongmobileMsg": "When using invoices and other documents, please fill them in correctly.",
    "HeTongcompanyAddressMsg": "When using invoices and other documents, please fill them in correctly.",
    "ShenQingRen": "Applicant",
    "JiJiangLiuShiKeHu": "Soon to be lost",
    "YiLiuShiKeHu": "Lost Customers",
    "HeTongbankInfoMsg": "When using invoices and other documents, please fill them in correctly.",
    "HeTongbankAccountMsg": "When using invoices and other documents, please fill them in correctly.",
    "HeTongswiftCodeMsg": "When using invoices and other documents, please fill them in correctly.",
    "HeTongpayConditionRemarkMsg": "This part will be applied to the “Terms of payment” in the invoice, please fill in correctly.",
    "HeTongshippingRemarkMsg": "If customer's cargo loading and related logistics have cooperation requirements, please inform the logistics department, please fill in the details, and the shipping information received by the shipping department will have corresponding reminders and displays.",
    "HeTongfinRemarkMsg": "Remarks on financial cooperation requirements",
    "HeTongpurchaseRemarkMsg": "If the customer's purchasing and production requirements need to be emphasized and notified to the purchasing department, please fill in the details, and the corresponding factory bill interface and order following interface will do the corresponding reminder and display.",
    "HeTongdocumentaryRemarkMsg": "If the customer's purchasing and production requirements need to be specially emphasized and notify the purchasing department, please fill in the details, and the corresponding factory list interface and the follow-up interface will have corresponding reminders and displays.",
    "HeTongwarehouseRemarkMsg": "If the customer needs special cooperation on the quality inspection and receipt of goods to notify the warehouse department, please fill in the details, and the system will do corresponding reminders and displays in the interface and receiving list.",
    "HeTongcustomerServiceRemarkMsg": "For customer cooperation remarks need business/buyer main, please fill in details.",
    "HeTongsigningCompanyIdMsg": "Our contracting body in the system of customs clearance, shipping, financial invoices and other documents have multiple applications, please choose accurately.",
    "ShangPinJingLiHuiFuLeXinD": "The product manager replied to a new message.",
    "ZuiHouJiaGouShiJian": "Last purchase time",
    "ZuiHouGenJinMaiShou": "Last Follow-Up manager",
    "YiLiuShi": "Churned",
    "JiJiangLiuShi": "Soon to be lost",
    "LiuShiShiJian": "Lost time",
    "QuShenHe": "Go to audit",
    "HeTongpaymentTypeMsg": "Read and display the settlement method in the customer's transaction information.",
    "HeTongfileListMsg": "Contract Attachment",
    "SouSuoKeHuMingZiBianMaYou": "Search for customer's name/code/email",
    "HeTongcodeMsg": "Contract Code",
    "ShangJiDuWanCheng": "Last Quarterly Completion",
    "YiNianZhongGuoJinKouE": "Import value in China in a year",
    "QingShuRuCaiGouPinLv": "Please enter the purchasing frequency",
    "NiKeYiChangShiShiYongJiao": "You can try using fewer or different keywords, or posting a search request.",
    "QingTianXieZhenShiYuJiCai": "Please fill in the real expected purchase quantity. If you fill in too big a difference with the actual, there will be inaccurate prices, do not meet the minimum order quantity and so on.",
    "DaiGenJin": "To be followed up",
    "BieRenGenJin": "Others to follow up",
    "WoDeGenJin": "My Follow-up",
    "RenWuBianHao": "Task number",
    "DaiTianXieFenXiBaoGao": "Analysis report to be filled",
    "WeiTianXieBaoGao": "No Report",
    "YiYuQi": "Overdue",
    "ShengTianTianXieKeHuFenXi": "There are {0} days left to fill in the customer analysis report, if it is overdue, the customer will be unbound.",
    "SouSuoKeHuMingZiYouXiang": "Search customer name/email",
    "NianDuMuBiaoBuKeDaYuJiDuM": "Annual target can not be greater than {0},Quarterly target sum can not be greater than {0}.",
    "LianXiKeHu": "Contact Customer",
    "KeHuFenXiBaoGaoTianXieYuQ": "Customer analysis report is overdue for completion and converted to weak bind.",
    "ZhuGuanDaiBan": "Supervisor to do",
    "ChangYongYuYan": "Common Language",
    "WoYaoGenJin": "I want to follow up",
    "ZhaoYangRenWu": "Sample search task",
    "GenJinChengGong": "Follow-up Success",
    "TuPianDanGeWenJianBuNeng2": "Picture jpeg,jpg,png,bmp, a single file can not exceed 10M.",
    "JiJiangShengChengDingDan": "Orders to be generated soon",
    "JiaoYiXinXiYiXiuGaiDengDa": "Transaction information has been modified and is awaiting review.",
    "FuWuFeiLvDingJinFangShiXi": "The service rate and deposit method information has been modified and needs to be reviewed by the supervisor before it can take effect.",
    "DaiShenHeJiaoYiXinXi": "Pending Review Transaction Information",
    "TianXieBuTongGuoYuanYin": "Fill in the reason for the change",
    "QueRenBianGengXinXi": "Confirm change of information",
    "YiTongGuo": "Approved",
    "ShenHeJiaoYiXinXiBianGeng": "Change of transaction information",
    "BuTongGuoYuanYin": "Reason for Failure",
    "GaiCheng": "Converted",
    "img_upload_400": "Image size must be >= 100px, <= 4096px, and less than 4MB",
    "img_upload_403": "The operation is too frequent, please try it later.",
    "KaiTongESSAONE": "Open ESSAONE permissions",
    "YiShenQing": "Applied",
    "WeiShenQing": "Not Applied",
    "YiKaiTong": "Opened",
    "WeiKaiTong": "Not yet opened",
    "DDPJiaGe": "Turnkey price",
    "KeHuKeXiangYouHuiXinTuoCh": "Discounts for customers",
    "JiaRuTuiJian": "Add a recommendation",
    "DaiLiShangZiYuanShangDaiB": "Agent & Resource Pending",
    "NiLeiJiTuiJianKuanShangPi": "You have recommended {0} items, {1} items have been selected, and the selection rate is {2}%.",
    "TiaoXuanShangPin": "Select product",
    "JuLiFaBuYiDengDaiTian": "It's been {0}  days since the mission was released.",
    "ZhaoDaoKuanKeHuJiaGouKuan": "{0}  items found, {1} items were added to the cart",
    "ZhaoYangShengYuTian": "{0} days left in the search",
    "KeHuMeiYouLiuYan": "No messages.",
    "KeHuYouXinLiuYanQingLiuYi": "There are new messages from customers, so keep an eye out!",
    "KeHuYouLiuYan": "There is a message from a customer.",
    "ZhaoYangRenWuChi": "Taskbar",
    "DangQianRenWuGenJin": "Current task follow-up",
    "ShangPinBanQuan": "Product copyright",
    "YiChuXuanPin": "Remove selection",
    "ZhiDingShangPinKeYong2": "Available for ordering selected item {0}",
    "QingKongXuanPin": "Empty the selection",
    "XuanPinZhuangTai": "Status",
    "PinLeiJingLi": "Product manager",
    "DangQianYouHuiQuanBuYunXu": "Current coupons are not allowed to be used with points.",
    "XuYaoGenJinRenWuHouCaiNen": "Needs to follow up on the task before it can be operated.",
    "NDeZhaoYang": "Search for {0}",
    "QueRenMiMa": "Confirm the password",
    "TianJiaYuanGongZhangHao": "Add employee account",
    "ZhaoYangGuanLi": "Sample search management",
    "DangQianShangPin": "Current products",
    "XiaDanZuiGaoKeXiangZheKou": "Up to 5% off your order",
    "NHouYiYouHuiQuanXingShiFaF": "The coupon will be issued after {0}. Please check \"My Coupons\".",
    "YiDaoGangRiQi": "Arrival Date",
    "TuiJianChengGong": "Successful referrals",
    "YiChuChengGong": "Successful removal",
    "FaJianRenMaiJia": "Seller",
    "QingZhuCeDengLuZhangHaoHo": "Please register and login to use the account",
    "YiCaiXuanPinXiaoQi": "ESSABUY-Platform Customer Service",
    "ZhuXiaoZhangHao": "Logout account",
    "BaoHuShangPinChaKanShenQi": "Protect goods view application",
    "ZhuZhangHaoQingSheZhiQiTa": "Master account please set other employee account as BOSS master account before logging out.",
    "QianWangYuanGongZhangHaoG": "Go to Employee Account Management",
    "YuanGongTouXiang": "Employee avatar",
    "MoRenMiMaShiYuanGongDianH": "Default password is employee phone",
    "YongHuLeiXing": "User Type",
    "LaXinYeWu": "New business",
    "LaShengYeWu": "Promotion",
    "MaiShou": "Buyer",
    "PuTongYongHu": "Ordinary user",
    "QingXuanZeYongHuLeiXing": "Please select the type of user",
    "MaiShouDengJi": "Buyer Level",
    "QingXuanZeMaiShouDengJi": "Please select the buyer level",
    "KaiFaKeHuShu": "Number of developed customers",
    "QingTianXieKaiFaKeHuShu": "Please fill in the number of developed customers",
    "QingTianXieDaYuHuoDengYuD": "Please fill in the integer greater than or equal to 0",
    "NRiLiuLanShangPinShu": "{0}Day Number of products viewed",
    "QingWanShanDanJuDingJinBi": "Please complete the single cabinet deposit ratio",
    "QingWanShanDingJinZhiFuSh": "Please improve Deposit Payment Time",
    "ZhuGongShiChangHeZhuGongQ": "Please note that the modification is allowed only once a year for the main market and main region.",
    "WoYiQingChu": "I am clear",
    "YiNianZiRanNianZhiYunXuXi": "Please note: You are only allowed to modify once a year (natural year).",
    "ShangCiXiuGai": "Last Modified",
    "ShuJuYinQingJiangGenJuNiS": "The data engine will display the data according to the market and region you selected.",
    "ZhenShiZhunQueTianXieZhuG": "Fill in the main market and region truthfully and accurately, you can get accurate product recommendation, support multiple selection.",
    "PCS": "PCS",
    "YouJiHuiYingDeYouHuiQuan": "Chance to win 5% off coupon",
    "MeiZhouYiGengXin": "Updated every Monday",
    "QuYuShuJuQingBao": "Regional Data Intelligence (last 4 weeks)",
    "XiuGaiZhuGongQuYu": "Modify the main focus area",
    "XuanPinPinLeiTop": "Top10 selected categories",
    "XunPanPinLeiTop": "Inquiries TOP5",
    "JinTianNeiMaoYiShangYiJia": "Top5 categories with the most negotiated price by traders in the past 30 days",
    "ShangXinPinLeiTop": "Top 10 new categories",
    "JinTianNeiPingTaiShangXin": "Top 10 categories with the most new products on the platform in the past 30 days",
    "ReMaiGongYingShangTop": "Top6 hot selling suppliers",
    "JinTianNeiPingTaiShangJia": "Top6 factories in terms of the number of products purchased on the platform in the past 30 days.",
    "JinKeChaKanQingBaoChiHuoY": "Only VIP can view, please keep active to upgrade to VIP.",
    "LeiJiDengLuNTianShuTianYiS": "Accumulated login days {0} days or more",
    "XuanPinNKuanHuoXunJiaNKuan": "Selected {0} items or inquired {1} items or more",
    "YiCaiXuanPinShuJuYinQingK": "ESSABUY data engine, you can view the main areas of customer selection trends, insight into the market opportunities.",
    "WeiXinSaoYiSaoMianFeiJieS": "Unlock the latest product prices for free with a single WeChat sweep.",
    "XianShiFuLiSaoMaLingDuJia": "Limited time benefit, sweep the code to get the exclusive new products list",
    "MianFeiLingZhangShangPinG": "Get 200 high-resolution pictures of products for free",
    "MianFeiJieSuoShangPinZuiX": "Free, unlock the latest product prices",
    "MianFeiLingZhangShangPinG2": "Free of charge, receive 200 high-resolution pictures of products",
    "DangQianCunZaiWeiShenHeJiLuWuFaChongFuTianJiaJiLu": "Currently there are unaudited records can not be repeated to add records",
    "ZiChanHeXinYong": "Assets and credit",
    "ShuBaiJiaZhiMingMaoYiGong": "Used by hundreds of well-known trading companies",
    "YaoZhaoShenMe": "What are you looking for?",
    "QingJianDanShuoMingYaoZha": "Please briefly explain what you are looking for",
    "ZhiChiTuPianDanWenJianZui": "Support pictures, single file support up to 10M, upload up to 5 files.",
    "GengXiangXiDeShangPinXinX": "More detailed product information, such as features, colors, materials, specified brands, packaging requirements, etc.",
    "ZuiDi": "Minimum",
    "ZuiGao": "Highest",
    "ZhaoYangFaBuHouTianJieZhi": "The deadline is {0} days after posting the sample, you can receive the reply from the factory in 30 minutes at the earliest.",
    "LeJieXinYongTiXi": "Learn About the ESSA Credit System",
    "XinYongFenShu": "Credit Score",
    "XinYongTiXiShuoMing": "Description of Credit System",
    "ZuiJinMeiYouBianDong": "No recent change",
    "ZuiJinBianDong": "Recent Change",
    "ZhangQiTianShu": "Days of Accounting Period",
    "ZhangQiLiXiJiSuanFangShi": "Interest Calculation Method",
    "ZhangQiJiSuanBiaoZhun": "Billing Period Calculation Criteria",
    "OAEDu": "OA Limit",
    "ShenQingOA": "Apply for OA",
    "XinYongDaDaoFenKeShenQing": "Credit score of {0} can be applied",
    "YiManZu": "Satisfied",
    "ChaKanOAXiangQing": "View OA Details",
    "ShenQingTiShengEDu": "Apply for a credit limit increase",
    "NTianNeiBuShiYongXuZhongXi": "Re-apply if not used within{ 0 }days.",
    "ZhuGuanShenHeZhong": "Supervisor reviewing",
    "CaiWuShenHeZhong": "Financial audit in progress",
    "ZhuGuanShenHeBuTongGuo": "Supervisor audit failed",
    "CaiWuShenHeBuTongGuo": "Financial audit failed",
    "WeiKaiTongESSAONE": "ESSAONE Permission not activated",
    "XinYongFen": "Credit Score",
    "XinYongFenMingXi": "Credit Score Breakdown",
    "XunJiaXinXi": "Inquiry Information",
    "ShiYongYouHui": "Use the offer",
    "RenZhengHouCaoZuo": "Operation after authentication",
    "WeiJiHuo": "Not activated",
    "JiHuo": "Activated",
    "ShiFouQueRenJiHuo": "Confirmation of activation",
    "FeiKeHuBuNengBangDing": "Non-ESSAONE customers cannot bind",
    "JiangChanShengPeiChangBin": "Compensation will be incurred and credit score will be deducted {0}",
    "TiXing": "Reminder",
    "YiXiaQingKuangQuXiaoShang": "Compensation will be charged for canceling products in the following cases",
    "WuXuPeiChang": "Fortunately, there is no compensation for this cancellation, as the product was not manufactured.",
    "DangQianXuPeiChangHeJi": "Currently need to compensate {0}%, total {1}",
    "JiangChanShengYiZhangFeiY": "An expense slip will be generated to charge the corresponding fee, please pay attention to timely collection.",
    "QuXiaoXiangShuBuNengQuanB": "The number of canceled boxes cannot all be 0",
    "FanKuiXiaoLv": "Feedback problem efficiency",
    "ShenHeZhongBuNengXiuGaiFu": "Transaction information has been modified, waiting for audit (service rate and deposit method cannot be modified during audit).",
    "XiuGaiJiaoYiXinXiShenHeBu": "Modify transaction information, audit failed",
    "ShenQingOA2": "Apply for OA",
    "ChaKanFeiYongDan": "View Charge Sheet",
    "MoRenJieSuanFangShi": "Default billing method",
    "FuWuFeiLvZhiWei": "Service rate value is 3~15",
    "DangQianXuPeiChangHeJi2": "Compensation required {0}%, total {1}",
    "QueDingQuXiaoShangPin": "Determine to cancel the product",
    "ZhangQiFeiYongJiSuanFangS": "Billing Fee Calculation Method",
    "XinYongNFenYiDaBiaoKeShenQ": "Credit score {0} has been reached, you can apply for OA settlement.",
    "XinYongNFen": "Credit Score {0}",
    "DengDaiShenHeZhong": "Waiting for review",
    "ShangCiShenQingBuTongGuo": "The last application did not pass",
    "QueDingBuZaiTiShi": "Make sure you are not prompted again",
    "ZhuangGuiWanChengHouQuXiaoTongKuanShangPinZhiNengCaoZuoYiCi": "Cancellation of the same product after loading is allowed once.",
    "HuoKuanYiHeXiaoBuNengQuXiaoShangPin": "You can't cancel the product after the payment has been canceled.",
    "ESSAONEWangZhanJieShaoH1": "OPTIONAL CHINA MARKETPLACE<br />from 1 carton directly from the factories \"turnkey\"",
    "ESSAONEWangZhanJieShao2": "New experience of purchasing from China for small and medium-sized businesses !",
    "ESSAONEWangZhanJieShao1": "How it works",
    "ESSAONEWangZhanJieShao3": "Ready-made solution for small wholesale purchases",
    "ESSAONEWangZhanJieShao4": "Price with turnkey delivery",
    "ESSAONEWangZhanJieShao5": "Reliable service guarantees",
    "ESSAONEWangZhanJieShao6": "Multiple services in one place",
    "ESSAONEWangZhanJieShao7": "The process of working with ESSAONE",
    "ESSAONEWangZhanJieShao8": "Event information and customer feedback",
    "QingGouXuanXuYaoBuHuoDeSh": "Please check the items to be restocked",
    "ShenQingHeZuoFangShi": "Apply for OA Cooperation",
    "ZhuGuanShenHe": "Supervisor Review",
    "CaiWuShenHe": "Financial Audit",
    "KeHuZhuCeHao": "Client Registration Number",
    "KeHuGongSiMingCheng": "Client Company Name",
    "KeHuGongSiDiZhi": "Customer Company Address",
    "ShenQingEDu": "Application Amount",
    "ZhangQiFeiLv": "Billing Rate",
    "ShenQingZhangQi": "Application Billing Period",
    "DaiShenHeShenQing": "Pending OA Application",
    "GongChangJieDanHouQuXiaoS": "If the factory cancels the order after accepting it, a certain percentage of compensation is required, and 1 credit point will be deducted for each charge, and the credit point will be restored after the customer pays the compensation.",
    "GongChangYiJieDanHuoWuZhe": "If the order is canceled while the goods are in production, 10% of the total amount of the goods in the order will be paid.",
    "HuoWuShengChanWanBiShiQuX": "Cancellation when the goods are finished production, 30% of the total amount of the goods in the order will be paid.",
    "HuoWuYiRuKuDengDaiZhuangJ": "Cancellation when the goods have been put into the warehouse and waiting for loading, 50% of the total amount of the goods in the order will be paid.",
    "HuoWuZhuangJuWanChengHouQ": "If the goods are canceled after loading, 100% of the total amount of the order will be paid.",
    "ChengShiDeBiaoZhi": "The symbol of honesty",
    "GuoJiaTiXi": "National system",
    "ShuZiBiaoJi": "Numeric markers",
    "ShiELuoSiShiChangShangZui": "Маяк is the most popular and affordable business development platform in the Russian market",
    "MianFeiKuoZhanGongNeng": "Free extension function",
    "YiZhongJianDanDeFangFaKeY": "A simple method to quickly analyze sales volume, order quantity, price change data+real-time monitoring of balance in warehouse environment, percentage of product repurchases by category, ability to monitor advertising auctions and competitor advertising bids.",
    "FuFeiJiHuaTiGongEWaiDeGon": "The paid plan provides additional tools to increase profits.",
    "DuiYuNeiXieZhengZaiXunZha": "For those who are looking for niche markets",
    "QianFenWeiNaXieLeiBieZaiL": "<li>Which categories there is money to be made?</li> <li>How easy it is to launch new products in niche markets?</li><li> In which categories demand exceeds supply?</li> <li>The 1000 most successful products on WB</li><li> Which categories are not successful for suppliers?</li>",
    "DuiYuNeiXieYiJingYuShiCha": "For those who have already collaborated with the market",
    "JiangChanPinTuiXiangDingF": "<li>Push the product to the peak</li><li>Automatically calculate advertising placement</li><li>Internal and external analysis</li><li>SEO optimization</li><li>Location monitoring</li><li>Advertising account and advertising rate management</li><li>Can integrate with 1C</li><li>2020 external analysis data</li>",
    "RenZhengHouKeXuanPinHeHuo": "You can select products and get factory information after authentication",
    "DengLuRenZhengHouKeChaKan": "Login to view contact information after authentication",
    "SouSuoKeHuMingChengBianHa": "Search for customer name/ID/phone",
    "QuanBuXinKeHu": "All new customers",
    "WeiYongHuTiGongDeLiWuTian": "为用户提供的礼物 - 3 天的测试费率访问链接：",
    "QingXuanZeZhangQiTianShu": "Please select the number of days of the billing period",
    "QingShuRuKeHuZhuCeHao": "Please enter the customer's registration number",
    "QingShuRuGongSiMingCheng": "Please enter your company name",
    "QingShuRuKeHuGongSiDiZhi": "Please enter the customer's company address",
    "QingShuRuShenQingEDu": "Please enter the application amount",
    "QingXuanZeZhangQiLiXiJiSu": "Please select the interest calculation method for the billing period",
    "QingXuanZeZhangQiJiSuanBi": "Please select the billing period calculation standard",
    "QingShuRuZhengQueDeShenQi": "Please enter the correct amount to be applied, (0.01-100000000000) retain up to two decimal places!",
    "XinYongFenJiangGenJuDingD": "Credit score will generate changes according to order fulfillment.",
    "ShiYongJieSuanShiZaiHuoWu": "When using DP/TT settlement: If payment is made before the arrival of the goods and in advance, 1 point will be added to the credit score. If payment is not made for more than 7 days after the arrival of the goods or the due date (whichever is later), 1 point will be deducted.",
    "ShiYongJieSuanShiZaiZhang": "When using OA settlement:1 point will be added to the credit score if payment is made in advance before the arrival of the billing period. If payment remains unpaid for more than 7 days beyond the billing period, 1 point will be deducted.",
    "ShangShuLiangZhongJieSuan": "In both of the above settlement methods, 1 point will be deducted temporarily until compensation is paid for canceled orders/goods after the factory has taken the order.",
    "XinYongFenJiangGenJuDing": "Credit score will be changed according to the order fulfillment, the initial score is 90 points.",
    "JiaFenZaiHuoWuDaoGangQian": "Extra points:1 point will be added to the credit score if the payment is made before the arrival of the goods and in advance.",
    "JianFenRuoZaiHuoWuDaoGang": "Minus points:1. If payment is not made for more than 7 days after the arrival time of the goods or the due date (whichever is later), 1 point will be deducted; 2. Cancellation of the order/goods by the factory after acceptance of the order will result in a temporary deduction of 1 point until compensation is paid.",
    "HeZuoHanYiWoSiXianJiangHu": "The meaning of OA cooperation: Our company will first send the goods to the purchasing customer. The customer needs to pay within the agreed period after receiving the goods. There is a maximum credit limit for each customer, and the amount that can be applied for will be evaluated based on their risk value.",
    "ShenQingTiaoJianDangKeHuY": "Application Criteria: When the customer's credit score is {0} or above, they can apply for OA cooperation. After applying, the customer needs to maintain a credit score of {1} or above to continue enjoying OA account terms.",
    "ZhangQiFenWeiTianTianTian": "OA Payment Terms: Divided into {0}. Different interest rates will apply for different payment terms, which are {1}.",
    "XinYongTiXiYongYuDingQiPi": "The ESSACHINA credit system is used to regularly assess and update the credit status of customers, to determine the risk of customer OA cooperation, and to apply for review of OA billing periods and amounts.",
    "DangKeHuYiChengGongWanChe": "When the customer's credit score is {0} or above, they can apply for OA cooperation. After applying, the customer needs to maintain a credit score of {1} or above to continue enjoying OA account terms.",
    "XinYongFenJiaJianGuiZeRuX": "Credit score adjustment rules are as follows：",
    "KeHuShiYongJieSuanZaiHuoW": "If the customer uses DP/TT settlement and pays before the goods arrive at the port, the credit score increases by 1 point.If the payment is not made within 7 days after the goods arrive at the port or the due date (whichever is later), 1 point will be deducted.",
    "KeHuYiShiYongJieSuanZaiZh": "Customers who have used OA settlement and paid for the goods in advance before the arrival of the billing period will have 1 point added to their credit score. If payment remains unpaid for more than 7 days beyond the billing period, 1 point will be deducted.",
    "CiWaiZaiShangShuLiangZhon": "In addition, in both of the above settlement methods, if the factory cancels the order/goods after accepting the order, 1 point will be deducted temporarily until the customer pays the compensation.",
    "XinKeHu": "Registered Customers",
    "ZuiJinFangWen": "Recent visits",
    "JieDuan": "Stage",
    "DaiChuBuLianXi": "Waiting for initial contact",
    "BaoChiDuiHua": "Keep in touch",
    "ChengJiaoShiXian": "Successful transaction",
    "ChengJiaoWeiShiXian": "Failed transaction",
    "PiFuEDu": "Approved Amount",
    "PiFuZhangQiTianShu": "Number of days to approve",
    "1059PR10001": "parametric error",
    "QingXuanZeKeHuJieDuan": "Please select stage",
    "XiaZaiDuiZhangDan": "Download the statement",
    "YongYuDingDanChuHuoDeDing": "Deposit guarantee for order shipment",
    "CaiWuShenHeTongGuo": "Financial audit approved",
    "ZhuGuanShenHeTongGuoDengD": "Supervisor approved, waiting for financial audit",
    "JiangChanShengYiZhangFeiYyicaiguoji": "A bill will be generated, and you need to pay the corresponding expenses, please pay attention and contact the account manager for payment in time.",
    "GenJinKeHu": "Follow-up with customers",
    "GongChangJieDanHouQuXiaoSyicaiguoji": "If a factory cancels an order, a certain percentage of compensation will be required, and 1 credit point will be deducted for each charge, which will be restored after you pay the compensation.",
    "DianJiChaKan": "Click to view",
    "GenJuQuXiaoShangPinPeiChangGuiZeKeHuXuZhiFuPeiChangKuan": "{0} Commodity {1} Compensation to be paid according to the rules of compensation for canceled commodities.",
    "BenCiGenJinNeiRong": "Content of this follow-up",
    "AnGongSiFeiYongDanZhiDuGu": "According to the company's expense order system management requirements, the expense order can not be initiated later than the loading time.",
    "ShenQingBuTongGuo": "The application is not approved",
    "ZhengZaiDengDaiShenHe": "Waiting to be reviewed",
    "FeiMuBiaoKeHu": "Non-target customer",
    "QingXuanZeShenHeYiJian": "Please select audit opinion",
    "QingTianXieGongChangZhang": "Please fill in the factory billing period",
    "AnZhuCeShiJian": "By registration time",
    "AnFangWenShiJian": "By visit time",
    "AnJiaGouShiJian": "By add to cart time",
    "AnGenJinShiJian": "By follow-up time",
    "QingShuRuZhengQueDeGongCh": "Please enter the correct factory billing period",
    "KeHuXinXiWanShan": "Improve customer information",
    "KeHuRenZheng": "Customer certification",
    "KeHuFuHeYiXiaTiaoJianHuiZ": "Customers who meet the following conditions will automatically become target customers:",
    "ShiFouShiFaRenQiYeHtml": "<ul><li>Must be a legal entity <ul><li>Match our category <ul><li>Can order at least 1 carton",
    "ShenQingTiShengEDuZhong": "Requesting a credit limit increase",
    "QuXiaoDanHao": "Cancel order number",
    "KeHuGenJinJieDuan": "Customer follow-up phase",
    "BaoChiLianXi": "Keep in touch",
    "ZhuanDaoXiaYiJieDuanJianGNTian": "Interval to next stage: {0} days",
    "HaiShengNTianXuYaoDaChengC": "There are {0} days left to reach the first order.",
    "CongZhuCeDaoShouDanChengJ": "From registration to first order, it took {0} days.",
    "BuZaiGenJin": "Give up",
    "ZanWeiQueRen": "Not confirmed yet",
    "MuBiaoYongHu2": "Target consumer",
    "EDu": "Amount",
    "ShiFouFaRenQiYe": "Is he/she a corporate enterprise?",
    "ShiFouXiangQiDing": "Can he order at least one carton?",
    "SouSuoKeHuBianMaMingZiYou": "Search for Customer Code/Name/Email",
    "DingDanZhongShangPinYiQua": "All items in the order have been canceled and the deposit cannot be paid again.",
    "WoFangQiGaiKeHu": "I'm dropping the client.",
    "ShiYongShiJian": "Time of Use",
    "ShiYongEDu": "Utilized Limit",
    "YiLaiKuan": "Incoming Payments",
    "OAMingXi": "OA Detail",
    "ShenQingTiShengOAEDu": "Application for OA Limit Enhancement",
    "YiChengJiaoKeHu": "Transacted Customers",
    "ChengZhangKeHu": "Growth customer",
    "LiuCunKeHu": "Retained customer",
    "YuLiuShiKeHu": "Pre-churned customer",
    "ZuiJinXiaDan": "Recently ordered",
    "KeHuNTianHouLiuShiQingGenJ": "Customer will be lost after {0} days, please follow up with the customer.",
    "ZaiYingShouZhangKuanDaoQi": "Interest fee will be waived for 5 days after the due date of the receivable, after 5 days interest will be calculated from the due date of the receivable, Daily Late Interest Fee = Unpaid Amount * {0}%",
    "YuQiHouMeiTianAnJiSuanLiX": "After overdue, interest will be calculated at 1‰ per day",
    "KeHuDeXinYongFenBuZuBuNen": "Customers whose credit score is less than {0} cannot use the OA settlement method, and this order will be settled using DP(T/T).",
    "JiXuDPJieSuan": "Continue DP settlement",
    "YiQianHeTong": "Contract signed",
    "QueRenBuZaiGenJin": "Sure you don't want to follow up?",
    "QueRenFangQiGaiKeHu": "Sure about dropping the customer ?",
    "BangDingChengGong2": "Binding successful",
    "ZhangQiLiXiFei": "Interest on Accounting Period",
    "LiXiJiangJunTanDaoShangPi": "Interest will be charged equally to the unit price of the goods and then charged according to the whole order. When the order is required to pay deposit, the interest charge = (total amount of the order - deposit) x the corresponding billing period interest rate; when the order is exempted from paying deposit, the interest charge = total amount of the order x the billing period interest rate",
    "OAZhangQi": "OA Accounting Period",
    "XiuGaiYuYanXuYaoZhongQiCa": "The modified language will only take effect after restarting the APP",
    "WeiJiaGou": "No purchase added",
    "ShiFouYaoQieHuanDaoNYuYan": "Do you want to switch to {0} language?",
    "YuYanJiaGeSheZhi": "Language & Price Setting",
    "XuanZeQuYu": "Select Region",
    "WoDePODan": "My PO",
    "XiaoShouJiaSheZhi": "Setting the selling price",
    "XiaoShouJiaJiSuanFangShi": "Calculation of sales price",
    "XianShiBiZhong": "Currency",
    "XiaoShouJia": "Selling price",
    "XianShi": "Show",
    "BuXianShi": "Do not show",
    "SheZhiXiaoShouJia": "Set selling price",
    "XiuGaiXianShiBiZhong": "Modify Display Currency",
    "JiangTongBuXiuGaiNinDeXia": "Your sales country information will be synchronized",
    "PingJiaDingDanFuWu": "Evaluate Order Service",
    "XingQiYi": "Понедельник",
    "XingQiEr": "Tuesday",
    "XingQiSan": "Wednesday",
    "XingQiSi": "Thursday",
    "XingQiWu": "Friday",
    "XingQiLiu": "Saturday",
    "XingQiRi": "Sunday",
    "YiChenShuiNTian": "Sleeping {0} days",
    "YiLiuShiNTian": "Lost {0} days",
    "NiXiuGaiDeXinXiShangWeiBa": "The information you modified has not been saved, if you leave this modified information will not take effect. Do you want to leave?",
    "ShengChanZhong": "Production in progress",
    "ZhuangJu": "Containerization",
    "DaiPingJia": "To be evaluated",
    "FuZeNaXieKeHu": "Which clients are you responsible for",
    "SouSuoRenWu": "Search assignments",
    "ShouCiZhuCePingTai": "First-time registrant",
    "ShiXiangDaiBan": "To-do list",
    "TiHuoTiXing": "Pickup Reminders",
    "DaiChuLiSuoPei": "Pending claims",
    "XinKeManYiDuDiaoCha": "New Client Satisfaction Survey",
    "YuLiuShiYongHuManYiDuDiao": "Satisfaction survey for Pre-churned customer",
    "GenJinTiXing": "To-do reminders",
    "DaiChuBuLianXiKeHu": "First contact",
    "KeHuXuanPin": "Add to cart",
    "ZhuanHuaLvKanBan": "Conversion Rate Report",
    "ZhiYouLuoZaiShiJianFanWei": "Only data that fits within the timeframe will be counted.",
    "QuanBuZhuCeQuDao": "All registered sources",
    "QuanBuGenJinRen": "All followers",
    "ShangYue": "last month",
    "XiaDan2": "First order",
    "DaiGenJinShiXiang": "To-do list",
    "ZhuanHuaLvN": "Conversion rate {0}%",
    "HuoWuZhuiZongChaXun": "Cargo Tracking Inquiry",
    "QuChaXun2": "Go to Inquiry",
    "ChaKanYuanYin": "View Reason",
    "ZongJinE": "total amount",
    "YiLianXiGuo": "Notified",
    "ZhuCeKeHuDaiBanTiXing": "Registered Customers - To-Do Reminders",
    "YiChengJiaoKeHuDaiBanTiXi": "Trading Clients - To-Do Reminders",
    "TiHuo": "Pick up goods",
    "YiLianXiGuo2": "Contacted.",
    "ZanWuGenJinNeiRongBeiWang": "No follow-up memo",
    "NYiGuoQiNTian": "{0} Expired {1} days",
    "MingTian": "tomorrow",
    "ChuanWuYiChangChuLi": "Shipping Exception Handling",
    "ZiDingYiShengChanYaoQiu": "Custom Production Requirements",
    "ZiDingYiShengChanYaoQiuWaiWen": "Custom Production Requirements",
    "NPCS": "{0} PCS",
    "NWaiXiang": "{0} Box",
    "ZhongYaoQingZaiTianNeiTiG": "[Important] Please provide the stickers within {0} days.",
    "ChaoGuoTianTiGongTieZhiKe": "Providing stickers after {0} days may affect the factory production schedule and delay the delivery date. Please provide the sticker information as soon as possible.",
    "QueRenZanBuSheZhiTieZhiMa": "Are you sure you want to proceed without setting the stickers?",
    "EssaoneQuanTaoChanPin": "Fullfilment for marketplaces from ESSAONE",
    "WoMenZhengZaiQingTingKeHu": "We listen to the wishes of our customers, which is why we are pleased to announce that ESSAONE is launching a full-field service. We are accepting applications for the service by mail",
    "NiZaiXunZhaoFuErFeiMenTe": "You're looking for a fullfilment",
    "ZheiYeShiNiDeRuGuoNiBaTa": "If you delegated this task to <br />professionals",
    "WoMenYouShenMeJianYi": "What do we offer?",
    "ZaiShiChangShangJiaoFuCha": "Comprehensive preparation of goods for delivery to Wildberries, Ozon marketplaces",
    "BaoZhuang2": "Packaging",
    "BiaoJi2": "Marking",
    "XiangHeCangKuJiaoFuDingDa": "Delivery of orders to Wildberries and Ozon warehouses",
    "WoMenDeYouShi": "Our advantages",
    "BuXuYaoZhiFuYunFei": "No shipping charges from warehouse <br />to full-field store",
    "ShouHuoWuXuFuFei": "No acceptance fee",
    "BuXuYaoZhiFuShangPinYanHu": "You don't have to pay to visually <br />check merchandise for defects",
    "WuXuZhiFuBaoZhuangHeHuoTu": "No charge for forming <br />a box or pallet",
    "WoMenGanXieWoMenDeKeHu": "We appreciate our customers!",
    "ZaiDingGouChanPinYongXinD": "Order goods on ESSAONE and grow your business with a new service!",
    "YanShouHuoWu": "Acceptance of goods",
    "ShangPinBiaoJi": "Product labelling",
    "ChuCunHuoWu": "Storage of goods",
    "DingDanChuLi": "Order processing",
    "HuiKuan2": "Transfer of money",
    "JiaoHuo2": "Delivery",
    "DingDanBaoZhuang": "Packaging of orders",
    "XieShang": "Consultation",
    "DeDaoBaoJia": "Get the offer",
    "ESSAONEWanQuanMianFei": "All this <span class=‘fw_700’>ESSAONE</span> will do absolutely free of charge!",
    "TiDanHao": "BILL OF LADING NUMBER",
    "TiDanSaoMiaoJian": "BILL OF LADING COPY",
    "QingShuRuShenQingLiYou": "Please enter the reason for your request.",
    "TouBaoMaiFangDaiMa": "Insured Buyer Code",
    "ShangPinZhengZaiTiJiaoDingDan": "The product is being submitted for an order. Please refresh the data later and try again.",
    "NNianChengJiao": "Sales amount in {0}",
    "ZhanShiHe": "Showbox",
    "FeiZhanShiHe": "Packaging",
    "RuKuNTian": "Arrival at warehouse {0} days",
    "ManYiDuDiaoCha": "Satisfaction surveys",
    "ZuiJinJiaGou": "Last added to cart time",
    "QueRenYiLianXiGuo": "Confirmation that contact has been made?",
    "MiMaGuiZe5": "Please enter 6-20 characters, a combination of letters and numbers.",
    "ShangPinBianMaJiuBianMaHu": "Product Code, Original commodity code, Item Number",
    "NinWuQuanXianFangWenGaiYe": "You do not have permission to access this page!",
    "ShouHuoQuYu": "Receiving Area",
    "DaiBanTiShiDingJinCuiShou": "<p>Please contact these customers and send a payment reminder to try to get them to pay the deposit in a timely manner. Otherwise, <b>the order will be cancelled automatically after 14 days! </b></p><p>System reminder rules: </p><p>1st time, 3rd day from order placement. </p><p>2nd time, 7th day from order placement. </p><p>3rd time, 11th day from order placement.</p>",
    "RuKuNTian2": "Arrived at the warehouse for {0} days, with {1} days of free storage time remaining.",
    "DaiBanTiShiTiHuoTiXing": "<p>The following orders have been paid for in full. Please inform these customers to book their pick-up appointments in a timely manner and it is necessary to emphasise to the customers that <b>the free stay of the order in the warehouse is only 30 days! Exceeding this period will be charged. </b></p><p>System reminder rules: </p><p>1st, 2nd day after arrival at the warehouse. </p><p>2nd, 15th day after arrival at the warehouse. </p><p>3rd, 25th day after arrival at the warehouse.</p>",
    "DaiBanTiShiWeiKuanCuiShou": "<p>Please contact these customers and send a payment reminder to try to get them to pay the final amount and book a pickup in a timely manner. <b>The free stay of the order in the warehouse is only 30 days! </b></p><p>System reminder rules: </p><p>1st time, 2nd day after arrival at the warehouse. </p><p>2nd, 10th day after arrival at the warehouse. </p><p>3rd, 20th day after arrival at the warehouse.</p>",
    "DaiBanTiShiTiDaiChuLiSuoPei": "<p><b>You should complete the review within 15 days of the customer filing the claim. </b>Firstly, judge whether the compensation is reasonable according to the company's claim criteria, and secondly, accept or reject the customer's compensation request. In special circumstances, you may negotiate a compensation solution with the customer.</p>",
    "DaiBanTiShiDaiChuBuLianXiKeHu": "<p><b>You need to call these customers within 7 days</b>, record the first contact and fill in the customer's information to certify if he is a target customer.</p>",
    "DaiBanTiShiKeHuXuanPin": "<p>These customers deserve attention. <b>Please further confirm whether the customer has the intention to co-operate</b>, and fully understand the needs of their purchase, and promote the transaction as much as possible.</p>",
    "DaiBanTiShiXiaDan": "<p>Now, you need to check that you have signed a contract with these customers and <b>inform them to pay the deposit within 14 days.</b></p>",
    "DaiBanTiShiChengJiaoShiBai": "<p>Unfortunately these orders were cancelled and <b>it is necessary for you to find out the reason for the cancellation and record it in the system.</b></p>",
    "HeJiDingJin": "The total deposits",
    "HeJiWeiKuan": "The total balance payment",
    "PingJunTingLiuS": "Average length of stay {0} days",
    "ZhuanHuaLvPingJunTingLiuS": "Conversion rate {0}%, average length of stay {1} days.",
    "RuKuNTian3": "Arrival at warehouse for {0} days, {1} days beyond free storage.",
    "ShengChengKongPo": "Generate an empty PO.",
    "QueRenDingDanChuHuoXinXi": "Confirm the order shipment details!",
    "QueRenHouJiangShengChengY": "Once confirmed, a pending consolidation PO (purchase order) will be generated for scheduling and cargo dispatch.",
    "QueRenShiFouYouWoSiChuanW": "Confirm whether our shipping department will handle the booking, customs declaration, and release of documents (booking is not required for bulk cargo delivered to designated locations).",
    "DiaoChaWenJuan": "Survey",
    "QuanBuGongChang": "All factories",
    "DengLuHouChaKanGengDuoJie": "Log in to see more",
    "AnTuiJianPaiXu": "Sort by Recommendation",
    "AnShangShiShiJianPaiXu": "Sort by Listing Time",
    "DaiBanTiShiXinKeHu": "<p>The purpose of the survey is to understand the satisfaction of new customers with their first order, identify problems in time, improve service and avoid losing new customers.</p> <p>A sample script: </p> <p>Good afternoon, XXX! I am ESSAONE's customer service manager. You recently placed your first order and we would like to conduct a satisfaction survey on your first order with ESSAONE. Could you please take a few minutes to answer a few questions? Your opinion will help us to be better. </p> <p>1) Customer answers - YES.Start answering the questions. </p> <p>2) Customer answers - NO, busy right now. You need to ask the customer for a convenient time for the next call. </p>",
    "DaiBanTiShiYuLiuShiDiaoYan": "<p>The purpose of the survey is to understand the reasons for losing users on the platform, to improve and solve the problems existing on the platform, to avoid further loss of customers.</p> <p>A sample script: </p> <p>Good afternoon, XXX! I am a customer service employee of the ESSAONE platform. I would like to ask you a couple of questions about your satisfaction with our site, could you spare a few minutes? Your opinion will help ESSAONE to become better.  </p> <p>1) Customer answers - YES.You start asking questions. </p> <p>2) The customer says NO.I'm busy right now. You need to ask the customer for a convenient time to call again.",
    "DiYiGeDingDanShiJian": "First order",
    "DengLuHouChaKanGouWuCheSh": "Log in to view cart items",
    "KeHuDiaoYanJieGuo": "Survey Result",
    "WenJuanDiaoChaJieGuo": "Survey Result",
    "XinKeHu2": "New customer",
    "QingXuanZeWenJuan": "Please select a questionnaire",
    "DiaoYanHuoDong": "Survey",
    "DiYiGeDingDan": "First order",
    "WenJuanTianXieShiJian": "Time of completion of the questionnaire",
    "TianXieRen": "Filler",
    "ZunJingDeHuoBan": "<div><b>Dear Customer:</div><br /> <div>Thank you for choosing to cooperate with ESSAONE! In order to continuously improve our service level and better provide you with quality service, we sincerely invite you to take part in our satisfaction survey and listen to your feelings and evaluation opinions about the website ordering service. Your suggestions will help ESSAONE become better.</div><br /> <div>Thank you for your support and cooperation!</div>",
    "TuiChuBianJi": "Exit Editing",
    "LiuLanShangPinJiaRuGouWuC": "Browse Products, Add to Cart",
    "QieHuanXiaoShouJingLi": "Switch Sales Manager",
    "TianJiaYiWei": "Add One",
    "QieHuanShiBai": "Switch Failed",
    "ShangPinYouYiChangXuYaoNi": "The product has an issue, you need to handle it. You can accept it or renegotiate the price.",
    "YuanLaiJiaGe": "Original Price",
    "XianJiaGe": "Current Price",
    "QueDingJieShouGaiShangPin": "Confirm to accept this product?",
    "QingShuRuQiWangJiaGe": "Please enter the expected price",
    "JiXuZiXunYiJia": "Continue Consultation & Negotiation",
    "GongChangQueRenShengChanY": "Factory confirming production requirements",
    "YiQueRenKeXiaDan2": "Confirmed, can place the order",
    "ShiFangJiKeShuaXin": "Release to refresh...",
    "ShangPinYiGuoJiaGeBaoHuQi": "The product has passed the price protection period",
    "WenJuanYiJingTianXieGuo": "The questionnaire has already been filled out.",
    "DiaoChaWenJuanTiJiaoCheng": "The survey was submitted successfully, thank you for your co-operation!",
    "DingDanZhengZaiGenJinChuL": "The order is being processed, please contact your sales consultant for any actions.",
    "ZuiJinQueRenShiJian": "Last Ordered",
    "ShouDanRuKuShiJian": "First order arrival time at the warehouse",
    "ShouDanChuKuShiJian": "First order leaving warehouse time",
    "WenJuanDiaoChaJieGuoXiang": "<div><i class=\"popRoundNum\">1</i> First order ordering time</div> <div><i class=\"popRoundNum\">2</i> First order arrival time at the warehouse</div> <div><i class=\"popRoundNum\">3</i> First order leaving warehouse time</div>",
    "QingQianWangDuanTiJiaoDin": "Please submit the order via PC",
    "ZuiJinXiaDanRiQi": "Last Ordered",
    "YiSheZhiYaoQiu": "Completed filling",
    "WeiRenZheng": "Not Verified",
    "ShouJiYanZhengMa": "Mobile Verification Code",
    "DanDuTie": "Additional stickers are added to the product",
    "ZhengShuLeiXing": "Type Of Certificate",
    "ShouZiMu": "First Letter",
    "ZuiShaoQiDingLiang": "MOQ",
    "YouShiPin": "Video",
    "XiaoShouJingLiXiangQing": "Account Manager Details",
    "CiBaoJiaZaiQianYouXiao": "This quote is valid until {0}",
    "ZhuTu": "banner",
    "DengLuQieRenZhengHouXianS": "Prices shown after login and authentication",
    "QuanBuXinXi": "All Information",
    "BaoZhuangFenLei": "Packaging Category",
    "NiXuYaoXianXuanZeYiGeKeHu": "You need to select a customer manager first",
    "ZaiAnYiCiFanHuiTuiChuYing": "Press again to exit the app",
    "ZuiJinYiGeDingDan": "Last order",
    "WenJuanDiaoChaJieGuoXiang2": "<div><i class=\"popRoundNum\">1</i>Last confirmed PO time</div> <div><i class=\"popRoundNum\">2</i>Last Inventory Time</div> <div><i class=\"popRoundNum\">3</i>Latest Outbound Time</div>",
    "ShouDanQueRenShiJian": "First order time",
    "ZuiJinRuKuShiJian": "Last arrival at warehouse",
    "ZuiJinChuKuShiJian": "Last pick up time",
    "ShangYiCiShiYong": "Last Used",
    "FaWangNaGeChengShi": "Which city is it being shipped to?",
    "ShouHuoDianCangKu": "Delivery Point (Warehouse)",
    "ShanChuDiZhi": "Delete Address",
    "ShiFouShanChuDiZhi": "Are you sure you want to delete the address?",
    "QingShuRuLianXiRenXingMin": "Please enter the contact name",
    "FaYunLianXiRen": "Shipping Contact",
    "QingShuRuFaYunLianXiRen": "Please enter the shipping contact",
    "FaYunLianXiRenDianHua": "Shipping Contact Phone Number",
    "QingShuRuFaYunLianXiRenDi": "Please enter the shipping contact phone number",
    "KeHuBianHaoWuLiuGongSi": "Customer Number (Logistics Company)",
    "DingDanFeiYong": "Order Cost",
    "YingFu": "Payable",
    "XuanZeShouHuoRen": "Select Recipient",
    "WuLiuKeHuBianHao": "Logistics/Customer Number",
    "SouSuoDingDan": "Search Orders",
    "DuanGongNengKaiFaZhongQin": "The PC functionality is under development. Please submit orders via the ESSACHINA APP.",
    "HuoHao2": "Goods Ready",
    "YouDingDanYiShengChanWanB": "Some orders have been completed and can arrange shipment",
    "ChuHuoAnPai": "Shipping Arrangement",
    "DangQianYouYiChangDingDan": "There are current orders with issues that need to be handled promptly",
    "XiaoXi": "Message",
    "WenXinTiShiZaiXiaDanEDuFa": "Reminder: Within the order limit, shipments will be allocated according to production progress",
    "TiJiaoDingDanChengGong": "Order Submitted Successfully",
    "PingTaiYiAnZhaoChuHuoShiJ": "The platform has split the orders based on shipment time",
    "GuanZhuBingShenQing": "Follow and Apply",
    "CaiZhi2": "Material",
    "DingDanYiChang": "Order Exception",
    "XianHuoQi": "Latest Delivery Date",
    "XianMOQ": "Latest MOQ",
    "YiXiaShangPinYouYiChangXu": "The following products have issues that need to be handled promptly",
    "ShangPinQuXiao": "Product Cancelled",
    "ChaKanZiJinZhangHu": "View Financial Account",
    "YouDingDanYiChuHuoQingJin": "Orders have been shipped; please arrange payment promptly.",
    "ZiJinZongLan": "Financial Overview",
    "ZongEDu": "Total Quota",
    "YiShiYongEDu": "Used Quota",
    "HaiKeChuHuo": "Remaining Shipping Quota",
    "NiDeEDuYiBuZuChuHuo": "Your quota is insufficient for shipping.",
    "ChaKanFuKuanXinXi": "View Payment Information",
    "HuoHaoDingDan": "Shippable orders",
    "LaiKuanHouShiFangDuiYingC": "Release the corresponding shipping quota upon receipt of payment.",
    "YinXingZhangHao": "Bank Account",
    "ZhiFuBaoZhiFu": "Alipay Payment",
    "WeiXinZhiFuTianJiaHaoYou": "WeChat Pay (Add On WeChat)",
    "XiaLaJiKeShuaXin": "Pull down to refresh...",
    "DanCiHuoQuDeFuKuanXinXiJi": "Payment information obtained is valid for only {0} days.",
    "KeHuZhaoYang": "Find sample",
    "YiGuiHai": "Returned",
    "HaiQian": "Outstanding Balance",
    "PaiZhaoSouTu": "Search Image by Photo",
    "ShangPinQuXiaoHuoDiaoChu": "Product Cancelled or Moved",
    "QuanBuNShangPin": "All {0} Products",
    "XinYuJiChuHuoShiJian": "New Estimated Shipping Time",
    "YuanYuJiChuHuoShiJian": "Original Estimated Shipping Time",
    "ChuHuoShiJian2": "Shipping Time",
    "ShaiXuanYiChangDingDan": "Filter Abnormal Orders",
    "ZhongXinFaSongQueRenYouJi": "Resend Confirmation Email",
    "DengDaiZhuZhangHaoQueRen": "Waiting for Main Account Confirmation",
    "XiaoShouJingLi": "Account Manager",
    "ZiChanXinYong": "Assets & Credit",
    "GuanYuAPP": "About the App",
    "FuWuTiaoKuan": "Terms of Service",
    "YingYongQuanXianShuoMing": "Application Permission Description",
    "XiTongQuanXian": "System Permissions",
    "JianCeXinBanBen": "Check for New Version",
    "QingXuanZeDengJiRen": "Register person",
    "GongSiYuanGongZhangHao": "Company Staff Account",
    "ZhangHaoRenZhengBuTongGuo": "Account Verification Failed",
    "ZhangHaoRenZhengZhong": "Account Under Verification",
    "ChaKanRenZhengXinXi": "View Certification Information",
    "QingShuRuSouSuoNeiRong": "Please enter search content",
    "NinYiJingShiZuiXinDeBanBe": "You are already using the latest version",
    "SouTuJieGuo": "Search Results",
    "DianJiKeQieHuanSouTuZhuTi": "Click to Switch Image Search Subject",
    "ShouDongKuangXuanZhuTi": "Manually Select Main Subject",
    "LiKeDengLu": "Log In Immediately",
    "ZhengZaiShangChuan": "Uploading",
    "XuanZeXiGuanDeYuYan": "Select Preferred Language",
    "SheZhiChengGong": "Successfully Set",
    "YiXuanZeNGeLeiMu": "{0} Categories Selected",
    "ZhongXinRenZheng": "Re-authenticate",
    "QingDengDaiPingTaiRenZhen": "Please Wait for Platform Authentication",
    "AnZhengXiangChuHuo": "Ship by Full Container",
    "YiXuanZeNGe": "{0} Items Selected",
    "ShangChuanShuiDanXinXi": "Upload Receipt Information",
    "LeJieDingJinMoShi": "Learn About ESSA Deposit Model",
    "GuDingBaoZhengJinEDu": "Fixed Guarantee Quota",
    "DingDanChuHuoHouTuiHaiEDu2": "Quota Returned After Order Shipment",
    "LeJieOAEDu": "Learn About OA Quota",
    "XuanZeKeHuJingLi": "Select Account Manager",
    "PingTaiMaiShou": "Account Manager",
    "GongSiYiCunZaiShiFouYaoJi": "The Company Already Exists, Do You Want to Join an Existing Company?",
    "TongYiJiaGongSiKeYi": "The Same Company Can",
    "GongYongDiZhi": "Shared Address",
    "GongYongZhiFu": "Shared Payment",
    "GongYongHeTong": "Shared Contract",
    "JiaRuYiYouGongSi": "Join Existing Company",
    "QingXuanZeLianXiFangShi": "Select Contact Method",
    "YuanGongZhangHaoXinXi": "Employee Account Information",
    "TianJiaLianXiFangShi": "Add Contact Information",
    "QingTianXieDianZiYouXiang": "Please Fill in the Email Address",
    "QueRenNinShiZhenRen": "Confirm you are human.",
    "XinJianShouHuoRenXinXi": "Add New Recipient Information",
    "XinJianWuLiuGongSiXinXi": "Add logistics company information",
    "DingDanShangPinChuLiZhong": "Order items are being processed, please check later",
    "QingShuRuLianXiFangShi": "Enter contact information",
    "DianJiYanZhengZhenRenJiKe": "Click to verify a real person for access",
    "ZhiShaoBaoHanNGeZiFu": "Must contain at least {0} characters",
    "BaoKuoZiMuHeShuZi": "Including letters and numbers",
    "YouHuiQuanMa": "Coupon code",
    "QingShuRuYouHuiQuanMa": "Please enter the coupon code",
    "GongSiXingZhi": "Company type",
    "GongSiZhangHaoXinXi": "Company account information",
    "QingXuanZeYiXiangCaiGouSh": "Please select the main purchasing categories, with a maximum of five choices.",
    "QingXuanZeGongSiXingZhi": "Please select the company type",
    "QingXuanZeQingGuanFangShi": "Please select the customs clearance way",
    "QingXuanZeZhuYaoXiaoShouQ": "Please select the main sales region",
    "TiaoGuo": "Skip",
    "ZhongGuoPiFaShiChang2": "CHINESE WHOLESALE MARKETPLACE",
    "WoMenZhiZuoPiFaBuZuoLingS": "We work only with legal entities and individual entrepreneurs. Only wholesale purchase, no retail.",
    "XiuGaiShouJiHaoMa": "Modify phone number",
    "XiuGaiDianZiYouXiang": "Modify email address",
    "QingShuRuDianZiYouXiang": "Please enter your email address",
    "XuanZeChengShi": "Select region",
    "XuanZeDiQuYouZhuYuWoMenJi": "This will allow us to calculate prices",
    "QingXuanZeZhuYaoCaiGouPin2": "Please select the main purchasing categories",
    "GongSiXingZhiWeiShiChangP": "The company type is market wholesale, and the customs clearance type cannot be \"formal customs clearance\".",
    "ZhangHaoShenQingJiaRuGong": "Account application to join the company {0}",
    "FaSongShiBai": "Sending failed",
    "GongSiXingZhiZanBuZhiChiX": "The company type cannot be modified at the moment. Please contact customer service if you need to make changes.",
    "QingGuanFangShiZanBuZhiCh": "The customs clearance type cannot be modified at the moment. Please contact customer service if you need to make changes.",
    "ZhuCeChengGongNiDeZhangHa": "Registration is successful! Your account : <a href=\"mailto:{0}\">{0}</a>",
    "WeiBaoZhangYongHuDeZhangH": "<div>1. In order to protect the user's account security and facilitate communication, we have sent you an email. Please check and click the link in the email to complete the verification. </div> <div>2. Our account manager will contact you within 48 hours on working days to help you find the right products and the best discounts! </div>",
    "ShenMeShiESSAONE2": "About ESSAONE",
    "XinRenZhuanQu": "Newcomer discount",
    "QiTaLianXiFangShiBuNengZh": "Other contact details cannot be duplicated or empty.",
    "ShouCiXiaDanJinXuZhiFuDeD": "Deposit only 10% for the first order!",
    "DianZiYouXiangYongHuZhang": "E-mail/User Account",
    "XiuGaiHuoYanZhengYouXiang": "Modify or verify email address",
    "YouXiangYiChengGongJieSho": "The email has been successfully received, but the user has not completed the authentication.",
    "YouXiangDiZhiWuXiao": "Invalid e-mail address",
    "YouJianFaSongShiBai": "Failed to send email",
    "WeiZhi": "Unknowns",
    "KeHuYuYan": "Language",
    "NiDeYouXiangYiYanZhengChe": "Your email has been successfully verified!",
    "WoMenChengNuoBuHuiXiangNi": "We promise not to send a huge number of emails and will send you only important news about the work of the site, ongoing promotions, as well as a selection of new products and trends.",
    "ZhiShaoGeZiFuZiMuYuShuZiZ": "At least 8 characters, must include letters and numbers",
    "SouSuoKeHuMingChengBianHa2": "Search for Customer name/NO./Phone/E-mail",
    "YouXiangYiZhi": "The email address has not changed, no need to change it.",
    "YouXiangYiBianGeng": "Email changed.",
    "GaiLianJieYiBieShiYong": "The link has been used.",
    "ZiJiGenJinDeKeHuCaiNengQuXiaoGenJin": "Invalid! The client is not yours.",
    "TuiGuangQuDao": "Promotion channels",
    "TuiGuangQuDaoLaiYuan": "Sources of promotion",
    "XinYongTiXiJiangGenJuDing": "1、ESSACHINA's credit system will periodically evaluate and update your credit status based on order fulfillment. The initial score is 90 points.",
    "PingFenLaiYuanYuYeWuJingL": "The ratings are based on real feedback from customers who have been served by the account manager. You can refer to evaluations of the manager's language ability, service attitude, issue response time, and problem-solving ability in these four areas to choose your preferred manager.",
    "EDuYongYuDingDanChuHuoDeD": "OA credit limit is used as a deposit guarantee for order shipments, and the corresponding deposit will be deducted after shipment. Available limit = credit guarantee limit - the portion that has been locked. The current balance can continue to be used as a deposit guarantee for orders.",
    "ZongHe": "All-Categories",
    "QingXuanZeGanXingQuDeLeiM": "Please select your categories of interest",
    "ShenQingJiaRuGongSi": "Apply to Join a Company",
    "XinBanBenShengJi": "New Version Upgrade",
    "GengXinNeiRong": "Update Details",
    "LiJiGengXin": "Update Now",
    "ZhengZaiXiaZaiYingYong": "Downloading",
    "JinDu": "Progress",
    "YiMingYongHuZhengZaiShenQ": "A user is applying to join your company.",
    "NinKeYiPiZhunHuoJuJueGaiQ": "You can approve or reject this request",
    "order_pay_shipment": "Payment and Shipment",
    "order_status_change": "Order Status Update",
    "order_abnormal": "Order Exception Notification",
    "system_salesman_change": "Sales Advisor Change",
    "system_account_change": "Account Information Changes",
    "system_other": "Other System Notifications",
    "XiaoXiSheZhi": "Message Settings",
    "WeiXinTongHao": "Same number on WeChat",
    "WhatsAppTongHao": "Same number on WhatsApp",
    "GongNengKaiFaZhong": "Function under development",
    "TiGaoSouTuJingZhunXiaoJiQ": "Improve search accuracy",
    "ChaKanKeXiaDanDeShangPin": "View available products for ordering.",
    "QuLianXi": "Contact immediately.",
    "QingLianXiNinDeKeHuJingLi": "Please contact your account manager.",
    "NinXianZaiXuYaoCaiGouShan": "Do you need to purchase products now? Please contact your account manager to assist you with order-related matters.",
    "XiTong": "System",
    "MeiYouGengDuoShangPin": "No more products",
    "RenGongGaiJiaFuLiRun": "Negative profit",
    "1059PR10020": "Duplicate buyer name",
    "QingTianXieZhengQueTianSh": "Please fill in the number of days correctly",
    "QingShuRuDaYuDeTianShu": "Please enter a number of days greater than {0}",
    "GaiJiaGeYouXiaoQi": "Price validity period",
    "ZaiQianXiaDanYiGaiJiaGeWe": "Orders placed before {0} will be based on this price",
    "GongChangZhangJiaXianChuL": "Factory price increase",
    "GongChangZhangJiaLeYaoXia": "Factory price increase",
    "GongChangCaiGouJiaXunHou": "Factory‘s price(after inquiry)",
    "GongChangCaiGouJia": "Factory‘s price",
    "RangLiHouCaiGouJia": "Discounted factory price",
    "YongYuJiSuanChengJiaoJia": "Calculate price",
    "XunHouYouZhangJiaXianChuL": "abnormal",
    "XunHou": "after inquiry",
    "XunQian": "before inquiry",
    "GaiJia": "Change price",
    "ChengJiaoJiaZhangJiaHou": "Transaction price",
    "GongChangCaiGouJiaZhangJi": "Factory‘s price",
    "DangAnJia": "Factory’s price",
    "DangNiShiYongShiHuiZaiShi": "When using the ESSACHINA APP, access to the album, camera, and storage permissions will be requested when searching for products via images or updating user profile information. Do you allow this?",
    "PaiZhao": "Take a photo",
    "CongXiangCeXuanZe": "Choose from album",
    "QingXianShanChuSuoYouDeZi": "Please cancel all sub-accounts before canceling the main account!",
    "QueDingZhuXiaoZhangHao": "Sure you want to cancel your account?",
    "YiTongZhiKeHu": "Customers have been notified",
    "TieZhiShenHe": "Check the sticker",
    "TiJiaoQueRenShiJian": "Time of submission",
    "GaiDingDanShangPinTieZhiY": "Product stickers for this order have been confirmed.",
    "XiuGaiTieZhi": "Modify the sticker",
    "QueRenShiJian": "Confirmation time",
    "TieZhiMoBan2": "Sticker templates",
    "XiuGaiShuoMing": "Modification instructions",
    "QingShuRuMiaoShuBenCiYaoX": "Please enter the content of the sticker to be modified.",
    "JieTuShuoMing": "Screenshot description",
    "XiuGaiLeiXing": "Modification type",
    "XuanZeShangPinTianXieTeSh": "Select the product and fill in the production requirements.",
    "RuNinDuiDingDanHuoDingDan": "If you have special requirements for the items in your order, please state them clearly. These requests include aspects such as the colour of the item, the specified style, and the function of the accessory.",
    "DingDanYaoQiuBeiZhu": "Order Requirements",
    "MeiYouXiuGaiXiang": "No modifications",
    "QueRen": "OK",
    "ZhuYiDuiDingDanHuoDingDan": "NOTE: If you have special requirements for the merchandise you are ordering, please state them clearly. These requests include aspects such as the colour of the item, the specified style, and the function of the accessory.",
    "KeHuDuiDingDanHuoDingDanZ": "Please clearly state any special requirements the customer may have for the merchandise ordered. These requests include aspects such as the colour of the item, the specified style, and the function of the accessory.",
    "TianXieYiBaoCunChengGong": "Saved successfully",
    "ShengChanZhuangTai": "Production status",
    "ZhiDingTiaoXingMa": "Specify barcode",
    "YiXiuGaiZaiQueRen": "Modified and confirmed",
    "ZhiDingShangPinTiaoXingMa": "Specify product barcode",
    "QingShuRuMiaoShuLiRuShang": "Please enter a description, e.g. in terms of product colour, specified style, accessory features, etc.",
    "DingDanYiJingZaiShengChan": "The order is already in production, so further special requests are not supported.",
    "ZhiDingShangPinTiaoMa": "Specify barcode",
    "ShenQingXiaZai": "Request download",
    "TuPianKeDaoChu": "Pictures can be exported",
    "ShenQingXiaZaiZhongQingNa": "Download in progress, please wait patiently for 1-3 minutes",
    "DaiZhuangJuRenYuanShangCh": "Waiting for the loading staff to upload pictures",
    "DaiChuanWuQueRenHouXiaZai": "Download after shipping confirmation",
    "XiaZaiZhuangXiangDan": "Download the packing list",
    "ZhaoYangLeiXing": "Sample search type",
    "GenJuShiJiZhaoYangXuQiuXu": "Choose the sample search type based on actual requirements.",
    "QingXuanZeZhaoYangLeiXing": "Please select the sample search type.",
    "KeHuYouTiGongZhaoYangZiLi": "The customer has provided sample search materials that need to be uploaded to retain the original sample search data.",
    "XiaZaiQuanBu": "Download All",
    "YuShangChuan": "{0}  uploaded a picture on {1}",
    "YiZhaoWang": "Found",
    "XiangYouHuaDongTianChongP": "Slide puzzle verification for real person.",
    "DianJiJinRu": "Click to Enter",
    "BuGenJin": "Not following up",
    "ShangPinDangAnJia": "Factory Price",
    "ChanQianYang": "Pre-production sample",
    "PiLiangXiaZai": "Batch download",
    "FuZhiXiaZaiLianJie": "Copy download link",
    "GaiJiaGe": "Change price",
    "ShangChuanPIDan": "Upload PI form",
    "ShangChuanPIWenJian": "Upload PI file",
    "ShangChuanWenJianZhiChiTu": "Upload files, supporting images/PDF/Excel",
    "ShuiDan": "Flow statement",
    "QingShuRuZengZhiShuiLv": "Please enter the value-added tax rate",
    "AIZhiXuan": "AI Search",
    "SiKaoZhong": "思考中",
    "FenXiTuiDaoGuoCheng": "分析推导过程",
    "FenXiNinDeXuQiu": "分析您的需求",
    "NinSouSuoDeNeiRong": "您搜索的内容",
    "SouSuoGuanJianCiTuiJian": "搜索关键词推荐",
    "QingZaiDuiHuaKuangZhongSh": "请在对话框中输入内容",
    "ShaiXuanTuiJian": "筛选推荐",
    "NiShiYaoCaiGouDeShangPin": "你是要采购的商品",
    "NiShiYaoCaiGouDeShangPinQiDingLiang": "你是要采购的商品起订量",
    "NiShiYaoCaiGouDeShangPinBaoZhuangYuYan": "你是要采购的商品包装语言",
    "NiShiYaoCaiGouDeShangPinBaoZhuangLeiXing": "你是要采购的商品包装类型",
    "NiShiYaoCaiGouDeShangPinHuoQi": "你是要采购的商品货期",
    "NiShiYaoCaiGouDeShangPinJiaGe": "你是要采购的商品价格",
    "NiShiYaoCaiGouDeShangPinBiaoQian": "你是要采购的商品标签",
    "NiShiYaoCaiGouDeShangPinCaiZhi": "你是要采购的商品材质",
    "NiShiYaoCaiGouDeShangPinZhengShu": "你是要采购的商品证书",
    "SouSuoShangPinJieGuo": "搜索商品结果",
    "ShaiXuanYouXiaoXinXi": "筛选有效信息",
    "FenXiNinDeXuanPinPianHaoH": "分析您的选品偏好和背景信息",
    "ChengRenYongPin": "Adult Products",
    "QueRenNinDeNianLing": "Confirm your age",
    "CiShangPinJinShiYongYuNia": "This product is only available for users over 18 years old to browse!",
    "ShiDeWoYiNianManSui": "Yes, I am over 18 years old",
    "BuShi": "Not",
    "QingMiaoShuNiDeXuQiu": "Describe your needs...",
    "XinKaiHuiHua": "New Chat",
    "KaoLvZhongZanBuNengXinKai": "Thinking, unable to start a new conversation for now",
    "MiaoShuNinDeXuQiu": "Describe your needs...",
    "TieZhiTuBiao": "иконка стикера",
    "XuanZeTieZhiTuBiao": "Выбор значка стикера",
    "ShiFouQiangZhiBiaoJi": "«Честный знак»",
    "ShangPinXinXiYouXiuGaiXuZ": "Информация о товаре изменена, требуется повторная подача заявки",
    "QingXuanZeShangPinFenLei": "Пожалуйста, выберите категорию товара",
    "FaqTitle": "Chestny Znak (Honest Sign) — FAQ | ESSAONE",
    "FaqTitleInfo": "End-to-end marking service: code issuance, label printing/application, compliant customs clearance, and data submission to CRPT via OFD. Categories covered: toys, bicycles, adult apparel accessories, selected home textiles. Free processing and labeling for ESSAONE customers with a valid contract and platform order.",
    "FaqIssue1": "What is Chestny Znak and why is import marking required?",
    "FaqAnswer1": "Chestny Znak is Russia’s national product marking and traceability system (CRPT). For categories like apparel/textiles, toys, and footwear, marking and data submission are mandatory at import and sale stages.",
    "FaqIssue2": "What “one-stop” services does ESSAONE provide?",
    "FaqAnswer2": "Code issuance → label printing/application → compliant customs clearance → data submission to CRPT via OFD → delivery of compliance and reconciliation documents.",
    "FaqIssue3": "Which categories are currently covered?",
    "FaqAnswer3": "Toys, bicycles, adult apparel accessories, and selected home textiles (e.g., towels/aprons). Children’s apparel/accessories are being added.",
    "FaqIssue4": "What’s the difference between EAC and Chestny Znak?",
    "FaqAnswer4": "EAC covers technical regulation compliance (certification/declaration); Chestny Znak covers product marking and traceability. ESSAONE can handle both.",
    "FaqIssue5": "Where should labeling be done — in China or in Russia?",
    "FaqAnswer5": "We recommend labeling in China during production and providing the required documents with the shipment to ensure end-to-end traceability and faster customs clearance.",
    "FaqIssue6": "What information is needed from the buyer?",
    "FaqAnswer6": "Company credentials (INN/OGRN) and a contact person; for urgent batches, please also provide an SKU list and packaging artwork if available.",
    "FaqIssue7": "What are the timelines and costs?",
    "FaqAnswer7": "Preparation typically 2–5 business days, labeling 1–3 days. The process adds time and labor to standard inbound/catalog workflows; for ESSAONE customers with a signed contract and platform order, processing and labeling are free (within agreed scope).",
    "FaqIssue8": "How is data transmitted to the system?",
    "FaqAnswer8": "Through connected operators/OFD to CRPT. After submission, confirmations and reconciliation documents are available in your account.",
    "FaqIssue9": "What are the risks of non-compliance?",
    "FaqAnswer9": "Fines and restrictions on circulation. Working with ESSAONE reduces compliance risks and keeps transactions aligned with regulations.",
    "FaqIssue10": "How do we get started?",
    "FaqAnswer10": "Sign a contract with ESSAONE and place a platform order with deposit; we handle the rest.",
    "FaqIssue11": "Contact",
    "FaqAnswer11": "Tel: 8-800-550-3301 | WhatsApp: +7-925-949-1117 | Telegram: +7-925-703-1115 | Email: service@essaone.com",
    "YongYuWoMenLianXi": "Leave a message or call",
    "ZhuCeHouCaiGouLianXiGongC": "Get wholesale prices from China factories (no middlemen)",
    "ZiXunGuWen": "Consultant",
    "KeHuBianHaoMingCheng": "CUS Code / Name",
    "ShouDan10DingJin": "10% deposit for the first order, the more you buy, the more discounts you get.",
    "QingShuRuJuHao": "Container number",
    "KuCunShuLiang": "Quantity in stock",
    "QingCangTeMaiJiaGeYouHui": "Clearance sale, price discount",
    "DingZhiTiaoMa": "Barcode customization instructions",
    "TiaoXingMaShiYongShuoMing": "Barcode customization instructions",
    "ShangPinTiaoXingMaDingZhi": "Barcode customization instructions",
    "DingZhiTiaoMaJiangTiHuanQ": "Customised barcodes will replace the original product barcodes on customs clearance labels.",
    "DingZhiFuWuPeiZhi": "Custom Service Configuration",
    "XuanZeBaoZhuangFuWu": "Choose Packaging Service",
    "XiTongJiangGenJuShangPinC": "System will auto-match model based on product size",
    "DangQianXuanZe": "Current Selection",
    "TiaoMaDingZhi": "Barcode Customization",
    "DingZhiTiaoMaShuoMing": "Barcode Customization Instructions",
    "ShangChuanTiaoMa": "Upload Barcode",
    "ShuRuTiaoMa": "Enter Barcode",
    "YiKuanDuoTiaoMa": "Multi-Barcode SKU",
    "QingShuRuTeShuCaoZuoZhiLi": "Please enter special handling instructions, e.g.: remove hangtag, replace box, insert card, etc.",
    "SuoYouDingZhiFuWuJiangZai": "All custom services will be completed before shipping.",
    "YunFeiJiaShou": "Add Shipping Fee",
    "XiaoHao": "Small",
    "ZhongHao": "Medium",
    "DaHao": "Large",
    "GenJuShangPinPiPeiXuShiYo": "Match Model to Item",
    "BaoZhuangFuWu": "Fulfillment",
    "MESSAONEHomeTitle": "Wholesale from China, EAC & Honest Sign end-to-end | ESSAONE",
    "MESSAONEHomeDescription": "ESSAONE — B2B wholesale from China for Russia: toys, kitchen products, stationery, kids goods. Honest Sign (Честный знак), customs and data handled end-to-end.",
    "XunQianChangJia": "询前厂价",
    "XunHouChangJia": "询后厂价",
    "ShiJiCaiGouJia": "实际采购价",
    "RangLiKeHu": "让利客户",
    "SuanLiRun": "算利润",
    "TuiN": "退 {0}%",
    "TuiDian": "退点",
    "FufilmentKey2": "Fulfillment Service",
    "QiTaYaoQiuShuoMing": "Other Requirements / Special Instructions",
    "YuGu": "Estimate",
    "ShangPinDeFaHuoFangShiShi": "This item ships directly from China; fulfillment service is not currently available.",
    "ShangPinZengJiaEWaiBaoZhu": "Added packaging increases the parcel volume, which may incur an additional shipping fee due to the volumetric weight.",
    "RuoNinXuYaoJiangCaiGouDeS": "<div><div class=\"mb_6\">We apply SKU barcodes for WB, Ozon, and other marketplaces before the goods are shipped from China. We handle all labeling on your behalf.</div>  <div class=\"mb_6\">What we need from you:</div> <div class=\"mb_6\">    1.Generate the barcodes in your WB/Ozon seller account (PDF / image / barcode data)..</div> <div class=\"mb_6\">    2.Upload the file to the ESSAONE platform.</div>  <div class=\"mb_6\">КHow it works:</div></div> <div class=\"mb_6\">    •\tIThe ID barcode and the “Chestny ZNAK” code are combined into one single sticker..</div> <div class=\"mb_6\">    •\tWhen Fulfillment service is enabled, stickers are applied:</div>  <div class=\"mb_6\">— — to the product packaging;</div> <div class=\"mb_6\">— — to the outer carton.</div>  <div class=\"mb_6\">Full-service labeling — the goods arrive in Russia fully ready for shipment to WB and Ozon, with no re-labeling or reprinting required.</div>  <div class=\"mb_6\">Important!</div> <div class=\"mb_6\">If one SKU includes different colors or models with different barcodes (mixed assortment), you must clearly specify which barcode corresponds to which product.</div>",
    "TiaoMaDingZhiShuoMing": "Turnkey Labeling & “Chestny ZNAK” Compliance",
    "QingGuanTieZhiYangLi": "Sample of customs clearance sticker",
    "KeHuDuiDingDanHuoDingDanZ2": "If the customer has special requirements for the order or any item in the order, please clearly specify them. These requirements may involve aspects such as product color, designated style, accessory functions, etc.",
    "ShenQingXiaZaiTieZhiWenJi": "Request to download sticker file",
    "TieZhiWenJianShengChengZh": "Generating sticker file...",
    "TieZhiWenJianKeXiaZai": "Sticker file is available for download.",
    "TieZhiWenJian": "Sticker file",
    "ZhongXinShengCheng": "Failed to generate sticker file.",
    "ChuLiChengShiBiaoZhiZhong": "Processing Chestny Znak...",
    "KeHuYouHuiQuan": "Customer Coupon",
    "KeDiKou": "Redeemable",
    "NDeJiFen": "{0}'s points",
    "TieZhiWenJianShengChengSh": "Failed to generate sticker file.",
    "HuoQuJiaGe": "Get Prices"
}
 export default lang;